import { Widget, BodyWidget, TableRowWidget, TableWidget, LineWidget, TextElementBox, ListTextElementBox, ImageElementBox, ParagraphWidget, TableCellWidget, FieldElementBox, BlockWidget, HeaderFooterWidget, BlockContainer, BookmarkElementBox, ElementBox, EditRangeStartElementBox, EditRangeEndElementBox, TabElementBox, CommentElementBox, CommentCharacterElementBox, TextFormField, CheckBoxFormField, DropDownFormField, ShapeElementBox, TextFrame, ContentControl, FieldTextElementBox, FootNoteWidget, FootnoteElementBox, ShapeBase, GroupShapeElementBox } from '../viewer/page';
import { HelperMethods, Point } from '../editor/editor-helper';
import { SelectionCharacterFormat, SelectionCellFormat, SelectionParagraphFormat, SelectionRowFormat, SelectionSectionFormat, SelectionTableFormat, SelectionImageFormat } from './selection-format';
import { PageLayoutViewer, WebLayoutViewer, WRowFormat } from '../index';
import { isNullOrUndefined, createElement, L10n, Browser } from '@syncfusion/ej2-base';
import { Dictionary } from '../../base/dictionary';
import { contentControlEvent, beforeFormFieldFillEvent, afterFormFieldFillEvent, requestNavigateEvent, CharacterRangeType, aftercontentControlFillEvent, beforecontentControlFillEvent, internalviewChangeEvent } from '../../base/index';
import { WCharacterFormat, WParagraphFormat, WParagraphStyle } from '../index';
import { HtmlExport } from '../writer/html-export';
import { DialogUtility, Popup } from '@syncfusion/ej2-popups';
import { TextPosition, SelectionWidgetInfo, Hyperlink } from './selection-helper';
import { DropDownButton } from '@syncfusion/ej2-splitbuttons';
/* eslint-disable */
/**
 * Selection
 */
export class Selection {
    /**
     * @param documentEditor
     * @private
     */
    constructor(documentEditor) {
        /**
         * @private
         */
        this.upDownSelectionLength = 0;
        /**
         * @private
         */
        this.upDownSelLength = 0;
        /**
         * @private
         */
        this.isSkipLayouting = false;
        /**
        * @private
        */
        this.isImageSelected = false;
        /**
        * @private
        */
        this.isExcludeBookmarkStartEnd = false;
        this.contextTypeInternal = undefined;
        /**
         * @private
         */
        this.caret = undefined;
        //Format Retrieval Field
        /**
         * @private
         */
        this.isRetrieveFormatting = false;
        /**
         * @private
         */
        this.isSelectCurrentWord = false;
        /**
         * @private
         */
        this.skipFormatRetrieval = false;
        /**
         * @private
         */
        this.isModifyingSelectionInternally = false;
        this.isMoveDownOrMoveUp = false;
        this.isSelectBookmark = false;
        this.isHighlightContentControlEditRegionIn = true;
        this.isPageUpAndDown = false;
        /**
         * @private
         * This will holds the selection html content to set data in clipboard. Avoid to use this field for other purpose.
         */
        this.htmlContent = undefined;
        /**
         * @private
         * This will holds the selection sfdt content to set data in clipboard. Avoid to use this field for other purpose.
         */
        this.sfdtContent = undefined;
        /**
         * @private
         */
        this.isEndOffset = false;
        /**
         * @private
         */
        this.isViewPasteOptions = false;
        /**
         * @private
         */
        this.skipEditRangeRetrieval = false;
        /**
         * @private
         */
        this.selectedWidgets = undefined;
        /**
         * @private
         */
        this.isHighlightEditRegionIn = false;
        /**
         * @private
         */
        this.isHighlightFormFields = false;
        /**
         * @private
         */
        this.isHightlightEditRegionInternal = false;
        /**
         * @private
         */
        this.isCurrentUser = false;
        /**
         * @private
         */
        this.isHighlightNext = false;
        /**
         * @private
         */
        this.isWebLayout = false;
        /**
         * @private
         */
        this.contentControlHighlighters = undefined;
        /**
         * @private
         */
        this.editRegionHighlighters = undefined;
        /**
         * @private
         */
        this.contentControleditRegionHighlighters = undefined;
        /**
         * @private
         */
        this.formFieldHighlighters = undefined;
        this.isSelectList = false;
        /**
         * @private
         */
        this.previousSelectedFormField = undefined;
        /**
         * @private
         */
        this.previousSelectedContentControl = undefined;
        /**
         * @private
         */
        this.currentContentControl = undefined;
        /**
         * @private
         */
        this.isFormatUpdated = false;
        /**
         * @private
         */
        this.isCellPrevSelected = false;
        /**
         * @private
         */
        this.currentFormField = undefined;
        /**
         * @private
         */
        this.contentControls = [];
        this.editRangeCachePage = [];
        /**
         * @private
         */
        this.isHomeEnd = false;
        /**
         * @private
         */
        this.isSelectLine = false;
        /**
         * @private
         */
        this.pasteOptions = (event) => {
            let locale = new L10n('documenteditor', this.owner.defaultLocale);
            locale.setLocale(this.owner.locale);
            if (event.item.text === locale.getConstant('Keep source formatting')) {
                this.owner.editorModule.applyPasteOptions('KeepSourceFormatting');
            }
            else if (event.item.text === locale.getConstant('Match destination formatting')) {
                this.owner.editorModule.applyPasteOptions('MergeWithExistingFormatting');
            }
            else if (event.item.text === locale.getConstant('NestTable')) {
                this.owner.editorModule.applyTablePasteOptions('NestTable');
            }
            else if (event.item.text === locale.getConstant('InsertAsRows')) {
                this.owner.editorModule.applyTablePasteOptions('InsertAsRows');
            }
            else if (event.item.text === locale.getConstant('InsertAsColumns')) {
                this.owner.editorModule.applyTablePasteOptions('InsertAsColumns');
            }
            else if (event.item.text === locale.getConstant('OverwriteCells')) {
                this.owner.editorModule.applyTablePasteOptions('OverwriteCells');
            }
            else {
                this.owner.editorModule.applyPasteOptions('KeepTextOnly');
            }
        };
        /**
         * Hides caret.
         *
         * @private
         * @returns {void}
         */
        this.hideCaret = () => {
            if (!isNullOrUndefined(this.caret)) {
                this.caret.style.display = 'none';
            }
        };
        this.owner = documentEditor;
        this.documentHelper = this.owner.documentHelper;
        this.start = new TextPosition(this.owner);
        this.end = new TextPosition(this.owner);
        this.selectedWidgets = new Dictionary();
        this.characterFormatIn = new SelectionCharacterFormat(this);
        this.paragraphFormatIn = new SelectionParagraphFormat(this, this.documentHelper);
        this.sectionFormatIn = new SelectionSectionFormat(this);
        this.rowFormatIn = new SelectionRowFormat(this);
        this.cellFormatIn = new SelectionCellFormat(this);
        this.tableFormatIn = new SelectionTableFormat(this);
        this.imageFormatInternal = new SelectionImageFormat(this);
        this.editRangeCollection = [];
        this.editRegionHighlighters = new Dictionary();
        this.contentControleditRegionHighlighters = new Dictionary();
        this.formFieldHighlighters = new Dictionary();
    }
    // Code for Comparing the offset calculated using old approach and optimized approach
    // /**
    //  * @private
    //  */
    // public isNewApproach: boolean;
    /**
     * @private
     * @returns {boolean} - Retuens true if highlighting editing region
     */
    get isHighlightEditRegion() {
        return this.isHighlightEditRegionIn;
    }
    /**
     * @private
     */
    set isHighlightEditRegion(value) {
        this.isHighlightEditRegionIn = value;
        this.onHighlight();
    }
    /**
     * @private
     * @returns {boolean} - Retuens true if highlighting editing region
     */
    get isHighlightContentControlEditRegion() {
        return this.isHighlightContentControlEditRegionIn;
    }
    /**
     * @private
     */
    set isHighlightContentControlEditRegion(value) {
        this.isHighlightContentControlEditRegionIn = value;
    }
    /**
     * @private
     */
    get htmlWriter() {
        if (isNullOrUndefined(this.htmlWriterIn)) {
            this.htmlWriterIn = new HtmlExport();
        }
        return this.htmlWriterIn;
    }
    /**
     * Gets the start text position of last range in the selection
     *
     * @private
     * @returns {TextPosition} - Returns selection start position.
     */
    get start() {
        if (!isNullOrUndefined(this.owner) && !isNullOrUndefined(this.viewer)) {
            if (isNullOrUndefined(this.startInternal)) {
                this.startInternal = this.owner.documentStart;
            }
            return this.startInternal;
        }
        return undefined;
    }
    /**
     * @private
     */
    set start(value) {
        this.startInternal = value;
    }
    //Format retrieval properties
    /**
     * Gets the instance of selection character format.
     *
     * @default undefined
     * @aspType SelectionCharacterFormat
     * @returns {SelectionCharacterFormat} Returns the selection character format.
     */
    get characterFormat() {
        return this.characterFormatIn;
    }
    /**
     * Gets the instance of selection paragraph format.
     *
     * @default undefined
     * @aspType SelectionParagraphFormat
     * @returns {SelectionParagraphFormat} Returns the selection paragraph format.
     */
    get paragraphFormat() {
        return this.paragraphFormatIn;
    }
    /**
     * Gets the instance of selection section format.
     *
     * @default undefined
     * @aspType SelectionSectionFormat
     * @returns {SelectionSectionFormat} Returns the selection section format.
     */
    get sectionFormat() {
        return this.sectionFormatIn;
    }
    /**
     * Gets the instance of selection table format.
     *
     * @default undefined
     * @aspType SelectionTableFormat
     * @returns {SelectionTableFormat} Returns the selection table format.
     */
    get tableFormat() {
        return this.tableFormatIn;
    }
    /**
     * Gets the instance of selection cell format.
     *
     * @default undefined
     * @aspType SelectionCellFormat
     * @returns {SelectionCellFormat} Returns the selection cell format.
     */
    get cellFormat() {
        return this.cellFormatIn;
    }
    /**
     * Gets the instance of selection row format.
     *
     * @default undefined
     * @aspType SelectionRowFormat
     * @returns {SelectionRowFormat} Returns selection row format.
     */
    get rowFormat() {
        return this.rowFormatIn;
    }
    /**
     * Gets the instance of selection image format.
     *
     * @default undefined
     * @aspType SelectionImageFormat
     * @returns {SelectionImageFormat} Returns the selection image format.
     */
    get imageFormat() {
        return this.imageFormatInternal;
    }
    /**
     * Gets the start text position of selection range.
     *
     * @private
     * @returns {TextPosition} - Returns selection end position.
     */
    get end() {
        return this.endInternal;
    }
    /**
     * For internal use
     *
     * @private
     */
    set end(value) {
        this.endInternal = value;
    }
    /**
     * Gets the current scroll position of the document editor.
     *
     * @returns {ScrollPosition} An object containing the current scroll position
     * @returns {ScrollPosition.scrollTop} The vertical scroll offset in pixels from the top
     * @returns {ScrollPosition.scrollLeft} The horizontal scroll offset in pixels from the left
     */
    getScrollPosition() {
        let scrollPosition = { scrollTop: this.documentHelper.viewerContainer.scrollTop, scrollLeft: this.documentHelper.viewerContainer.scrollLeft };
        return scrollPosition;
    }
    /**
     * Sets the scroll position of the document editor.
     *
     * @param {ScrollPosition} position - The target scroll position
     * @param {number} position.scrollTop - The vertical scroll offset in pixels from the top
     * @param {number} position.scrollLeft - The horizontal scroll offset in pixels from the left
     * @returns {void}
     */
    setScrollPosition(position) {
        if (!isNullOrUndefined(position.scrollTop)) {
            this.documentHelper.viewerContainer.scrollTop = position.scrollTop;
        }
        if (!isNullOrUndefined(position.scrollLeft)) {
            this.documentHelper.viewerContainer.scrollLeft = position.scrollLeft;
        }
    }
    /**
     * Gets the page number where the selection starts.
     *
     * @returns {number} Returns the selection start page number.
     */
    get startPage() {
        if (!this.owner.isDocumentLoaded || isNullOrUndefined(this.viewer)
            || this.viewer instanceof WebLayoutViewer || isNullOrUndefined(this.documentHelper.selectionStartPage)) {
            return 1;
        }
        return this.documentHelper.pages.indexOf(this.documentHelper.selectionStartPage) + 1;
    }
    /**
     * Gets the page number where the selection ends.
     *
     * @returns {number} Returns the selection end page number.
     */
    get endPage() {
        if (!this.owner.isDocumentLoaded || isNullOrUndefined(this.viewer)
            || this.viewer instanceof WebLayoutViewer || isNullOrUndefined(this.documentHelper.selectionEndPage)) {
            return 1;
        }
        return this.documentHelper.pages.indexOf(this.documentHelper.selectionEndPage) + 1;
    }
    /**
     * Determines whether the selection direction is forward or not.
     *
     * @default false
     * @private
     * @returns {boolean} Returns isForward
     */
    get isForward() {
        return this.start.isExistBefore(this.end);
    }
    /**
     * Determines whether the selection is in footnote or not.
     *
     * @default false
     * @returns {boolean} Returns true if selection is in footnote
     * @private
     */
    get isinFootnote() {
        return this.isFootNoteParagraph(this.start.paragraph);
    }
    /**
     * Determines whether the selection is in endnote or not.
     *
     * @default false
     * @returns {boolean}
     * @private
     */
    get isinEndnote() {
        return this.isEndNoteParagraph(this.start.paragraph);
    }
    /**
     * Determines whether the start and end positions are same or not.
     *
     * @default false
     * @returns {boolean}
     * @private
     */
    get isEmpty() {
        if (isNullOrUndefined(this.start)) {
            return true;
        }
        return this.start.isAtSamePosition(this.end);
    }
    /**
     * Returns the start hierarchical index.
     */
    get startOffset() {
        return this.getHierarchicalIndexByPosition(this.start);
    }
    /**
     * Returns the end hierarchical index.
     */
    get endOffset() {
        return this.getHierarchicalIndexByPosition(this.end);
    }
    /**
     * @private
     */
    get isInShape() {
        let container = this.start.paragraph.containerWidget;
        do {
            if (container instanceof TextFrame) {
                return true;
            }
            if (container) {
                container = container.containerWidget;
            }
        } while (container);
        return false;
    }
    /**
     * Gets the text within selection.
     *
     * @default ''
     * @aspType string
     * @returns {string} Returns the text within selection.
     */
    get text() {
        return this.getText(false);
    }
    /**
     * Gets the context type of the selection.
     */
    get contextType() {
        return this.contextTypeInternal;
    }
    /**
     * Gets bookmark name collection.
     */
    get bookmarks() {
        return this.getSelBookmarks(false, false);
    }
    /**
    * Gets the selected content of the document as SFDT(Syncfusion Document Text) file format.
    *
    * @default undefined
    * @returns {string}
    */
    get sfdt() {
        if (this.owner.editorModule && !this.isEmpty) {
            return JSON.stringify(this.writeSfdt());
        }
        else {
            return undefined;
        }
    }
    /**
     * Gets the list of fields present within the current selection in the document. This property can be used to identify and work with field elements present in the selected text range.
     *
     * @returns {FieldStartInfo[]} An array of objects containing information about each field present in the selected text range.
     */
    get fields() {
        return this.getSelBookmarks(false, true);
    }
    /**
     * Gets the bookmark name collection in current selection.
     *
     * @param includeHidden - Decide whether to include hidden bookmark name in current selection or not.
     * @returns Returns the bookmark name collection in current selection.
     */
    getBookmarks(includeHidden) {
        return this.getSelBookmarks(includeHidden, false);
    }
    /**
     * @private
     */
    get isCleared() {
        return isNullOrUndefined(this.end);
    }
    /**
     * Returns true if selection is in field.
     *
     * @returns Returns true if selection is in field; Otherwise, false.
     */
    get isInField() {
        if (!isNullOrUndefined(this.getHyperlinkField(true))) {
            return true;
        }
        return false;
    }
    /**
     *  Determines whether the current selection is within a field.
     *
     * @param includeFieldStart - Optional. If true, includes the field start in the selection check. Default is false.
     * @param includeFieldEnd - Optional. If true, includes the field end in the selection check. Default is false.
     *
     * @returns Returns true if the selection is within a field, false otherwise.
     */
    isSelectionInField(includeFieldStart = false, includeFieldEnd = false) {
        if (!isNullOrUndefined(this.getHyperlinkField(true, includeFieldStart, includeFieldEnd, true))) {
            return true;
        }
        return false;
    }
    /**
     * Gets the field information for the selected field.
     *
     * @returns { FieldInfo } Returns `FieldInfo` if selection is in field, otherwise `undefined`
     * > Returns `undefined` for text, image, table, shape. For nested fields, it returns combined field code and result.
     */
    getFieldInfo() {
        const field = this.getHyperlinkField(true);
        if (!isNullOrUndefined(field)) {
            let code = this.getFieldCode(field);
            let result = this.owner.editorModule.getFieldResultText(field);
            return {
                code: code,
                result: result
            };
        }
        return undefined;
    }
    isFootNoteParagraph(paragraph) {
        const container = this.getContainerWidget(paragraph);
        if (container instanceof FootNoteWidget && container.footNoteType === 'Footnote') {
            return true;
        }
        else {
            return false;
        }
    }
    isEndNoteParagraph(paragraph) {
        const container = this.getContainerWidget(paragraph);
        if (container instanceof FootNoteWidget && container.footNoteType === 'Endnote') {
            return true;
        }
        else {
            return false;
        }
    }
    /**
     * @param documentEditor
     * @private
     */
    isFootEndNoteParagraph(paragraph) {
        if (this.isFootNoteParagraph(paragraph)) {
            return true;
        }
        else if (this.isEndNoteParagraph(paragraph)) {
            return true;
        }
        else {
            return false;
        }
    }
    getSelBookmarks(includeHidden, isField) {
        const bookmarkCln = [];
        const fieldCln = [];
        let bookmarks = this.documentHelper.bookmarks;
        let fields = this.documentHelper.fields;
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        let elementStart;
        let elementEnd;
        let isCellSelected = false;
        const selectedCells = this.getSelectedCells();
        let count = isField ? fields.length : bookmarks.length;
        for (let i = 0; i < count; i++) {
            if (isField || (includeHidden || !includeHidden && bookmarks.keys[i].indexOf('_') !== 0)) {
                elementStart = isField ? fields[i] : bookmarks.get(bookmarks.keys[i]);
                elementEnd = isField ? fields[i].fieldEnd : elementStart.reference;
                if (isNullOrUndefined(elementEnd)) {
                    continue;
                }
                const bmStartPos = this.getElementPosition(elementStart, false, false).startPosition;
                const bmEndPos = this.getElementPosition(elementEnd, true, false).startPosition;
                if (!isField && !isNullOrUndefined(elementEnd.properties) && this.checkIsAfterBookmark(elementEnd.properties)) {
                    bmEndPos.offset++;
                }
                if (bmStartPos.paragraph.isInsideTable || bmEndPos.paragraph.isInsideTable) {
                    if (selectedCells.length > 0) {
                        if (selectedCells.indexOf(bmStartPos.paragraph.associatedCell) >= 0
                            || selectedCells.indexOf(bmEndPos.paragraph.associatedCell) >= 0) {
                            isCellSelected = true;
                        }
                        else {
                            isCellSelected = false;
                            if (selectedCells.indexOf(bmStartPos.paragraph.associatedCell) < 0
                                || selectedCells.indexOf(bmEndPos.paragraph.associatedCell) < 0) {
                                const endCell = end.paragraph.isInsideTable && end.paragraph.associatedCell;
                                const bmEndPosCell = bmEndPos.paragraph.associatedCell;
                                if (endCell && bmEndPosCell && endCell.ownerTable.equals(bmEndPosCell.ownerTable) &&
                                    !(endCell.ownerTable
                                        && selectedCells.indexOf(this.getCellInTable(endCell.ownerTable, bmEndPosCell)) >= 0)) {
                                    // Bug 891131: The below code is comment to resolve the bookmark is not retrieved when selecting the table cell
                                    // continue;
                                }
                            }
                        }
                    }
                    else {
                        isCellSelected = false;
                    }
                }
                else {
                    isCellSelected = false;
                }
                if ((start.isExistAfter(bmStartPos) || start.isAtSamePosition(bmStartPos))
                    && (end.isExistBefore(bmEndPos) || end.isAtSamePosition(bmEndPos)) ||
                    ((bmStartPos.isExistAfter(start) || bmStartPos.isAtSamePosition(start))
                        && (bmEndPos.isExistBefore(end) || bmEndPos.isAtSamePosition(end))) ||
                    (bmStartPos.isExistAfter(start) && bmStartPos.isExistBefore(end)
                        && (end.isExistAfter(bmEndPos) || end.isExistBefore(bmEndPos))) ||
                    (bmEndPos.isExistBefore(end) && bmEndPos.isExistAfter(start)
                        && (start.isExistBefore(bmStartPos) || start.isExistAfter(bmStartPos))) || isCellSelected) {
                    if (isField) {
                        let fieldInfo = { field: elementStart };
                        fieldCln.push(fieldInfo);
                    }
                    else {
                        bookmarkCln.push(elementStart.name);
                    }
                }
            }
        }
        if (isField) {
            return fieldCln;
        }
        else {
            return bookmarkCln;
        }
    }
    checkIsAfterBookmark(properties) {
        if (properties.hasOwnProperty('isAfterParagraphMark') && properties['isAfterParagraphMark']) {
            return true;
        }
        if (properties.hasOwnProperty('isAfterTableMark') && properties['isAfterTableMark']) {
            return true;
        }
        if (properties.hasOwnProperty('isAfterRowMark') && properties['isAfterRowMark']) {
            return true;
        }
        if (properties.hasOwnProperty('isAfterCellMark') && properties['isAfterCellMark']) {
            return true;
        }
        return false;
    }
    /**
    *
    * @private
    */
    get viewer() {
        return this.owner.viewer;
    }
    getModuleName() {
        return 'Selection';
    }
    checkLayout() {
        if (this.owner.layoutType === 'Continuous') {
            this.isWebLayout = true;
            this.documentHelper.isHeaderFooter = true;
            this.owner.layoutType = 'Pages';
            this.owner.viewer.destroy();
            this.owner.viewer = new PageLayoutViewer(this.owner);
            this.documentHelper.layout.layoutWholeDocument();
        }
    }
    //Public API
    /**
     * Moves the selection to the header of current page.
     *
     * @returns {void}
     */
    goToHeader() {
        this.checkLayout();
        this.owner.enableHeaderAndFooter = true;
        this.enableHeadersFootersRegion(this.start.paragraph.bodyWidget.page.headerWidget, this.start.paragraph.bodyWidget.page);
        this.isWebLayout = false;
    }
    /**
     * Moves the selection to the footer of current page.
     *
     * @returns {void}
     */
    goToFooter() {
        this.checkLayout();
        this.owner.enableHeaderAndFooter = true;
        this.enableHeadersFootersRegion(this.start.paragraph.bodyWidget.page.footerWidget, this.start.paragraph.bodyWidget.page);
        this.isWebLayout = false;
    }
    /**
     * Closes the header and footer region.
     *
     * @returns {void}
     */
    closeHeaderFooter() {
        this.disableHeaderFooter();
        if (this.documentHelper.isHeaderFooter && this.owner.layoutType === 'Pages') {
            this.owner.layoutType = 'Continuous';
            this.documentHelper.isHeaderFooter = false;
        }
    }
    /**
    * Closes the xml Pane region.
    *
    * @returns {void}
    */
    closeXmlPane() {
        this.disableXml();
        this.owner.enableXMLPane = false;
        if (this.documentHelper.isHeaderFooter && this.owner.layoutType === 'Pages') {
            this.owner.layoutType = 'Continuous';
            this.documentHelper.isHeaderFooter = false;
        }
    }
    /**
     * Moves the selection to the start of specified page number.
     *
     * @param pageNumber Specify the page number to move selection.
     * @returns {void}
     */
    goToPage(pageNumber) {
        this.owner.scrollToPage(pageNumber);
        if (pageNumber >= 1 && pageNumber <= this.owner.documentHelper.pages.length) {
            const page = this.owner.documentHelper.pages[pageNumber - 1];
            this.updateTextPositionForBlockContainer(page.bodyWidgets[0]);
        }
    }
    /**
     * Selects the entire table if the context is within table.
     *
     * @returns {void}
     */
    selectTable() {
        if (!this.owner.enableSelection) {
            return;
        }
        this.selectTableInternal();
    }
    /**
     * Selects the entire row if the context is within table.
     *
     * @returns {void}
     */
    selectRow() {
        if (!this.owner.enableSelection) {
            return;
        }
        this.selectTableRow();
    }
    /**
     * Selects the entire column if the context is within table.
     *
     * @returns {void}
     */
    selectColumn() {
        if (!this.owner.enableSelection) {
            return;
        }
        this.selectColumnInternal();
    }
    /**
     * Selects the entire cell if the context is within table.
     *
     * @returns {void}
     */
    selectCell() {
        if (!this.owner.enableSelection) {
            return;
        }
        this.selectTableCell();
    }
    select(selectionSettings, startOrEnd) {
        if (typeof (selectionSettings) === 'string') {
            const startPosition = this.getTextPosBasedOnLogicalIndex(selectionSettings);
            const endPosition = this.getTextPosBasedOnLogicalIndex(startOrEnd);
            this.selectPosition(startPosition, endPosition);
        }
        else {
            const point = new Point(selectionSettings.x, selectionSettings.y);
            const pageCoordinates = this.viewer.findFocusedPage(point, true, false, this.isPageUpAndDown);
            if (selectionSettings.extend) {
                this.moveTextPosition(pageCoordinates, this.end);
            }
            else {
                this.documentHelper.updateTextPositionForSelection(pageCoordinates, 1);
            }
        }
    }
    /**
     * Selects the content based on the specified start and end hierarchical index.
     *
     * @param start Specify the start index to select.
     * @param end Specify the end index to select.
     * @returns {void}
     */
    selectByHierarchicalIndex(start, end) {
        const startPosition = this.getTextPosBasedOnLogicalIndex(start);
        const endPosition = this.getTextPosBasedOnLogicalIndex(end);
        this.selectPosition(startPosition, endPosition);
    }
    selectField(fieldInfo) {
        if (!isNullOrUndefined(fieldInfo) && fieldInfo.field) {
            fieldInfo = fieldInfo.field;
        }
        if (this.isInField || !isNullOrUndefined(fieldInfo)) {
            if (isNullOrUndefined(fieldInfo)) {
                fieldInfo = this.getHyperlinkField(true);
            }
            this.selectFieldInternal(fieldInfo);
        }
    }
    /**
     * @private
     * @param fieldStart
     * @returns {void}
     */
    selectContentControlInternal(fieldStart) {
        if (fieldStart) {
            const offset = fieldStart.nextElement instanceof EditRangeStartElementBox ?
                fieldStart.line.getOffset(fieldStart, 2) : fieldStart.line.getOffset(fieldStart, 1);
            const startPosition = new TextPosition(this.owner);
            let fieldEnd = fieldStart.reference;
            startPosition.setPositionParagraph(fieldStart.line, offset);
            const endoffset = fieldEnd.previousElement instanceof EditRangeEndElementBox ?
                fieldEnd.line.getOffset(fieldEnd, -1) : fieldEnd.line.getOffset(fieldEnd, 0);
            const endPosition = new TextPosition(this.owner);
            endPosition.setPositionParagraph(fieldEnd.line, endoffset);
            //selects the field range
            this.documentHelper.selection.selectRange(startPosition, endPosition);
        }
    }
    /**
     * @private
     * @param fieldStart
     * @returns {void}
     */
    selectFieldInternal(fieldStart, isKeyBoardEvent, isReplacingFormResult) {
        if (fieldStart) {
            const formFillingMode = this.documentHelper.isFormFillProtectedMode || isReplacingFormResult;
            let fieldEnd = fieldStart.fieldEnd;
            if (formFillingMode) {
                fieldStart = fieldStart.fieldSeparator;
            }
            const offset = fieldStart.line.getOffset(fieldStart, formFillingMode ? 1 : 0);
            const startPosition = new TextPosition(this.owner);
            startPosition.setPositionParagraph(fieldStart.line, offset);
            const isBookmark = fieldStart.nextNode instanceof BookmarkElementBox;
            if (isBookmark && !formFillingMode && fieldStart.nextElement.reference) {
                fieldEnd = fieldStart.nextElement.reference;
            }
            const endoffset = fieldEnd.line.getOffset(fieldEnd, formFillingMode ? 0 : 1);
            const endPosition = new TextPosition(this.owner);
            endPosition.setPositionParagraph(fieldEnd.line, endoffset);
            //selects the field range
            this.documentHelper.selection.selectRange(startPosition, endPosition);
            if (!isReplacingFormResult) {
                this.triggerFormFillEvent(isKeyBoardEvent);
            }
        }
    }
    /**
     * @private
     * @param contentControl
     * @returns {void}
     */
    selectContentControl(contentControl) {
        if (contentControl) {
            let fieldEnd = contentControl.reference;
            const offset = contentControl.line.getOffset(contentControl, 0);
            const startPosition = new TextPosition(this.owner);
            startPosition.setPositionParagraph(contentControl.line, offset);
            const endoffset = fieldEnd.line.getOffset(fieldEnd, 1);
            const endPosition = new TextPosition(this.owner);
            endPosition.setPositionParagraph(fieldEnd.line, endoffset);
            this.documentHelper.selection.selectRange(startPosition, endPosition);
        }
    }
    /**
     * @param shape
     * @private
     * @returns {void}
     */
    selectShape(shape) {
        if (shape) {
            const offset = shape.line.getOffset(shape, 0);
            const startPosition = new TextPosition(this.owner);
            startPosition.setPositionParagraph(shape.line, offset);
            const endoffset = shape.line.getOffset(shape, 1);
            const endPosition = new TextPosition(this.owner);
            endPosition.setPositionParagraph(shape.line, endoffset);
            this.documentHelper.selection.selectRange(startPosition, endPosition);
        }
    }
    /**
     * Toggles the bold property of selected contents.
     *
     * @private
     * @returns {void}
     */
    toggleBold() {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleBold();
        }
    }
    /**
     * Toggles the italic property of selected contents.
     *
     * @private
     * @returns {void}
     */
    toggleItalic() {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleItalic();
        }
    }
    /**
     * Toggles the allCaps property of selected contents.
     *
     * @private
     * @returns {void}
     */
    toggleAllCaps() {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleAllCaps();
        }
    }
    /**
     * Toggles the underline property of selected contents.
     *
     * @param {Underline} underline Default value of ‘underline’ parameter is Single.
     * @private
     * @returns {void}
     */
    toggleUnderline(underline) {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleUnderline(underline);
        }
    }
    /**
     * Toggles the strike through property of selected contents.
     *
     * @param {Strikethrough} strikethrough Default value of strikethrough parameter is SingleStrike.
     * @private
     * @returns {void}
     */
    toggleStrikethrough(strikethrough) {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleStrikethrough(strikethrough);
        }
    }
    /**
     * Toggles the highlight color property of selected contents.
     *
     * @param {HighlightColor} highlightColor Default value of ‘underline’ parameter is Yellow.
     * @private
     * @returns {void}
     */
    toggleHighlightColor(highlightColor) {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleHighlightColor(highlightColor);
        }
    }
    /**
     * Toggles the subscript formatting of selected contents.
     *
     * @private
     * @returns {void}
     */
    toggleSubscript() {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleSubscript();
        }
    }
    /**
     * Toggles the superscript formatting of selected contents.
     *
     * @private
     * @returns {void}
     */
    toggleSuperscript() {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleSuperscript();
        }
    }
    /**
     * Toggles the text alignment property of selected contents.
     *
     * @param {TextAlignment} textAlignment Default value of ‘textAlignment parameter is TextAlignment.Left.
     * @private
     * @returns {void}
     */
    toggleTextAlignment(textAlignment) {
        if (this.owner.editorModule) {
            this.owner.editorModule.toggleTextAlignment(textAlignment);
        }
    }
    /**
     * Increases the left indent of selected paragraphs to a factor of 36 points.
     *
     * @private
     * @returns {void}
     */
    increaseIndent() {
        if (this.owner.editorModule) {
            this.owner.editorModule.increaseIndent();
        }
    }
    /**
     * Decreases the left indent of selected paragraphs to a factor of 36 points.
     *
     * @private
     * @returns {void}
     */
    decreaseIndent() {
        if (this.owner.editorModule) {
            this.owner.editorModule.decreaseIndent();
        }
    }
    /**
     * Fires the `requestNavigate` event if current selection context is in hyperlink.
     *
     * @returns {void}
     */
    navigateHyperlink() {
        const fieldBegin = this.getHyperlinkField();
        if (fieldBegin) {
            this.fireRequestNavigate(fieldBegin);
        }
    }
    /**
     * Navigate Hyperlink
     *
     * @param fieldBegin
     * @private
     * @returns {void}
     */
    fireRequestNavigate(fieldBegin) {
        const code = this.getFieldCode(fieldBegin);
        if (code.toLowerCase().indexOf('ref ') === 0 && !code.match('\\h')) {
            return;
        }
        const hyperlink = new Hyperlink(fieldBegin, this);
        const eventArgs = {
            isHandled: false,
            navigationLink: hyperlink.navigationLink,
            linkType: hyperlink.linkType,
            localReference: hyperlink.localReference,
            source: this.owner
        };
        this.owner.trigger(requestNavigateEvent, eventArgs);
        if (!eventArgs.isHandled) {
            this.documentHelper.selection.navigateBookmark(hyperlink.localReference, true);
        }
    }
    /**
     * Copies the hyperlink URL if the context is within hyperlink.
     *
     * @returns {void}
     */
    copyHyperlink() {
        const hyperLinkField = this.getHyperlinkField();
        const linkText = this.getLinkText(hyperLinkField, true);
        this.copyToClipboard(linkText);
    }
    isHideSelection(paragraph) {
        const bodyWgt = paragraph.bodyWidget;
        const sectionFormat = bodyWgt.sectionFormat;
        const pageHt = sectionFormat.pageHeight - sectionFormat.footerDistance;
        const headerFooterHt = this.documentHelper.compatibilityMode === 'Word2013'
            && bodyWgt.page.headerWidget && bodyWgt.page.footerWidget
            && bodyWgt.page.headerWidget.height + bodyWgt.page.footerWidget.height < bodyWgt.page.boundingRectangle.height / 100 * 80 ?
            bodyWgt.page.boundingRectangle.height / 100 * 80 : bodyWgt.page.boundingRectangle.height / 100 * 40;
        return this.contextType.indexOf('Footer') >= 0
            && (paragraph.y + paragraph.height > HelperMethods.convertPointToPixel(pageHt))
            || this.contextType.indexOf('Header') >= 0 && paragraph.y + paragraph.height > headerFooterHt;
    }
    //Selection add, Highlight, remove API starts
    /**
     * @private
     * @returns {void}
     */
    highlightSelection(isSelectionChanged, isBookmark) {
        if (this.owner.enableImageResizerMode) {
            this.owner.imageResizerModule.hideImageResizer();
        }
        if (this.isEmpty) {
            if (!this.isInShape && this.isHideSelection(this.start.paragraph)) {
                this.hideCaret();
                return;
            }
            if (this.isInShape) {
                this.showResizerForShape();
            }
            this.updateCaretPosition();
        }
        else {
            if (this.isForward) {
                this.highlightSelectedContent(this.start, this.end);
            }
            else {
                this.highlightSelectedContent(this.end, this.start);
            }
            if (this.documentHelper.isComposingIME) {
                this.updateCaretPosition();
            }
        }
        this.documentHelper.updateTouchMarkPosition();
        if (isSelectionChanged) {
            this.documentHelper.scrollToPosition(this.start, this.end, undefined, isBookmark);
        }
        if (this.documentHelper.comments.length > 0) {
            this.highlightCommentMarkIcon();
        }
    }
    addCommentMarkhighlight(comment) {
        if (!isNullOrUndefined(comment.commentStart.commentMark) && !isNullOrUndefined(comment.commentStart.commentMark.classList)) {
            comment.commentStart.commentMark.classList.add('e-de-cmt-mark-hover');
        }
    }
    removeCommentMarkHighlight(comment) {
        if (!isNullOrUndefined(comment.commentStart.commentMark) && !isNullOrUndefined(comment.commentStart.commentMark.classList)) {
            comment.commentStart.commentMark.classList.remove('e-de-cmt-mark-hover');
        }
    }
    highlightCommentMarkIcon() {
        let selectionStartPosition;
        let selectionEndPosition;
        if (this.isForward) {
            selectionStartPosition = this.start;
            selectionEndPosition = this.end;
        }
        else {
            selectionStartPosition = this.end;
            selectionEndPosition = this.start;
        }
        const comments = this.documentHelper.comments;
        let low = 0;
        let high = comments.length - 1;
        let currentMatch = null;
        while (low <= high) {
            const mid = (low + high) >> 1;
            const comment = comments[mid];
            const commentStartPosition = this.getElementPosition(comment.commentStart).startPosition;
            const commentEndPosition = this.getElementPosition(comment.commentEnd).startPosition;
            const insideComment = (selectionStartPosition.isExistAfter(commentStartPosition) || selectionStartPosition.isAtSamePosition(commentStartPosition)) &&
                (selectionStartPosition.isExistBefore(commentEndPosition) || selectionStartPosition.isAtSamePosition(commentEndPosition));
            if (insideComment) {
                const startInsideTable = selectionStartPosition.paragraph.isInsideTable;
                const endInsideTable = selectionEndPosition.paragraph.isInsideTable;
                let shouldHighlight = false;
                if (!startInsideTable) {
                    shouldHighlight = true;
                }
                else if (startInsideTable && endInsideTable) {
                    const sameTable = selectionStartPosition.paragraph.associatedCell.ownerTable.tableFormat ===
                        selectionEndPosition.paragraph.associatedCell.ownerTable.tableFormat;
                    shouldHighlight = sameTable;
                }
                currentMatch = shouldHighlight ? comment : null;
                break;
            }
            if (selectionStartPosition.isExistBefore(commentStartPosition)) {
                high = mid - 1;
            }
            else {
                low = mid + 1;
            }
        }
        const previousComment = this.previousHighlightedComment;
        const nextComment = currentMatch;
        if (previousComment !== nextComment) {
            if (previousComment) {
                this.removeCommentMarkHighlight(previousComment);
            }
            if (nextComment) {
                this.addCommentMarkhighlight(nextComment);
            }
            this.previousHighlightedComment = nextComment;
        }
    }
    createHighlightBorder(lineWidget, width, left, top, isElementBoxHighlight, contentControl) {
        if (width < 0) {
            width = 0;
        }
        const paragraph = lineWidget.paragraph;
        const floatingItems = [];
        if (paragraph.floatingElements.length > 0) {
            for (let k = 0; k < paragraph.floatingElements.length; k++) {
                const shapeElement = paragraph.floatingElements[k];
                if (shapeElement.line === lineWidget) {
                    let startTextPos = this.start;
                    let endTextPos = this.end;
                    if (!this.isForward) {
                        startTextPos = this.end;
                        endTextPos = this.start;
                    }
                    const offset = shapeElement.line.getOffset(shapeElement, 0);
                    if ((startTextPos.currentWidget !== lineWidget && endTextPos.currentWidget !== lineWidget) ||
                        (startTextPos.currentWidget === lineWidget && startTextPos.offset <= offset
                            && (endTextPos.currentWidget === lineWidget && endTextPos.offset >= offset + 1
                                || endTextPos.currentWidget !== lineWidget)) || (startTextPos.currentWidget !== lineWidget
                        && endTextPos.currentWidget === lineWidget && endTextPos.offset >= offset)) {
                        floatingItems.push(shapeElement);
                    }
                }
            }
        }
        const page = this.getPage(lineWidget.paragraph);
        let height = lineWidget.height;
        const widgets = this.selectedWidgets;
        let selectionWidget = undefined;
        let selectionWidgetCollection = undefined;
        if (this.isHighlightContentControlEditRegion && !isNullOrUndefined(contentControl)) {
            if (width === 0) {
                width = this.documentHelper.textHelper.getParagraphMarkSize(paragraph.characterFormat).Width;
            }
            this.addContentControlEditRegionHighlight(lineWidget, left, width, contentControl);
            return;
        }
        else if (this.isHightlightEditRegionInternal) {
            this.addEditRegionHighlight(lineWidget, left, width);
            return;
        }
        else if (this.isHighlightFormFields) {
            this.addFormFieldHighlight(lineWidget, left, width);
            return;
        }
        else {
            if (widgets.containsKey(lineWidget)) {
                if (widgets.get(lineWidget) instanceof SelectionWidgetInfo) {
                    selectionWidget = widgets.get(lineWidget);
                    // if the line element has already added with SelectionWidgetInfo
                    // now its need to be added as ElementBox highlighting them remove it from dictionary and add it collection.
                    if (isElementBoxHighlight) {
                        widgets.remove(lineWidget);
                        selectionWidgetCollection = [];
                        widgets.add(lineWidget, selectionWidgetCollection);
                    }
                }
                else {
                    selectionWidgetCollection = widgets.get(lineWidget);
                }
            }
            else {
                if (isElementBoxHighlight) {
                    selectionWidgetCollection = [];
                    widgets.add(lineWidget, selectionWidgetCollection);
                }
                else {
                    const wrapPosition = this.getWrapPosition(lineWidget, paragraph);
                    if (wrapPosition.length > 0) {
                        let selectionWidgetInfos = this.splitSelectionHighlightPosition(left, width, wrapPosition);
                        if (selectionWidgetInfos.length > 0) {
                            selectionWidgetInfos[0].floatingItems = floatingItems;
                            widgets.add(lineWidget, selectionWidgetInfos);
                            this.renderHighlight(page, lineWidget, selectionWidgetInfos, top, floatingItems);
                            return;
                        }
                        else {
                            selectionWidget = new SelectionWidgetInfo(left, width);
                            selectionWidget.floatingItems = floatingItems;
                            widgets.add(lineWidget, selectionWidget);
                        }
                    }
                    else {
                        selectionWidget = new SelectionWidgetInfo(left, width);
                        selectionWidget.floatingItems = floatingItems;
                        widgets.add(lineWidget, selectionWidget);
                    }
                }
            }
            if (selectionWidget === undefined) {
                selectionWidget = new SelectionWidgetInfo(left, width);
                selectionWidget.floatingItems = floatingItems;
                widgets.add(lineWidget, selectionWidget);
            }
        }
        this.renderHighlight(page, lineWidget, [selectionWidget], top, floatingItems);
        if (isElementBoxHighlight) {
            selectionWidgetCollection.push(selectionWidget);
        }
    }
    renderHighlight(page, lineWidget, selectionWidget, top, floatingItems) {
        const documentHelper = this.owner.documentHelper;
        const pageTop = this.getPageTop(page);
        const pageLeft = page.boundingRectangle.x;
        const height = lineWidget.height;
        if (this.viewer.containerTop <= pageTop
            || pageTop < this.viewer.containerTop + documentHelper.selectionCanvas.height) {
            const zoomFactor = documentHelper.zoomFactor;
            this.clipSelection(page, pageTop);
            for (let i = 0; i < selectionWidget.length; i++) {
                let selectedWidget = selectionWidget[i];
                let left = selectedWidget.left;
                let width = selectedWidget.width;
                if (this.documentHelper.isComposingIME) {
                    this.renderDashLine(documentHelper.selectionContext, page, lineWidget, (pageLeft + (left * zoomFactor)) - this.viewer.containerLeft, top, width * zoomFactor, height);
                }
                else {
                    this.documentHelper.selectionContext.fillStyle = 'gray';
                    documentHelper.selectionContext.globalAlpha = 0.4;
                    documentHelper.selectionContext.fillRect((pageLeft + (left * zoomFactor)) - this.viewer.containerLeft, (pageTop + (top * zoomFactor)) - this.viewer.containerTop, width * zoomFactor, height * zoomFactor);
                }
            }
            if (floatingItems.length > 0) {
                for (let z = 0; z < floatingItems.length; z++) {
                    const left = floatingItems[z].x;
                    const shapeTop = floatingItems[z].y;
                    const shapeWidth = floatingItems[z].width;
                    const shapeHeight = floatingItems[z].height;
                    documentHelper.selectionContext.fillRect((pageLeft + (left * zoomFactor)) - this.viewer.containerLeft, (pageTop + (shapeTop * zoomFactor)) - this.viewer.containerTop, shapeWidth * zoomFactor, shapeHeight * zoomFactor);
                }
            }
            documentHelper.selectionContext.restore();
        }
    }
    getWrapPosition(lineWidget, paragraph) {
        const bodyWidget = paragraph.bodyWidget;
        if (!isNullOrUndefined(bodyWidget) && bodyWidget.floatingElements.length > 0 && lineWidget.children.length > 0) {
            let startLeft = this.getLeftInternal(lineWidget, lineWidget.children[0], 0);
            let width = 0;
            const wrapPos = [];
            let isStarted = false;
            for (var z = 0; z < lineWidget.children.length; z++) {
                var element = lineWidget.children[z];
                if (element instanceof ShapeBase && element.textWrappingStyle !== 'Inline') {
                    continue;
                }
                if (element.padding.left > 0) {
                    if (wrapPos.length === 1 && wrapPos[0].end === 0) {
                        wrapPos[0].end = wrapPos[0].start - paragraph.x;
                        wrapPos[0].start = paragraph.x;
                        startLeft = paragraph.x;
                    }
                    let clipInfo = {};
                    clipInfo.start = startLeft + width;
                    clipInfo.end = 0;
                    if (isStarted) {
                        clipInfo.end = startLeft + width + element.padding.left;
                    }
                    wrapPos.push(clipInfo);
                }
                width += element.padding.left + element.width;
                if (element instanceof TextElementBox) {
                    isStarted = true;
                }
            }
            if (wrapPos.length === 1 && wrapPos[0].end === 0) {
                wrapPos[0].end = wrapPos[0].start - paragraph.x;
                wrapPos[0].start = paragraph.x;
            }
            return wrapPos;
        }
        return [];
    }
    splitSelectionHighlightPosition(left, width, clipInfo) {
        const selectedWidget = [];
        for (let m = 0; m < clipInfo.length; m++) {
            const info = clipInfo[m];
            if ((left < info.start && left + width < info.end) || left > (info.end)) {
                continue;
            }
            if (left < info.start && left + width > info.end) {
                selectedWidget.push(new SelectionWidgetInfo(left, info.start - left));
                width = (left + width) - info.end;
                left = info.end;
            }
            else if (left === info.start) {
                if (width < info.end) {
                    width = left + width - info.end;
                    left = info.end;
                }
                else {
                    left += info.end;
                    width = width - info.end;
                }
            }
            if (m === clipInfo.length - 1) {
                selectedWidget.push(new SelectionWidgetInfo(left, width));
            }
        }
        return selectedWidget;
    }
    addEditRegionHighlight(lineWidget, left, width) {
        let highlighters = undefined;
        const collection = this.editRegionHighlighters;
        if (collection.containsKey(lineWidget)) {
            highlighters = collection.get(lineWidget);
            const widgetInfoInternal = this.checkSelectionwidgetInfoPresent(highlighters, left, width);
            if (!isNullOrUndefined(widgetInfoInternal)) {
                return widgetInfoInternal;
            }
        }
        else {
            highlighters = [];
            collection.add(lineWidget, highlighters);
        }
        const editRegionHighlight = new SelectionWidgetInfo(left, width);
        if (this.isCurrentUser) {
            editRegionHighlight.color = this.owner.userColor !== '' ? this.owner.userColor : '#FFFF00';
        }
        highlighters.push(editRegionHighlight);
        return editRegionHighlight;
    }
    checkSelectionwidgetInfoPresent(highlighters, left, width) {
        for (let i = 0; i < highlighters.length; i++) {
            const highlighter = highlighters[i];
            if (highlighter.left === left && highlighter.width === width) {
                return highlighter;
            }
        }
        return undefined;
    }
    addContentControlEditRegionHighlight(lineWidget, left, width, contentControl) {
        const collection = this.contentControleditRegionHighlighters;
        let highlighters = [];
        if (!collection.containsKey(contentControl)) {
            collection.add(contentControl, new Dictionary());
        }
        let contentInfo = collection.get(contentControl);
        contentInfo.add(lineWidget, highlighters);
        const editRegionHighlight = new SelectionWidgetInfo(left, width);
        highlighters.push(editRegionHighlight);
    }
    addFormFieldHighlight(lineWidget, left, width) {
        let highlighters = undefined;
        const collection = this.formFieldHighlighters;
        if (collection.containsKey(lineWidget)) {
            highlighters = collection.get(lineWidget);
        }
        else {
            highlighters = [];
            collection.add(lineWidget, highlighters);
        }
        const formFieldHighlight = new SelectionWidgetInfo(left, width);
        highlighters.push(formFieldHighlight);
    }
    createHighlightBorderInsideTable(cellWidget) {
        const page = this.getPage(cellWidget);
        let selectionWidget = undefined;
        const left = cellWidget.x - cellWidget.margin.left + cellWidget.leftBorderWidth;
        const width = cellWidget.width + cellWidget.margin.left
            + cellWidget.margin.right - cellWidget.leftBorderWidth - cellWidget.rightBorderWidth;
        const top = cellWidget.y;
        const height = cellWidget.height;
        const pageTop = this.getPageTop(page);
        const pageLeft = page.boundingRectangle.x;
        const isVisiblePage = this.documentHelper.isPageInVisibleBound(page, pageTop);
        const widgets = this.selectedWidgets;
        if (!this.isHightlightEditRegionInternal && !this.isHighlightFormFields) {
            if (widgets.containsKey(cellWidget) && widgets.get(cellWidget) instanceof SelectionWidgetInfo) {
                selectionWidget = widgets.get(cellWidget);
                if (isVisiblePage) {
                    this.documentHelper.selectionContext.clearRect((pageLeft + (selectionWidget.left * this.documentHelper.zoomFactor) - this.viewer.containerLeft), (pageTop + (top * this.documentHelper.zoomFactor)) - this.viewer.containerTop, selectionWidget.width * this.documentHelper.zoomFactor, height * this.documentHelper.zoomFactor);
                }
            }
            else {
                selectionWidget = new SelectionWidgetInfo(left, width);
                if (widgets.containsKey(cellWidget)) {
                    widgets.remove(widgets.get(cellWidget));
                }
                widgets.add(cellWidget, selectionWidget);
            }
        }
        if (isVisiblePage) {
            this.documentHelper.selectionContext.fillStyle = 'gray';
            this.documentHelper.selectionContext.globalAlpha = 0.4;
            const zoomFactor = this.documentHelper.zoomFactor;
            this.clipSelection(page, pageTop);
            this.documentHelper.selectionContext.fillRect((pageLeft + (left * zoomFactor)) - this.viewer.containerLeft, (pageTop + (top * zoomFactor)) - this.viewer.containerTop, width * zoomFactor, height * zoomFactor);
            this.documentHelper.selectionContext.restore();
        }
    }
    clipSelection(page, pageTop) {
        const documentHelper = this.owner.documentHelper;
        let width;
        let height;
        if (this.viewer instanceof WebLayoutViewer && this.documentHelper.zoomFactor < 1) {
            width = page.boundingRectangle.width / this.documentHelper.zoomFactor;
            height = page.boundingRectangle.height / this.documentHelper.zoomFactor;
        }
        else {
            width = page.boundingRectangle.width * this.documentHelper.zoomFactor;
            height = page.boundingRectangle.height * this.documentHelper.zoomFactor;
        }
        const left = page.boundingRectangle.x;
        documentHelper.selectionContext.beginPath();
        documentHelper.selectionContext.save();
        documentHelper.selectionContext.rect(left - this.viewer.containerLeft, pageTop - this.viewer.containerTop, width, height);
        documentHelper.selectionContext.clip();
    }
    /**
     * Add selection highlight
     *
     * @private
     * @returns {void}
     */
    addSelectionHighlight(canvasContext, widget, top, page) {
        if (this.selectedWidgets.containsKey(widget)) {
            let height = this.documentHelper.render.getScaledValue(widget.height);
            const widgetInfo = this.selectedWidgets.get(widget);
            let widgetInfoCollection = undefined;
            if (widgetInfo instanceof SelectionWidgetInfo) {
                widgetInfoCollection = [];
                widgetInfoCollection.push(widgetInfo);
            }
            else {
                widgetInfoCollection = widgetInfo;
            }
            if (!isNullOrUndefined(widgetInfoCollection)) {
                for (let i = 0; i < widgetInfoCollection.length; i++) {
                    const selectedWidgetInfo = widgetInfoCollection[i];
                    let width = this.documentHelper.render.getScaledValue(widgetInfoCollection[i].width);
                    let left = this.documentHelper.render.getScaledValue(widgetInfoCollection[i].left, 1);
                    if (isNullOrUndefined(page)) {
                        page = this.owner.selectionModule.getPage(widget.paragraph);
                    }
                    this.owner.selectionModule.clipSelection(page, this.owner.selectionModule.getPageTop(page));
                    if (this.documentHelper.isComposingIME) {
                        this.renderDashLine(canvasContext, page, widget, left, top, width, height);
                    }
                    else {
                        canvasContext.clearRect(left, this.documentHelper.render.getScaledValue(top, 2), width, height);
                        canvasContext.globalAlpha = 0.4;
                        canvasContext.fillStyle = 'gray';
                        canvasContext.fillRect(left, this.documentHelper.render.getScaledValue(top, 2), width, height);
                        if (selectedWidgetInfo.floatingItems && selectedWidgetInfo.floatingItems.length > 0) {
                            for (let j = 0; j < selectedWidgetInfo.floatingItems.length; j++) {
                                const shape = selectedWidgetInfo.floatingItems[j];
                                width = this.documentHelper.render.getScaledValue(shape.width);
                                left = this.documentHelper.render.getScaledValue(shape.x, 1);
                                let shapeTop = this.documentHelper.render.getScaledValue(shape.y, 2);
                                canvasContext.fillRect(left, shapeTop, width, this.documentHelper.render.getScaledValue(shape.height));
                            }
                        }
                    }
                    canvasContext.restore();
                }
            }
        }
    }
    renderDashLine(ctx, page, widget, left, top, width, height) {
        const fontColor = this.characterFormat.fontColor;
        const fillColor = fontColor ? HelperMethods.getColor(fontColor) : '#000000';
        ctx.globalAlpha = 1;
        // Get character format copied from selection format
        const format = this.owner.editorModule.copyInsertFormat(new WCharacterFormat(undefined, this.owner), false);
        const heightInfo = this.documentHelper.textHelper.getHeight(format);
        const pageTop = this.getPageTop(page);
        const descent = heightInfo.Height - heightInfo.BaselineOffset;
        top = this.documentHelper.render.getUnderlineYPosition(widget) + top + 4 - descent;
        this.documentHelper.render.renderDashLine(ctx, left, (pageTop - this.viewer.containerTop) + (top * this.documentHelper.zoomFactor), width, fillColor, true);
    }
    /**
     * Add Selection highlight inside table
     *
     * @private
     * @returns {void}
     */
    addSelectionHighlightTable(canvasContext, tableCellWidget, page) {
        if (this.selectedWidgets.containsKey(tableCellWidget)) {
            const selectedWidgetInfo = this.selectedWidgets.get(tableCellWidget);
            let selectedWidgetInfoCollection = undefined;
            if (selectedWidgetInfo instanceof SelectionWidgetInfo) {
                selectedWidgetInfoCollection = [];
                selectedWidgetInfoCollection.push(selectedWidgetInfo);
            }
            else {
                selectedWidgetInfoCollection = selectedWidgetInfo;
            }
            if (!isNullOrUndefined(selectedWidgetInfoCollection)) {
                for (let i = 0; i < selectedWidgetInfoCollection.length; i++) {
                    const left = this.documentHelper.render.getScaledValue(selectedWidgetInfoCollection[i].left, 1);
                    const top = this.documentHelper.render.getScaledValue(tableCellWidget.y, 2);
                    const width = this.documentHelper.render.getScaledValue(selectedWidgetInfoCollection[i].width);
                    const height = this.documentHelper.render.getScaledValue(tableCellWidget.height);
                    canvasContext.clearRect(left, top, width, height);
                    canvasContext.fillStyle = 'gray';
                    if (isNullOrUndefined(page)) {
                        page = this.owner.selectionModule.getPage(tableCellWidget);
                    }
                    this.owner.selectionModule.clipSelection(page, this.owner.selectionModule.getPageTop(page));
                    canvasContext.fillRect(left, top, width, height);
                    canvasContext.restore();
                }
            }
        }
    }
    removeSelectionHighlight(widget) {
        let left = 0;
        let top = 0;
        let width = 0;
        let height = 0;
        let page = undefined;
        if (widget instanceof LineWidget) {
            const lineWidget = widget;
            const currentParaWidget = lineWidget.paragraph;
            page = !isNullOrUndefined(currentParaWidget) ?
                this.getPage((lineWidget.paragraph)) : undefined;
            if (isNullOrUndefined(page)) {
                return;
            }
            top = this.getTop(lineWidget);
            height = lineWidget.height;
        }
        else if (widget instanceof TableCellWidget) {
            page = !isNullOrUndefined(widget) ?
                this.getPage(widget) : undefined;
            if (isNullOrUndefined(page)) {
                return;
            }
            top = widget.y;
            height = widget.height;
        }
        if (isNullOrUndefined(page)) {
            return;
        }
        const selectedWidget = this.selectedWidgets.get(widget);
        let selectedWidgetCollection = undefined;
        if (selectedWidget instanceof SelectionWidgetInfo) {
            selectedWidgetCollection = [];
            selectedWidgetCollection.push(selectedWidget);
        }
        else {
            selectedWidgetCollection = selectedWidget;
        }
        if (!isNullOrUndefined(selectedWidgetCollection)) {
            for (let i = 0; i < selectedWidgetCollection.length; i++) {
                width = selectedWidgetCollection[i].width;
                left = selectedWidgetCollection[i].left;
                const pageRect = page.boundingRectangle;
                const pageIndex = this.documentHelper.pages.indexOf(page);
                const pageGap = this.viewer.pageGap;
                const pageTop = (pageRect.y - pageGap * (pageIndex + 1)) * this.documentHelper.zoomFactor + pageGap * (pageIndex + 1);
                const pageLeft = pageRect.x;
                const zoomFactor = this.documentHelper.zoomFactor;
                if (this.viewer.containerTop <= pageTop
                    || pageTop < this.viewer.containerTop + this.documentHelper.selectionCanvas.height) {
                    this.documentHelper.selectionContext.clearRect((pageLeft + (left * zoomFactor) - this.viewer.containerLeft) - 0.5, (pageTop + (top * zoomFactor)) - this.viewer.containerTop - 0.5, width * zoomFactor + 0.5, height * zoomFactor + 0.5);
                }
            }
        }
    }
    /**
     * Selects the current word.
     *
     * @param excludeSpace True if exclude white space; Otherwise, false.
     * @returns {void}
     */
    selectCurrentWord(excludeSpace) {
        this.isSelectCurrentWord = true;
        const startPosition = this.start.clone();
        const endPosition = this.end.clone();
        this.selectCurrentWordRange(startPosition, endPosition, excludeSpace ? excludeSpace : false);
        this.selectRange(startPosition, endPosition);
        this.isSelectCurrentWord = false;
    }
    /**
     * Selects the current paragraph.
     *
     * @returns {void}
     */
    selectParagraph() {
        if (!isNullOrUndefined(this.start)) {
            this.start.paragraphStartInternal(this, false);
            this.end.moveToParagraphEndInternal(this, false);
            this.upDownSelectionLength = this.end.location.x;
            this.fireSelectionChanged(true);
        }
    }
    /**
     * Selects the current line.
     *
     * @returns {void}
     */
    selectLine() {
        if (!isNullOrUndefined(this.start) && this.start.paragraph.isInsideTable) {
            let lastPara = this.getLastParagraph(this.start.paragraph.associatedCell);
            if (!isNullOrUndefined(lastPara) && lastPara.lastChild === this.start.paragraph.lastChild && this.start.paragraph.isEmpty()) {
                return;
            }
        }
        if (!isNullOrUndefined(this.start)) {
            this.isSelectLine = true;
            this.moveToLineStart();
            this.handleShiftEndKey();
            this.isSelectLine = false;
        }
    }
    /**
     * Moves the selection to the start of the document.
     *
     * @returns {void}
     */
    moveToDocumentStart() {
        this.handleControlHomeKey();
    }
    /**
     * Moves the selection to the end of the document.
     *
     * @returns {void}
     */
    moveToDocumentEnd() {
        this.handleControlEndKey();
    }
    /**
     * Moves the selection to the current paragraph start.
     *
     * @returns {void}
     */
    moveToParagraphStart() {
        if (this.isForward) {
            this.start.paragraphStartInternal(this, false);
            this.end.setPositionInternal(this.start);
            this.upDownSelectionLength = this.end.location.x;
        }
        else {
            this.end.paragraphStartInternal(this, false);
            this.start.setPositionInternal(this.end);
            this.upDownSelectionLength = this.start.location.x;
        }
        this.fireSelectionChanged(true);
    }
    /**
     * Moves the selection to the current paragraph end.
     *
     * @returns {void}
     */
    moveToParagraphEnd() {
        if (this.isForward) {
            this.start.moveToParagraphEndInternal(this, false);
            this.end.setPositionInternal(this.start);
            this.upDownSelectionLength = this.end.location.x;
        }
        else {
            this.end.moveToParagraphEndInternal(this, false, true);
            this.start.setPositionInternal(this.end);
            this.upDownSelectionLength = this.start.location.x;
        }
        this.fireSelectionChanged(true);
    }
    /**
     * Moves the selection to the next line.
     *
     * @returns {void}
     */
    moveToNextLine() {
        this.moveDown();
    }
    /**
     * Moves the selection to the previous line.
     *
     * @returns {void}
     */
    moveToPreviousLine() {
        this.moveUp();
    }
    /**
     * Moves the selection to the next character.
     *
     * @returns {void}
     */
    moveToNextCharacter() {
        this.handleRightKey();
    }
    /**
     * Moves the selection to the previous character.
     *
     * @returns {void}
     */
    moveToPreviousCharacter() {
        this.handleLeftKey();
    }
    selectCurrentWordRange(startPosition, endPosition, excludeSpace) {
        if (!isNullOrUndefined(startPosition)) {
            if (startPosition.offset > 0) {
                const wordStart = startPosition.clone();
                let indexInInline = 0;
                const inlineObj = startPosition.currentWidget.getInline(startPosition.offset, indexInInline);
                const inline = inlineObj.element;
                indexInInline = inlineObj.index;
                if (!isNullOrUndefined(inline) && inline instanceof FieldElementBox && inline.fieldType === 1) {
                    if (startPosition.offset > 2 && (!isNullOrUndefined(inline.fieldSeparator) || isNullOrUndefined(inline.fieldBegin))) {
                        wordStart.setPositionParagraph(wordStart.currentWidget, startPosition.offset - 2);
                        wordStart.moveToWordEndInternal(0, false);
                        if (!(wordStart.paragraph === startPosition.paragraph && wordStart.offset === startPosition.offset - 1)) {
                            startPosition.moveToWordStartInternal(2);
                        }
                    }
                    else if (startPosition.offset > 3 && isNullOrUndefined(inline.fieldSeparator)) {
                        wordStart.setPositionParagraph(wordStart.currentWidget, startPosition.offset - 3);
                        wordStart.moveToWordEndInternal(0, false);
                        if (!(wordStart.paragraph === startPosition.paragraph && wordStart.offset === startPosition.offset)) {
                            startPosition.moveToWordStartInternal(2);
                        }
                    }
                }
                else {
                    wordStart.setPositionParagraph(wordStart.currentWidget, startPosition.offset - 1);
                    wordStart.moveToWordEndInternal(0, false);
                    if (!(wordStart.paragraph === startPosition.paragraph && wordStart.offset === startPosition.offset)) {
                        startPosition.moveToWordStartInternal(2);
                    }
                }
            }
            endPosition.moveToWordEndInternal(2, excludeSpace);
        }
    }
    /**
     * Extends the selection to the paragraph start.
     *
     * @returns {void}
     */
    extendToParagraphStart() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.paragraphStartInternal(this, true);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to the paragraph end.
     *
     * @returns {void}
     */
    extendToParagraphEnd() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToParagraphEndInternal(this, true);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Move to next text position
     *
     * @private
     * @returns {void}
     */
    moveNextPosition() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        if (this.isEmpty) {
            this.start.moveNextPosition();
            this.end.setPositionInternal(this.start);
        }
        this.updateForwardSelection();
        this.upDownSelectionLength = this.start.location.x;
        this.fireSelectionChanged(true);
        if (this.documentHelper.isFormFillProtectedMode) {
            let formField = this.getCurrentFormField();
            if (!formField) {
                formField = this.getFormFieldInFormFillMode();
                this.selectPrevNextFormField(true, formField);
            }
        }
        if ((!isNullOrUndefined(this.previousSelectedContentControl) || !isNullOrUndefined(this.currentContentControl)) && this.previousSelectedContentControl !== this.currentContentControl) {
            this.documentHelper.viewer.updateScrollBars();
        }
    }
    /**
     * Move to next paragraph
     *
     * @private
     * @returns {void}
     */
    moveToNextParagraph() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToNextParagraphStartInternal();
        this.start.setPositionInternal(this.end);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Navigates to the next footnote from the current selection.
     *
     * @returns {void}
     */
    nextFootnote() {
        if (this.isinFootnote) {
            const footNoteElement = this.start.paragraph.bodyWidget.footNoteReference;
            const colLength = this.documentHelper.footnoteCollection.length;
            const indexCount = this.documentHelper.footnoteCollection.indexOf(footNoteElement);
            let nextFootnoteElement = this.documentHelper.footnoteCollection[indexCount + 1];
            if (isNullOrUndefined(nextFootnoteElement)) {
                nextFootnoteElement = footNoteElement;
            }
            const start = this.start.clone();
            const end = this.end.clone();
            for (let i = 0; i < this.documentHelper.pages.length; i++) {
                const referenceElement = this.documentHelper.pages[i].footnoteWidget;
                for (let j = 1; j < referenceElement.bodyWidgets.length; j++) {
                    const element = (referenceElement.bodyWidgets[j]).footNoteReference;
                    if (element === nextFootnoteElement) {
                        start.setPositionParagraph(referenceElement.bodyWidgets[j].childWidgets[0].childWidgets[0], 0);
                        end.setPositionInternal(start);
                        this.selectRange(start, end);
                    }
                }
            }
        }
    }
    /**
     * Navigates to the previous footnote from the current selection.
     *
     * @returns {void}
     */
    previousFootnote() {
        if (this.isinFootnote) {
            const footNoteElement = this.start.paragraph.bodyWidget.footNoteReference;
            const colLength = this.documentHelper.footnoteCollection.length;
            const indexCount = this.documentHelper.footnoteCollection.indexOf(footNoteElement);
            let previousFootnote = this.documentHelper.footnoteCollection[indexCount - 1];
            if (isNullOrUndefined(previousFootnote)) {
                previousFootnote = footNoteElement;
            }
            const startPosition = this.start.clone();
            const endPosition = this.end.clone();
            for (let i = 0; i < this.documentHelper.pages.length; i++) {
                const footnote = this.documentHelper.pages[i].footnoteWidget;
                for (let j = 1; j < footnote.bodyWidgets.length; j++) {
                    const element = (footnote.bodyWidgets[j]).footNoteReference;
                    if (element === previousFootnote) {
                        startPosition.setPositionParagraph(footnote.bodyWidgets[j].childWidgets[0].childWidgets[0], 0);
                        endPosition.setPositionInternal(startPosition);
                        this.selectRange(startPosition, endPosition);
                    }
                }
            }
        }
    }
    /**
     * Navigates to the next endnote from the current selection
     *
     * @returns {void}
     */
    nextEndnote() {
        if (this.isinEndnote) {
            const endNoteElement = this.start.paragraph.bodyWidget.footNoteReference;
            const indexCount = this.documentHelper.endnoteCollection.indexOf(endNoteElement);
            let nextEndnote = this.documentHelper.endnoteCollection[indexCount + 1];
            if (isNullOrUndefined(nextEndnote)) {
                nextEndnote = endNoteElement;
            }
            const startPosition = this.start.clone();
            const endPosition = this.end.clone();
            const endnoteElement = this.documentHelper.pages[this.endPage - 1].endnoteWidget;
            for (let j = 0; j < endnoteElement.childWidgets.length; j++) {
                const element = (endnoteElement.bodyWidgets[j]).footNoteReference;
                if (element === nextEndnote) {
                    startPosition.setPositionParagraph(endnoteElement.bodyWidgets[j].childWidgets[0].childWidgets[0], 0);
                    endPosition.setPositionInternal(startPosition);
                    this.selectRange(startPosition, endPosition);
                }
            }
        }
    }
    /**
     * Navigates to the previous endnote from the current selection.
     *
     * @returns {void}
     */
    previousEndnote() {
        if (this.isinEndnote) {
            const endNoteElement = this.start.paragraph.bodyWidget.footNoteReference;
            const indexCount = this.documentHelper.endnoteCollection.indexOf(endNoteElement);
            let inline = this.documentHelper.endnoteCollection[indexCount - 1];
            if (isNullOrUndefined(inline)) {
                inline = endNoteElement;
            }
            const startPosition = this.start.clone();
            const endPosition = this.end.clone();
            const referenceElement = this.documentHelper.pages[this.endPage - 1].endnoteWidget;
            for (let j = 0; j < referenceElement.childWidgets.length; j++) {
                const element = (referenceElement.bodyWidgets[j]).footNoteReference;
                if (element === inline) {
                    startPosition.setPositionParagraph(referenceElement.bodyWidgets[j].childWidgets[0].childWidgets[0], 0);
                    endPosition.setPositionInternal(startPosition);
                    this.selectRange(startPosition, endPosition);
                }
            }
        }
    }
    /**
     * Move to previous text position
     *
     * @private
     * @returns {void}
     */
    movePreviousPosition() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        if (this.isEmpty) {
            this.start.movePreviousPosition();
            this.end.setPositionInternal(this.start);
        }
        this.updateBackwardSelection();
        this.upDownSelectionLength = this.start.location.x;
        this.fireSelectionChanged(true);
        if (this.documentHelper.isFormFillProtectedMode) {
            let formField = this.getCurrentFormField();
            if (!formField) {
                formField = this.getFormFieldInFormFillMode();
                this.selectPrevNextFormField(false, formField);
            }
        }
        if ((!isNullOrUndefined(this.previousSelectedContentControl) || !isNullOrUndefined(this.currentContentControl)) && this.previousSelectedContentControl !== this.currentContentControl) {
            this.documentHelper.viewer.updateScrollBars();
        }
    }
    /**
     * Move to previous paragraph
     *
     * @private
     * @returns {void}
     */
    moveToPreviousParagraph() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToPreviousParagraph(this);
        this.start.setPositionInternal(this.end);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to previous line.
     *
     * @returns {void}
     */
    extendToPreviousLine() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToPreviousLine(this, this.upDownSelectionLength);
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to line end
     *
     * @returns {void}
     */
    extendToLineEnd() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToLineEndInternal(this, true);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to line start.
     *
     * @returns {void}
     */
    extendToLineStart() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToLineStartInternal(this, true);
        this.upDownSelectionLength = this.end.location.x;
        // To select Paragraph mark similar to MS WORD
        if (this.start.paragraph === this.end.paragraph && this.start.offset === this.start.currentWidget.getEndOffset()
            && this.isParagraphLastLine(this.start.currentWidget) && this.isParagraphFirstLine(this.end.currentWidget)) {
            this.start.setPositionParagraph(this.start.currentWidget, this.start.offset + 1);
        }
        this.fireSelectionChanged(true);
    }
    /**
     * @private
     * @returns {void}
     */
    moveUp() {
        if (this.documentHelper.isFormFillProtectedMode) {
            this.selectPrevNextFormField(false);
            return;
        }
        if (isNullOrUndefined(this.start)) {
            return;
        }
        if (!this.isEmpty) {
            if (this.isForward) {
                this.end.setPositionInternal(this.start);
            }
            else {
                this.start.setPositionInternal(this.end);
            }
            this.upDownSelectionLength = this.start.location.x;
        }
        this.upDownSelectionLength = this.start.location.x;
        if (this.isMoveDownOrMoveUp) {
            this.upDownSelLength = this.upDownSelLength === 0 ? this.upDownSelectionLength : this.upDownSelLength;
            this.upDownSelectionLength = this.upDownSelLength;
        }
        let beforeUp = this.start.currentWidget.paragraph.bodyWidget.columnIndex;
        let isMultiColumn = this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns > 1 ? true : false;
        let beforeIndex = this.start.currentWidget.paragraph.bodyWidget.index;
        this.start.moveUp(this, this.upDownSelectionLength);
        isMultiColumn = this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns > 1 ? true : false;
        let afterUp = this.start.currentWidget.paragraph.bodyWidget.columnIndex;
        if (isMultiColumn) {
            if (beforeUp === afterUp || beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns === 1) {
                this.end.setPositionInternal(this.start);
            }
            else {
                do {
                    if (isNullOrUndefined(this.start.currentWidget.paragraph.previousRenderedWidget) || (beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns === 1)) {
                        break;
                    }
                    if (beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns > 1 && beforeUp > this.start.currentWidget.paragraph.bodyWidget.columnIndex) {
                        break;
                    }
                    this.start.moveUp(this, this.upDownSelectionLength);
                } while (beforeUp !== this.start.currentWidget.paragraph.bodyWidget.columnIndex);
            }
        }
        this.end.setPositionInternal(this.start);
        this.fireSelectionChanged(true);
    }
    /**
     * @private
     * @returns {void}
     */
    moveDown() {
        if (this.documentHelper.isFormFillProtectedMode) {
            this.selectPrevNextFormField(true);
            return;
        }
        if (isNullOrUndefined(this.start)) {
            return;
        }
        if (!this.isEmpty) {
            if (this.isForward) {
                this.start.setPositionInternal(this.end);
            }
            else {
                this.end.setPositionInternal(this.start);
            }
            this.upDownSelectionLength = this.start.location.x;
        }
        this.upDownSelectionLength = this.start.location.x;
        if (this.isMoveDownOrMoveUp) {
            this.upDownSelLength = this.upDownSelLength === 0 ? this.upDownSelectionLength : this.upDownSelLength;
            this.upDownSelectionLength = this.upDownSelLength;
        }
        let beforeDown = this.start.currentWidget.paragraph.bodyWidget.columnIndex;
        let beforeIndex = this.start.currentWidget.paragraph.bodyWidget.index;
        let isMultiColumn = this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns > 1 ? true : false;
        this.start.moveDown(this, this.upDownSelectionLength);
        let afterDown = this.start.currentWidget.paragraph.bodyWidget.columnIndex;
        if (isMultiColumn) {
            if (beforeDown === afterDown || beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns === 1) {
                this.end.setPositionInternal(this.start);
            }
            else {
                do {
                    if (isNullOrUndefined(this.start.currentWidget.paragraph.nextRenderedWidget) || (beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns === 1)) {
                        break;
                    }
                    if (beforeIndex !== this.start.currentWidget.paragraph.bodyWidget.index && this.start.currentWidget.paragraph.bodyWidget.sectionFormat.numberOfColumns > 1 && this.documentHelper.layout.getBodyWidget(this.start.currentWidget.paragraph.bodyWidget, false) === this.start.currentWidget.paragraph.bodyWidget) {
                        break;
                    }
                    this.start.moveDown(this, this.upDownSelectionLength);
                } while (beforeDown !== this.start.currentWidget.paragraph.bodyWidget.columnIndex);
            }
        }
        this.end.setPositionInternal(this.start);
        this.fireSelectionChanged(true);
    }
    updateForwardSelection() {
        if (!this.isEmpty) {
            if (this.isForward) {
                this.start.setPositionInternal(this.end);
            }
            else {
                this.end.setPositionInternal(this.start);
            }
        }
    }
    updateBackwardSelection() {
        if (!this.isEmpty) {
            if (this.isForward) {
                this.end.setPositionInternal(this.start);
            }
            else {
                this.start.setPositionInternal(this.end);
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    getFirstBlockInFirstCell(table) {
        if (table.childWidgets.length > 0) {
            const firstrow = table.childWidgets[0];
            for (let i = 0; i < firstrow.childWidgets.length; i++) {
                const firstcell = firstrow.childWidgets[i];
                if (firstcell.childWidgets.length > 0) {
                    return firstcell.childWidgets[0];
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     * @returns {void}
     */
    getFirstCellInRegion(row, startCell, selectionLength, isMovePrevious) {
        const cellStart = this.getCellLeft(row, startCell);
        const cellEnd = cellStart + startCell.cellFormat.cellWidth;
        let flag = true;
        if (cellStart <= selectionLength && selectionLength < cellEnd) {
            for (let k = 0; k < row.childWidgets.length; k++) {
                const left = this.getCellLeft(row, row.childWidgets[k]);
                if (HelperMethods.round(cellStart, 2) <= HelperMethods.round(left, 2) &&
                    HelperMethods.round(left, 2) < HelperMethods.round(cellEnd, 2)) {
                    flag = false;
                    return row.childWidgets[k];
                }
            }
        }
        else {
            for (let j = 0; j < row.childWidgets.length; j++) {
                const cellLeft = this.getCellLeft(row, row.childWidgets[j]);
                if (cellLeft <= selectionLength && cellLeft +
                    row.childWidgets[j].cellFormat.cellWidth > selectionLength) {
                    flag = false;
                    return row.childWidgets[j];
                }
            }
        }
        if (flag) {
            if (!isNullOrUndefined(row.previousRenderedWidget) && isMovePrevious) {
                const previousWidget = row.previousRenderedWidget;
                return this.getFirstCellInRegion(previousWidget, startCell, selectionLength, isMovePrevious);
            }
            else if (!isNullOrUndefined(row.nextRenderedWidget) && !isMovePrevious) {
                return this.getFirstCellInRegion(row.nextRenderedWidget, startCell, selectionLength, isMovePrevious);
            }
        }
        return row.childWidgets[0];
    }
    /**
     * @private
     * @returns {void}
     */
    getFirstParagraph(tableCell) {
        while (tableCell.previousSplitWidget && tableCell.previousSplitWidget.childWidgets.length > 0) {
            tableCell = tableCell.previousSplitWidget;
        }
        const firstBlock = tableCell.firstChild;
        return this.documentHelper.getFirstParagraphBlock(firstBlock);
    }
    /**
     * Get last block in last cell
     *
     * @private
     * @returns {void}
     */
    //Table
    getLastBlockInLastCell(table, checkSpannedCell) {
        if (table.childWidgets.length > 0) {
            const lastRow = table.childWidgets[table.childWidgets.length - 1];
            let lastCell = lastRow.childWidgets[lastRow.childWidgets.length - 1];
            while (lastCell.childWidgets.length === 0 && checkSpannedCell ? !isNullOrUndefined(lastCell.previousWidget) : !isNullOrUndefined(lastCell.previousSplitWidget)) {
                lastCell = checkSpannedCell ? lastCell.previousWidget : lastCell.previousSplitWidget;
            }
            return lastCell.childWidgets[lastCell.childWidgets.length - 1];
        }
        return undefined;
    }
    /**
     * Moves the selection to start of the current line.
     *
     * @returns {void}
     */
    moveToLineStart() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.updateBackwardSelection();
        this.start.moveToLineStartInternal(this, false);
        this.end.setPositionInternal(this.start);
        this.upDownSelectionLength = this.start.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Moves the selection to end of the current line.
     *
     * @returns {void}
     */
    moveToLineEnd() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.updateForwardSelection();
        this.start.moveToLineEndInternal(this, false);
        this.end.setPositionInternal(this.start);
        this.upDownSelectionLength = this.start.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Get Page top
     *
     * @private
     * @returns {void}
     */
    getPageTop(page) {
        return (page.boundingRectangle.y - this.viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1)) * this.documentHelper.zoomFactor + this.viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1);
    }
    /**
     * Move text position to cursor point
     *
     * @private
     * @returns {void}
     */
    moveTextPosition(cursorPoint, textPosition, isMouseLeave) {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        //Updates the text position based on the cursor position.
        const widget = this.documentHelper.getLineWidgetInternal(cursorPoint, true);
        const startIndex = this.start.getHierarchicalIndexInternal();
        const endIndex = this.end.getHierarchicalIndexInternal();
        const isForward = TextPosition.isForwardSelection(startIndex, endIndex);
        if (!isNullOrUndefined(widget)) {
            this.updateTextPositionWidget(widget, cursorPoint, textPosition, isForward);
        }
        this.upDownSelectionLength = textPosition.location.x;
        const selectionStartIndex = this.start.getHierarchicalIndexInternal();
        const selectionEndIndex = this.end.getHierarchicalIndexInternal();
        if (selectionStartIndex !== selectionEndIndex && !isMouseLeave) {
            // Extends selection end to field begin or field end.
            if (TextPosition.isForwardSelection(selectionStartIndex, selectionEndIndex)) {
                textPosition.validateForwardFieldSelection(selectionStartIndex, selectionEndIndex);
            }
            else {
                textPosition.validateBackwardFieldSelection(selectionStartIndex, selectionEndIndex);
            }
        }
        this.fireSelectionChanged(true);
    }
    //Helper Method Implementation
    //Document
    /**
     * Get document start position
     *
     * @private
     * @returns {TextPosition}
     */
    getDocumentStart() {
        const textPosition = undefined;
        const block = this.documentHelper.pages[0].bodyWidgets[0].childWidgets[0];
        return this.setPositionForBlock(block, true);
    }
    /**
     * Get document end position
     *
     * @private
     * @returns {TextPosition}
     */
    getDocumentEnd() {
        let textPosition = undefined;
        const documentStart = this.owner.documentStart;
        let lastPage = this.documentHelper.pages[this.documentHelper.pages.length - 1];
        // Bug 893168: If the length of the page's body widgets is 1 and the length of the child widgets is 0, then it is necessary to check the previous page.
        while (lastPage.previousPage && lastPage.bodyWidgets.length === 1
            && lastPage.bodyWidgets[0].childWidgets.length === 0) {
            lastPage = lastPage.previousPage;
        }
        if (!isNullOrUndefined(documentStart) && lastPage.bodyWidgets[lastPage.bodyWidgets.length - 1].childWidgets.length > 0) {
            let block = undefined;
            const section = lastPage.bodyWidgets[lastPage.bodyWidgets.length - 1];
            const blocks = section.childWidgets;
            const lastBlkItem = blocks.length - 1;
            const lastBlock = blocks[lastBlkItem];
            if (lastBlock instanceof BlockWidget) {
                block = lastBlock;
            }
            textPosition = this.setPositionForBlock(block, false);
        }
        return textPosition;
    }
    //Keyboard shortcut internal API
    /**
     * @private
     * @returns {void}
     */
    handleControlEndKey() {
        this.isHomeEnd = true;
        let documentEnd = undefined;
        if (!isNullOrUndefined(this.owner.documentEnd)) {
            documentEnd = this.owner.documentEnd;
        }
        if (!isNullOrUndefined(documentEnd)) {
            this.owner.selectionModule.selectContent(documentEnd, true);
        }
        if (this.owner.enableAutoFocus) {
            this.checkForCursorVisibility();
        }
        this.isHomeEnd = false;
    }
    /**
     * @private
     * @returns {void}
     */
    handleControlHomeKey() {
        this.isHomeEnd = true;
        let documentStart = undefined;
        if (!isNullOrUndefined(this.owner.documentStart)) {
            documentStart = this.owner.documentStart;
        }
        if (!isNullOrUndefined(documentStart)) {
            this.owner.selectionModule.selectContent(documentStart, true);
        }
        if (this.owner.enableAutoFocus) {
            this.checkForCursorVisibility();
        }
        this.isHomeEnd = false;
    }
    /**
     * @private
     * @returns {void}
     */
    handleControlLeftKey() {
        this.extendToWordStartInternal(true);
        this.checkForCursorVisibility();
    }
    /**
     * @private
     * @returns {void}
     */
    handleControlRightKey() {
        this.extendToWordEndInternal(true);
        this.checkForCursorVisibility();
    }
    /**
     * Handles control down key.
     *
     * @private
     * @returns {void}
     */
    handleControlDownKey() {
        this.moveToNextParagraph();
        this.checkForCursorVisibility();
    }
    /**
     * Handles control up key.
     *
     * @private
     * @returns {void}
     */
    handleControlUpKey() {
        this.moveToPreviousParagraph();
        this.checkForCursorVisibility();
    }
    /**
     * @private
     * @returns {void}
     */
    handleShiftLeftKey() {
        this.extendBackward();
        this.checkForCursorVisibility();
    }
    /**
     * Handles shift up key.
     *
     * @private
     * @returns {void}
     */
    handleShiftUpKey() {
        this.extendToPreviousLine();
        this.checkForCursorVisibility();
    }
    /**
     * Handles shift right key.
     *
     * @private
     * @returns {void}
     */
    handleShiftRightKey() {
        this.extendForward();
        this.checkForCursorVisibility();
    }
    /**
     * Handles shift down key.
     *
     * @private
     * @returns {void}
     */
    handleShiftDownKey() {
        this.extendToNextLine();
        this.checkForCursorVisibility();
    }
    /**
     * @private
     * @returns {void}
     */
    handleControlShiftLeftKey() {
        const isForward = this.isForward ? this.start.isCurrentParaBidi : this.end.isCurrentParaBidi;
        if (isForward) {
            this.extendToWordEndInternal(false);
        }
        else {
            this.extendToWordStartInternal(false);
        }
        this.checkForCursorVisibility();
    }
    /**
     * Handles control shift up key.
     *
     * @private
     * @returns {void}
     */
    handleControlShiftUpKey() {
        this.extendToParagraphStart();
        this.checkForCursorVisibility();
    }
    /**
     * Handles control shift right key
     *
     * @private
     * @returns {void}
     */
    handleControlShiftRightKey() {
        const isForward = this.isForward ? this.start.isCurrentParaBidi : this.end.isCurrentParaBidi;
        if (isForward) {
            this.extendToWordStartInternal(false);
        }
        else {
            this.extendToWordEndInternal(false);
        }
        this.checkForCursorVisibility();
    }
    /**
     * Handles control shift down key.
     *
     * @private
     * @returns {void}
     */
    handleControlShiftDownKey() {
        this.extendToParagraphEnd();
        this.checkForCursorVisibility();
    }
    /**
     * Handles left key.
     *
     * @private
     * @returns {void}
     */
    handleLeftKey() {
        if (this.end.isCurrentParaBidi) {
            this.moveNextPosition();
        }
        else {
            this.movePreviousPosition();
        }
        if (this.owner.enableAutoFocus) {
            this.checkForCursorVisibility();
        }
    }
    /**
     * Handles up key.
     *
     * @private
     * @returns {void}
     */
    handleUpKey() {
        this.isMoveDownOrMoveUp = true;
        this.moveUp();
        this.isMoveDownOrMoveUp = false;
        this.checkForCursorVisibility();
    }
    /**
     * Handles right key.
     *
     * @private
     * @returns {void}
     */
    handleRightKey() {
        if (this.end.isCurrentParaBidi) {
            this.movePreviousPosition();
        }
        else {
            this.moveNextPosition();
        }
        if (this.owner.enableAutoFocus) {
            this.checkForCursorVisibility();
        }
    }
    /**
     * Handles end key.
     *
     * @private
     * @returns {void}
     */
    handleEndKey() {
        this.isHomeEnd = true;
        this.moveToLineEnd();
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * Handles home key.
     *
     * @private
     * @returns {void}
     */
    handleHomeKey() {
        this.isHomeEnd = true;
        this.moveToLineStart();
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * Handles down key.
     *
     * @private
     * @returns {void}
     */
    handleDownKey() {
        this.isMoveDownOrMoveUp = true;
        this.moveDown();
        this.isMoveDownOrMoveUp = false;
        this.checkForCursorVisibility();
    }
    /**
     * Handles shift end key.
     *
     * @private
     * @returns {void}
     */
    handleShiftEndKey() {
        this.isHomeEnd = true;
        this.extendToLineEnd();
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * Handles shift home key.
     *
     * @private
     * @returns {void}
     */
    handleShiftHomeKey() {
        this.isHomeEnd = true;
        this.extendToLineStart();
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * Handles control shift end key.
     *
     * @private
     * @returns {void}
     */
    handleControlShiftEndKey() {
        this.isHomeEnd = true;
        let documentEnd = undefined;
        if (!isNullOrUndefined(this.owner.documentEnd)) {
            documentEnd = this.owner.documentEnd;
        }
        if (!isNullOrUndefined(documentEnd)) {
            this.end.setPosition(documentEnd.currentWidget, false);
            this.fireSelectionChanged(true);
        }
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * Handles control shift home key.
     *
     * @private
     * @returns {void}
     */
    handleControlShiftHomeKey() {
        this.isHomeEnd = true;
        let documentStart = undefined;
        if (!isNullOrUndefined(this.owner.documentStart)) {
            documentStart = this.owner.documentStart;
        }
        if (!isNullOrUndefined(documentStart)) {
            this.end.setPositionInternal(documentStart);
            this.fireSelectionChanged(true);
        }
        this.checkForCursorVisibility();
        this.isHomeEnd = false;
    }
    /**
     * @private
     * @returns {void}
     */
    handleSpaceBarKey() {
        if (this.owner.documentHelper.isDocumentProtected && this.owner.documentHelper.protectionType === 'FormFieldsOnly'
            && this.getFormFieldType() === 'CheckBox') {
            this.owner.editorModule.toggleCheckBoxFormField(this.getCurrentFormField());
        }
    }
    /**
     *  @private
     * @returns {number}
     */
    getSelectedFieldWidth(start) {
        let fieldResultWidth = 0;
        if (this.isInField || (!start.paragraph.isEmpty() && start.currentWidget.children[0] instanceof ContentControl)) {
            let fieldStart = undefined;
            for (let i = 0; i < start.currentWidget.children.length; i++) {
                if (start.currentWidget.children[i] instanceof FieldElementBox && start.currentWidget.children[i].fieldType === 0) {
                    fieldStart = start.currentWidget.children[i];
                    break;
                }
                else if (start.currentWidget.children[i] instanceof TextElementBox) {
                    break;
                }
            }
            if (!isNullOrUndefined(fieldStart)) {
                let fieldCode = this.owner.selectionModule.getFieldCode(fieldStart);
                if (fieldCode.match('PAGE') && !isNullOrUndefined(fieldStart.fieldSeparator) && !isNullOrUndefined(fieldStart.fieldSeparator.nextElement)) {
                    fieldResultWidth = fieldStart.fieldSeparator.nextElement.width + HelperMethods.convertPointToPixel(this.documentHelper.defaultTabWidth);
                }
            }
        }
        return fieldResultWidth;
    }
    /**
     * Handles tab key.
     *
     * @param isNavigateInCell
     * @param isShiftTab
     * @private
     * @returns {void}
     */
    handleTabKey(isNavigateInCell, isShiftTab) {
        let start = this.start;
        if (!this.isForward) {
            start = this.end;
        }
        let isCursorAtParaStart = false;
        let isCursorAtLineStart = false;
        if (isNullOrUndefined(start)) {
            return;
        }
        if ((start.offset === 0 || (!this.isForward && this.end.offset === 0)) && start.paragraph.paragraphFormat.listFormat.listId == -1) {
            if (start.currentWidget.isFirstLine()) {
                isCursorAtParaStart = true;
            }
            isCursorAtLineStart = true;
        }
        if (this.start.paragraph.isInsideTable && this.end.paragraph.isInsideTable && (isNavigateInCell || isShiftTab)) {
            //Perform tab navigation
            if (!this.owner.documentHelper.isDocumentProtected && !(this.documentHelper.protectionType === 'FormFieldsOnly')) {
                if (isShiftTab) {
                    this.selectPreviousCell();
                }
                else {
                    this.selectNextCell();
                }
            }
        }
        else if ((isNavigateInCell || isShiftTab) && !isNullOrUndefined(start) && start.offset === this.getStartOffset(start.paragraph)
            && !isNullOrUndefined(start.paragraph.paragraphFormat) && !isNullOrUndefined(start.paragraph.paragraphFormat.listFormat)
            && start.paragraph.paragraphFormat.listFormat.listId !== -1 && !this.owner.isReadOnlyMode) {
            let selection = this.documentHelper.selection;
            let currentPara = start.paragraph;
            let isFirstParaForList = false;
            if (!selection.isForward) {
                currentPara = selection.end.paragraph;
            }
            isFirstParaForList = this.owner.editorModule.isFirstParaForList(selection, currentPara);
            if (isFirstParaForList) {
                if (isShiftTab) {
                    this.owner.editorModule.updateListLevelIndent(-this.documentHelper.defaultTabWidth, currentPara);
                }
                else {
                    this.owner.editorModule.updateListLevelIndent(this.documentHelper.defaultTabWidth, currentPara);
                }
            }
            else {
                this.owner.editorModule.updateListLevel(isShiftTab ? false : true);
            }
        }
        else if (!this.owner.isReadOnlyMode && !this.documentHelper.isFormFillProtectedMode) {
            if (isCursorAtParaStart && start.paragraph.paragraphFormat.firstLineIndent < this.documentHelper.defaultTabWidth && !start.paragraph.isEmpty()) {
                if (this.owner.selection.isEmpty && start.paragraph.paragraphFormat.tabs && start.paragraph.paragraphFormat.tabs.length > 0) {
                    this.owner.editorModule.handleTextInput('\t');
                }
                else {
                    this.documentHelper.owner.editorModule.onApplyParagraphFormat('firstLineIndent', this.documentHelper.defaultTabWidth, true, false);
                }
            }
            else if (isCursorAtLineStart && !start.paragraph.isEmpty()) {
                if (isShiftTab) {
                    this.owner.editorModule.decreaseIndent();
                }
                else {
                    if ((HelperMethods.convertPointToPixel(start.paragraph.paragraphFormat.firstLineIndent + start.paragraph.paragraphFormat.leftIndent) + this.getSelectedFieldWidth(start)) < this.documentHelper.viewer.clientArea.width) {
                        this.owner.editorModule.increaseIndent();
                    }
                }
            }
            else {
                this.owner.editorModule.handleTextInput('\t');
            }
        }
        if (this.documentHelper.protectionType === 'FormFieldsOnly' && this.documentHelper.formFields.length > 0) {
            this.selectPrevNextFormField(!isShiftTab);
        }
        this.checkForCursorVisibility();
    }
    /**
    * @private
    * @returns {void}
    */
    handlePageUpPageDownKey(isPageDown, shiftKey) {
        this.isPageUpAndDown = true;
        let offsetX = this.end.location.x;
        let offsetY = this.end.location.y;
        let page = this.end.paragraph.bodyWidget.page;
        let pageTop = this.getPageTop(page);
        let previousScrollTop = this.documentHelper.viewerContainer.scrollTop;
        offsetY = (offsetY * this.documentHelper.zoomFactor) + (pageTop - previousScrollTop);
        offsetX = (offsetX * this.documentHelper.zoomFactor) + page.boundingRectangle.x;
        if (isPageDown) {
            this.documentHelper.viewerContainer.scrollTop += this.documentHelper.visibleBounds.height;
        }
        else {
            this.documentHelper.viewerContainer.scrollTop -= this.documentHelper.visibleBounds.height;
        }
        let isSameScrollTop = false;
        if (previousScrollTop === this.documentHelper.viewerContainer.scrollTop) {
            isSameScrollTop = true;
        }
        if (shiftKey) {
            this.documentHelper.skipScrollToPosition = true;
        }
        if (isSameScrollTop) {
            if (!shiftKey) {
                if (isPageDown)
                    this.moveToDocumentEnd();
                else
                    this.moveToDocumentStart();
            }
            else {
                let position;
                if (isPageDown) {
                    position = this.getDocumentEnd();
                }
                else {
                    position = this.getDocumentStart();
                }
                this.end.setPositionForLineWidget(position.currentWidget, position.offset);
                this.fireSelectionChanged(true);
            }
        }
        else {
            this.select({ x: offsetX, y: offsetY, extend: shiftKey });
        }
        this.isPageUpAndDown = true;
    }
    // returns current field in FormFill mode
    getFormFieldInFormFillMode() {
        const currentStart = this.owner.selectionModule.start;
        let formField;
        for (let i = (this.documentHelper.formFields.length - 1); i >= 0; i--) {
            if (!this.documentHelper.formFields[i].formFieldData.enabled) {
                continue;
            }
            const paraIndex = this.getElementPosition(this.documentHelper.formFields[i]).startPosition;
            if (paraIndex.isExistBefore(currentStart)) {
                formField = this.documentHelper.formFields[i];
                break;
            }
            else if (i === 0) {
                formField = this.documentHelper.formFields[(this.documentHelper.formFields.length - 1)];
            }
        }
        return formField;
    }
    // Navigates & Selects next form field
    selectPrevNextFormField(forward, formField) {
        if (this.documentHelper.isFormFillProtectedMode) {
            if (!formField) {
                formField = this.getCurrentFormField();
            }
            const index = this.documentHelper.formFields.indexOf(formField);
            if (index !== -1) {
                if (forward) {
                    for (let i = index;; i++) {
                        if (i === (this.documentHelper.formFields.length - 1)) {
                            i = 0;
                        }
                        else {
                            i = i + 1;
                        }
                        if (!this.documentHelper.formFields[i].formFieldData.enabled) {
                            i = i - 1;
                            continue;
                        }
                        this.selectFieldInternal(this.documentHelper.formFields[i], true);
                        break;
                    }
                }
                else {
                    for (let i = index;; i--) {
                        if (i === 0) {
                            i = (this.documentHelper.formFields.length - 1);
                        }
                        else {
                            i = i - 1;
                        }
                        if (!this.documentHelper.formFields[i].formFieldData.enabled) {
                            i = i + 1;
                            continue;
                        }
                        this.selectFieldInternal(this.documentHelper.formFields[i], true);
                        break;
                    }
                }
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    navigateToNextFormField() {
        const currentStart = this.owner.selectionModule.end;
        let currentFormField;
        for (let i = 0; i < this.documentHelper.formFields.length; i++) {
            currentFormField = this.documentHelper.formFields[i];
            if (!this.documentHelper.formFields[i].formFieldData.enabled) {
                continue;
            }
            const paraIndex = this.getElementPosition(this.documentHelper.formFields[i]).startPosition;
            if (paraIndex.isExistAfter(currentStart)) {
                if (currentFormField.formFieldData instanceof TextFormField && currentFormField.formFieldData.type === 'Text' &&
                    this.documentHelper.isInlineFormFillProtectedMode) {
                    this.selectTextElementStartOfField(this.documentHelper.formFields[i]);
                }
                else {
                    this.selectFieldInternal(this.documentHelper.formFields[i]);
                }
                break;
            }
            else if (i === (this.documentHelper.formFields.length - 1)) {
                currentFormField = this.documentHelper.formFields[0];
                if (currentFormField.formFieldData instanceof TextFormField && currentFormField.formFieldData.type === 'Text' &&
                    this.documentHelper.isInlineFormFillProtectedMode) {
                    this.selectTextElementStartOfField(this.documentHelper.formFields[0]);
                }
                else {
                    this.selectFieldInternal(this.documentHelper.formFields[0]);
                }
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    selectTextElementStartOfField(formField) {
        const fieldSeparator = formField.fieldSeparator;
        let element = fieldSeparator.nextElement;
        if (element) {
            while (!(element instanceof TextElementBox)) {
                element = element.nextElement;
            }
            const offset = formField.line.getOffset(element, 0);
            const point = this.getPhysicalPositionInternal(formField.line, offset, false);
            this.selectInternal(formField.line, element, 0, point);
        }
    }
    triggerFormFillEvent(isKeyBoardNavigation) {
        let previousField = this.previousSelectedFormField;
        const currentField = this.currentFormField;
        let previousFieldData;
        let currentFieldData;
        if (currentField !== previousField && currentField && previousField && previousField.formFieldData instanceof TextFormField && this.documentHelper.isInlineFormFillProtectedMode) {
            const formFieldData = previousField.formFieldData;
            if (formFieldData.type === 'Number' || formFieldData.type === 'Date') {
                const isValid = this.validateFormFieldValue(previousField);
                if (!isValid) {
                    const validationMessage = formFieldData.type === 'Number' ? 'A valid number is required' : 'A valid date or time is required';
                    const localValue = new L10n('documenteditor', this.owner.defaultLocale);
                    localValue.setLocale(this.owner.locale);
                    DialogUtility.alert({
                        title: localValue.getConstant('Information'),
                        content: validationMessage,
                        closeOnEscape: true,
                        showCloseIcon: true,
                        position: { X: 'center', Y: 'center' },
                        animationSettings: { effect: 'Zoom' }
                    }).enableRtl = this.owner.enableRtl;
                    // Refocus the previous field — block leaving
                    this.selectFieldInternal(previousField, true);
                    return;
                }
            }
        }
        if (currentField !== previousField && previousField && previousField.formFieldData instanceof TextFormField
            && previousField.formFieldData.type === 'Text') {
            if (previousField.formFieldData.format !== '' && !this.isFormatUpdated) {
                // Need to handle update form field format
                this.owner.editorModule.applyFormTextFormat(previousField);
                if (!isNullOrUndefined(this.previousSelectedFormField)) {
                    previousField = this.previousSelectedFormField;
                }
            }
            previousFieldData = { 'fieldName': previousField.formFieldData.name, 'value': this.owner.editorModule.getFieldResultText(previousField) };
            this.owner.trigger(afterFormFieldFillEvent, previousFieldData);
        }
        if (currentField !== previousField && currentField && ((currentField.formFieldData instanceof TextFormField
            && currentField.formFieldData.type === 'Text' && isKeyBoardNavigation == undefined) || (((currentField.formFieldData instanceof TextFormField && this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Inline') || (currentField.formFieldData instanceof CheckBoxFormField)) && isKeyBoardNavigation))) {
            currentFieldData = { 'fieldName': currentField.formFieldData.name, 'value': this.owner.editorModule.getFieldResultText(currentField) };
            this.owner.trigger(beforeFormFieldFillEvent, currentFieldData);
        }
    }
    validateFormFieldValue(field) {
        const formFieldData = field.formFieldData;
        const resultantText = this.owner.editorModule.getFieldResultText(field);
        if (resultantText === '') {
            return true;
        }
        if (formFieldData.type === 'Number') {
            const number = Number(resultantText.replace(/[$,%]/g, '').replace(/,/g, '').replace(/^\((.+)\)$/, '-$1'));
            if (isNaN(number)) {
                return false;
            }
            const formattedNumber = HelperMethods.formatNumber(formFieldData.format, resultantText);
            this.owner.editorModule.updateFormField(field, formattedNumber);
            return true;
        }
        if (formFieldData.type === 'Date') {
            const date = new Date(resultantText);
            if (isNaN(date.getTime())) {
                return false;
            }
            const formattedDate = HelperMethods.formatDate(formFieldData.format, resultantText);
            this.owner.editorModule.updateFormField(field, formattedDate);
            return true;
        }
        return true;
    }
    /**
     * @private
     * @returns {void}
     */
    triggerContentControlFillEvent() {
        let currentContentControl = this.currentContentControl;
        let previousContentControl = this.previousSelectedContentControl;
        if (!isNullOrUndefined(previousContentControl) && previousContentControl.contentControlProperties
            && previousContentControl.contentControlProperties.xmlMapping) {
            let data = { 'Text': this.owner.editor.getResultContentControlText(previousContentControl) };
            this.owner.trigger(aftercontentControlFillEvent, data);
            if (!isNullOrUndefined(previousContentControl.contentControlProperties.xmlMapping)) {
                let xpath = previousContentControl.contentControlProperties.xmlMapping.xPath;
                this.owner.xmlPaneModule.updateContent(data.Text, xpath);
            }
        }
        if (!isNullOrUndefined(currentContentControl) && currentContentControl.contentControlProperties
            && currentContentControl.contentControlProperties.xmlMapping) {
            let data = { 'Text': this.owner.editor.getResultContentControlText(currentContentControl) };
            this.owner.trigger(beforecontentControlFillEvent, data);
        }
    }
    selectPreviousCell() {
        const tableCell = this.start.paragraph.associatedCell;
        const tableRow = tableCell.ownerRow;
        const tableAdv = tableRow.ownerTable;
        if (isNullOrUndefined(tableCell.previousWidget)) {
            if (!isNullOrUndefined(tableRow.previousRenderedWidget)) {
                //Move text selection or cursor to previous row's last cell
                let prevRow = undefined;
                if (tableRow.previousRenderedWidget instanceof TableRowWidget) {
                    prevRow = tableRow.previousRenderedWidget;
                }
                this.selectTableCellInternal(prevRow.childWidgets[prevRow.childWidgets.length - 1], true);
            }
        }
        else {
            //Move text selection or cursor to next cell in current row
            let prevCell = undefined;
            if (tableCell.previousWidget instanceof TableCellWidget) {
                prevCell = tableCell.previousWidget;
            }
            this.selectTableCellInternal(prevCell, true);
        }
    }
    selectNextCell() {
        const tableCell = this.start.paragraph.associatedCell;
        const tableRow = tableCell.ownerRow;
        const tableAdv = tableRow.ownerTable;
        if (isNullOrUndefined(tableCell.nextWidget)) {
            if (isNullOrUndefined(tableRow.nextRenderedWidget) && !this.owner.isReadOnlyMode) {
                //Insert new row below
                this.owner.editorModule.insertRow(false);
            }
            else {
                //Move text selection or cursor to next row's first cell
                let nextRow = undefined;
                if (tableRow.nextRenderedWidget instanceof TableRowWidget) {
                    nextRow = tableRow.nextRenderedWidget;
                }
                this.selectTableCellInternal(nextRow.childWidgets[0], true);
            }
            // }
        }
        else {
            //Move text selection or cursor to next cell in current row
            let nextCell = undefined;
            if (tableCell.nextRenderedWidget instanceof TableCellWidget) {
                nextCell = tableCell.nextRenderedWidget;
            }
            this.selectTableCellInternal(nextCell, true);
        }
    }
    /**
     * Select given table cell
     *
     * @private
     * @returns {void}
     */
    selectTableCellInternal(tableCell, clearMultiSelection) {
        const firstParagraph = this.getFirstParagraph(tableCell);
        const lastParagraph = this.getLastParagraph(tableCell);
        if (firstParagraph === lastParagraph && lastParagraph.isEmpty()) {
            this.selectParagraphInternal(lastParagraph, true);
        }
        else {
            const firstLineWidget = lastParagraph.childWidgets[0];
            this.start.setPosition(firstParagraph.childWidgets[0], true);
            this.end.setPositionParagraph(firstLineWidget, firstLineWidget.getEndOffset());
            this.fireSelectionChanged(true);
        }
    }
    /**
     * Select while table
     *
     * @private
     * @returns {void}
     */
    selectTableInternal() {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (!isNullOrUndefined(start) && !isNullOrUndefined(end) && !isNullOrUndefined(this.getTable(start, end))) {
            const containerCell = this.getContainerCellOf(start.paragraph.associatedCell, end.paragraph.associatedCell);
            const table = containerCell.ownerTable.getSplitWidgets();
            const firstPara = this.documentHelper.getFirstParagraphBlock(table[0]);
            const lastPara = this.documentHelper.getLastParagraphBlock(table[table.length - 1]);
            const offset = lastPara.lastChild.getEndOffset();
            this.start.setPosition(firstPara.childWidgets[0], true);
            this.end.setPositionParagraph(lastPara.lastChild, offset + 1);
        }
        this.selectPosition(this.start, this.end);
    }
    /**
     * @private
     */
    getTableRevision() {
        let start = this.start.clone();
        let end = this.end.clone();
        if (!this.isForward) {
            start = this.end.clone();
            end = this.start.clone();
        }
        if (!isNullOrUndefined(start) && !isNullOrUndefined(end) && !isNullOrUndefined(this.getTable(start, end))) {
            const containerCell = this.getContainerCellOf(start.paragraph.associatedCell, end.paragraph.associatedCell);
            const table = containerCell.ownerTable;
            const firstPara = this.documentHelper.getFirstParagraphBlock(table);
            const lastPara = this.documentHelper.getLastParagraphBlock(table);
            const offset = lastPara.lastChild.getEndOffset();
            start.setPosition(firstPara.childWidgets[0], true);
            end.setPositionParagraph(lastPara.lastChild, offset + 1);
        }
        let startIndex = this.getAbsolutePositionFromRelativePosition(start);
        let endIndex = this.getAbsolutePositionFromRelativePosition(end);
        return Math.abs(endIndex - startIndex);
        // this.selectPosition(this.start, this.end);
    }
    /**
     * Select single column
     *
     * @private
     * @returns {void}
     */
    selectColumnInternal() {
        let startTextPos = this.start;
        let endTextPos = this.end;
        if (!this.isForward) {
            startTextPos = this.end;
            endTextPos = this.start;
        }
        if (!isNullOrUndefined(startTextPos) && !isNullOrUndefined(endTextPos) && !isNullOrUndefined(this.getTable(startTextPos, endTextPos))) {
            const containerCell = this.getContainerCellOf(startTextPos.paragraph.associatedCell, endTextPos.paragraph.associatedCell);
            if (containerCell.ownerTable.contains(endTextPos.paragraph.associatedCell)) {
                const startCell = this.getSelectedCell(startTextPos.paragraph.associatedCell, containerCell);
                const endCell = this.getSelectedCell(endTextPos.paragraph.associatedCell, containerCell);
                if (this.containsCell(containerCell, endTextPos.paragraph.associatedCell)) {
                    const row = startCell.ownerRow;
                    const columnCells = containerCell.ownerTable.getColumnCellsForSelection(containerCell, containerCell);
                    if (columnCells.length > 0) {
                        const firstPara = this.getFirstParagraph(columnCells[0]);
                        const lastPara = this.getLastParagraph(columnCells[columnCells.length - 1]);
                        this.start.setPosition(firstPara.firstChild, true);
                        const lastLine = lastPara.lastChild;
                        this.end.setPositionParagraph(lastLine, lastLine.getEndOffset() + 1);
                    }
                }
                else {
                    const startCellColumnCells = containerCell.ownerTable.getColumnCellsForSelection(startCell, startCell);
                    const endCellColumnCells = containerCell.ownerTable.getColumnCellsForSelection(endCell, endCell);
                    if (startCellColumnCells.length > 0 && endCellColumnCells.length > 0) {
                        const firstPara = this.getFirstParagraph(startCellColumnCells[0]);
                        const lastPara = this.getLastParagraph(endCellColumnCells[endCellColumnCells.length - 1]);
                        this.start.setPosition(firstPara.firstChild, true);
                        const lastLine = lastPara.lastChild;
                        this.end.setPositionParagraph(lastLine, lastLine.getEndOffset() + 1);
                    }
                }
            }
        }
        this.selectPosition(this.start, this.end);
    }
    /**
     * Select single row
     *
     * @private
     * @returns {void}
     */
    selectTableRow() {
        let startPos = this.start;
        let endPos = this.end;
        if (!this.isForward) {
            startPos = this.end;
            endPos = this.start;
        }
        if (!isNullOrUndefined(startPos) && !isNullOrUndefined(endPos) && !isNullOrUndefined(this.getTable(startPos, endPos))) {
            let containerCell;
            containerCell = this.getContainerCellOf(startPos.paragraph.associatedCell, endPos.paragraph.associatedCell);
            if (containerCell.ownerTable.contains(endPos.paragraph.associatedCell)) {
                const startCell = this.getSelectedCell(startPos.paragraph.associatedCell, containerCell);
                const endCell = this.getSelectedCell(endPos.paragraph.associatedCell, containerCell);
                if (this.containsCell(containerCell, endPos.paragraph.associatedCell)) {
                    const row = startCell.ownerRow;
                    const firstPara = this.getFirstParagraph(row.childWidgets[0]);
                    const lastPara = this.getLastParagraph(row.childWidgets[row.childWidgets.length - 1]);
                    this.start.setPosition(firstPara.firstChild, true);
                    this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                }
                else {
                    const firstPara = this.getFirstParagraph(startCell.ownerRow.childWidgets[0]);
                    let lastPara;
                    lastPara = this.getLastParagraph(endCell.ownerRow.childWidgets[endCell.ownerRow.childWidgets.length - 1]);
                    this.start.setPosition(firstPara.firstChild, true);
                    this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                }
            }
        }
        this.selectPosition(this.start, this.end);
    }
    /**
     * Select single cell
     *
     * @private
     * @returns {void}
     */
    selectTableCell() {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (isNullOrUndefined(this.getTable(start, end))) {
            return;
        }
        if (this.isEmpty) {
            if (start.paragraph.isInsideTable && !isNullOrUndefined(start.paragraph.associatedCell)) {
                const firstPara = this.getFirstParagraph(start.paragraph.associatedCell);
                const lastPara = this.getLastParagraph(end.paragraph.associatedCell);
                if (firstPara === lastPara) {
                    this.start.setPosition(lastPara.firstChild, true);
                    this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                }
                else {
                    this.start.setPosition(firstPara.firstChild, true);
                    this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                }
            }
        }
        else {
            const containerCell = this.getContainerCell(start.paragraph.associatedCell);
            if (this.containsCell(containerCell, start.paragraph.associatedCell) && this.containsCell(containerCell, end.paragraph.associatedCell)) {
                const firstPara = this.getFirstParagraph(containerCell);
                const lastPara = this.getLastParagraph(containerCell);
                if (!isNullOrUndefined(firstPara) && !isNullOrUndefined(lastPara)) {
                    this.start.setPosition(firstPara.firstChild, true);
                    this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                }
            }
        }
        this.selectPosition(this.start, this.end);
    }
    /**
     * Selects the entire document.
     *
     * @returns {void}
     */
    selectAll() {
        let documentStart;
        let documentEnd;
        this.documentHelper.skipScrollToPosition = true;
        const container = this.getContainerWidget(this.start.paragraph);
        if (this.owner.enableHeaderAndFooter) {
            const headerFooter = this.getContainerWidget(this.start.paragraph);
            documentStart = this.setPositionForBlock(headerFooter.firstChild, true);
            documentEnd = this.setPositionForBlock(headerFooter.lastChild, false);
        }
        else if (this.isInShape) {
            const textFrame = this.getCurrentTextFrame();
            documentStart = this.setPositionForBlock(textFrame.firstChild, true);
            documentEnd = this.setPositionForBlock(textFrame.lastChild, false);
        }
        else if (container instanceof FootNoteWidget && container.footNoteType === 'Footnote') {
            let i;
            let j;
            const pageLength = this.documentHelper.pages.length;
            for (i = 0; i <= pageLength - 1; i++) {
                if (isNullOrUndefined(this.documentHelper.pages[i].footnoteWidget)) {
                    continue;
                }
                else {
                    documentStart = this.setPositionForBlock(this.documentHelper.pages[i].footnoteWidget.bodyWidgets[0].firstChild, true);
                    break;
                }
            }
            for (j = pageLength - 1; j >= 0; j--) {
                if (isNullOrUndefined(this.documentHelper.pages[j].footnoteWidget)) {
                    continue;
                }
                else {
                    const child = this.documentHelper.pages[j].footnoteWidget.bodyWidgets.length;
                    const lastChild = this.documentHelper.pages[j].footnoteWidget.bodyWidgets[child - 1].childWidgets.length;
                    documentEnd = this.setPositionForBlock(this.documentHelper.pages[j].footnoteWidget.bodyWidgets[child - 1].childWidgets[lastChild - 1], false);
                    break;
                }
            }
        }
        else if (container instanceof FootNoteWidget && container.footNoteType === 'Endnote') {
            const endNotes = this.getContainerWidget(this.start.paragraph);
            documentStart = this.setPositionForBlock(endNotes.bodyWidgets[0].firstChild, true);
            documentEnd = this.setPositionForBlock(endNotes.bodyWidgets[endNotes.bodyWidgets.length - 1].firstChild, false);
        }
        else {
            documentStart = this.owner.documentStart;
            documentEnd = this.owner.documentEnd;
        }
        //Selects the entire document.
        if (!isNullOrUndefined(documentStart)) {
            this.start.setPositionInternal(documentStart);
            this.end.setPositionParagraph(documentEnd.currentWidget, documentEnd.offset + 1);
            this.upDownSelectionLength = this.end.location.x;
            this.fireSelectionChanged(true);
        }
    }
    /**
     * Extends the selection backward.
     *
     * @returns {void}
     */
    extendBackward() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        const isForward = this.isForward ? this.start.isCurrentParaBidi && !this.isImageSelected : this.end.isCurrentParaBidi && !this.isImageSelected;
        if (isForward) {
            this.end.moveForward();
        }
        else {
            this.end.moveBackward();
        }
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection forward.
     *
     * @returns {void}
     */
    extendForward() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        const isForward = this.isForward ? this.start.isCurrentParaBidi && !this.isImageSelected : this.end.isCurrentParaBidi && !this.isImageSelected;
        if (isForward) {
            this.end.moveBackward();
        }
        else {
            this.end.moveForward();
        }
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extend selection to word start and end
     *
     * @private
     * @returns {void}
     */
    extendToWordStartEnd() {
        if ((this.start.paragraph.isInsideTable || this.end.paragraph.isInsideTable)
            && (this.start.paragraph.associatedCell !== this.end.paragraph.associatedCell
                || this.isCellSelected(this.start.paragraph.associatedCell, this.start, this.end))) {
            return true;
        }
        return false;
    }
    /**
     * Extends the selection to word start.
     *
     * @returns {void}
     */
    extendToWordStart() {
        this.extendToWordStartInternal(false);
    }
    /**
     * Extends the selection to word end.
     *
     * @returns {void}
     */
    extendToWordEnd() {
        this.extendToWordEndInternal(false);
    }
    /**
     * Extends selection to word start
     *
     * @private
     * @returns {void}
     */
    extendToWordStartInternal(isNavigation) {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        const isCellSelected = this.extendToWordStartEnd();
        if (isCellSelected) {
            this.end.moveToPreviousParagraphInTable(this);
        }
        else {
            if (isNavigation && this.end.isCurrentParaBidi) {
                this.end.moveToWordEndInternal(isNavigation ? 0 : 1, false);
            }
            else {
                this.end.moveToWordStartInternal(isNavigation ? 0 : 1);
            }
        }
        if (isNavigation) {
            this.start.setPositionInternal(this.end);
        }
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to word end.
     *
     * @returns {void}
     */
    extendToWordEndInternal(isNavigation) {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        const isCellSelect = this.extendToWordStartEnd();
        if (isCellSelect) {
            this.end.moveToNextParagraphInTable();
        }
        else {
            if (isNavigation && this.end.isCurrentParaBidi) {
                this.end.moveToWordStartInternal(isNavigation ? 0 : 1);
            }
            else {
                this.end.moveToWordEndInternal(isNavigation ? 0 : 1, false);
            }
        }
        if (isNavigation) {
            this.start.setPositionInternal(this.end);
        }
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Extends the selection to next line.
     *
     * @returns {void}
     */
    extendToNextLine() {
        if (isNullOrUndefined(this.start)) {
            return;
        }
        this.end.moveToNextLine(this.upDownSelectionLength);
        this.fireSelectionChanged(true);
    }
    //Selection Text get API
    //Selection add, Highlight, remove API enda
    getTextPosition(hierarchicalIndex) {
        const textPosition = new TextPosition(this.owner);
        textPosition.setPositionForCurrentIndex(hierarchicalIndex);
        return textPosition;
    }
    /**
     * Get Selected text
     *
     * @private
     * @returns {void}
     */
    getText(includeObject) {
        if (isNullOrUndefined(this.start) || isNullOrUndefined(this.end)
            || isNullOrUndefined(this.start.paragraph) || isNullOrUndefined(this.end.paragraph)) {
            return undefined;
        }
        const startPosition = this.start;
        const endPosition = this.end;
        if (startPosition.isAtSamePosition(endPosition)) {
            return '';
        }
        return this.getTextInternal(startPosition, endPosition, includeObject);
    }
    /**
     * Get selected text
     *
     * @private
     * @returns {string}
     */
    getTextInternal(start, end, includeObject) {
        if (start.isExistAfter(end)) {
            const temp = end;
            end = start;
            start = temp;
        }
        const startPosition = start;
        const endPosition = end;
        if (!isNullOrUndefined(start) && !isNullOrUndefined(end) && !isNullOrUndefined(start.paragraph) && !isNullOrUndefined(end.paragraph)) {
            let startIndex = 0;
            let endIndex = 0;
            const startOffset = start.offset;
            const endOffset = end.offset;
            const startInlineObj = start.currentWidget.getInline(startOffset, startIndex);
            startIndex = startInlineObj.index;
            let inline = startInlineObj.element;
            // If the start position is at the beginning of field begin that has field end, then field code should be skipped.
            if (inline instanceof FieldElementBox && !isNullOrUndefined(inline.fieldEnd)) {
                const elementInfo = this.getRenderedInline(inline, startIndex);
                inline = elementInfo.element;
                startIndex = elementInfo.index;
            }
            const endInlineObj = end.currentWidget.getInline(endOffset, endIndex);
            const endInline = endInlineObj.element;
            endIndex = endInlineObj.index;
            let text = '';
            // Retrieves the text from start inline.
            if ((inline instanceof ImageElementBox || inline instanceof GroupShapeElementBox) && includeObject && startIndex === 0) {
                text = ElementBox.objectCharacter;
            }
            else if (inline instanceof TextElementBox) {
                text = ((isNullOrUndefined(inline.text)) || (inline.text) === '') || inline.text.length < startIndex ? text : inline.text.substring(startIndex);
            }
            if (startPosition.paragraph === endPosition.paragraph) {
                if (inline instanceof ElementBox) {
                    if (inline === endInline && inline instanceof TextElementBox) {
                        text = text.length < endIndex - startIndex ? text : text.substring(0, endIndex - startIndex);
                    }
                    else if (inline.nextNode instanceof ElementBox) {
                        text = text + this.getTextInline(inline.nextNode, endPosition.paragraph, endInline, endIndex, includeObject);
                    }
                }
            }
            else {
                let currentParagraph = startPosition.paragraph;
                let isFirstParagraph = true;
                while (!isNullOrUndefined(currentParagraph)) {
                    if (isFirstParagraph) {
                        if (inline instanceof ElementBox && inline.nextNode instanceof ElementBox) {
                            text += this.getTextInline(inline.nextNode, endPosition.paragraph, endInline, endIndex, includeObject);
                        }
                        isFirstParagraph = false;
                    }
                    else if (currentParagraph.isEmpty() && currentParagraph !== endPosition.paragraph) {
                        text += '\r';
                    }
                    else {
                        const firstInline = currentParagraph.childWidgets[0].children[0];
                        text += this.getTextInline(firstInline, endPosition.paragraph, endInline, endIndex, includeObject);
                    }
                    if (currentParagraph === endPosition.paragraph) {
                        break;
                    }
                    const nextParagraph = this.documentHelper.selection.getNextParagraphBlock(currentParagraph);
                    if (!currentParagraph.isEmpty()) {
                        if (!(nextParagraph && currentParagraph.nextSplitWidget &&
                            currentParagraph.nextSplitWidget.index === nextParagraph.index &&
                            currentParagraph.nextSplitWidget.equals(nextParagraph))) {
                            text += '\r';
                        }
                    }
                    currentParagraph = nextParagraph;
                }
            }
            // If the selection includes end paragraph mark.
            if (endOffset === (endPosition.currentWidget).getEndOffset() + 1) {
                text = text + '\r';
            }
            return text;
        }
        return undefined;
    }
    /**
     * @private
     */
    getHeaderFooterIndex(block) {
        const headersFooters = this.documentHelper.headersFooters;
        for (let i = 0; i < headersFooters.length; i++) {
            const headerFooter = headersFooters[i];
            for (const key in headerFooter) {
                if (headerFooter.hasOwnProperty(key)) {
                    const currentHeaderFooter = headerFooter[key];
                    if (currentHeaderFooter === block) {
                        return parseInt(key, 10);
                    }
                }
            }
        }
        return -1;
    }
    /**
     * @private
     * @param block
     * @param offset
     * @returns {string}
     */
    getHierarchicalIndex(block, offset) {
        let index;
        if (block) {
            if (block instanceof HeaderFooterWidget) {
                if (this.owner.enableLayout) {
                    const hfString = block.headerFooterType.indexOf('Header') !== -1 ? 'H' : 'F';
                    const pageIndex = block.page.index.toString();
                    // let headerFooterIndex: string = (this.viewer as PageLayoutViewer).getHeaderFooter(block.headerFooterType).toString();
                    const sectionIndex = block.page.sectionIndex;
                    index = sectionIndex + ';' + hfString + ';' + pageIndex + ';' + offset;
                }
                else {
                    const hfString = block.headerFooterType.indexOf('Header') !== -1 ? 'H' : 'F';
                    const pageIndex = this.getHeaderFooterIndex(block).toString();
                    // let headerFooterIndex: string = (this.viewer as PageLayoutViewer).getHeaderFooter(block.headerFooterType).toString();
                    const sectionIndex = block.headerSectionIndex;
                    index = sectionIndex + ';' + hfString + ';' + pageIndex + ';' + offset;
                }
            }
            else {
                if (block instanceof BodyWidget && !isNullOrUndefined(block.containerWidget) && block.containerWidget instanceof FootNoteWidget) {
                    let ind = block.containerWidget.bodyWidgets.indexOf(block);
                    index = ind + ';' + offset;
                }
                else {
                    let blockIndex = block.index;
                    // we need to consider index of cells only if the cell is from same row.
                    if (block instanceof TableCellWidget) {
                        let cells = block.ownerRow.childWidgets.filter(cell => cell.rowIndex === cell.ownerRow.index);
                        if (cells.length > 0) {
                            blockIndex = cells.indexOf(block);
                        }
                    }
                    // If the cell's row span is greater than 1, then the cell is spitted into mutiple page. We should not consider spitted cell. Becuase the cell index may change.
                    // So need to consider the split widget index.
                    if (block instanceof TableCellWidget && block.cellFormat.rowSpan > 1) {
                        let cellWidget = block.getSplitWidgets();
                        if (!isNullOrUndefined(cellWidget) && cellWidget.length > 0) {
                            blockIndex = cellWidget[0].index;
                        }
                    }
                    // if (block instanceof BodyWidget && block.sectionFormat.columns.length > 1) {
                    //         index = block.indexInOwner + ';' + offset;
                    // }
                    // else {
                    index = blockIndex + ';' + offset;
                    // }
                }
            }
            if (block instanceof TextFrame) {
                let indexInOwner = block.containerShape.line.getOffset(block.containerShape, 1);
                index = 'S' + ';' + indexInOwner + ';' + offset;
                if (block.containerShape.containerShape instanceof GroupShapeElementBox) {
                    index = (this.getHierarchicalIndexForGroupShape(block.containerShape)) + offset;
                }
                return this.getHierarchicalIndex(block.containerShape.paragraph, index);
            }
            if (block instanceof FootNoteWidget) {
                // index = block.index + ';' + index;
                //block = block.containerWidget;
                const hfString = block.footNoteType === 'Footnote' ? 'FN' : 'EN';
                const pageIndex = block.page.index.toString();
                // let headerFooterIndex: string = (this.viewer as PageLayoutViewer).getHeaderFooter(block.headerFooterType).toString();
                const sectionIndex = block.page.sectionIndex;
                index = sectionIndex + ';' + hfString + ';' + pageIndex + ';' + offset;
            }
            if (block.containerWidget) {
                if (block instanceof TableCellWidget && block.rowIndex !== block.containerWidget.index) {
                    index = block.rowIndex + ';' + index;
                    block = block.containerWidget;
                }
                return this.getHierarchicalIndex(block.containerWidget, index);
            }
        }
        return index;
    }
    getHierarchicalIndexForGroupShape(shape) {
        let index = '';
        while (shape.containerShape) {
            let childIndex = shape.containerShape.childWidgets.indexOf(shape);
            index = childIndex + ';' + index;
            shape = shape.containerShape;
            if (isNullOrUndefined(shape.containerShape)) {
                let indexInOwner = shape.line.getOffset(shape, 1);
                index = 'G' + ';' + indexInOwner + ';' + index + 'S' + ';';
            }
        }
        return index;
    }
    /**
     * @private
     * @returns {string}
     */
    getHierarchicalIndexByPosition(position) {
        const info = this.getParagraphInfo(position);
        return this.getHierarchicalIndex(info.paragraph, info.offset.toString());
    }
    /**
     * @private
     * @returns {TextPosition}
     */
    getTextPosBasedOnLogicalIndex(hierarchicalIndex) {
        const textPosition = new TextPosition(this.owner);
        const blockInfo = this.getParagraph({ index: hierarchicalIndex });
        const lineInfo = this.getLineInfoBasedOnParagraph(blockInfo.paragraph, blockInfo.offset);
        textPosition.setPositionForLineWidget(lineInfo.line, lineInfo.offset);
        return textPosition;
    }
    /**
     * Get offset value to update in selection
     *
     * @private
     * @returns {LineInfo}
     */
    getLineInfoBasedOnParagraph(paragraph, offset) {
        const position = undefined;
        const element = undefined;
        let length = this.getParagraphLength(paragraph);
        let next = paragraph.nextSplitWidget;
        if (offset > length + 1 && isNullOrUndefined(next)) {
            offset = length;
        }
        while (offset > length && next instanceof ParagraphWidget) {
            offset -= length;
            paragraph = next;
            length = this.getParagraphLength(paragraph);
            next = paragraph.nextSplitWidget;
        }
        return this.getLineInfo(paragraph, offset);
    }
    /**
     * @private
     * @returns {ParagraphInfo}
     */
    getParagraph(position) {
        const paragraph = this.getParagraphInternal(this.getBodyWidget(position), position);
        return { paragraph: paragraph, offset: parseInt(position.index, 10) };
    }
    /**
     * Gets body widget based on position.
     *
     * @private
     * @returns {BlockContainer}
     */
    getBodyWidget(position) {
        let index = position.index.indexOf(';');
        let value = position.index.substring(0, index);
        position.index = position.index.substring(index).replace(';', '');
        const sectionIndex = parseInt(value, 10);
        index = parseInt(value, 10);
        index = position.index.indexOf(';');
        value = position.index.substring(0, index);
        // position = position.substring(index).replace(';', '');
        if (value === 'H' || value === 'F') {
            return this.getHeaderFooterWidget(position, sectionIndex);
        }
        else if (value === 'FN' || value === 'EN') {
            return this.getFootNoteWidget(position);
        }
        index = parseInt(value, 10);
        return this.getBodyWidgetInternal(sectionIndex, index);
    }
    getFootNoteWidget(position) {
        let index1 = position.index.indexOf(';');
        let value1 = position.index.substring(0, index1);
        position.index = position.index.substring(index1).replace(';', '');
        const footNote = value1 === 'FN';
        index1 = position.index.indexOf(';');
        value1 = position.index.substring(0, index1);
        position.index = position.index.substring(index1).replace(';', '');
        index1 = parseInt(value1, 10);
        const page = this.documentHelper.pages[index1];
        index1 = position.index.indexOf(';');
        value1 = position.index.substring(0, index1);
        position.index = position.index.substring(index1).replace(';', '');
        index1 = parseInt(value1, 10);
        if (footNote) {
            return page.footnoteWidget.bodyWidgets[index1];
        }
        else {
            return page.endnoteWidget.bodyWidgets[index1];
        }
    }
    getHeaderFooterWidget(position, sectionIndex) {
        //HEADER OR FOOTER WIDGET
        let index = position.index.indexOf(';');
        let value = position.index.substring(0, index);
        position.index = position.index.substring(index).replace(';', '');
        const isHeader = value === 'H';
        index = position.index.indexOf(';');
        value = position.index.substring(0, index);
        position.index = position.index.substring(index).replace(';', '');
        index = parseInt(value, 10);
        let headerFooterWidget;
        if (this.owner.enableLayout) {
            const page = this.documentHelper.pages[index];
            if (isHeader) {
                headerFooterWidget = page.headerWidget;
            }
            else {
                headerFooterWidget = page.footerWidget;
            }
            if (!isNullOrUndefined(headerFooterWidget)) {
                headerFooterWidget.page = page;
            }
        }
        else {
            const headersFooters = this.documentHelper.headersFooters[sectionIndex];
            if (headersFooters) {
                const currentHeaderFooter = headersFooters[index];
                if (currentHeaderFooter) {
                    headerFooterWidget = currentHeaderFooter;
                }
            }
        }
        return headerFooterWidget;
    }
    /**
     * @private
     * @returns {BodyWidget}
     */
    getBodyWidgetInternal(sectionIndex, blockIndex) {
        for (let i = 0; i < this.documentHelper.pages.length; i++) {
            for (let j = 0; j < this.documentHelper.pages[i].bodyWidgets.length; j++) {
                let bodyWidget = this.documentHelper.pages[i].bodyWidgets[j];
                if (bodyWidget.index === sectionIndex) {
                    if (bodyWidget.childWidgets.length > 0 && bodyWidget.firstChild.index <= blockIndex &&
                        bodyWidget.lastChild.index >= blockIndex) {
                        return bodyWidget;
                    }
                }
                if (bodyWidget.index > sectionIndex) {
                    break;
                }
            }
        }
        return undefined;
    }
    getParagraphInternal(container, position, cellIndex) {
        if (isNullOrUndefined(position.index)) {
            return undefined;
        }
        if (container instanceof TableRowWidget && isNullOrUndefined(cellIndex)) {
            cellIndex = position.index;
        }
        // let ins: Widget = container;
        let index = position.index.indexOf(';');
        let value = '0';
        if (index >= 0) {
            value = position.index.substring(0, index);
            position.index = position.index.substring(index).replace(';', '');
        }
        // if (container instanceof BodyWidget && value === 'HF') {
        //     return this.getParagraph(container.headerFooters, position);
        // }
        index = parseInt(value, 10);
        if (container instanceof TableRowWidget && index >= container.childWidgets.length) {
            index = container.childWidgets.length - 1;
        }
        let childWidget = this.getBlockByIndex(container, index, position);
        if (!isNullOrUndefined(cellIndex) && isNullOrUndefined(childWidget) && container instanceof TableCellWidget && container.containerWidget && isNullOrUndefined(container.getSplitWidgets().pop().nextRenderedWidget)) {
            index = cellIndex.indexOf(';');
            index = parseInt(cellIndex.substring(0, index), 10) - 1;
            position.index = cellIndex.substring(cellIndex.indexOf(';')).replace(';', '');
            if (index >= 0) {
                childWidget = this.getBlockByIndex(container.containerWidget, index);
            }
            cellIndex = undefined;
        }
        if (childWidget) {
            value = position.index.substring(0, 1);
            if (value === 'S') {
                position.index = position.index.substring(1).replace(';', '');
                const indexInOwner = position.index.substring(0, position.index.indexOf(';'));
                position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
                const paraIndex = position.index.substring(0, position.index.indexOf(';'));
                position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
                let shape = childWidget.getInline(parseInt(indexInOwner), 0).element;
                childWidget = shape.textFrame.childWidgets[paraIndex];
            }
            if (value === 'G') {
                childWidget = this.getBlockFromGroup(childWidget, position);
            }
            const child = childWidget;
            if (child instanceof ParagraphWidget) {
                if (position.index.indexOf(';') > 0) {
                    position.index = '0';
                }
                return child;
            }
            if (child instanceof Widget) {
                if (position.index.indexOf(';') > 0) {
                    return this.getParagraphInternal(child, position, cellIndex);
                }
                else {
                    //If table is shifted to previous text position then return the first paragraph within table.
                    if (child instanceof TableWidget) {
                        return this.documentHelper.getFirstParagraphInFirstCell(child);
                    }
                    return undefined;
                }
            }
        }
        else if (container) {
            const nextWidget = container.getSplitWidgets().pop().nextRenderedWidget;
            if (nextWidget instanceof Widget) {
                position.index = '0';
                if (nextWidget instanceof TableWidget) {
                    return this.documentHelper.getFirstParagraphInFirstCell(nextWidget);
                }
                return nextWidget;
            }
        }
        return undefined;
    }
    getBlockFromGroup(block, position) {
        position.index = position.index.substring(1).replace(';', '');
        const indexInOwner = position.index.substring(0, position.index.indexOf(';'));
        position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
        let groupShape = block.getInline(parseInt(indexInOwner), 0).element;
        while (position.index.substring(0, position.index.indexOf(';')) !== 'S') {
            const childValue = position.index.substring(0, position.index.indexOf(';'));
            if (childValue === 'S') {
                break;
            }
            position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
            groupShape = groupShape.childWidgets[parseInt(childValue)];
        }
        if (position.index.substring(0, position.index.indexOf(';')) === 'S') {
            position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
            const paraIndex = parseInt(position.index.substring(0, position.index.indexOf(';')), 10);
            position.index = position.index.substring(position.index.indexOf(';')).replace(';', '');
            block = groupShape.textFrame.childWidgets[paraIndex];
        }
        return block;
    }
    /**
     * @private
     * @returns {Widget}
     */
    getBlockByIndex(container, blockIndex, position) {
        let childWidget;
        if (container) {
            // the cell index is considered only if it is from same row.
            if (container instanceof TableRowWidget) {
                let cells = container.childWidgets.filter(cell => cell.rowIndex === cell.ownerRow.index);
                if (cells.length > 0) {
                    childWidget = cells[blockIndex];
                }
            }
            else {
                for (let j = 0; j < container.childWidgets.length; j++) {
                    if (container.childWidgets[j].index === blockIndex) {
                        childWidget = container.childWidgets[j];
                        break;
                    }
                }
            }
            // If the row contains a vertically merged cell and the cell count differs between the current row and the split row. So, we have added the following code to update the split cell widget for selection.
            if (!isNullOrUndefined(childWidget) && childWidget instanceof TableRowWidget && childWidget.nextSplitWidget && this.documentHelper.layout.isVerticalMergedCellContinue(childWidget) && !isNullOrUndefined(position)) {
                let positionIndex = position.index;
                let index = positionIndex.indexOf(';');
                let cellIndexValue = positionIndex.substring(0, index);
                positionIndex = positionIndex.substring(index).replace(';', '');
                let currentCell = this.getBlockByIndex(childWidget, parseInt(cellIndexValue, 10));
                index = positionIndex.indexOf(';');
                let blockIndexValue = positionIndex.substring(0, index);
                if (currentCell && currentCell instanceof TableCellWidget && currentCell.childWidgets.length > 0 && currentCell.lastChild.index < parseInt(blockIndexValue, 10)) {
                    let prevCell = this.getBlockByIndex(childWidget, parseInt(cellIndexValue, 10) - 1);
                    if (prevCell && prevCell instanceof TableCellWidget && prevCell.childWidgets.length > 0 && prevCell.lastChild.index < parseInt(blockIndexValue, 10)) {
                        return this.getBlockByIndex(container.nextSplitWidget, blockIndex, position);
                    }
                }
            }
            if (!childWidget && !(container instanceof HeaderFooterWidget)) {
                return this.getBlockByIndex(container.nextSplitWidget, blockIndex, position);
            }
        }
        return childWidget;
    }
    /**
     * Get logical offset of paragraph.
     *
     * @private
     * @returns {ParagraphInfo}
     */
    getParagraphInfo(position) {
        return this.getParagraphInfoInternal(position.currentWidget, position.offset);
    }
    /**
     * Get the start or end cell from current selection
     *
     * @private
     * @returns {TableCellWidget}
     */
    getCellFromSelection(type) {
        let cell;
        let selectedCells = this.getSelectedCells();
        if (this.hasMergedCells()) {
            return undefined;
        }
        if (type == 0 && selectedCells.length > 0) {
            if (!(this.selectedWidgets.keys[0] instanceof TableCellWidget)) {
                return undefined;
            }
            cell = selectedCells[0];
            let rowIndex = cell.rowIndex;
            let colIndex = cell.columnIndex;
            let tableIndex = cell.ownerTable.index;
            for (let i = 0; i < selectedCells.length; i++) {
                let widget = selectedCells[i];
                if (widget.rowIndex < rowIndex) {
                    rowIndex = widget.rowIndex;
                }
                if (widget.columnIndex < colIndex) {
                    colIndex = widget.columnIndex;
                }
                if (widget.ownerTable.index < tableIndex) {
                    tableIndex = widget.ownerTable.index;
                }
            }
            for (let i = 0; i < selectedCells.length; i++) {
                let widget = selectedCells[i];
                if (rowIndex == widget.rowIndex && colIndex == widget.columnIndex && tableIndex == widget.ownerTable.index) {
                    cell = widget;
                }
            }
        }
        else if (type == 1 && selectedCells.length > 0) {
            if (!(this.selectedWidgets.keys[this.selectedWidgets.length - 1] instanceof TableCellWidget)) {
                return undefined;
            }
            cell = selectedCells[selectedCells.length - 1];
            let rowIndex = cell.rowIndex;
            let colIndex = cell.columnIndex;
            let tableIndex = cell.ownerTable.index;
            for (let i = selectedCells.length - 1; i >= 0; i--) {
                let widget = selectedCells[i];
                if (widget.rowIndex > rowIndex) {
                    rowIndex = widget.rowIndex;
                }
                if (widget.columnIndex > colIndex) {
                    colIndex = widget.columnIndex;
                }
                if (widget.ownerTable.index > tableIndex) {
                    tableIndex = widget.ownerTable.index;
                }
            }
            for (let i = 0; i < selectedCells.length; i++) {
                let widget = selectedCells[i];
                if (rowIndex == widget.rowIndex && colIndex == widget.columnIndex && tableIndex == widget.ownerTable.index) {
                    cell = widget;
                }
            }
        }
        return (cell instanceof TableCellWidget) ? cell : undefined;
    }
    /**
     * Get the start cell or end cell in table with merged cells from current selection.
     *
     * @private
     * @returns {TableCellWidget}
     */
    getCellFromSelectionInTable(type) {
        let cell;
        let selectedCells = this.getSelectedCells();
        let bounds = this.getCellBoundsInfo();
        let sortedRowIndexArray = [];
        let sortedColumnIndexArray = [];
        for (let i = 0; i < selectedCells.length; i++) {
            var widget = selectedCells[i];
            sortedRowIndexArray.push(widget.rowIndex);
            sortedColumnIndexArray.push(widget.columnIndex);
        }
        sortedRowIndexArray.sort();
        sortedColumnIndexArray.sort();
        let requiredRow;
        let requiredCol;
        if (type == 1) {
            requiredRow = bounds.row.rowLast;
            requiredCol = bounds.column.colLast;
            let isRequiredCellExist = false;
            while (!isRequiredCellExist && isNullOrUndefined(cell)) {
                for (let i = 0; i < selectedCells.length; i++) {
                    let widget = selectedCells[i];
                    if (widget.rowIndex == requiredRow && widget.columnIndex == requiredCol) {
                        isRequiredCellExist = true;
                        cell = widget;
                        break;
                    }
                }
                if (!isRequiredCellExist) {
                    requiredRow -= 1;
                }
            }
        }
        else if (type == 0) {
            requiredRow = bounds.row.rowFirst;
            requiredCol = bounds.column.colFirst;
            let isRequiredCellExist = false;
            while (!isRequiredCellExist && isNullOrUndefined(cell)) {
                for (let i = 0; i < selectedCells.length; i++) {
                    let widget = selectedCells[i];
                    if (widget.rowIndex == requiredRow && widget.columnIndex == requiredCol) {
                        isRequiredCellExist = true;
                        cell = widget;
                        break;
                    }
                }
                if (!isRequiredCellExist) {
                    requiredCol += 1;
                }
            }
        }
        return cell;
    }
    /**
     * Get the actual offset from the current selection.
     *
     * @private
     * @returns {string}
     */
    getActualOffset(cell, type) {
        let offset;
        if (type == 0) {
            let paraElement = this.getFirstParagraph(cell);
            offset = this.getHierarchicalIndex(paraElement, this.getStartOffset(paraElement).toString());
        }
        else if (type == 1) {
            let paraElement = this.getLastParagraph(cell);
            let lastLine = paraElement.lastChild;
            let length = this.getParagraphLength(paraElement, lastLine) + this.getLineLength(lastLine) + 1;
            offset = this.getHierarchicalIndex(paraElement, length.toString());
        }
        return offset;
    }
    /**
     * Get the properties for Bookmark.
     *
     * @private
     * @returns {object}
     */
    getBookmarkProperties(bookmark) {
        let selectedWidgets = this.selectedWidgets.keys;
        if (bookmark.bookmarkType == 0) {
            if (!(selectedWidgets[0] instanceof TableCellWidget)) {
                return undefined;
            }
            let bounds = this.getCellBoundsInfo();
            if (!isNullOrUndefined(bounds)) {
                return {
                    'columnFirst': bounds.column.colFirst.toString(),
                    'columnLast': bounds.column.colLast.toString()
                };
            }
        }
        if (bookmark.bookmarkType == 1) {
            if (selectedWidgets[selectedWidgets.length - 1] instanceof TableCellWidget) {
                return undefined;
            }
            let properties = {};
            // isAfterParagraphMark
            // In Ms Word, If the paragraph mark is selected and the bookmark end is inside the table, then the bookmark end is considered to be after the paragraph mark.
            let paraElement = this.isForward ? this.start.paragraph : this.end.paragraph;
            if (this.isParagraphMarkSelected() && !isNullOrUndefined(paraElement) && !isNullOrUndefined(paraElement.nextRenderedWidget)) {
                properties.isAfterParagraphMark = true;
            }
            // isAfterCellMark
            let bookmarkStart = bookmark.reference;
            let selectedCells = this.getSelectedCells();
            if (bookmarkStart && !isNullOrUndefined(bookmarkStart.properties)) {
                if (selectedCells.length == 1) {
                    if (this.isCellSelected(selectedCells[0], this.start, this.end)) {
                        properties.isAfterCellMark = true;
                        delete properties.isAfterParagraphMark;
                    }
                }
            }
            // isAfterTableMark
            if (this.isTableSelected()) {
                properties.isAfterTableMark = true;
            }
            // isAfterRowMark
            if (this.isRowSelected()) {
                properties.isAfterRowMark = true;
            }
            if (!isNullOrUndefined(properties.isAfterParagraphMark) || !isNullOrUndefined(properties.isAfterCellMark)) {
                return properties;
            }
        }
        return undefined;
    }
    /**
     * Returns true if Paragraph Mark is selected.
     *
     * @private
     * @returns {boolean}
     */
    isParagraphMarkSelected() {
        let end = this.isForward ? this.end : this.start;
        let line = end.currentWidget;
        let paraElement;
        if (line instanceof LineWidget) {
            paraElement = line.paragraph;
        }
        let paraLength = this.getParagraphLength(paraElement);
        if (paraElement) {
            let previous = paraElement.previousSplitWidget;
            while (previous instanceof ParagraphWidget) {
                paraElement = previous;
                paraLength += this.getParagraphLength(paraElement);
                previous = paraElement.previousSplitWidget;
            }
        }
        let endIndices = this.getHierarchicalIndexByPosition(end).split(';');
        let endIndex = parseInt(endIndices[endIndices.length - 1]);
        if (endIndex > paraLength) {
            return true;
        }
        return false;
    }
    /**
     * Returns true if Row is selected.
     *
     * @private
     * @returns {boolean}
     */
    isRowSelected() {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (isNullOrUndefined(start.paragraph.associatedCell) ||
            isNullOrUndefined(end.paragraph.associatedCell)) {
            return false;
        }
        let row = end.paragraph.associatedCell.ownerRow.getSplitWidgets();
        let firstParagraph;
        let firstcell;
        if (row[0].childWidgets.length > 0) {
            firstcell = row[0].childWidgets[0];
            if (firstcell.childWidgets.length === 0) {
                return undefined;
            }
            firstParagraph = firstcell.childWidgets[0];
        }
        let lastParagraph;
        let lastRow = row[row.length - 1];
        let lastCell = lastRow.childWidgets[lastRow.childWidgets.length - 1];
        while (lastCell.childWidgets.length === 0 && !isNullOrUndefined(lastCell.previousSplitWidget)) {
            lastCell = lastCell.previousSplitWidget;
        }
        lastParagraph = lastCell.childWidgets[lastCell.childWidgets.length - 1];
        return firstcell.equals(firstParagraph.associatedCell) &&
            end.paragraph.associatedCell.equals(lastParagraph.associatedCell)
            && (!firstParagraph.associatedCell.equals(lastParagraph.associatedCell) || (start.offset === 0
                && end.offset === this.getLineLength(lastParagraph.lastChild) + 1));
    }
    /**
     * Get the bounds of row and col index from selected cells
     *
     * @private
     * @returns {object}
     */
    getCellBoundsInfo() {
        let selectedWidgets = this.getSelectedCells();
        if (selectedWidgets.length > 0) {
            let colFirst = selectedWidgets[0].columnIndex;
            let colLast = selectedWidgets[selectedWidgets.length - 1].columnIndex;
            let rowFirst = selectedWidgets[0].rowIndex;
            let rowLast = selectedWidgets[selectedWidgets.length - 1].rowIndex;
            for (let i = 0; i < selectedWidgets.length; i++) {
                let widget = selectedWidgets[i];
                if (widget.columnIndex < colFirst) {
                    colFirst = widget.columnIndex;
                }
                if (widget.columnIndex > colLast) {
                    colLast = widget.columnIndex;
                }
                if (widget.rowIndex < rowFirst) {
                    rowFirst = widget.rowIndex;
                }
                if (widget.rowIndex > rowLast) {
                    rowLast = widget.rowIndex;
                }
            }
            return { 'column': {
                    'colFirst': colFirst,
                    'colLast': colLast
                },
                'row': {
                    'rowFirst': rowFirst,
                    'rowLast': rowLast
                }
            };
        }
        return undefined;
    }
    /**
     * Return true if the selection has merged cells, else false.
     *
     * @private
     * @returns {boolean}
     */
    hasMergedCells() {
        let selectedCells = this.getSelectedCells();
        for (let i = 0; i < selectedCells.length; i++) {
            let widget = selectedCells[i];
            if (widget.cellFormat.rowSpan > 1 || widget.cellFormat.columnSpan > 1) {
                return true;
            }
        }
        return false;
    }
    /**
     * @private
     * @returns {ParagraphInfo}
     */
    getParagraphInfoInternal(line, lineOffset) {
        let paragraph = line.paragraph;
        let offset = this.getParagraphLength(paragraph, line) + lineOffset;
        let previous = paragraph.previousSplitWidget;
        while (previous instanceof ParagraphWidget) {
            paragraph = previous;
            offset += this.documentHelper.selection.getParagraphLength(paragraph);
            previous = paragraph.previousSplitWidget;
        }
        return { 'paragraph': paragraph, 'offset': offset };
    }
    /**
     * @private
     * @returns {ListTextElementBox}
     */
    getListTextElementBox(paragarph) {
        if (isNullOrUndefined(paragarph)) {
            return undefined;
        }
        let listTextElement;
        if (!paragarph.isEmpty()) {
            const lineWidget = paragarph.childWidgets[0];
            if (lineWidget.children.length > 1) {
                if (lineWidget.children[0] instanceof ListTextElementBox) {
                    listTextElement = lineWidget.children[0];
                }
            }
        }
        return listTextElement;
    }
    /**
     * @private
     * @returns {WListLevel}
     */
    getListLevel(paragraph) {
        let currentList = undefined;
        let listLevelNumber = 0;
        if (!isNullOrUndefined(paragraph.paragraphFormat) && !isNullOrUndefined(paragraph.paragraphFormat.listFormat)) {
            currentList = this.documentHelper.getListById(paragraph.paragraphFormat.listFormat.listId);
            listLevelNumber = paragraph.paragraphFormat.listFormat.listLevelNumber;
        }
        if (!isNullOrUndefined(currentList) &&
            !isNullOrUndefined(this.documentHelper.getAbstractListById(currentList.abstractListId))
            // && !isNullOrUndefined(this.documentHelper.getAbstractListById(currentList.abstractListId).levels.getItem(listLevelNumber))) {
            && !isNullOrUndefined(this.documentHelper.getAbstractListById(currentList.abstractListId).levels)) {
            return this.documentHelper.layout.getListLevel(currentList, listLevelNumber);
        }
        return undefined;
    }
    getTextInline(inlineElement, endParagraphWidget, endInline, endIndex, includeObject) {
        let text = '';
        do {
            if (inlineElement === endInline) {
                if (inlineElement instanceof TextElementBox) {
                    const span = inlineElement;
                    if (!(isNullOrUndefined(span.text) || span.text === '')) {
                        if (span.text.length < endIndex) {
                            text = text + span.text;
                        }
                        else {
                            text = text + span.text.substring(0, endIndex);
                        }
                    }
                }
                else if ((inlineElement instanceof ImageElementBox || inlineElement instanceof GroupShapeElementBox) && includeObject && endIndex === inlineElement.length) {
                    text = text + ElementBox.objectCharacter;
                }
                return text;
            }
            if (inlineElement instanceof TextElementBox) {
                text = text + inlineElement.text;
            }
            else if ((inlineElement instanceof ImageElementBox || inlineElement instanceof GroupShapeElementBox) && includeObject) {
                text = text + ElementBox.objectCharacter;
            }
            else if (inlineElement instanceof FieldElementBox && !isNullOrUndefined(inlineElement.fieldEnd)) {
                if (!isNullOrUndefined(inlineElement.fieldSeparator)) {
                    inlineElement = inlineElement.fieldSeparator;
                }
                else {
                    inlineElement = inlineElement.fieldEnd;
                }
            }
            if (isNullOrUndefined(inlineElement.nextNode)) {
                break;
            }
            inlineElement = inlineElement.nextNode;
        } while (!isNullOrUndefined(inlineElement));
        return text;
    }
    /**
     * Returns field code.
     *
     * @private
     * @param fieldBegin
     * @returns {string}
     */
    getFieldCode(fieldBegin, isSkipTrim) {
        let fieldCode = '';
        if (!isNullOrUndefined(fieldBegin) && !(fieldBegin.fieldEnd instanceof FieldElementBox)) {
            return fieldCode;
        }
        let paragraph = fieldBegin.paragraph;
        let endParagraph = fieldBegin.fieldEnd.paragraph;
        if (fieldBegin.fieldSeparator instanceof FieldElementBox) {
            endParagraph = fieldBegin.fieldSeparator.paragraph;
        }
        let startLineIndex = fieldBegin.line.indexInOwner;
        let startIndex = fieldBegin.indexInOwner;
        do {
            fieldCode += this.getFieldCodeInternal(paragraph, startLineIndex, startIndex);
            if (paragraph === endParagraph) {
                break;
            }
            paragraph = this.getNextParagraphBlock(paragraph);
            startLineIndex = 0;
            startIndex = 0;
        } while (paragraph instanceof ParagraphWidget);
        return isSkipTrim ? fieldCode : fieldCode.trim();
    }
    getFieldCodeInternal(paragraph, startLineIndex, inlineIndex) {
        let fieldCode = '';
        for (let i = startLineIndex; i < paragraph.childWidgets.length; i++) {
            const line = paragraph.childWidgets[i];
            for (let i = inlineIndex; i < line.children.length; i++) {
                const element = line.children[i];
                if (element instanceof TextElementBox) {
                    fieldCode += element.text;
                }
                if (element instanceof FieldElementBox
                    && (element.fieldType === 2 || element.fieldType === 1)) {
                    return fieldCode;
                }
            }
            inlineIndex = 0;
        }
        return fieldCode;
    }
    /**
     * @private
     * @returns {FieldElementBox}
     */
    getTocFieldInternal() {
        let paragraph = this.start.paragraph;
        if (!this.isEmpty && !this.isForward) {
            paragraph = this.end.paragraph;
        }
        while (paragraph instanceof ParagraphWidget && paragraph.childWidgets.length > 0) {
            const line = paragraph.firstChild;
            if (line.children.length > 0) {
                const element = line.children[0];
                const nextElement = element.nextNode;
                if (element instanceof FieldElementBox && element.fieldType === 0 && nextElement instanceof TextElementBox
                    && nextElement.text.trim().toLowerCase().indexOf('toc') === 0) {
                    return element;
                }
            }
            paragraph = paragraph.previousRenderedWidget;
        }
        return undefined;
    }
    /**
     * Get next paragraph in bodyWidget
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getNextParagraph(section) {
        if (section.nextRenderedWidget instanceof BodyWidget) {
            const block = section.nextRenderedWidget.childWidgets[0];
            return this.documentHelper.getFirstParagraphBlock(block);
        }
        return undefined;
    }
    /**
     * @private
     * @returns {ParagraphWidget}
     */
    getPreviousParagraph(section) {
        if (section.previousRenderedWidget instanceof BodyWidget) {
            const bodyWidget = section.previousRenderedWidget;
            const block = bodyWidget.childWidgets[bodyWidget.childWidgets.length - 1];
            return this.documentHelper.getLastParagraphBlock(block);
        }
        return undefined;
    }
    /**
     * Get Next start inline
     *
     * @private
     * @returns {ElementBox}
     */
    getNextStartInline(line, offset) {
        let indexInInline = 0;
        const inlineObj = line.getInline(offset, indexInInline);
        let inline = inlineObj.element;
        indexInInline = inlineObj.index;
        if ((!isNullOrUndefined(inline) && indexInInline === inline.length && inline.nextNode instanceof FieldElementBox)
            || inline instanceof ShapeElementBox) {
            const nextValidInline = this.documentHelper.getNextValidElement(inline.nextNode);
            if (nextValidInline instanceof FieldElementBox && nextValidInline.fieldType === 0) {
                inline = nextValidInline;
            }
        }
        return inline;
    }
    /**
     * Get previous text inline
     *
     * @private
     * @returns {ElementBox}
     */
    getPreviousTextInline(inline) {
        if (inline.previousNode instanceof TextElementBox) {
            return inline.previousNode;
        }
        if (inline.previousNode instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline.previousNode)) {
            if (inline.previousNode.fieldType === 0 || inline.previousNode.fieldType === 1) {
                return inline.previousNode;
            }
            return inline.previousNode.fieldBegin;
        }
        if (!isNullOrUndefined(inline.previousNode)) {
            return this.getPreviousTextInline((inline.previousNode));
        }
        return undefined;
    }
    /**
     * Get next text inline
     *
     * @private
     * @returns {ElementBox}
     */
    getNextTextInline(inline) {
        if (inline.nextNode instanceof TextElementBox) {
            return inline.nextNode;
        }
        if (inline.nextNode instanceof FieldElementBox && (HelperMethods.isLinkedFieldCharacter(inline.nextNode))) {
            if (inline.nextNode.fieldType === 1 || inline.nextNode.fieldType === 0) {
                return inline.nextNode;
            }
            return inline.nextNode.fieldEnd;
        }
        if (!isNullOrUndefined(inline.nextNode)) {
            return this.getNextTextInline((inline.nextNode));
        }
        return undefined;
    }
    /**
     * Get container table
     *
     * @private
     * @returns {TableWidget}
     */
    getContainerTable(block) {
        if (block.isInsideTable) {
            if (block.associatedCell.ownerTable.isInsideTable) {
                block = this.getContainerTable(block.associatedCell.ownerTable);
            }
            else {
                block = block.associatedCell.ownerTable;
            }
        }
        if (block instanceof TableWidget) {
            return block;
        }
        return undefined;
    }
    /**
     * @private
     * @param element
     * @returns
     */
    isElementInSelection(element, isEnd) {
        let offset = element.line.getOffset(element, isEnd ? 1 : 0);
        let elemPosition = new TextPosition(this.owner);
        elemPosition.setPositionParagraph(element.line, offset);
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        return ((elemPosition.isExistAfter(start) || (elemPosition.isAtSamePosition(start) && !isEnd))
            && (elemPosition.isExistBefore(end) || (elemPosition.isAtSamePosition(end) && isEnd)));
    }
    /**
     * @private
     */
    isSelectionInsideElement(element) {
        //Handled for spellcheck
        if (this.isEmpty) {
            let startOffset = element.line.getOffset(element, 0);
            let startPosition = new TextPosition(this.owner);
            startPosition.setPositionParagraph(element.line, startOffset);
            let endOffset = element.line.getOffset(element, element.length);
            let endPosition = new TextPosition(this.owner);
            endPosition.setPositionParagraph(element.line, endOffset);
            return ((this.start.isExistAfter(startPosition) || this.start.isAtSamePosition(startPosition))
                && (this.start.isExistBefore(endPosition) || this.start.isAtSamePosition(endPosition)));
        }
        return false;
    }
    /**
     * @private
     * @returns {boolean}
     */
    isExistBefore(start, block) {
        if (start.isInsideTable) {
            let cell1 = start.associatedCell;
            if (block.isInsideTable) {
                let cell2 = block.associatedCell;
                if (cell1 === cell2) {
                    return cell1.childWidgets.indexOf(start) < cell1.childWidgets.indexOf(block);
                }
                if (cell1.ownerRow === cell2.ownerRow) {
                    return cell1.cellIndex < cell2.cellIndex;
                }
                if (cell1.ownerTable === cell2.ownerTable) {
                    return cell1.ownerRow.rowIndex < cell2.ownerRow.rowIndex;
                }
                //Checks if current block exists before the block.
                const containerCell = this.getContainerCellOf(cell1, cell2);
                if (containerCell.ownerTable.contains(cell2)) {
                    cell1 = this.getSelectedCell(cell1, containerCell);
                    cell2 = this.getSelectedCell(cell2, containerCell);
                    // Need to check if the cell1 and cell2 is same owner table then need to check the owner row and table
                    if (cell1.ownerRow === cell2.ownerRow) {
                        return cell1.cellIndex < cell2.cellIndex;
                    }
                    if (cell1.ownerTable === cell2.ownerTable) {
                        return cell1.ownerRow.rowIndex < cell2.ownerRow.rowIndex;
                    }
                    if (cell1 === containerCell) {
                        return this.isExistBefore(start, cell2.ownerTable);
                    }
                    if (cell2 === containerCell) {
                        return this.isExistBefore(cell1.ownerTable, block);
                    }
                    if (containerCell.ownerRow === cell2.ownerRow) {
                        return containerCell.cellIndex < cell2.cellIndex;
                    }
                    if (containerCell.ownerTable === cell2.ownerTable) {
                        return containerCell.ownerRow.rowIndex < cell2.ownerRow.rowIndex;
                    }
                    return this.isExistBefore(cell1.ownerTable, cell2.ownerTable);
                }
                return this.isExistBefore(containerCell.ownerTable, this.getContainerTable(cell2.ownerTable));
            }
            else {
                const ownerTable = this.getContainerTable(start);
                return this.isExistBefore(ownerTable, block);
            }
        }
        else if (block.isInsideTable) {
            const ownerTable = this.getContainerTable(block);
            return this.isExistBefore(start, ownerTable);
        }
        else {
            {
                if (start.containerWidget === block.containerWidget) {
                    return start.index <
                        block.index;
                }
                if ((start.containerWidget instanceof BodyWidget && block.containerWidget instanceof BodyWidget)) {
                    if (this.documentHelper.isCopying && start.containerWidget.footNoteReference && start.containerWidget.footNoteReference.line && start.containerWidget.footNoteReference.line.paragraph.index < block.index) {
                        return true;
                    }
                    //Splitted blocks
                    const startPage = this.documentHelper.pages.indexOf(start.containerWidget.page);
                    const endPage = this.documentHelper.pages.indexOf(block.containerWidget.page);
                    if (startPage === endPage) {
                        return start.containerWidget.indexInOwner < block.containerWidget.indexInOwner;
                    }
                    if (startPage === endPage && start.containerWidget.containerWidget instanceof FootNoteWidget && block.containerWidget.containerWidget instanceof FootNoteWidget) {
                        const startindex = this.documentHelper.pages[startPage].footnoteWidget.bodyWidgets.indexOf(start.containerWidget);
                        const endindex = this.documentHelper.pages[endPage].footnoteWidget.bodyWidgets.indexOf(block.containerWidget);
                        return startindex < endindex;
                    }
                    else if (startPage === endPage && start.containerWidget.index !== block.containerWidget.index) {
                        const startindex = this.documentHelper.pages[startPage].bodyWidgets.indexOf(start.containerWidget);
                        const endindex = this.documentHelper.pages[endPage].bodyWidgets.indexOf(block.containerWidget);
                        return startindex < endindex;
                    }
                    else {
                        return startPage < endPage;
                    }
                }
                if (this.documentHelper.isCopying && start.containerWidget && start.containerWidget !== block.containerWidget && start.containerWidget instanceof TextFrame
                    && start.containerWidget.containerShape && start.containerWidget.containerShape instanceof ShapeElementBox && start.containerWidget.containerShape.line
                    && start.containerWidget.containerShape.line.paragraph && start.containerWidget.containerShape.line.paragraph.index < block.index) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * @private
     * @returns {boolean}
     */
    isExistAfter(start, block) {
        if (start.isInsideTable) {
            let cell1 = start.associatedCell;
            //Current paragraph in cell, paragraph in cell
            if (block.isInsideTable) {
                let cell2 = block.associatedCell;
                if (cell1 === cell2) {
                    return cell1.childWidgets.indexOf(start) > cell1.childWidgets.indexOf(block);
                }
                if (cell1.ownerRow === cell2.ownerRow) {
                    return cell1.cellIndex > cell2.cellIndex;
                }
                if (cell1.ownerTable === cell2.ownerTable) {
                    return cell1.ownerRow.rowIndex > cell2.ownerRow.rowIndex;
                }
                //Checks if this block exists before block.
                const containerCell = this.getContainerCellOf(cell1, cell2);
                if (containerCell.ownerTable.contains(cell2)) {
                    cell1 = this.getSelectedCell(cell1, containerCell);
                    cell2 = this.getSelectedCell(cell2, containerCell);
                    if (containerCell.ownerRow === cell2.ownerRow) {
                        return containerCell.cellIndex > cell2.cellIndex;
                    }
                    if (containerCell.ownerTable === cell2.ownerTable) {
                        return containerCell.ownerRow.rowIndex > cell2.ownerRow.rowIndex;
                    }
                    if (cell1 === containerCell) {
                        return this.isExistAfter(start, cell2.ownerTable);
                    }
                    if (cell2 === containerCell) {
                        return this.isExistAfter(cell1.ownerTable, block);
                    }
                    return this.isExistAfter(cell1.ownerTable, cell2.ownerTable);
                }
                return this.isExistAfter(containerCell.ownerTable, this.getContainerTable(cell2.ownerTable));
            }
            else {
                const ownerTable = this.getContainerTable(start);
                return this.isExistAfter(ownerTable, block);
            }
        }
        else if (block.isInsideTable) {
            const ownerTable = this.getContainerTable(block);
            return this.isExistAfter(start, ownerTable);
        }
        else {
            if (start.containerWidget === block.containerWidget) {
                return start.index >
                    block.index;
            }
            if ((start.containerWidget instanceof BodyWidget && block.containerWidget instanceof BodyWidget) || (start.containerWidget instanceof FootNoteWidget && block.containerWidget instanceof FootNoteWidget)) {
                //Splitted blocks
                const startPage = this.documentHelper.pages.indexOf(start.containerWidget.page);
                const endPage = this.documentHelper.pages.indexOf(block.containerWidget.page);
                return startPage > endPage;
            }
            //     if (start.owner instanceof WHeaderFooter) {
            //         return (start.owner as WHeaderFooter).childWidgets.indexOf(start)
            // > (block.owner as WHeaderFooter).childWidgets.indexOf(block);
            //     } else if (start.section === block.section && start.section instanceof WSection) {
            //         return (start.section as WSection).childWidgets.indexOf(start)
            //  > (start.section as WSection).childWidgets.indexOf(block);
            //     } else if (start.wordDocument instanceof WordDocument) {
            //         return (start.wordDocument as WordDocument).sections.indexOf(start.section as WSection) > (start.wordDocument as WordDocument).sections.indexOf(block.section as WSection);
        }
        return false;
    }
    /**
     * Return true if current inline in exist before inline
     *
     * @private
     * @returns {boolean}
     */
    isExistBeforeInline(currentInline, inline, isIncludeFieldStart, isIncludeField) {
        if (currentInline.line === inline.line) {
            const fieldBegin = inline instanceof FieldElementBox ? inline : inline.nextNode;
            const offset = this.isForward ? this.start.offset : this.end.offset;
            const isSelectionBegin = (fieldBegin instanceof FieldElementBox && fieldBegin.fieldType === 0 && (inline instanceof FieldElementBox || offset === inline.line.getOffset(inline, inline.length)));
            if (((isIncludeField && isIncludeFieldStart) || (!isIncludeField && !(inline instanceof BookmarkElementBox))) && isSelectionBegin) {
                return currentInline.line.children.indexOf(currentInline) >= inline.line.children.indexOf(inline);
            }
            else {
                return currentInline.line.children.indexOf(currentInline) <= inline.line.children.indexOf(inline);
            }
        }
        if (currentInline.line.paragraph === inline.line.paragraph) {
            return currentInline.line.paragraph.childWidgets.indexOf(currentInline.line)
                < inline.line.paragraph.childWidgets.indexOf(inline.line);
        }
        const startParagraph = currentInline.line.paragraph;
        const endParagraph = inline.line.paragraph;
        if (startParagraph.containerWidget === endParagraph.containerWidget) {
            if (startParagraph.isInsideTable) {
                return startParagraph.associatedCell.childWidgets.indexOf(startParagraph) <
                    endParagraph.associatedCell.childWidgets.indexOf(endParagraph);
            }
            else if (startParagraph.containerWidget instanceof HeaderFooterWidget) {
                // return ((currentInline.owner as WParagraph).owner as WHeaderFooter).blocks.indexOf(currentInline.owner as WParagraph) <
                //     ((inline.owner as WParagraph).owner as WHeaderFooter).blocks.indexOf(inline.owner as WParagraph);
            }
            else {
                return startParagraph.containerWidget.childWidgets.indexOf(startParagraph) <
                    endParagraph.containerWidget.childWidgets.indexOf(endParagraph);
            }
        }
        return this.isExistBefore(startParagraph, endParagraph);
    }
    /**
     * Return true id current inline is exist after inline
     *
     * @private
     * @returns {boolean}
     */
    isExistAfterInline(currentInline, inline, isRetrieve, isIncludeFieldEnd, isIncludeField) {
        if (currentInline.line === inline.line) {
            let selection = this.documentHelper.selection;
            const isSelectionEnd = (isIncludeField && (currentInline instanceof BookmarkElementBox ||
                (currentInline instanceof FieldElementBox && currentInline.fieldType === 1)));
            if (isRetrieve) {
                if (((isSelectionEnd && !isIncludeFieldEnd) || (!isIncludeField && currentInline instanceof FieldElementBox && currentInline.fieldType === 1)) && this.isEmpty) {
                    return currentInline.line.children.indexOf(currentInline) >
                        inline.line.children.indexOf(inline);
                }
                else {
                    return currentInline.line.children.indexOf(currentInline) >=
                        inline.line.children.indexOf(inline);
                }
            }
            else if (currentInline === inline && selection.start.offset !== selection.end.offset) {
                return currentInline.line.children.indexOf(currentInline) ===
                    inline.line.children.indexOf(inline);
            }
            else {
                return currentInline.line.children.indexOf(currentInline) >
                    inline.line.children.indexOf(inline);
            }
        }
        if (currentInline.line.paragraph === inline.line.paragraph) {
            return currentInline.line.paragraph.childWidgets.indexOf(currentInline.line)
                > inline.line.paragraph.childWidgets.indexOf(inline.line);
        }
        const startParagraph = currentInline.line.paragraph;
        const endParagraph = inline.line.paragraph;
        if (startParagraph.containerWidget === endParagraph.containerWidget) {
            if (startParagraph.isInsideTable) {
                return startParagraph.associatedCell.childWidgets.indexOf(startParagraph) >
                    endParagraph.associatedCell.childWidgets.indexOf(endParagraph);
            }
            else if (startParagraph.containerWidget instanceof HeaderFooterWidget) {
                // return ((currentInline.owner as WParagraph).owner as WHeaderFooter).blocks.indexOf(currentInline.owner as WParagraph) <
                //     ((inline.owner as WParagraph).owner as WHeaderFooter).blocks.indexOf(inline.owner as WParagraph);
            }
            else {
                return startParagraph.containerWidget.childWidgets.indexOf(startParagraph) >
                    endParagraph.containerWidget.childWidgets.indexOf(endParagraph);
            }
        }
        return this.isExistAfter(startParagraph, endParagraph);
    }
    /**
     * Get next rendered block
     *
     * @private
     * @returns {BlockWidget}
     */
    getNextRenderedBlock(block) {
        if (isNullOrUndefined(block.nextWidget)) {
            return block.nextRenderedWidget;
        }
        return block.nextWidget;
    }
    /**
     * Get next rendered block
     *
     * @private
     * @returns {BlockWidget}
     */
    getPreviousRenderedBlock(block) {
        if (isNullOrUndefined(block.previousWidget)) {
            return block.previousRenderedWidget;
        }
        return block.previousWidget;
    }
    /**
     * Get Next paragraph in block
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getNextParagraphBlock(block) {
        if (block.nextRenderedWidget instanceof ParagraphWidget) {
            return block.nextRenderedWidget;
        }
        else if (block.nextRenderedWidget instanceof TableWidget) {
            return this.documentHelper.getFirstParagraphInFirstCell(block.nextRenderedWidget);
        }
        if (block.containerWidget instanceof TableCellWidget) {
            return this.getNextParagraphCell(block.containerWidget);
        }
        else if (block.containerWidget instanceof BodyWidget) {
            const bodyWidget = block.containerWidget;
            return this.getNextParagraph(block.containerWidget);
        }
        else if (block.containerWidget instanceof HeaderFooterWidget && this.isMoveDownOrMoveUp) {
            return this.getFirstBlockInNextHeaderFooter(block);
        }
        return undefined;
    }
    /**
     * @private
     * @returns {ParagraphWidget}
     */
    getFirstBlockInNextHeaderFooter(block) {
        const headerFooter = block.containerWidget;
        let nextBlock;
        if (headerFooter.headerFooterType.indexOf('Header') !== -1) {
            nextBlock = headerFooter.page.footerWidget.firstChild;
        }
        else if (headerFooter.page.nextPage) {
            const nextPage = headerFooter.page.nextPage;
            const headerWidget = nextPage.headerWidget;
            headerWidget.page = nextPage;
            if (nextPage.footerWidget) {
                nextPage.footerWidget.page = nextPage;
            }
            nextBlock = headerWidget.firstChild;
        }
        else {
            return undefined;
        }
        if (nextBlock instanceof ParagraphWidget) {
            return nextBlock;
        }
        else {
            return this.getFirstBlockInFirstCell(nextBlock);
        }
    }
    /**
     * @private
     * @returns {ParagraphWidget}
     */
    getLastBlockInPreviousHeaderFooter(block) {
        const headerFooter = block.containerWidget;
        let previousBlock;
        if (headerFooter.headerFooterType.indexOf('Footer') !== -1) {
            previousBlock = headerFooter.page.headerWidget.lastChild;
        }
        else if (headerFooter.page.previousPage) {
            const previousPage = headerFooter.page.previousPage;
            const footerWidget = previousPage.footerWidget;
            footerWidget.page = previousPage;
            if (previousPage.headerWidget) {
                previousPage.headerWidget.page = previousPage;
            }
            previousBlock = footerWidget.lastChild;
        }
        else {
            return undefined;
        }
        if (previousBlock instanceof ParagraphWidget) {
            return previousBlock;
        }
        else {
            return this.getFirstBlockInFirstCell(previousBlock);
        }
    }
    /**
     * Get previous paragraph in block
     *
     * @private
     * @returns {ParagraphWidget}
     */
    getPreviousParagraphBlock(block, isAutoList) {
        if (block.previousRenderedWidget instanceof ParagraphWidget) {
            return block.previousRenderedWidget;
        }
        else if (block.previousRenderedWidget instanceof TableWidget) {
            return this.documentHelper.getLastParagraphInLastCell((block.previousRenderedWidget));
        }
        if (block.containerWidget instanceof TableCellWidget) {
            return this.getPreviousParagraphCell((block.containerWidget));
        }
        else if (block.containerWidget instanceof BodyWidget) {
            return this.getPreviousParagraph(block.containerWidget);
        }
        else if (block.containerWidget instanceof HeaderFooterWidget && this.isMoveDownOrMoveUp && !isAutoList) {
            return this.getLastBlockInPreviousHeaderFooter(block);
        }
        return undefined;
    }
    /**
     * Return true if paragraph has valid inline
     *
     * @private
     * @returns {ParagraphWidget}
     */
    hasValidInline(paragraph, start, end) {
        const index = paragraph.childWidgets.indexOf(start.line);
        for (let i = index; i < paragraph.childWidgets.length; i++) {
            for (let j = 0; j < paragraph.childWidgets[i].children.length; j++) {
                const inline = paragraph.childWidgets[i].children[j];
                if (inline.length === 0) {
                    continue;
                }
                if (inline === end) {
                    return false;
                }
                if (inline instanceof TextElementBox || inline instanceof ImageElementBox || inline instanceof GroupShapeElementBox
                    || (inline instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline))) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * Get paragraph length
     *
     * @private
     * @returns {number}
     */
    getParagraphLength(paragraph, endLine, elementInfo, includeShape) {
        let length = 0;
        if (!isNullOrUndefined(paragraph)) {
            for (let j = 0; j < paragraph.childWidgets.length; j++) {
                const line = paragraph.childWidgets[j];
                if (endLine instanceof LineWidget && endLine === line) {
                    if (elementInfo) {
                        length += this.getLineLength(line, elementInfo, includeShape);
                    }
                    break;
                }
                length += this.getLineLength(line, undefined, includeShape);
            }
        }
        return length;
    }
    /**
     * Get Line length
     *
     * @private
     * @returns {number}
     */
    getLineLength(line, elementInfo, includeShape) {
        let length = 0;
        const bidi = line.paragraph.bidi;
        for (let i = !bidi ? 0 : line.children.length - 1; bidi ? i > -1 : i < line.children.length; bidi ? i-- : i++) {
            const element = line.children[i];
            if (element instanceof ListTextElementBox) {
                continue;
            }
            if (includeShape) {
                if (element instanceof ShapeElementBox) {
                    for (let m = 0; m < element.textFrame.childWidgets.length; m++) {
                        let para = element.textFrame.childWidgets[m];
                        length += this.getParagraphLength(para) + 1;
                    }
                }
                else if (element instanceof FootnoteElementBox) {
                    for (let m = 0; m < element.bodyWidget.childWidgets.length; m++) {
                        let para = element.bodyWidget.childWidgets[m];
                        length += this.getParagraphLength(para) + 1;
                    }
                }
            }
            if (elementInfo && elementInfo.element instanceof ElementBox && elementInfo.element === element) {
                length += elementInfo.index;
                break;
            }
            length += element.length;
        }
        return length;
    }
    /**
     * Get line information
     *
     * @private
     * @returns {LineInfo}
     */
    getLineInfo(paragraph, offset) {
        let line = undefined;
        let length = 0;
        const childLength = paragraph.childWidgets.length;
        for (let j = 0; j < childLength; j++) {
            line = paragraph.childWidgets[j];
            length = this.getLineLength(line);
            if (offset <= length || j === childLength - 1) {
                break;
            }
            else {
                offset = offset - length;
            }
        }
        return { 'line': line, 'offset': offset };
    }
    /**
     * @private
     * @returns {ElementInfo}
     */
    getElementInfo(line, offset) {
        const index = 0;
        let element = undefined;
        for (let i = 0; i < line.children.length; i++) {
            element = line.children[i];
            if (element instanceof ListTextElementBox) {
                continue;
            }
            if (offset > element.length
                && (!(offset === element.length + 1 && isNullOrUndefined(element.nextNode)))) {
                offset = offset - element.length;
            }
            else {
                break;
            }
        }
        return { 'element': element, 'index': offset };
    }
    /**
     * Get paragraph start offset
     *
     * @private
     * @returns {number}
     */
    getStartOffset(paragraph) {
        const startOffset = 0;
        if (paragraph.childWidgets.length > 0) {
            const childWidgets = paragraph.childWidgets[0];
            return this.getStartLineOffset(childWidgets);
        }
        return startOffset;
    }
    /**
     * @private
     */
    getStartLineOffset(line, isNavigate) {
        let startOffset = 0;
        let isHidden = true;
        for (let i = 0; i < line.children.length; i++) {
            const inline = line.children[i];
            if (inline.length === 0) {
                continue;
            }
            if (inline instanceof ElementBox && inline.characterFormat.hidden) {
                startOffset += inline.length;
                if (isHidden) {
                    startOffset += 1;
                    isHidden = false;
                }
                continue;
            }
            // if the first element in the line is a Bookmark Start, need to move the cursor inside bookmark start element.
            if (inline instanceof BookmarkElementBox && inline.bookmarkType == 0 && isNavigate) {
                return startOffset + inline.length;
            }
            if (inline instanceof TextElementBox || inline instanceof ImageElementBox || inline instanceof BookmarkElementBox
                || inline instanceof ShapeElementBox || inline instanceof EditRangeStartElementBox || inline instanceof GroupShapeElementBox
                || inline instanceof EditRangeEndElementBox || inline instanceof CommentCharacterElementBox
                || (inline instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline))
                || inline instanceof ContentControl) {
                return startOffset;
            }
            if (inline instanceof ListTextElementBox) {
                continue;
            }
            startOffset += inline.length;
        }
        return startOffset;
    }
    /**
     * Get previous paragraph from selection
     *
     * @private
     */
    getPreviousSelectionCell(cell) {
        if (!isNullOrUndefined(cell.previousRenderedWidget)) {
            if (!this.isForward) {
                const block = cell.previousRenderedWidget.childWidgets[0];
                if (block instanceof ParagraphWidget) {
                    return block;
                }
                else {
                    return this.documentHelper.getFirstParagraphInLastRow(block);
                }
            }
            else {
                const widgets = cell.previousRenderedWidget.childWidgets;
                const block = widgets[widgets.length - 1];
                if (block instanceof ParagraphWidget) {
                    return block;
                }
                else {
                    return this.getPreviousParagraphSelection(block.childWidgets[block.childWidgets.length - 1]);
                }
            }
        }
        return this.getPreviousSelectionRow(cell.ownerRow);
    }
    /**
     * Get previous paragraph selection in selection
     *
     * @private
     */
    getPreviousSelectionRow(row) {
        if (!isNullOrUndefined(row.previousRenderedWidget)) {
            if (!this.isForward) {
                const cell = row.previousRenderedWidget.childWidgets[0];
                const block = cell.childWidgets[0];
                return this.documentHelper.getFirstParagraphBlock(block);
            }
            else {
                return this.getPreviousParagraphSelection(row.previousRenderedWidget);
            }
        }
        return this.getPreviousSelectionBlock(row.ownerTable);
    }
    /**
     * @private
     */
    getNextSelectionBlock(block) {
        if (block.nextRenderedWidget instanceof ParagraphWidget) {
            return block.nextRenderedWidget;
        }
        else if (block.nextRenderedWidget instanceof TableWidget) {
            if (this.isEmpty || this.isForward) {
                return this.documentHelper.getLastParagraphInFirstRow(block.nextRenderedWidget);
            }
            else {
                return this.getNextParagraphSelection(block.nextRenderedWidget.childWidgets[0]);
            }
        }
        if (block.containerWidget instanceof TableCellWidget) {
            return this.getNextSelectionCell(block.containerWidget);
        }
        else if (block.containerWidget instanceof BodyWidget) {
            return this.getNextSelection(block.containerWidget);
        }
        return undefined;
    }
    /**
     * Get next paragraph from selected cell
     *
     * @private
     */
    getNextSelectionCell(cell) {
        if (!isNullOrUndefined(cell.nextRenderedWidget)) {
            if (this.isEmpty || this.isForward) {
                const block = cell.nextRenderedWidget.childWidgets[cell.nextRenderedWidget.childWidgets.length - 1];
                return this.documentHelper.getLastParagraphBlock(block);
            }
            else {
                //Return first paragraph in cell.
                const block = cell.nextRenderedWidget.childWidgets[0];
                if (block instanceof ParagraphWidget) {
                    return block;
                }
                else {
                    return this.getNextParagraphSelection(block.childWidgets[0]);
                }
            }
        }
        return this.getNextSelectionRow(cell.ownerRow);
    }
    /**
     * Get next paragraph in selection
     *
     * @private
     */
    getNextSelectionRow(row) {
        if (!isNullOrUndefined(row.nextRenderedWidget)) {
            const isForwardSelection = this.isEmpty || this.isForward;
            if (isForwardSelection) {
                const cell = row.nextRenderedWidget.childWidgets[row.nextRenderedWidget.childWidgets.length - 1];
                const block = cell.childWidgets[cell.childWidgets.length - 1];
                return this.documentHelper.getLastParagraphBlock(block);
            }
            else {
                return this.getNextParagraphSelection(row.nextRenderedWidget);
            }
        }
        return this.getNextSelectionBlock(row.ownerTable);
    }
    /**
     * Get next block with selection
     *
     * @private
     */
    getNextSelection(section) {
        if (section.nextRenderedWidget instanceof BodyWidget) {
            const block = section.nextRenderedWidget.childWidgets[0];
            if (block instanceof ParagraphWidget) {
                return block;
            }
            else {
                if (this.isEmpty || this.isForward) {
                    return this.documentHelper.getLastParagraphInFirstRow(block);
                }
                else {
                    return this.getNextParagraphSelection(block.childWidgets[0]);
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    getNextParagraphSelection(row) {
        //Iterate the exact cell based on UP/Down selection length.
        let cell = row.childWidgets[0];
        if (this.start.paragraph.isInsideTable
            && row.ownerTable.contains(this.start.paragraph.associatedCell)) {
            const startCell = this.getCellInTable(row.ownerTable, this.start.paragraph.associatedCell);
            cell = this.getFirstCellInRegion(row, startCell, this.upDownSelectionLength, false);
        }
        const block = cell.childWidgets[0];
        return this.documentHelper.getFirstParagraphBlock(block);
    }
    /**
     * @private
     */
    getPreviousSelectionBlock(block) {
        if (block.previousRenderedWidget instanceof ParagraphWidget) {
            return block.previousRenderedWidget;
        }
        else if (block.previousRenderedWidget instanceof TableWidget) {
            if (!this.isForward) {
                return this.documentHelper.getFirstParagraphInLastRow(block.previousRenderedWidget);
            }
            else {
                return this.getPreviousParagraphSelection(block.previousRenderedWidget.childWidgets[block.previousRenderedWidget.childWidgets.length - 1]);
            }
        }
        if (block.containerWidget instanceof TableCellWidget) {
            return this.getPreviousSelectionCell(block.containerWidget);
        }
        else if (block.containerWidget instanceof BodyWidget) {
            return this.getPreviousSelection(block.containerWidget);
        }
        return undefined;
    }
    /**
     * Get previous paragraph in selection
     *
     * @private
     */
    getPreviousSelection(section) {
        if (section.previousRenderedWidget instanceof BodyWidget) {
            const prevBodyWidget = section.previousRenderedWidget;
            const block = prevBodyWidget.childWidgets[prevBodyWidget.childWidgets.length - 1];
            if (block instanceof ParagraphWidget) {
                return block;
            }
            else {
                if (!this.isForward) {
                    return this.documentHelper.getFirstParagraphInLastRow(block);
                }
                else {
                    const tableWidget = block;
                    return this.getPreviousParagraphSelection(tableWidget.childWidgets[tableWidget.childWidgets.length - 1]);
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    getPreviousParagraphSelection(row) {
        //Iterate the exact cell based on UP/Down selection length.
        let cell = row.childWidgets[row.childWidgets.length - 1];
        if (this.start.paragraph.isInsideTable
            && row.ownerTable.contains(this.start.paragraph.associatedCell)) {
            const startCell = this.getCellInTable(row.ownerTable, this.start.paragraph.associatedCell);
            cell = this.getLastCellInRegion(row, startCell, this.upDownSelectionLength, true);
        }
        const block = cell.childWidgets[cell.childWidgets.length - 1];
        return this.documentHelper.getLastParagraphBlock(block);
    }
    /**
     * Get last cell in the selected region
     *
     * @private
     */
    getLastCellInRegion(row, startCell, selLength, isMovePrev) {
        const start = this.getCellLeft(row, startCell);
        const end = start + startCell.cellFormat.cellWidth;
        let flag = true;
        if (start <= selLength && selLength < end) {
            for (let i = row.childWidgets.length - 1; i >= 0; i--) {
                const left = this.getCellLeft(row, row.childWidgets[i]);
                if (HelperMethods.round(start, 2) <= HelperMethods.round(left, 2) &&
                    HelperMethods.round(left, 2) < HelperMethods.round(end, 2)) {
                    flag = false;
                    return row.childWidgets[i];
                }
            }
        }
        else {
            for (let i = row.childWidgets.length - 1; i >= 0; i--) {
                const left = this.getCellLeft(row, row.childWidgets[i]);
                if (left <= selLength && left + row.childWidgets[i].width > selLength) {
                    flag = false;
                    return row.childWidgets[i];
                }
            }
        }
        if (flag) {
            if (!isNullOrUndefined(row.previousRenderedWidget) && isMovePrev) {
                return this.getLastCellInRegion(row.previousRenderedWidget, startCell, selLength, isMovePrev);
            }
            else if (!isNullOrUndefined(row.nextRenderedWidget) && !isMovePrev) {
                return this.getLastCellInRegion(row.nextRenderedWidget, startCell, selLength, isMovePrev);
            }
        }
        return row.childWidgets[row.childWidgets.length - 1];
    }
    /**
     * Get Container table
     *
     * @private
     */
    getCellInTable(table, tableCell) {
        while (tableCell.ownerTable.isInsideTable) {
            if (table.equals(tableCell.ownerTable)) {
                return tableCell;
            }
            tableCell = tableCell.ownerTable.associatedCell;
        }
        return tableCell;
    }
    /**
     * Get previous valid offset
     *
     * @private
     */
    getPreviousValidOffset(line, offset) {
        if (offset === 0) {
            return 0;
        }
        let validOffset = 0;
        let count = 0;
        let hiddenTextLength = 0;
        for (let j = 0; j < line.children.length; j++) {
            const inline = line.children[j];
            if (inline.length === 0 || inline instanceof ListTextElementBox) {
                continue;
            }
            if (inline.characterFormat.hidden) {
                hiddenTextLength += inline.length;
                count += inline.length;
                continue;
            }
            hiddenTextLength = 0;
            if (offset <= count + inline.length) {
                return offset - 1 === count ? validOffset : offset - 1;
            }
            if (inline instanceof TextElementBox || inline instanceof ContentControl || inline instanceof ImageElementBox || inline instanceof CommentCharacterElementBox || inline instanceof BookmarkElementBox || inline instanceof GroupShapeElementBox
                || (inline instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline))) {
                validOffset = count + inline.length;
            }
            count += inline.length;
        }
        return offset - 1 === count ? validOffset : hiddenTextLength > 0 ? offset - (hiddenTextLength + 1) : offset - 1;
    }
    /**
     * Get next valid offset
     *
     * @private
     */
    getNextValidOffset(line, offset, isNavigate) {
        let count = 0;
        // if (!line.paragraph.paragraphFormat.bidi) {
        for (let i = 0; i < line.children.length; i++) {
            const inline = line.children[i];
            if (inline.length === 0 || inline instanceof ListTextElementBox) {
                continue;
            }
            if (inline.characterFormat.hidden) {
                count += inline.length;
                continue;
            }
            if (inline instanceof TextElementBox && inline.text === '\v') {
                count += inline.length;
                continue;
            }
            if (offset < count + inline.length) {
                if (inline instanceof TextElementBox || inline instanceof ContentControl || inline instanceof ImageElementBox || inline instanceof GroupShapeElementBox
                    || (inline instanceof FieldElementBox && HelperMethods.isLinkedFieldCharacter(inline))) {
                    // If the next element is a Bookmark Start and the current offset is just before it,
                    // recursively call getNextValidOffset to move the cursor inside the bookmark start position.
                    if (inline.nextNode instanceof BookmarkElementBox && inline.nextNode.bookmarkType == 0 && offset + 1 == count + inline.length) {
                        return this.getNextValidOffset(line, count + inline.length, true);
                    }
                    return isNullOrUndefined(isNavigate) ? (offset > count ? offset : count) + 1 : count;
                }
            }
            if (offset === count + inline.length && inline instanceof FieldElementBox &&
                inline.fieldType === 1 && inline.previousNode instanceof ImageElementBox) {
                return offset;
            }
            count += inline.length;
        }
        // } else {
        //     if (offset !== this.getLineLength(line)) {
        //         offset = line.getInlineForOffset(offset, false, undefined, false, false, true).index;
        //     }
        // }
        return offset;
    }
    /**
     * Get paragraph mark size info
     *
     * @private
     */
    getParagraphMarkSize(paragraph, topMargin, bottomMargin) {
        const size = this.documentHelper.textHelper.getParagraphMarkSize(paragraph.characterFormat);
        const baselineOffset = size.BaselineOffset;
        const maxHeight = size.Height;
        const maxBaselineOffset = baselineOffset;
        if (paragraph instanceof ParagraphWidget) {
            // let paragraphWidget: ParagraphWidget[] = paragraph.renderedElement() as ParagraphWidget[];
            if (paragraph.childWidgets.length > 0) {
                const lineWidget = paragraph.childWidgets[0];
            }
            //Gets line spacing.
            const lineSpacing = this.documentHelper.layout.getLineSpacing(paragraph, maxHeight);
            const beforeSpacing = this.documentHelper.layout.getBeforeSpacing(paragraph);
            topMargin = maxBaselineOffset - baselineOffset;
            bottomMargin = maxHeight - maxBaselineOffset - (size.Height - baselineOffset);
            //Updates line spacing, paragraph after/ before spacing and aligns the text to base line offset.
            const lineSpacingType = paragraph.paragraphFormat.lineSpacingType;
            if (lineSpacingType === 'Multiple') {
                if (lineSpacing > maxHeight) {
                    bottomMargin += lineSpacing - maxHeight;
                }
                else {
                    topMargin += lineSpacing - maxHeight;
                }
            }
            else if (lineSpacingType === 'Exactly') {
                topMargin += lineSpacing - (topMargin + size.Height + bottomMargin);
            }
            else if (lineSpacing > topMargin + size.Height + bottomMargin) {
                topMargin += lineSpacing - (topMargin + size.Height + bottomMargin);
            }
            topMargin += beforeSpacing;
            bottomMargin += this.documentHelper.layout.getAfterSpacing(paragraph);
        }
        return { 'width': size.Width, 'height': size.Height, 'topMargin': topMargin, 'bottomMargin': bottomMargin };
    }
    /**
     * @private
     */
    getPhysicalPositionInternal(line, offset, moveNextLine) {
        if (line.paragraph.isEmpty()) {
            const paragraphWidget = line.paragraph;
            let left = paragraphWidget.x;
            if (paragraphWidget.childWidgets.length > 0) {
                const lineWidget = paragraphWidget.childWidgets[0];
                left = this.getLeft(lineWidget);
            }
            const topMargin = 0;
            const bottomMargin = 0;
            const size = this.getParagraphMarkSize(line.paragraph, topMargin, bottomMargin);
            if (offset > 0 || (offset === 0 && paragraphWidget.isEmpty() && paragraphWidget.bidi)) {
                left += size.width;
            }
            return new Point(left, paragraphWidget.y + size.topMargin);
        }
        else {
            let indexInInline = 0;
            const inlineObj = line.getInline(offset, indexInInline, line.paragraph.bidi);
            const inline = inlineObj.element; //return indexInInline must
            indexInInline = inlineObj.index;
            // if (inline.length === indexInInline && !isNullOrUndefined(inline.nextNode) && this.viewer.renderedElements.containsKey(inline) &&
            //     this.viewer.renderedElements.get(inline).length > 0 && this.viewer.renderedElements.containsKey(inline.nextNode as WInline)
            //     && this.viewer.renderedElements.get(inline.nextNode as WInline).length > 0 &&
            //     (this.viewer.renderedElements.get(inline)[this.viewer.renderedElements.get(inline).length - 1] as ElementBox).line !== (this.viewer.renderedElements.get(inline.nextNode as WInline)[0] as ElementBox).line) {
            //     //Handled specifically to move the cursor at start of next line.
            //     inline = inline.nextNode as WInline;
            //     indexInInline = 0;
            // }
            return this.getPhysicalPositionInline(inline, indexInInline, moveNextLine);
        }
    }
    /**
     * Highlight selected content
     *
     * @private
     */
    highlightSelectedContent(start, end) {
        if (start.paragraph.isInsideTable && (!end.paragraph.isInsideTable
            || (!start.paragraph.associatedCell.equals(end.paragraph.associatedCell))
            || (!this.documentHelper.isSelectionChangedOnMouseMoved && this.isCellSelected(start.paragraph.associatedCell, start, end))
            || this.isCellPrevSelected)) {
            this.highlightCell(start.paragraph.associatedCell, this, start, end);
            this.isCellPrevSelected = true;
        }
        else {
            let inline = undefined;
            let index = 0;
            if (!this.owner.isReadOnlyMode && start.paragraph === end.paragraph) {
                if (start.offset + 1 === end.offset) {
                    const inlineObj = end.currentWidget.getInline(end.offset, index);
                    inline = inlineObj.element; // return index value
                    index = inlineObj.index;
                    if (inline instanceof ImageElementBox || inline instanceof ShapeElementBox || inline instanceof GroupShapeElementBox) {
                        const startOffset = start.currentWidget.getOffset(inline, 0);
                        if (startOffset !== start.offset) {
                            inline = undefined;
                        }
                    }
                }
                else {
                    let indexInInline = 0;
                    const startInlineObj = start.currentWidget.getInline(start.offset, indexInInline);
                    let startInline = startInlineObj.element; //return indexInInline
                    indexInInline = startInlineObj.index;
                    if (indexInInline === startInline.length) {
                        startInline = this.getNextRenderedElementBox(startInline, indexInInline);
                    }
                    const endInlineObj = end.currentWidget.getInline(end.offset, indexInInline);
                    const endInline = endInlineObj.element; //return indexInInline
                    indexInInline = endInlineObj.index;
                    if (startInline instanceof FieldElementBox && endInline instanceof FieldElementBox && !isNullOrUndefined(startInline.fieldSeparator)) {
                        const fieldValue = startInline.fieldSeparator.nextNode;
                        if (fieldValue instanceof ImageElementBox && fieldValue.nextNode === endInline) {
                            inline = fieldValue;
                        }
                    }
                }
            }
            if (!this.owner.isReadOnlyMode && this.owner.isDocumentLoaded && (inline instanceof ImageElementBox || inline instanceof ShapeElementBox || inline instanceof GroupShapeElementBox)) {
                const elementBoxObj = this.getElementBoxInternal(inline, index);
                const elementBox = elementBoxObj.element; //return index
                index = elementBoxObj.index;
                if (this.owner.enableImageResizerMode && !this.owner.editorModule.isRemoteAction) {
                    this.owner.imageResizerModule.positionImageResizer(elementBox);
                    this.owner.imageResizerModule.showImageResizer();
                }
                if (this.documentHelper.isTouchInput) {
                    this.documentHelper.touchStart.style.display = 'none';
                    this.documentHelper.touchEnd.style.display = 'none';
                }
            }
            else {
                if (start.paragraph.isInsideTable
                    && start.paragraph.associatedCell.equals(end.paragraph.associatedCell)
                    && end.paragraph.equals(this.getLastParagraph(end.paragraph.associatedCell))
                    && (this.getParagraphLength(end.paragraph) + 1) == end.offset) {
                    end.offset--;
                }
                this.highlight(start.paragraph, start, end);
                if (this.isHighlightNext) {
                    if (this.hightLightNextParagraph === start.paragraph) {
                        this.highlightNextBlock(this.hightLightNextParagraph, start, end);
                    }
                    this.isHighlightNext = false;
                    this.hightLightNextParagraph = undefined;
                }
            }
            if (this.isInShape) {
                this.showResizerForShape();
            }
        }
    }
    showResizerForShape() {
        const shape = this.getCurrentTextFrame().containerShape;
        if (shape.containerShape) {
            let container = shape.containerShape;
            while (container) {
                if (isNullOrUndefined(container.containerShape)) {
                    break;
                }
                container = container.containerShape;
            }
            this.owner.imageResizerModule.positionImageResizer(container);
            this.owner.imageResizerModule.showImageResizer();
        }
        else {
            this.owner.imageResizerModule.positionImageResizer(shape);
            this.owner.imageResizerModule.showImageResizer();
        }
    }
    /**
     * @private
     * @returns {void}
     */
    highlight(paragraph, start, end, contentControl) {
        let selectionStartIndex = 0;
        let selectionEndIndex = 0;
        let startElement = undefined;
        let endElement = undefined;
        let startLineWidget = undefined;
        let endLineWidget = undefined;
        //return start Element and selection start index
        let startLineObj = this.getStartLineWidget(paragraph, start, startElement, selectionStartIndex);
        startElement = startLineObj.element;
        if (isNullOrUndefined(startElement) || (!isNullOrUndefined(startElement) && startElement instanceof TextElementBox && startElement.paragraph !== paragraph && startElement.text === "\u000b")) {
            startLineWidget = paragraph.childWidgets[0];
            selectionStartIndex = isNullOrUndefined(startElement) ? startLineObj.index : 0;
        }
        else {
            startLineWidget = startElement.line;
            selectionStartIndex = startLineObj.index;
        }
        let endLineObj = this.getEndLineWidget(end, endElement, selectionEndIndex);
        endElement = endLineObj.element;
        if (endElement) {
            endLineWidget = endElement.line;
        }
        else {
            endLineWidget = end.paragraph.childWidgets[end.paragraph.childWidgets.length - 1];
        }
        selectionEndIndex = endLineObj.index;
        let top = 0;
        let left = 0;
        if (!isNullOrUndefined(startLineWidget)) {
            top = this.getTop(startLineWidget);
            left = this.getLeftInternal(startLineWidget, startElement, selectionStartIndex);
        }
        if (!isNullOrUndefined(startLineWidget) && startLineWidget === endLineWidget) {
            //Selection ends in current line.
            let right = this.getLeftInternal(endLineWidget, endElement, selectionEndIndex);
            let width = 0;
            let isRtlText = false;
            if (endElement instanceof TextElementBox) {
                isRtlText = endElement.isRightToLeft;
            }
            if (!isRtlText && startElement instanceof TextElementBox) {
                isRtlText = startElement.isRightToLeft;
            }
            width = Math.abs(right - left);
            // Handled the highlighting approach as genric for normal and rtl text.
            if (isRtlText || paragraph.bidi) {
                let elementBoxCollection = this.getElementsForward(startLineWidget, startElement, endElement, paragraph.bidi);
                if (elementBoxCollection && elementBoxCollection.length > 1) {
                    for (let i = 0; i < elementBoxCollection.length; i++) {
                        let element = elementBoxCollection[i];
                        let elementIsRTL = false;
                        let index = element instanceof TextElementBox ? element.length : 1;
                        if (element === startElement) {
                            left = this.getLeftInternal(startLineWidget, element, selectionStartIndex);
                            right = this.getLeftInternal(startLineWidget, element, index);
                        }
                        else if (element === endElement) {
                            left = this.getLeftInternal(startLineWidget, element, 0);
                            right = this.getLeftInternal(startLineWidget, element, selectionEndIndex);
                        }
                        else {
                            left = this.getLeftInternal(startLineWidget, element, 0);
                            right = this.getLeftInternal(startLineWidget, element, index);
                        }
                        if (element instanceof TextElementBox) {
                            elementIsRTL = element.isRightToLeft && element.characterRange === CharacterRangeType.RightToLeft;
                        }
                        width = Math.abs(right - left);
                        // Handled the paragraph mark highliting as special case.
                        if (element === endElement && element instanceof TextElementBox
                            && selectionEndIndex > element.length) {
                            let charFormat = element.line.paragraph.characterFormat;
                            let paragraphMarkWidth = this.documentHelper.textHelper.getParagraphMarkSize(charFormat).Width;
                            if (paragraph.bidi && !elementIsRTL) {
                                width -= paragraphMarkWidth;
                                // Highlight the element.
                                this.createHighlightBorder(startLineWidget, width, left, top, true, contentControl);
                                // Highlight the paragraph mark of Bidi paragrph. 
                                left = this.getLineStartLeft(startLineWidget) - paragraphMarkWidth;
                                this.createHighlightBorder(startLineWidget, paragraphMarkWidth, left, top, true, contentControl);
                                // continue to next element.
                                continue;
                            }
                        }
                        this.createHighlightBorder(startLineWidget, width, elementIsRTL ? right : left, top, true, contentControl);
                    }
                }
                else { // Need to handle the Paragraph mark highlighting.
                    if (endElement instanceof TextElementBox && selectionEndIndex > endElement.length) {
                        let charFormat = endElement.line.paragraph.characterFormat;
                        let paragraphMarkWidth = this.documentHelper.textHelper.getParagraphMarkSize(charFormat).Width;
                        // Since isRTLText is truo, so the right is considered as left
                        if (!paragraph.bidi && isRtlText) {
                            right += paragraphMarkWidth;
                            width -= paragraphMarkWidth;
                            // Highlight the element.
                            this.createHighlightBorder(startLineWidget, width, right, top, true, contentControl);
                            // Highlight the paragraph mark. 
                            right += endElement.width;
                            this.createHighlightBorder(startLineWidget, paragraphMarkWidth, right, top, true, contentControl);
                        }
                        else if (paragraph.bidi && !isRtlText) {
                            width -= paragraphMarkWidth;
                            // Highlight the element.
                            this.createHighlightBorder(startLineWidget, width, left, top, true, contentControl);
                            // Highlight the paragraph mark of Bidi paragrph. 
                            left = this.getLineStartLeft(startLineWidget) - paragraphMarkWidth;
                            this.createHighlightBorder(startLineWidget, paragraphMarkWidth, left, top, true, contentControl);
                        }
                        else {
                            this.createHighlightBorder(startLineWidget, width, isRtlText ? right : left, top, false, contentControl);
                        }
                    }
                    else {
                        this.createHighlightBorder(startLineWidget, width, isRtlText ? right : left, top, false, contentControl);
                    }
                }
            }
            else {
                // Start element and end element will be in reverese for Bidi paragraph highlighting. 
                // So, the right is considered based on Bidi property.
                this.createHighlightBorder(startLineWidget, width, paragraph.bidi ? right : left, top, false, contentControl);
            }
        }
        else {
            if (!isNullOrUndefined(startLineWidget)) {
                let x = startLineWidget.paragraph.x;
                if (paragraph !== startLineWidget.paragraph) {
                    paragraph = startLineWidget.paragraph;
                }
                let width = this.getWidth(startLineWidget, true) - (left - startLineWidget.paragraph.x);
                // Handled the  highlighting approach as genric for normal and rtl text.
                if (paragraph.bidi || (startElement instanceof TextElementBox && startElement.isRightToLeft)) {
                    let right = 0;
                    let elementCollection = this.getElementsForward(startLineWidget, startElement, endElement, paragraph.bidi);
                    if (elementCollection) {
                        let elementIsRTL = false;
                        for (let i = 0; i < elementCollection.length; i++) {
                            let element = elementCollection[i];
                            elementIsRTL = false;
                            if (element === startElement) {
                                left = this.getLeftInternal(startLineWidget, element, selectionStartIndex);
                            }
                            else {
                                left = this.getLeftInternal(startLineWidget, element, 0);
                            }
                            let index = element instanceof TextElementBox ? element.length : 1;
                            right = this.getLeftInternal(startLineWidget, element, index);
                            if (element instanceof TextElementBox) {
                                elementIsRTL = element.isRightToLeft && element.characterRange === CharacterRangeType.RightToLeft;
                            }
                            width = Math.abs(right - left);
                            this.createHighlightBorder(startLineWidget, width, elementIsRTL ? right : left, top, true, contentControl);
                        }
                        // Highlight the Paragrph mark for last line.
                        if (startLineWidget.isLastLine()) {
                            let charFormat = elementCollection[elementCollection.length - 1].line.paragraph.characterFormat;
                            let paragraphMarkWidth = this.documentHelper.textHelper.getParagraphMarkSize(charFormat).Width;
                            if (paragraph.bidi) {
                                // The paragraph mark will be at the left most end.
                                left = this.getLineStartLeft(startLineWidget) - paragraphMarkWidth;
                            }
                            else { // The paragraph mark will at right most end.
                                left = elementIsRTL ? startLineWidget.paragraph.x + this.getWidth(startLineWidget, false) : right;
                            }
                            this.createHighlightBorder(startLineWidget, paragraphMarkWidth, left, top, true, contentControl);
                        }
                    }
                    else {
                        this.createHighlightBorder(startLineWidget, width, left, top, false, contentControl);
                    }
                }
                else {
                    this.createHighlightBorder(startLineWidget, width, left, top, false, contentControl);
                }
                let lineIndex = startLineWidget.paragraph.childWidgets.indexOf(startLineWidget);
                //Iterates to last item of paragraph or selection end.                                             
                this.highlightParagraph(paragraph, lineIndex + 1, endLineWidget, endElement, selectionEndIndex, contentControl);
                if (paragraph.childWidgets.indexOf(end.currentWidget) !== -1) {
                    return;
                }
            }
            if (this.isHideSelection(paragraph)) {
                this.isHighlightNext = false;
                return;
            }
            this.isHighlightNext = true;
            this.hightLightNextParagraph = paragraph;
        }
    }
    highlightNextBlock(paragraph, start, end) {
        let block = paragraph.nextRenderedWidget;
        while (!isNullOrUndefined(block)) {
            if (block instanceof ParagraphWidget) {
                this.isHighlightNext = false;
                this.highlight(block, start, end);
                block = undefined;
                if (this.isHighlightNext && !isNullOrUndefined(this.hightLightNextParagraph)) {
                    block = this.hightLightNextParagraph.nextRenderedWidget;
                    this.isHighlightNext = false;
                    this.hightLightNextParagraph = undefined;
                }
            }
            else {
                this.highlightTable(block, start, end);
                break;
            }
        }
    }
    /**
     * Get start line widget
     * @private
     * @returns {ElementInfo}
     */
    getStartLineWidget(paragraph, start, startElement, selectionStartIndex) {
        let offset = paragraph === start.paragraph ? start.offset : this.getStartOffset(paragraph);
        let startInlineObj = undefined;
        if (paragraph === start.paragraph) {
            startInlineObj = start.currentWidget.getInline(offset, selectionStartIndex);
        }
        else {
            startInlineObj = paragraph.firstChild.getInline(offset, selectionStartIndex);
        }
        startElement = startInlineObj.element; //return selectionStartIndex
        selectionStartIndex = startInlineObj.index;
        if (startElement instanceof FieldElementBox) {
            let inlineInfo = this.getRenderedInline(startElement, selectionStartIndex);
            startElement = inlineInfo.element;
            selectionStartIndex = inlineInfo.index;
        }
        if (offset === this.getParagraphLength(start.paragraph) + 1) {
            selectionStartIndex++;
        }
        return {
            'index': selectionStartIndex, 'element': startElement
        };
    }
    /**
     * Get end line widget
     * @private
     */
    getEndLineWidget(end, endElement, selectionEndIndex) {
        let endInlineObj = end.currentWidget.getInline(end.offset, selectionEndIndex);
        endElement = endInlineObj.element; //return selection end index
        selectionEndIndex = endInlineObj.index;
        if (endElement instanceof FieldElementBox) {
            let inlineInfo = this.getRenderedInline(endElement, selectionEndIndex);
            endElement = inlineInfo.element;
            selectionEndIndex = inlineInfo.index;
        }
        let lineIndex = end.paragraph.childWidgets.indexOf(end.currentWidget);
        if (lineIndex === end.paragraph.childWidgets.length - 1 && end.offset === this.getLineLength(end.currentWidget) + 1) {
            selectionEndIndex = endElement ? endElement.length + 1 : 1;
        }
        return { 'index': selectionEndIndex, 'element': endElement };
    }
    /**
     * Get line widget
     * @private
     */
    getLineWidgetInternal(line, offset, moveToNextLine) {
        let lineWidget = undefined;
        if (line.children.length === 0 && line instanceof LineWidget) {
            lineWidget = line;
        }
        else {
            let indexInInline = 0;
            let inlineInfo = line.getInline(offset, indexInInline);
            let inline = inlineInfo.element;
            indexInInline = inlineInfo.index;
            lineWidget = inline instanceof ElementBox ? inline.line
                : this.getLineWidgetInternalInline(inline, indexInInline, moveToNextLine);
        }
        return lineWidget;
    }
    /**
     * Get last line widget
     * @private
     */
    getLineWidgetParagraph(offset, line) {
        let linewidget = undefined;
        if (line.children.length === 0) {
            linewidget = line;
        }
        else {
            let indexInInline = 0;
            let inlineInfo = line.getInline(offset, indexInInline);
            let inline = inlineInfo.element;
            indexInInline = inlineInfo.index;
            linewidget = this.getLineWidget(inline, indexInInline);
        }
        return linewidget;
    }
    /**
     * Highlight selected cell
     * @private
     */
    highlightCells(table, startCell, endCell) {
        let start = this.getCellLeft(startCell.ownerRow, startCell);
        let end = start + startCell.cellFormat.cellWidth;
        let endCellLeft = this.getCellLeft(endCell.ownerRow, endCell);
        let endCellRight = endCellLeft + endCell.cellFormat.cellWidth;
        if (start > endCellLeft) {
            start = endCellLeft;
        }
        if (end < endCellRight) {
            end = endCellRight;
        }
        if (start > this.upDownSelectionLength) {
            start = this.upDownSelectionLength;
        }
        if (end < this.upDownSelectionLength) {
            end = this.upDownSelectionLength;
        }
        let tableWidgetCollection = table.getSplitWidgets();
        let startTableIndex = tableWidgetCollection.indexOf(startCell.ownerRow.ownerTable);
        let endTableIndex = tableWidgetCollection.indexOf(endCell.ownerRow.ownerTable);
        if (startTableIndex === endTableIndex) {
            let count = table.childWidgets.indexOf(endCell.ownerRow);
            for (let i = table.childWidgets.indexOf(startCell.ownerRow); i <= count; i++) {
                this.highlightRow(table.childWidgets[i], start, end);
            }
        }
        else {
            let startRowIndex = 0;
            let endRowIndex = 0;
            for (let i = startTableIndex; i <= endTableIndex; i++) {
                table = tableWidgetCollection[i];
                if (i === startTableIndex) {
                    startRowIndex = table.childWidgets.indexOf(startCell.ownerRow);
                }
                else {
                    startRowIndex = 0;
                }
                if (i === endTableIndex) {
                    endRowIndex = table.childWidgets.indexOf(endCell.ownerRow);
                }
                else {
                    endRowIndex = table.childWidgets.length - 1;
                }
                for (let j = startRowIndex; j <= endRowIndex; j++) {
                    this.highlightRow(table.childWidgets[j], start, end);
                }
            }
        }
    }
    /**
     * highlight selected table
     *
     * @private
     */
    highlightTable(table, start, end) {
        if (this.isHightlightEditRegionInternal) {
            this.highlightTableCells(table, start, end);
        }
        else {
            this.highlightInternal(table.childWidgets[0], start, end);
        }
        if (!end.paragraph.isInsideTable //Selection end is outside the table cell.
            || !table.contains(end.paragraph.associatedCell)) { //Selection end is not inside the current table.
            this.highlightNextBlock(table, start, end);
        }
    }
    highlightTableCells(table, start, end) {
        for (let i = 0; i < table.childWidgets.length; i++) {
            let row = table.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                for (let k = 0; k < cell.childWidgets.length; k++) {
                    let block = cell.childWidgets[k];
                    if (block instanceof ParagraphWidget) {
                        this.highlight(block, start, end);
                    }
                    else {
                        this.highlightTable(block, start, end);
                    }
                }
                if (end.paragraph && end.paragraph.associatedCell === cell) {
                    return;
                }
            }
        }
    }
    /**
     * Get cell left
     *
     * @private
     */
    getCellLeft(row, cell) {
        let left = 0;
        left += cell.x - cell.margin.left;
        return left;
    }
    /**
     * Get next paragraph for row
     *
     * @private
     */
    getNextParagraphRow(row) {
        if (!isNullOrUndefined(row.nextRenderedWidget)) {
            let cell = row.nextRenderedWidget.childWidgets[0];
            while (cell.childWidgets.length == 0 && !isNullOrUndefined(cell.previousSplitWidget) && !isNullOrUndefined(cell.nextRenderedWidget) && cell.nextRenderedWidget instanceof TableCellWidget) {
                cell = cell.nextRenderedWidget;
            }
            const block = cell.childWidgets[0];
            if (isNullOrUndefined(block)) {
                return this.getNextParagraphCell(cell);
            }
            return this.documentHelper.getFirstParagraphBlock(block);
        }
        return this.getNextParagraphBlock(row.ownerTable);
    }
    /**
     * Get previous paragraph from row
     *
     * @private
     */
    getPreviousParagraphRow(row) {
        if (!isNullOrUndefined(row.previousRenderedWidget)) {
            const cell = row.previousRenderedWidget.lastChild;
            const block = cell.lastChild ? cell.lastChild : (cell.previousSplitWidget).lastChild;
            return this.documentHelper.getLastParagraphBlock(block);
        }
        return this.getPreviousParagraphBlock(row.ownerTable);
    }
    /**
     * Return true if row contain cell
     *
     * @private
     */
    containsRow(row, tableCell) {
        if (row.childWidgets.indexOf(tableCell) !== -1) {
            return true;
        }
        while (tableCell.ownerTable.isInsideTable) {
            if (row.childWidgets.indexOf(tableCell) !== -1) {
                return true;
            }
            tableCell = tableCell.ownerTable.associatedCell;
        }
        return row.childWidgets.indexOf(tableCell) !== -1;
    }
    /**
     * Highlight selected row
     *
     * @private
     */
    highlightRow(row, start, end) {
        for (let i = 0; i < row.childWidgets.length; i++) {
            const left = this.getCellLeft(row, row.childWidgets[i]);
            if (HelperMethods.round(start, 2) <= HelperMethods.round(left, 2) &&
                HelperMethods.round(left, 2) < HelperMethods.round(end, 2)) {
                this.highlightCellWidget(row.childWidgets[i]);
            }
        }
    }
    /**
     * @private
     */
    highlightInternal(row, start, end) {
        for (let i = 0; i < row.childWidgets.length; i++) {
            this.highlightCellWidget(row.childWidgets[i]);
        }
        if (end.paragraph.isInsideTable && this.containsRow(row, end.paragraph.associatedCell)) {
            return;
        }
        else if (row.nextRenderedWidget instanceof TableRowWidget) {
            this.highlightInternal(row.nextRenderedWidget, start, end);
        }
    }
    /**
     * Get last paragraph in cell
     *
     * @private
     */
    getLastParagraph(cell) {
        while (cell.nextSplitWidget) {
            if (cell.nextSplitWidget.childWidgets.length > 0) {
                cell = cell.nextSplitWidget;
            }
            else {
                break;
            }
        }
        let lastBlock;
        if (cell.childWidgets.length > 0) {
            lastBlock = cell.lastChild;
        }
        else {
            lastBlock = cell.previousSplitWidget.lastChild;
        }
        return this.documentHelper.getLastParagraphBlock(lastBlock);
    }
    /**
     * Return true is source cell contain cell
     *
     * @private
     */
    containsCell(sourceCell, cell) {
        if (sourceCell.equals(cell)) {
            return true;
        }
        while (cell.ownerTable.isInsideTable) {
            if (sourceCell.equals(cell.ownerTable.associatedCell)) {
                return true;
            }
            cell = cell.ownerTable.associatedCell;
        }
        return false;
    }
    /**
     * Return true if cell is selected
     *
     * @private
     */
    isCellSelected(cell, startPosition, endPosition, skipParaMark) {
        const lastParagraph = this.getLastParagraph(cell);
        const isAtCellEnd = lastParagraph === endPosition.paragraph && lastParagraph.lastChild === endPosition.currentWidget && endPosition.offset === this.getLineLength(lastParagraph.lastChild) + (!skipParaMark ? 1 : 0);
        return isAtCellEnd || (!this.containsCell(cell, startPosition.paragraph.associatedCell) ||
            !this.containsCell(cell, endPosition.paragraph.associatedCell));
    }
    /**
    * Return true if cell or row selected
    *
    * @private
    */
    isCellOrRowSelected() {
        let start = this.start;
        let end = this.end;
        let cellOrRowSelected = start.paragraph.isInsideTable && (!end.paragraph.isInsideTable
            || start.paragraph.associatedCell !== end.paragraph.associatedCell
            || this.isCellSelected(start.paragraph.associatedCell, start, end));
        return cellOrRowSelected;
    }
    /**
     * Return Container cell
     *
     * @private
     */
    getContainerCellOf(cell, tableCell) {
        while (cell.ownerTable.isInsideTable) {
            if (cell.ownerTable.contains(tableCell)) {
                return cell;
            }
            cell = cell.ownerTable.associatedCell;
        }
        return cell;
    }
    /**
     * Get Selected cell
     *
     * @private
     */
    getSelectedCell(cell, containerCell) {
        if (cell.ownerTable.equals(containerCell.ownerTable)) {
            return cell;
        }
        while (cell.ownerTable.isInsideTable) {
            if (cell.ownerTable.associatedCell.equals(containerCell)) {
                return cell;
            }
            cell = cell.ownerTable.associatedCell;
        }
        return cell;
    }
    /**
     * @private
     */
    getSelectedCells() {
        const cells = [];
        for (let i = 0; i < this.selectedWidgets.keys.length; i++) {
            const widget = this.selectedWidgets.keys[i];
            if (widget instanceof TableCellWidget) {
                cells.push(widget);
            }
        }
        return cells;
    }
    /**
     * @private
     * @return
     */
    getLevelFormatNumber() {
        let numberFormat = '%';
        numberFormat = numberFormat + (((this.paragraphFormat.listLevelNumber <= 0) ? 0 : this.paragraphFormat.listLevelNumber) + 1) + '.';
        return numberFormat;
    }
    /**
     * Get Next paragraph from cell
     *
     * @private
     */
    getNextParagraphCell(cell) {
        if (cell.nextRenderedWidget && cell.nextRenderedWidget instanceof TableCellWidget) {
            if (cell.rowIndex === cell.nextRenderedWidget.rowIndex) {
                //Return first paragraph in cell.
                cell = cell.nextRenderedWidget;
                if (cell.getSplitWidgets()[0] instanceof TableCellWidget) {
                    for (let widget of cell.getSplitWidgets()) {
                        cell = widget;
                        if (cell.firstChild) {
                            break;
                        }
                    }
                }
                const block = cell.firstChild;
                if (block) {
                    return this.documentHelper.getFirstParagraphBlock(block);
                }
                else {
                    return this.getNextParagraphCell(cell);
                }
            }
            else {
                cell = cell.nextRenderedWidget;
                return this.getNextParagraphCell(cell);
            }
        }
        else if (cell.nextSplitWidget && cell.nextSplitWidget.childWidgets.length === 0) {
            cell = cell.getSplitWidgets().pop();
        }
        return this.getNextParagraphRow(cell.containerWidget);
    }
    /**
     * Get previous paragraph from cell
     *
     * @private
     */
    getPreviousParagraphCell(cell) {
        if (!isNullOrUndefined(cell.previousRenderedWidget) && cell.previousRenderedWidget instanceof TableCellWidget) {
            cell = cell.previousRenderedWidget;
            const block = cell.lastChild;
            return this.documentHelper.getLastParagraphBlock(block);
        }
        return this.getPreviousParagraphRow(cell.ownerRow);
    }
    /**
     * Get cell's container cell
     *
     * @private
     */
    getContainerCell(cell) {
        while (!isNullOrUndefined(cell.ownerTable) && cell.ownerTable.isInsideTable) {
            cell = cell.ownerTable.associatedCell;
        }
        return cell;
    }
    /**
     * Highlight selected cell
     *
     * @private
     */
    highlightCell(cell, selection, start, end) {
        if (end.paragraph.isInsideTable) {
            let containerCell = this.getContainerCellOf(cell, end.paragraph.associatedCell);
            if (containerCell.ownerTable.contains(end.paragraph.associatedCell)) {
                let startCell = this.getSelectedCell(cell, containerCell);
                let endCell = this.getSelectedCell(end.paragraph.associatedCell, containerCell);
                if (this.containsCell(containerCell, end.paragraph.associatedCell)) {
                    //Selection end is in container cell.
                    if (this.isCellSelected(containerCell, start, end)) {
                        this.highlightCellWidget(containerCell);
                    }
                    else {
                        if (startCell === containerCell) {
                            this.highlight(start.paragraph, start, end);
                            if (this.isHighlightNext) {
                                this.highlightNextBlock(this.hightLightNextParagraph, start, end);
                                this.isHighlightNext = false;
                                this.hightLightNextParagraph = undefined;
                            }
                        }
                        else {
                            this.highlightContainer(startCell, start, end);
                        }
                    }
                }
                else {
                    //Selection end is not in container cell.
                    this.highlightCellWidget(containerCell);
                    if (containerCell.ownerRow.equals(endCell.ownerRow)) {
                        //Highlight other selected cells in current row.
                        startCell = containerCell;
                        while (!isNullOrUndefined(startCell.nextRenderedWidget)) {
                            startCell = startCell.nextRenderedWidget;
                            this.highlightCellWidget(startCell);
                            if (startCell === endCell) {
                                break;
                            }
                        }
                    }
                    else {
                        this.highlightCells(containerCell.ownerTable, containerCell, endCell);
                    }
                }
            }
            else {
                this.highlightContainer(containerCell, start, end);
            }
        }
        else {
            const cell1 = this.getContainerCell(cell);
            this.highlightContainer(cell1, start, end);
        }
    }
    /**
     * @private
     */
    highlightContainer(cell, start, end) {
        this.highlightInternal(cell.containerWidget, start, end);
        this.highlightNextBlock(cell.ownerTable.getSplitWidgets().pop(), start, end);
    }
    /**
     * Get previous valid element
     *
     * @private
     */
    getPreviousValidElement(inline) {
        let previousValidInline = undefined;
        if (this.documentHelper.isFormFillProtectedMode && inline.fieldType === 2) {
            return inline;
        }
        while (inline instanceof FieldElementBox) {
            if (HelperMethods.isLinkedFieldCharacter(inline)) {
                if (inline instanceof FieldElementBox && inline.fieldType === 0) {
                    previousValidInline = inline;
                }
                else if (inline instanceof FieldElementBox && inline.fieldType === 1) {
                    previousValidInline = inline;
                    if (isNullOrUndefined(inline.fieldSeparator)) {
                        inline = inline.fieldBegin;
                        previousValidInline = inline;
                    }
                }
                else {
                    inline = inline.fieldBegin;
                    previousValidInline = inline;
                }
            }
            inline = inline.previousNode;
        }
        return isNullOrUndefined(previousValidInline) ? inline : previousValidInline;
    }
    /**
     * Return next valid inline with index
     *
     * @private
     */
    validateTextPosition(inline, index) {
        let nextNode = inline.nextNode;
        if (inline.length === index && (nextNode instanceof FieldElementBox
            || (!(inline instanceof ImageElementBox || inline instanceof GroupShapeElementBox) && (nextNode instanceof BookmarkElementBox || nextNode instanceof CommentCharacterElementBox)))) {
            //If inline is last item within field, then set field end as text position.
            const nextInline = this.documentHelper.getNextValidElement(inline.nextNode);
            if ((nextInline instanceof FieldElementBox && nextInline.fieldType === 1)
                || (nextInline instanceof BookmarkElementBox && nextInline.bookmarkType === 1)
                || (nextInline instanceof CommentCharacterElementBox && nextInline.commentType === 1)) {
                inline = nextInline;
                index = this.documentHelper.isFormFillProtectedMode ? 0 : 1;
            }
        }
        else if (index === 0 && inline.previousNode instanceof FieldElementBox) {
            const prevInline = this.getPreviousValidElement(inline.previousNode);
            inline = prevInline;
            index = inline instanceof FieldElementBox ? 0 : inline.length;
            if (inline instanceof FieldElementBox && inline.fieldType === 1) {
                index++;
            }
        }
        return { 'element': inline, 'index': index };
    }
    /**
     * Get inline physical location
     *
     * @private
     */
    getPhysicalPositionInline(inline, index, moveNextLine) {
        let element = undefined;
        element = this.getElementBox(inline, index, moveNextLine).element;
        let lineWidget = undefined;
        if (isNullOrUndefined(element) || isNullOrUndefined(element.line)) {
            if (inline instanceof FieldElementBox || inline instanceof BookmarkElementBox || inline instanceof CommentCharacterElementBox || inline instanceof ContentControl) {
                return this.getFieldCharacterPosition(inline);
            }
            return new Point(0, 0);
        }
        const margin = element.margin;
        let top = 0;
        let left = 0;
        if (element instanceof TextElementBox && element.text === '\v' && isNullOrUndefined(inline.nextNode) && !this.owner.editorModule.handledEnter) {
            lineWidget = this.getNextLineWidget(element.line.paragraph, element);
            index = 0;
        }
        else {
            lineWidget = element.line;
        }
        top = this.getTop(lineWidget);
        if ((element instanceof ImageElementBox || element instanceof GroupShapeElementBox) && element.textWrappingStyle === 'Inline') {
            let format = element.line.paragraph.characterFormat;
            const previousInline = this.getPreviousTextElement(inline);
            if (!isNullOrUndefined(previousInline)) {
                format = previousInline.characterFormat;
            }
            else {
                const nextInline = this.getNextTextElement(inline);
                if (!isNullOrUndefined(nextInline)) {
                    format = nextInline.characterFormat;
                }
            }
            const measureObj = this.documentHelper.textHelper.getHeight(format);
            if (element.margin.top + element.height - measureObj.BaselineOffset > 0) {
                top += element.margin.top + element.height - measureObj.BaselineOffset;
            }
        }
        else if (!(element instanceof FieldElementBox || element instanceof EditRangeStartElementBox
            || element instanceof EditRangeEndElementBox)) {
            top += margin.top > 0 ? margin.top : 0;
        }
        left = (isNullOrUndefined(element) || isNullOrUndefined(lineWidget)) ? 0 : this.getLeftInternal(lineWidget, element, index);
        return new Point(left, top);
    }
    /**
     * Get field character position
     *
     * @private
     */
    getFieldCharacterPosition(firstInline) {
        const nextValidInline = this.documentHelper.getNextValidElementForField(firstInline);
        //If field separator/end exists at end of paragraph, then move to next paragraph.
        if (isNullOrUndefined(nextValidInline)) {
            const nextParagraph = firstInline.line.paragraph;
            return this.getEndPosition(nextParagraph);
        }
        else {
            return this.getPhysicalPositionInline(nextValidInline, 0, true);
        }
    }
    /**
     * @private
     */
    isRenderBookmarkAtEnd(bookmark) {
        let bookmarkElement;
        if (bookmark.bookmarkType == 1) {
            bookmarkElement = bookmark.reference;
        }
        else {
            bookmarkElement = bookmark;
        }
        if (bookmarkElement && isNullOrUndefined(bookmarkElement.properties)) {
            let endCell = bookmarkElement.reference ? bookmarkElement.reference.paragraph.associatedCell : undefined;
            if (isNullOrUndefined(endCell)) {
                return false;
            }
            let lastRow = bookmarkElement.reference ? bookmarkElement.reference.paragraph.associatedCell.ownerRow : undefined;
            let lastCell = lastRow ? lastRow.childWidgets[lastRow.childWidgets.length - 1] : undefined;
            if (isNullOrUndefined(lastCell)) {
                return false;
            }
            if (endCell == lastCell && !(bookmark.bookmarkType === 1 && !isNullOrUndefined(bookmark.line) && bookmark.line.children.indexOf(bookmark) !== bookmark.line.children.length - 1)) {
                return true;
            }
            else {
                return false;
            }
        }
        return false;
    }
    /**
     * Get paragraph end position
     *
     * @private
     */
    getEndPosition(widget) {
        let left = widget.x;
        let top = widget.y;
        let lineWidget = undefined;
        if (widget.childWidgets.length > 0) {
            lineWidget = widget.childWidgets[widget.childWidgets.length - 1];
            if (widget.paragraphFormat.bidi) {
                left = this.getLeft(lineWidget);
            }
            else {
                left += this.getWidth(lineWidget, false);
            }
        }
        if (!isNullOrUndefined(lineWidget)) {
            top = this.getTop(lineWidget);
        }
        const topMargin = 0;
        const bottomMargin = 0;
        const size = this.getParagraphMarkSize(widget, topMargin, bottomMargin);
        return new Point(left, top + size.topMargin);
    }
    /**
     * Get element box
     *
     * @private
     */
    getElementBox(currentInline, index, moveToNextLine) {
        let elementBox = undefined;
        if (!(currentInline instanceof FieldElementBox || currentInline instanceof BookmarkElementBox || currentInline instanceof CommentCharacterElementBox || currentInline instanceof ContentControl)) {
            elementBox = currentInline;
        }
        return { 'element': elementBox, 'index': index };
    }
    /**
     * @private
     */
    getPreviousTextElement(inline) {
        if (inline.previousNode instanceof TextElementBox) {
            return inline.previousNode;
        }
        if (!isNullOrUndefined(inline.previousNode)) {
            return this.getPreviousTextElement(inline.previousNode);
        }
        return undefined;
    }
    /**
     * Get next text inline
     *
     * @private
     */
    getNextTextElement(inline) {
        if (inline.nextNode instanceof TextElementBox) {
            return inline.nextNode;
        }
        if (!isNullOrUndefined(inline.nextNode)) {
            return this.getNextTextElement(inline.nextNode);
        }
        return undefined;
    }
    /**
     * @private
     */
    getNextRenderedElementBox(inline, indexInInline) {
        if (inline instanceof FieldElementBox) {
            const fieldBegin = inline;
            if (fieldBegin.fieldType === 0) {
                inline = this.getRenderedField(fieldBegin);
                if (fieldBegin === inline) {
                    return fieldBegin;
                }
            }
            indexInInline = 1;
        }
        while (!isNullOrUndefined(inline) && indexInInline === inline.length && inline.nextNode instanceof FieldElementBox) {
            const nextValidInline = this.documentHelper.getNextValidElement((inline.nextNode));
            if (nextValidInline instanceof FieldElementBox && nextValidInline.fieldType === 0) {
                const fieldBegin = nextValidInline;
                inline = this.getRenderedField(fieldBegin);
                if (!isNullOrUndefined(inline) && fieldBegin === inline) {
                    return fieldBegin;
                }
                indexInInline = 1;
            }
            else {
                inline = nextValidInline;
            }
        }
        return inline;
    }
    /**
     * @private
     */
    getElementBoxInternal(inline, index) {
        let element = undefined;
        element = inline;
        return {
            'element': element, 'index': index
        };
    }
    /**
     * Get Line widget
     *
     * @private
     */
    getLineWidget(inline, index) {
        return this.getLineWidgetInternalInline(inline, index, true);
    }
    /**
     * @private
     */
    getLineWidgetInternalInline(inline, index, moveToNextLine) {
        const elementObj = this.getElementBox(inline, index, moveToNextLine);
        const element = elementObj.element; //return index
        index = elementObj.index;
        if (!isNullOrUndefined(element)) {
            if (moveToNextLine && element instanceof TextElementBox && element.text === '\v' && index === 1) {
                return this.getNextLineWidget(element.line.paragraph, element);
            }
            else {
                return element.line;
            }
        }
        const startInline = inline;
        //ToDo: Check previous inline here.
        const nextValidInline = this.documentHelper.getNextValidElementForField(startInline);
        //If field separator/end exists at end of paragraph, then move to next paragraph.
        if (isNullOrUndefined(nextValidInline)) {
            let lineWidget = undefined;
            const widget = startInline.line.paragraph;
            if (widget.childWidgets.length > 0) {
                lineWidget = widget.childWidgets[widget.childWidgets.length - 1];
            }
            return lineWidget;
        }
        else {
            return this.getLineWidget(nextValidInline, 0);
        }
    }
    /**
     * Get next line widget
     *
     * @private
     */
    getNextLineWidget(paragraph, element) {
        let lineWidget = undefined;
        let widget = paragraph;
        if (widget.childWidgets.length > 0) {
            let widgetIndex = widget.childWidgets.indexOf(element.line);
            if (widgetIndex === widget.childWidgets.length - 1) {
                widget = paragraph;
                // widget = paragraph.leafWidgets[paragraph.leafWidgets.length - 1];
                widgetIndex = -1;
            }
            else if (widgetIndex > widget.childWidgets.length - 1) {
                widget = this.getNextParagraphBlock(paragraph);
                widgetIndex = -1;
            }
            else if (widgetIndex < 0) {
                // widget = paragraph.leafWidgets[paragraph.leafWidgets.length - 1];
                widget = paragraph;
                widgetIndex = widget.childWidgets.indexOf(element.line);
            }
            lineWidget = widget.childWidgets[widgetIndex + 1];
        }
        return lineWidget;
    }
    getCaretHeight(inline, index, format, isEmptySelection, topMargin, isItalic) {
        const elementBoxInfo = this.getElementBox(inline, index, false);
        const element = elementBoxInfo.element;
        const currentInline = inline;
        if (isNullOrUndefined(element)) {
            if (currentInline instanceof FieldElementBox) {
                return this.getFieldCharacterHeight(currentInline, format, isEmptySelection, topMargin, isItalic);
            }
            return { 'height': this.documentHelper.textHelper.getHeight(format).Height, 'topMargin': topMargin, 'isItalic': isItalic };
        }
        const margin = element.margin;
        const heightElement = element.height;
        let maxLineHeight = 0;
        if (element instanceof ImageElementBox || element instanceof GroupShapeElementBox) {
            const previousInline = this.getPreviousTextElement(inline);
            const nextInline = this.getNextTextElement(inline);
            if (isNullOrUndefined(previousInline) && isNullOrUndefined(nextInline)) {
                let top = 0;
                let bottom = 0;
                const paragarph = inline.line.paragraph;
                const sizeInfo = this.getParagraphMarkSize(paragarph, top, bottom);
                top = sizeInfo.topMargin;
                bottom = sizeInfo.bottomMargin;
                maxLineHeight = sizeInfo.height;
                isItalic = paragarph.characterFormat.italic;
                if (!isEmptySelection) {
                    maxLineHeight += this.documentHelper.layout.getAfterSpacing(paragarph);
                }
            }
            else if (isNullOrUndefined(previousInline)) {
                isItalic = nextInline.characterFormat.italic;
                return this.getCaretHeight(nextInline, 0, nextInline.characterFormat, isEmptySelection, topMargin, isItalic);
            }
            else {
                if (!isNullOrUndefined(nextInline) && (element instanceof ImageElementBox || element instanceof GroupShapeElementBox)) {
                    //Calculates the caret size using image character format.
                    const textSizeInfo = this.documentHelper.textHelper.getHeight(element.characterFormat);
                    const charHeight = textSizeInfo.Height;
                    const baselineOffset = textSizeInfo.BaselineOffset;
                    maxLineHeight = (element.margin.top < 0 && baselineOffset > element.margin.top + element.height) ? element.margin.top + element.height + charHeight - baselineOffset : charHeight;
                    if (!isEmptySelection) {
                        maxLineHeight += element.margin.bottom;
                    }
                }
                else {
                    isItalic = previousInline.characterFormat.italic;
                    return this.getCaretHeight(previousInline, previousInline.length, previousInline.characterFormat, isEmptySelection, topMargin, isItalic);
                }
            }
        }
        else {
            const baselineAlignment = this.characterFormat.baselineAlignment;
            let elementHeight = heightElement;
            if (baselineAlignment !== 'Normal' && isEmptySelection) {
                //Set the caret height as sub/super script text height and updates the top margin for sub script text.
                elementHeight = elementHeight / 1.5;
                if (baselineAlignment === 'Subscript') {
                    topMargin = heightElement - elementHeight;
                }
            }
            maxLineHeight = (margin.top < 0 ? margin.top : 0) + elementHeight;
            if (!isEmptySelection) {
                maxLineHeight += margin.bottom;
            }
        }
        if (!isEmptySelection) {
            return { 'height': maxLineHeight, 'topMargin': topMargin, 'isItalic': isItalic };
        }
        let height = this.documentHelper.textHelper.getHeight(format).Height;
        if (maxLineHeight === 0 && (element instanceof EditRangeStartElementBox || element instanceof EditRangeEndElementBox)) {
            maxLineHeight = height;
        }
        if (height > maxLineHeight) {
            height = maxLineHeight;
        }
        return { 'height': height, 'topMargin': topMargin, 'isItalic': isItalic };
    }
    getFieldCharacterHeight(startInline, format, isEmptySelection, topMargin, isItalic) {
        const nextValidInline = this.documentHelper.getNextValidElementForField(startInline);
        //If field separator/end exists at end of paragraph, then move to next paragraph.
        if (isNullOrUndefined(nextValidInline)) {
            const nextParagraph = startInline.line.paragraph;
            let height = this.documentHelper.textHelper.getParagraphMarkSize(format).Height;
            let top = 0;
            let bottom = 0;
            const sizeInfo = this.getParagraphMarkSize(nextParagraph, top, bottom);
            let maxLineHeight = sizeInfo.height;
            top = sizeInfo.topMargin;
            bottom = sizeInfo.bottomMargin;
            if (!isEmptySelection) {
                maxLineHeight += bottom;
                return { 'height': maxLineHeight, 'topMargin': topMargin, 'isItalic': isItalic };
            }
            if (height > maxLineHeight) {
                height = maxLineHeight;
            }
            return { 'height': height, 'topMargin': topMargin, 'isItalic': isItalic };
        }
        else {
            return this.getCaretHeight(nextValidInline, 0, format, isEmptySelection, topMargin, isItalic);
        }
    }
    /**
     * Get rendered inline
     *
     * @private
     */
    //FieldCharacter
    getRenderedInline(inline, inlineIndex) {
        if (this.documentHelper.isFormFillProtectedMode && inline.fieldType === 2) {
            return { 'element': inline, 'index': inlineIndex };
        }
        let prevInline = this.getPreviousValidElement(inline);
        while (prevInline instanceof FieldElementBox) {
            prevInline = this.getPreviousTextElement(prevInline);
            if (prevInline instanceof FieldElementBox) {
                prevInline = prevInline.previousNode;
            }
        }
        if (!isNullOrUndefined(prevInline)) {
            inlineIndex = prevInline.length;
            return { 'element': prevInline, 'index': inlineIndex };
        }
        inlineIndex = 0;
        let nextInline = this.getNextRenderedElementBox(inline, 0);
        if (nextInline instanceof FieldElementBox && nextInline.fieldType === 0) {
            nextInline = nextInline.fieldSeparator;
            nextInline = nextInline.nextNode;
            while (nextInline instanceof FieldElementBox) {
                if (nextInline instanceof FieldElementBox && nextInline.fieldType === 0
                    && HelperMethods.isLinkedFieldCharacter(nextInline)) {
                    if (isNullOrUndefined(nextInline.fieldSeparator)) {
                        nextInline = nextInline.fieldEnd;
                    }
                    else {
                        nextInline = nextInline.fieldSeparator;
                    }
                }
                nextInline = nextInline.nextNode;
            }
        }
        return { 'element': nextInline, 'index': inlineIndex };
    }
    //Field Begin
    /**
     * Get rendered field
     *
     * @private
     */
    getRenderedField(fieldBegin) {
        let inline = fieldBegin;
        if (isNullOrUndefined(fieldBegin.fieldSeparator)) {
            inline = fieldBegin.fieldEnd;
        }
        else {
            inline = fieldBegin.fieldSeparator;
            const paragraph = inline.line.paragraph;
            if (paragraph === fieldBegin.fieldEnd.line.paragraph
                && !this.hasValidInline(paragraph, inline, fieldBegin.fieldEnd)) {
                inline = fieldBegin.fieldEnd;
            }
            else {
                return inline;
            }
        }
        return inline;
    }
    /**
     * Return true is inline is tha last inline
     *
     * @private
     */
    isLastRenderedInline(inline, index) {
        while (index === inline.length && inline.nextNode instanceof FieldElementBox) {
            const nextValidInline = this.documentHelper.getNextValidElement(inline.nextNode);
            index = 0;
            if (nextValidInline instanceof FieldElementBox && nextValidInline.fieldType === 0) {
                inline = nextValidInline;
            }
            if (inline instanceof FieldElementBox && inline.fieldType === 0 && !isNullOrUndefined(inline.fieldEnd)) {
                const fieldBegin = inline;
                if (isNullOrUndefined(fieldBegin.fieldSeparator)) {
                    inline = fieldBegin.fieldEnd;
                    index = 1;
                }
                else {
                    inline = fieldBegin.fieldSeparator;
                    const paragraph = inline.line.paragraph;
                    index = 1;
                    if (paragraph === fieldBegin.fieldEnd.line.paragraph
                        && !this.hasValidInline(paragraph, inline, fieldBegin.fieldEnd)) {
                        inline = fieldBegin.fieldEnd;
                    }
                    else {
                        break;
                    }
                }
            }
        }
        return index === inline.length && isNullOrUndefined(inline.nextNode);
    }
    /**
     * Get page
     *
     * @private
     */
    getPage(widget) {
        let page = undefined;
        if (widget.containerWidget instanceof TextFrame) {
            const shape = widget.containerWidget.containerShape;
            if (shape.line) {
                page = this.getPage(shape.line.paragraph);
            }
        }
        else if (widget.containerWidget instanceof BlockContainer) {
            const bodyWidget = widget.containerWidget;
            page = widget.containerWidget.page;
        }
        else if (!isNullOrUndefined(widget.containerWidget)) {
            page = this.getPage(widget.containerWidget);
        }
        return page;
    }
    /**
     * Clear Selection highlight
     *
     * @private
     */
    clearSelectionHighlightInSelectedWidgets() {
        let isNonEmptySelection = false;
        const widgets = this.selectedWidgets.keys;
        if (!this.viewer.documentHelper.isDragStarted) {
            for (let i = 0; i < widgets.length; i++) {
                this.removeSelectionHighlight(widgets[i]);
                isNonEmptySelection = true;
            }
            this.selectedWidgets.clear();
        }
        return isNonEmptySelection;
    }
    /**
     * Clear selection highlight
     *
     * @private
     */
    clearChildSelectionHighlight(widget) {
        for (let i = 0; i < widget.childWidgets.length; i++) {
            if (widget.childWidgets[i] instanceof LineWidget) {
                this.clearSelectionHighlightLineWidget(widget.childWidgets[i]);
            }
            else if (widget.childWidgets[i] instanceof TableCellWidget) {
                this.clearSelectionHighlight(widget.childWidgets[i]);
            }
            else if (widget.childWidgets[i] instanceof Widget) {
                this.clearChildSelectionHighlight(widget.childWidgets[i]);
            }
        }
    }
    /**
     * Get line widget from paragraph widget
     *
     * @private
     */
    //Body Widget 
    getLineWidgetBodyWidget(widget, point, isGetFirstChild) {
        isGetFirstChild = isNullOrUndefined(isGetFirstChild) ? true : isGetFirstChild;
        let bodyWgt = widget;
        if (bodyWgt instanceof BlockContainer) {
            for (let x = 0; x < bodyWgt.floatingElements.length; x++) {
                const floatWidget = bodyWgt.floatingElements[x];
                if (floatWidget instanceof TableWidget) {
                    let floatWidgetWidth = floatWidget.getTableCellWidth();
                    if (point.x <= floatWidget.x + floatWidgetWidth && point.x >= floatWidget.x
                        && point.y <= floatWidget.y + floatWidget.height && point.y >= floatWidget.y) {
                        return this.getLineWidgetTableWidget(floatWidget, point);
                    }
                }
                else if (floatWidget instanceof ShapeBase && floatWidget.textWrappingStyle !== 'Behind' && floatWidget.x <= point.x && (floatWidget.x + floatWidget.width) >= point.x
                    && floatWidget.y <= point.y && (floatWidget.y + floatWidget.height) >= point.y) {
                    return floatWidget.line;
                }
            }
        }
        if (widget instanceof FootNoteWidget) {
            let selectionBody;
            let isFit = false;
            for (let j = 0; j < widget.bodyWidgets.length; j++) {
                if (widget.sectionFormat.columns.length <= 1) {
                    for (let k = 0; k < widget.bodyWidgets[j].childWidgets.length; k++) {
                        const footChild = widget.bodyWidgets[j].childWidgets[k];
                        if (footChild instanceof Widget && footChild.y <= point.y
                            && (footChild.y + footChild.height) >= point.y) {
                            if (footChild instanceof ParagraphWidget) {
                                return this.getLineWidgetParaWidget(footChild, point);
                            }
                            else {
                                return this.getLineWidgetTableWidget(footChild, point);
                            }
                        }
                    }
                }
                else {
                    let bodyWidget = widget.bodyWidgets[j];
                    if (bodyWidget.firstChild.x + bodyWidget.sectionFormat.columns[bodyWidget.columnIndex].width >= point.x && bodyWidget.firstChild.x <= point.x && bodyWidget.firstChild.y <= point.y && this.documentHelper.layout.getNextWidgetHeight(bodyWidget) >= point.y) {
                        selectionBody = bodyWidget;
                    }
                    else if (bodyWidget.firstChild.x + bodyWidget.sectionFormat.columns[bodyWidget.columnIndex].width < point.x && bodyWidget.firstChild.y <= point.y && this.documentHelper.layout.getNextWidgetHeight(bodyWidget) >= point.y) {
                        selectionBody = bodyWidget;
                    }
                    else if (widget.x > point.x && bodyWidget.firstChild.y <= point.y && this.documentHelper.layout.getNextWidgetHeight(bodyWidget) >= point.y && !isFit) {
                        selectionBody = bodyWidget;
                        isFit = true;
                    }
                    if (j === widget.bodyWidgets.length - 1 && !isNullOrUndefined(selectionBody)) {
                        for (let k = 0; k < selectionBody.childWidgets.length; k++) {
                            const footChild = selectionBody.childWidgets[k];
                            if (footChild instanceof Widget && footChild.y <= point.y
                                && (footChild.y + footChild.height) >= point.y) {
                                if (footChild instanceof ParagraphWidget) {
                                    return this.getLineWidgetParaWidget(footChild, point);
                                }
                                else {
                                    return this.getLineWidgetTableWidget(footChild, point);
                                }
                            }
                        }
                    }
                }
            }
        }
        for (let i = 0; i < widget.childWidgets.length; i++) {
            const childWidget = widget.childWidgets[i];
            if (childWidget instanceof FootNoteWidget) {
                return childWidget[i];
            }
            else {
                if (childWidget instanceof Widget && childWidget.y <= point.y
                    && (childWidget.y + childWidget.height) >= point.y) {
                    for (let k = 0; k < widget.childWidgets.length; k++) {
                        let shapeInfo = undefined;
                        const childWidget = widget.childWidgets[k];
                        if (childWidget instanceof TableWidget || childWidget.floatingElements.length === 0) {
                            continue;
                        }
                        shapeInfo = this.documentHelper.checkFloatingItems(childWidget, point, false, false, true);
                        if (shapeInfo && shapeInfo.isShapeSelected && !this.documentHelper.isEmptyShape(shapeInfo)) {
                            if (shapeInfo.isInShapeBorder || shapeInfo.element instanceof ShapeElementBox) {
                                return shapeInfo.element.line;
                            }
                        }
                    }
                    if (childWidget instanceof ParagraphWidget) {
                        // if ((childWidget as Widget).x <= point.x
                        // && ((childWidget as Widget).x + (childWidget as Widget).width) >= point.x) {
                        return this.getLineWidgetParaWidget(childWidget, point);
                        // }// return this.getLineWidgetParaWidget((childWidget as ParagraphWidget), point);
                    }
                    else {
                        let table = childWidget;
                        if (table.wrapTextAround) {
                            continue;
                        }
                        return this.getLineWidgetTableWidget(table, point);
                    }
                }
            }
        }
        let line = undefined;
        if (isGetFirstChild) {
            if (widget.childWidgets.length > 0) {
                const firstChild = widget.childWidgets[0];
                if (firstChild instanceof Widget && firstChild.y <= point.y) {
                    if (widget.childWidgets[widget.childWidgets.length - 1] instanceof ParagraphWidget) {
                        for (let i = 0; i < widget.childWidgets.length; i++) {
                            line = this.getLineWidgetParaWidget(widget.childWidgets[i], point);
                        }
                    }
                    else {
                        for (let i = 0; i < widget.childWidgets.length; i++) {
                            line = this.getLineWidgetTableWidget(widget.childWidgets[i], point);
                        }
                    }
                }
                else {
                    let childWidget = undefined;
                    if (firstChild instanceof Widget) {
                        childWidget = firstChild;
                    }
                    if (!isNullOrUndefined(childWidget)) {
                        if (childWidget instanceof ParagraphWidget) {
                            line = this.getLineWidgetParaWidget(firstChild, point);
                        }
                        else {
                            line = this.getLineWidgetTableWidget(firstChild, point);
                        }
                    }
                }
            }
        }
        return line;
    }
    //ParagraphWidget
    /**
     * Get line widget from paragraph widget
     *
     * @private
     */
    getLineWidgetParaWidget(widget, point) {
        const childWidgets = widget.childWidgets;
        let top = widget.y;
        for (let i = 0; i < childWidgets.length; i++) {
            let line = childWidgets[i];
            top += line.marginTop;
            let lineTotalHeight = line.height;
            if (line.nextLine && line.nextLine.marginTop > 0) {
                lineTotalHeight += line.nextLine.marginTop;
            }
            if (top <= point.y
                && (top + lineTotalHeight) >= point.y) {
                return line;
            }
            top += line.height;
        }
        let lineWidget = undefined;
        if (childWidgets.length > 0) {
            if (widget.y <= point.y) {
                lineWidget = childWidgets[childWidgets.length - 1];
            }
            else {
                lineWidget = childWidgets[0];
            }
        }
        return lineWidget;
    }
    highlightParagraph(widget, startIndex, endLine, endElement, endIndex, contentControl) {
        let top = 0;
        let width = 0;
        let isRtlText = false;
        let startElement = endElement;
        if (widget.paragraphFormat.bidi && endLine.children.indexOf(endElement) > 0) {
            startElement = endLine.children[0];
        }
        for (let i = startIndex; i < widget.childWidgets.length; i++) {
            const line = widget.childWidgets[i];
            if (i === startIndex) {
                top = this.getTop(line);
            }
            else {
                top += line.marginTop;
            }
            if (endElement instanceof TextElementBox) {
                isRtlText = endElement.isRightToLeft;
            }
            let left = this.getLeft(line);
            if (line === endLine) {
                //Selection ends in current line.
                let right = 0;
                // highlighting approach for normal and rtl text.
                if (isRtlText || widget.bidi) {
                    const elementBoxCollection = this.getElementsBackward(line, startElement, endElement, widget.bidi);
                    for (let i = 0; i < elementBoxCollection.length; i++) {
                        const element = elementBoxCollection[i];
                        let elementIsRTL = false;
                        if (element === endElement) {
                            right = this.getLeftInternal(line, element, element.length);
                        }
                        else {
                            const index = element instanceof TextElementBox ? element.length : 1;
                            right = this.getLeftInternal(line, element, index);
                        }
                        left = this.getLeftInternal(line, element, 0);
                        if (element instanceof TextElementBox) {
                            elementIsRTL = element.isRightToLeft;
                        }
                        width = Math.abs(right - left);
                        // Handled the paragraph mark highliting as special case.
                        if (element === endElement && element instanceof TextElementBox && endIndex > element.length) {
                            const paragraphMarkWidth = this.documentHelper.textHelper.getParagraphMarkSize(element.line.paragraph.characterFormat).Width;
                            if (!widget.bidi && elementIsRTL) {
                                right += paragraphMarkWidth;
                            }
                            else if (widget.bidi && !elementIsRTL) { // Paragrph and Selection ends in normal text
                                width -= paragraphMarkWidth;
                                // Highlight the element.
                                this.createHighlightBorder(line, width, left, top, true, contentControl);
                                // Highlight the paragraph mark of Bidi paragrph.
                                left = this.getLineStartLeft(line) - paragraphMarkWidth;
                                this.createHighlightBorder(line, paragraphMarkWidth, left, top, true, contentControl);
                                // continue to next element.
                                continue;
                            }
                        }
                        this.createHighlightBorder(line, width, elementIsRTL ? right : left, top, true, contentControl);
                    }
                    return;
                }
                else {
                    right = this.getLeftInternal(endLine, endElement, endIndex, true);
                    width = Math.abs(right - left);
                    this.createHighlightBorder(line, width, isRtlText ? right : left, top, false, contentControl);
                    return;
                }
            }
            else {
                width = this.getWidth(line, true) - (left - widget.x);
                // Highlight the paragrph mark for Bidi paragrph.
                if (widget.bidi && line.isLastLine()) {
                    left -= this.documentHelper.textHelper.getParagraphMarkSize(widget.characterFormat).Width;
                }
                this.createHighlightBorder(line, width, left, top, false, contentControl);
                top += line.height;
            }
        }
    }
    //Table Widget
    /**
     * Get line widget form table widget
     *
     * @private
     */
    getLineWidgetTableWidget(widget, point) {
        let lineWidget = undefined;
        for (let i = 0; i < widget.childWidgets.length; i++) {
            //Removed the height condition check to handle the vertically merged cells.
            const childWidget = widget.childWidgets[i];
            if (childWidget instanceof TableRowWidget && childWidget.y <= point.y) {
                if (childWidget.rowFormat.heightType === 'Exactly' &&
                    (childWidget.y + HelperMethods.convertPointToPixel(childWidget.rowFormat.height) < point.y)) {
                    continue;
                }
                lineWidget = this.getLineWidgetRowWidget(childWidget, point);
                let cellWidget = undefined;
                if (!isNullOrUndefined(lineWidget) && lineWidget.paragraph.containerWidget instanceof TableCellWidget) {
                    cellWidget = lineWidget.paragraph.containerWidget;
                }
                let cellSpacing = 0;
                let rowSpan = 0;
                if (!isNullOrUndefined(cellWidget)) {
                    const tableWidget = cellWidget.ownerRow.containerWidget;
                    cellSpacing = HelperMethods.convertPointToPixel(tableWidget.tableFormat.cellSpacing);
                    rowSpan = cellWidget.cellFormat.rowSpan;
                }
                let leftCellSpacing = 0;
                let rightCellSpacing = 0;
                let topCellSpacing = 0;
                let bottomCellSpacing = 0;
                if (cellSpacing > 0) {
                    leftCellSpacing = cellWidget.cellIndex === 0 ? cellSpacing : cellSpacing / 2;
                    rightCellSpacing = cellWidget.cellIndex === cellWidget.ownerRow.childWidgets.length - 1 ? cellSpacing : cellSpacing / 2;
                    let rowWidget = undefined;
                    if (cellWidget.containerWidget instanceof TableRowWidget) {
                        rowWidget = cellWidget.containerWidget;
                    }
                    let tableWidget = undefined;
                    if (cellWidget.containerWidget.containerWidget instanceof TableWidget) {
                        tableWidget = cellWidget.containerWidget.containerWidget;
                    }
                    if (!isNullOrUndefined(rowWidget) && !isNullOrUndefined(tableWidget)) {
                        topCellSpacing = cellWidget.ownerRow.rowIndex === 0 ? cellSpacing : cellSpacing / 2;
                        if (cellWidget.ownerRow.rowIndex + rowSpan === cellWidget.ownerTable.childWidgets.length) {
                            bottomCellSpacing = cellSpacing;
                        }
                        else {
                            bottomCellSpacing = cellSpacing / 2;
                        }
                    }
                }
                if ((!isNullOrUndefined(lineWidget) && lineWidget.paragraph.x <= point.x
                    && lineWidget.paragraph.x + lineWidget.width >= point.x
                    && lineWidget.paragraph.y <= point.y && this.getTop(lineWidget) + lineWidget.height >= point.y)
                    || (!isNullOrUndefined(cellWidget) && cellWidget.x - cellWidget.margin.left - leftCellSpacing <= point.x
                        && cellWidget.x + cellWidget.width + cellWidget.margin.right + rightCellSpacing >= point.x
                        && cellWidget.y - cellWidget.margin.top - topCellSpacing <= point.y
                        && cellWidget.y + cellWidget.height + cellWidget.margin.bottom + bottomCellSpacing >= point.y)) {
                    break;
                }
            }
        }
        if (isNullOrUndefined(lineWidget)) {
            const childWidget = widget.firstChild;
            if (widget.header && !isNullOrUndefined(childWidget) && childWidget.y >= point.y) {
                const newPoint = new Point(point.x, childWidget.y);
                return this.getLineWidgetRowWidget(childWidget, newPoint);
            }
        }
        return lineWidget;
    }
    /**
     *
     * @private
     */
    getTableCellWidget(widget, point) {
        for (let i = 0; i < widget.childWidgets.length; i++) {
            let cellSpacing = 0;
            cellSpacing = HelperMethods.convertPointToPixel(widget.ownerTable.tableFormat.cellSpacing);
            let leftCellSpacing = 0;
            let rightCellSpacing = 0;
            if (cellSpacing > 0) {
                leftCellSpacing = widget.childWidgets[i].columnIndex === 0 ? cellSpacing : cellSpacing / 2;
                rightCellSpacing = widget.childWidgets[i].cellIndex === widget.childWidgets[i].ownerRow.childWidgets.length - 1 ? cellSpacing : cellSpacing / 2;
            }
            if (widget.childWidgets[i].x -
                widget.childWidgets[i].margin.left - leftCellSpacing <= point.x && (widget.childWidgets[i].x +
                widget.childWidgets[i].width) + widget.childWidgets[i].margin.right + rightCellSpacing >= point.x) {
                if (widget.childWidgets[i].childWidgets.length > 0) {
                    return widget.childWidgets[i];
                }
                else if (this.isPageUpAndDown) {
                    for (let j = 0; j < widget.childWidgets.length; j++) {
                        if (widget.childWidgets[j].childWidgets.length > 0) {
                            return widget.childWidgets[j];
                        }
                    }
                }
            }
        }
        return undefined;
    }
    //TableRowWidget
    /**
     * Get line widget fom row
     *
     * @private
     */
    getLineWidgetRowWidget(widget, point) {
        let cell = this.getTableCellWidget(widget, point);
        if (cell) {
            return this.getLineWidgetCellWidget(cell, point);
        }
        let lineWidget = undefined;
        const rowWidth = this.documentHelper.layout.getTableWidth(widget.ownerTable);
        if (point.x >= widget.x && point.x <= rowWidth + widget.x) {
            return lineWidget;
        }
        if (widget.childWidgets.length > 0) {
            if (widget.childWidgets[0].x <= point.x) {
                lineWidget = this.getLineWidgetCellWidget(widget.childWidgets[widget.childWidgets.length - 1], point);
            }
            else {
                lineWidget = this.getLineWidgetCellWidget(widget.childWidgets[0], point);
            }
        }
        return lineWidget;
    }
    /**
     * @private
     */
    getFirstBlock(cell) {
        if (cell.childWidgets.length > 0) {
            return cell.childWidgets[0];
        }
        return undefined;
    }
    //Table Cell Widget
    /**
     * Highlight selected cell widget
     *
     * @private
     */
    highlightCellWidget(widget) {
        let widgets = [];
        if (widget.previousSplitWidget || widget.nextSplitWidget) {
            widgets = widget.getSplitWidgets();
        }
        else {
            widgets.push(widget);
        }
        for (let i = 0; i < widgets.length; i++) {
            widget = widgets[i];
            //Clears Selection highlight of the child widgets.
            this.clearChildSelectionHighlight(widget);
            //Highlights the entire cell.
            this.createHighlightBorderInsideTable(widget);
        }
    }
    /**
     * Clear selection highlight
     *
     * @private
     */
    clearSelectionHighlight(widget) {
        if (this.selectedWidgets.containsKey(widget)) {
            this.removeSelectionHighlight(widget);
            this.selectedWidgets.remove(widget);
        }
    }
    /**
     * Get line widget from cell widget
     *
     * @private
     */
    getLineWidgetCellWidget(widget, point) {
        for (let i = 0; i < widget.childWidgets.length; i++) {
            if (widget.childWidgets[i].y <= point.y
                && (widget.childWidgets[i].y + widget.childWidgets[i].height) >= point.y) {
                if (widget.childWidgets[i] instanceof ParagraphWidget) {
                    return this.getLineWidgetParaWidget(widget.childWidgets[i], point);
                }
                else {
                    return this.getLineWidgetTableWidget(widget.childWidgets[i], point);
                }
            }
        }
        let lineWidget = undefined;
        if (widget.childWidgets.length > 0) {
            if (widget.y - widget.margin.top <= point.y) {
                if (widget.childWidgets[widget.childWidgets.length - 1] instanceof ParagraphWidget) {
                    lineWidget = this.getLineWidgetParaWidget(widget.childWidgets[widget.childWidgets.length - 1], point);
                }
                else {
                    lineWidget = this.getLineWidgetTableWidget(widget.childWidgets[0], point);
                }
            }
            else if (this.isPageUpAndDown && widget.y < point.y && (widget.y + widget.height > point.y)) {
                this.updateYPointPosition(widget.childWidgets[0], point);
                if (widget.childWidgets[0] instanceof ParagraphWidget) {
                    return this.getLineWidgetParaWidget(widget.childWidgets[0], point);
                }
                else {
                    return this.getLineWidgetTableWidget(widget.childWidgets[0], point);
                }
            }
        }
        return lineWidget;
    }
    /**
     * update Y position
     *
     * @private
     */
    updateYPointPosition(widget, point) {
        if (widget instanceof ParagraphWidget) {
            point.y = widget.y;
        }
        else if (widget instanceof TableWidget && widget.firstChild instanceof TableRowWidget) {
            let cell = this.documentHelper.selection.getTableCellWidget(widget.firstChild, point);
            if (cell) {
                let firstWidget = cell.firstChild;
                if (firstWidget instanceof ParagraphWidget) {
                    this.updateYPointPosition(firstWidget, point);
                }
                else if (firstWidget instanceof TableWidget) {
                    this.updateYPointPosition(firstWidget, point);
                }
            }
        }
    }
    //LineWidget
    /**
     * update text position
     *
     * @private
     */
    updateTextPosition(widget, point) {
        let caretPosition = point;
        let element = undefined;
        let index = 0;
        let isImageSelected = false;
        if (this.owner.enableHeaderAndFooter) {
            let headerFooterWidget = this.start.paragraph.bodyWidget;
            if (headerFooterWidget.headerFooterType.indexOf('Header') != -1) {
                this.comparePageWidthAndMargins(headerFooterWidget.page.headerWidget, headerFooterWidget.page);
            }
            else {
                this.comparePageWidthAndMargins(headerFooterWidget.page.footerWidget, headerFooterWidget.page);
            }
        }
        const isImageSelectedObj = this.updateTextPositionIn(widget, element, index, point, false);
        if (!isNullOrUndefined(isImageSelectedObj)) {
            element = isImageSelectedObj.element;
            index = isImageSelectedObj.index;
            caretPosition = isImageSelectedObj.caretPosition;
            isImageSelected = isImageSelectedObj.isImageSelected;
            this.isImageSelected = isImageSelected;
        }
        if (isImageSelected) {
            this.selectInternal(widget, element, index, caretPosition);
            if (index === 0) {
                this.extendForward();
            }
            else {
                this.extendBackward();
            }
        }
        else {
            if (!isNullOrUndefined(this.owner.imageResizerModule)) {
                this.owner.imageResizerModule.selectedImageWidget.clear();
            }
            this.selectInternal(widget, element, index, caretPosition);
        }
    }
    /**
     * @private
     */
    updateTextPositionIn(widget, inline, index, caretPosition, includeParagraphMark) {
        let isImageSelected = false;
        let top = this.getTop(widget);
        let left = widget.paragraph.x;
        let elementValues = this.getFirstElement(widget, left);
        let element = elementValues.element;
        let isRtlText = false;
        let isParaBidi = false;
        left = elementValues.left;
        let children = widget.renderedElements;
        if (isNullOrUndefined(element)) {
            let topMargin = 0;
            let bottomMargin = 0;
            let size = this.getParagraphMarkSize(widget.paragraph, topMargin, bottomMargin);
            topMargin = size.topMargin;
            bottomMargin = size.bottomMargin;
            let selectParaMark = this.documentHelper.mouseDownOffset.y >= top && this.documentHelper.mouseDownOffset.y < top + widget.height ? (this.documentHelper.mouseDownOffset.x < left + size.width) : true;
            if (selectParaMark && includeParagraphMark && caretPosition.x > left + size.width / 2) {
                left += size.width;
                if (children.length > 0) {
                    inline = children[children.length - 1];
                    index = inline.length;
                }
                index++;
            }
            else if (widget.paragraph.isEmpty() && widget.paragraph.bidi) {
                left += size.width;
            }
            caretPosition = new Point(left, topMargin > 0 ? top + topMargin : top);
        }
        else {
            if (!isNullOrUndefined(element)) {
                if (caretPosition.x > left + element.margin.left || (element instanceof ShapeBase && element.textWrappingStyle !== 'Inline')) {
                    let isInInline = false;
                    if (widget.paragraph.floatingElements.length > 0) {
                        isInInline = this.documentHelper.checkPointIsInLine(widget, caretPosition);
                    }
                    for (let i = children.indexOf(element); i < children.length; i++) {
                        element = children[i];
                        if (element instanceof ShapeBase && element.textWrappingStyle !== 'Inline') {
                            if (this.documentHelper.isInShapeBorder(element, caretPosition) &&
                                !this.documentHelper.isSelectionChangedOnMouseMoved && !isInInline) {
                                left = element.x;
                                top = element.y;
                                break;
                            }
                            continue;
                        }
                        let isCurrentParaBidi = false;
                        if (element instanceof ListTextElementBox || element instanceof TextElementBox) {
                            isCurrentParaBidi = element.line.paragraph.paragraphFormat.bidi;
                        }
                        if (caretPosition.x < left + element.margin.left + element.width + element.padding.left || i === children.length - 1
                            || ((children[i + 1] instanceof ListTextElementBox) && isCurrentParaBidi)) {
                            break;
                        }
                        left += element.margin.left + element.width + element.padding.left;
                    }
                    if (element instanceof TextElementBox) {
                        isRtlText = element.isRightToLeft;
                        isParaBidi = element.line.paragraph.paragraphFormat.bidi;
                    }
                    if (caretPosition.x > left + element.margin.left + element.width + element.padding.left && !(element instanceof ShapeElementBox)) {
                        //Line End
                        index = element instanceof TextElementBox ? element.length : 1;
                        if (isRtlText && isParaBidi) {
                            index = 0;
                        }
                        if ((element instanceof TextElementBox && (element.text !== "\v" && element.text !== '\f' && element.text !== String.fromCharCode(14))) || includeParagraphMark) {
                            left += element.margin.left + element.width + element.padding.left;
                        }
                    }
                    else if (element instanceof TextElementBox) {
                        if (element instanceof TextElementBox && isRtlText) {
                            left += element.width + element.padding.left;
                        }
                        let x = 0;
                        if (isRtlText) {
                            x = (left + element.margin.left) - caretPosition.x;
                        }
                        else {
                            x = caretPosition.x - left - element.margin.left - element.padding.left;
                        }
                        left += (element.margin.left + element.padding.left);
                        let prevWidth = 0;
                        let charIndex = 0;
                        for (let i = 1; i <= element.length; i++) {
                            let width = 0;
                            if (i === element.length) {
                                width = element.width + element.padding.left;
                            }
                            else {
                                width = this.documentHelper.textHelper.getWidth(element.text.substr(0, i), element.characterFormat, element.scriptType);
                            }
                            if (x < width || i === element.length) {
                                //Updates exact left position of the caret.
                                let charWidth = width - prevWidth;
                                if (x - prevWidth > charWidth / 2) {
                                    if (isRtlText) {
                                        left -= width;
                                    }
                                    else {
                                        left += width;
                                    }
                                    charIndex = i;
                                }
                                else {
                                    if (isRtlText) {
                                        left -= prevWidth;
                                    }
                                    else {
                                        left += prevWidth;
                                    }
                                    charIndex = i - 1;
                                    if (i === 1 && element !== children[0] && !(children[0] instanceof ShapeBase &&
                                        children[0].textWrappingStyle !== 'Inline')) {
                                        let curIndex = children.indexOf(element);
                                        if (!(children[curIndex - 1] instanceof ListTextElementBox) && !isRtlText) {
                                            element = children[curIndex - 1];
                                            if (element instanceof ShapeBase && element.textWrappingStyle !== 'Inline' && charIndex == 0 && !isNullOrUndefined(element.previousElement)) {
                                                element = children[children.indexOf(element) - 1];
                                            }
                                            charIndex = element instanceof TextElementBox ? element.length : 1;
                                        }
                                    }
                                }
                                // If the next element is a Bookmark Start and the current offset is just before it,need to move the cursor inside the bookmark start position.
                                if (i == element.length && element.nextNode instanceof BookmarkElementBox && element.nextNode.bookmarkType == 0) {
                                    charIndex += this.getNextValidOffset(element.line, charIndex, true);
                                }
                                break;
                            }
                            prevWidth = width;
                        }
                        index = charIndex;
                    }
                    else {
                        isImageSelected = element instanceof ImageElementBox || element instanceof ShapeElementBox || element instanceof GroupShapeElementBox;
                        if (caretPosition.x - left - element.margin.left > element.width / 2) {
                            index = 1;
                            left += (element.margin.left + element.width + element.padding.left);
                        }
                        else if (element !== children[0] && !isImageSelected) {
                            let curIndex = children.indexOf(element);
                            if (!(children[curIndex - 1] instanceof ListTextElementBox)) {
                                element = children[curIndex - 1];
                                index = element instanceof TextElementBox ? element.length : 1;
                            }
                        }
                    }
                    if (element instanceof TextElementBox && (element.text === '\v' || element.text === '\f' || element.text === String.fromCharCode(14))) {
                        index = 0;
                    }
                }
                else {
                    isRtlText = element.characterFormat.bidi;
                    isParaBidi = element.line.paragraph.paragraphFormat.bidi;
                    if (element instanceof TextElementBox && (isParaBidi || isRtlText) && caretPosition.x < left + element.margin.left + element.width + element.padding.left) {
                        index = this.getTextLength(element.line, element) + element.length;
                    }
                    else if (element instanceof BookmarkElementBox && element.bookmarkType == 0) {
                        let hasMouseDrag = (this.documentHelper.isSelectionChangedOnMouseMoved || this.documentHelper.isSelectionActive);
                        if (!hasMouseDrag && this.documentHelper.isMouseDown && this.documentHelper.mouseDownOffset) {
                            if (this.documentHelper.mouseDownOffset.x !== caretPosition.x || this.documentHelper.mouseDownOffset.y !== caretPosition.y) {
                                hasMouseDrag = true;
                            }
                        }
                        if (hasMouseDrag) {
                            index = this.getTextLength(element.line, element);
                        }
                        else {
                            index = this.getNextValidOffset(element.line, 0, true);
                        }
                    }
                    else {
                        index = this.getTextLength(element.line, element);
                    }
                    left += element.margin.left;
                }
                if (element instanceof TextElementBox) {
                    top += element.margin.top > 0 ? element.margin.top : 0;
                }
                else if (!((element instanceof BookmarkElementBox && element.indexInOwner === 0 && this.lineHasOnlyBookmarksAndEditRanges(element.line)) || element instanceof EditRangeStartElementBox
                    || element instanceof EditRangeEndElementBox || element instanceof ImageElementBox)) {
                    let textMetrics = this.documentHelper.textHelper.getHeight(element.characterFormat); //for ascent and descent
                    let height = element.height;
                    if (element instanceof BookmarkElementBox && !this.documentHelper.layout.hasValidElement(element.line.paragraph)) {
                        height = textMetrics.Height; //after text helper class
                    }
                    top += element.margin.top + height - textMetrics.BaselineOffset;
                }
                inline = element;
                if (inline instanceof FieldElementBox && inline.fieldType === 2 && !isNullOrUndefined(inline.fieldBegin)) {
                    inline = inline.fieldBegin;
                    index = 0;
                }
                if (inline instanceof EditRangeEndElementBox) {
                    index = 0;
                }
                if (element instanceof ContentControl) {
                    if ((element.type == 0 && element.nextNode == element.reference) || (element.type == 1 && element.previousNode == element.reference) || this.isMoveDownOrMoveUp) {
                        index = element.type === 0 ? (index + 1) : (index - 1);
                    }
                    if ((element.type === 0 && element.nextNode instanceof EditRangeStartElementBox) || (element.type === 1 && element.previousNode instanceof EditRangeEndElementBox)) {
                        index = element.type === 0 ? (index + 2) : (index - 2);
                    }
                }
                if (!isNullOrUndefined(inline.previousElement) && inline.previousElement instanceof ShapeBase && inline.previousElement.textWrappingStyle !== 'Inline' && index == 0) {
                    inline = inline.previousElement;
                }
                let inlineObj = this.validateTextPosition(inline, index);
                inline = inlineObj.element;
                index = inlineObj.index;
                let isParagraphEnd = isNullOrUndefined(inline.nextNode) && index === inline.length;
                let isLineEnd = inline.line.isEndsWithLineBreak
                    && inline instanceof TextElementBox && inline.text === '\v';
                if (includeParagraphMark && inline.nextNode instanceof FieldElementBox && index === inline.length) {
                    isParagraphEnd = this.isLastRenderedInline(inline, index);
                }
                if (includeParagraphMark && isParagraphEnd || isLineEnd) {
                    let width = 0;
                    //Include width of Paragraph mark.
                    if (isParagraphEnd) {
                        width = this.documentHelper.textHelper.getParagraphMarkWidth(widget.paragraph.characterFormat);
                        let selectParaMark = this.documentHelper.mouseDownOffset.y >= top && this.documentHelper.mouseDownOffset.y < top + widget.height ? (this.documentHelper.mouseDownOffset.x < left + width) : true;
                        if (selectParaMark && caretPosition.x > left + width / 2) {
                            left += width;
                            index = inline.length + 1;
                        }
                        //Include width of line break mark.
                    }
                    else if (isLineEnd) {
                        width = element.width + element.padding.left;
                        left += width;
                        // index = inline.length;
                    }
                }
                caretPosition = new Point(left, top);
            }
        }
        return {
            'element': inline,
            'index': index,
            'caretPosition': caretPosition,
            'isImageSelected': isImageSelected
        };
    }
    /**
     * Returns true if the current line contains only the bookmark element.
     */
    lineHasOnlyBookmarksAndEditRanges(line) {
        let lineHasOnlyBookmarks = false;
        if (line.children.length === 0) {
            return false;
        }
        for (let i = 0; i < line.children.length; i++) {
            let elementBox = line.children[i];
            if (elementBox instanceof BookmarkElementBox || elementBox instanceof EditRangeStartElementBox || elementBox instanceof EditRangeEndElementBox) {
                lineHasOnlyBookmarks = true;
            }
            else {
                return false;
            }
        }
        return lineHasOnlyBookmarks;
    }
    /**
     * @private
     */
    checkAllFloatingElements(widget, caretPosition) {
        let bodyWidget;
        let isShapeSelected = false;
        let isInShapeBorder = false;
        let floatElement;
        if (!isNullOrUndefined(widget)) {
            bodyWidget = widget.paragraph.bodyWidget;
            isShapeSelected = false;
            isInShapeBorder = false;
            for (let i = 0; i < bodyWidget.floatingElements.length; i++) {
                if (bodyWidget.floatingElements[i] instanceof TableWidget) {
                    continue;
                }
                floatElement = bodyWidget.floatingElements[i];
                if (caretPosition.x < floatElement.x + floatElement.margin.left + floatElement.width && caretPosition.x > floatElement.x
                    && caretPosition.y < floatElement.y + floatElement.margin.top + floatElement.height && caretPosition.y > floatElement.y) {
                    isShapeSelected = true;
                    if (this.documentHelper.isInShapeBorder(floatElement, caretPosition)) {
                        isInShapeBorder = true;
                    }
                    break;
                }
            }
        }
        return {
            'element': floatElement,
            'caretPosition': caretPosition,
            'isShapeSelected': isShapeSelected,
            'isInShapeBorder': isInShapeBorder
        };
    }
    /**
     * Get text length if the line widget
     *
     * @private
     */
    getTextLength(widget, element) {
        let length = 0;
        let renderedElement = widget.renderedElements;
        let count = renderedElement.indexOf(element);
        if (renderedElement.length > 0 && renderedElement[0] instanceof ListTextElementBox) {
            if (renderedElement[1] instanceof ListTextElementBox) {
                count -= 2;
            }
            else {
                count -= 1;
            }
        }
        for (let i = 1; i < count; i++) {
            length += renderedElement[i].length;
        }
        return length;
    }
    /**
     * Get Line widget left
     *
     * @private
     */
    getLeft(widget) {
        let left = widget.paragraph.x;
        const paragraphFormat = widget.paragraph.paragraphFormat;
        if (this.isParagraphFirstLine(widget) && !paragraphFormat.bidi && !(paragraphFormat.textAlignment === 'Right')) {
            left += HelperMethods.convertPointToPixel(paragraphFormat.firstLineIndent);
        }
        let renderedElements = widget.renderedElements;
        for (let i = 0; i < renderedElements.length; i++) {
            const element = renderedElements[i];
            if (element instanceof ListTextElementBox && !paragraphFormat.bidi) { //after list implementation
                if (i === 0) {
                    left += element.margin.left + element.width;
                    if (element.padding) {
                        left += element.padding.left;
                    }
                }
                else {
                    left += element.width;
                }
            }
            else {
                left += element.margin.left;
                break;
            }
        }
        return left;
    }
    /**
     * Get line widget top
     *
     * @private
     */
    getTop(widget) {
        let top = widget.paragraph.y;
        const count = widget.paragraph.childWidgets.indexOf(widget);
        for (let i = 0; i < count; i++) {
            let line = widget.paragraph.childWidgets[i];
            top = (top + line.height + line.marginTop);
        }
        top += widget.marginTop;
        return top;
    }
    /**
     * Get first element the widget
     *
     * @private
     */
    getFirstElement(widget, left) {
        let firstLineIndent = 0;
        if (this.isParagraphFirstLine(widget) && !widget.paragraph.paragraphFormat.bidi) {
            firstLineIndent = HelperMethods.convertPointToPixel(widget.paragraph.paragraphFormat.firstLineIndent);
        }
        left += firstLineIndent;
        let element = undefined;
        let renderedChild = widget.renderedElements;
        for (let i = 0; i < renderedChild.length; i++) {
            element = renderedChild[i];
            if (element instanceof ListTextElementBox) {
                if (widget.paragraph.paragraphFormat.bidi) {
                    left += element.margin.left;
                    element = undefined;
                }
                else {
                    left += element.margin.left + element.width + element.padding.left;
                    element = undefined;
                }
                // }
                //  else if (element instanceof FieldElementBox || element instanceof BookmarkElementBox
                //     || (element.nextNode instanceof FieldElementBox && ((element.nextNode as FieldElementBox).fieldType === 2))) {
                //     element = undefined;
            }
            else {
                break;
            }
        }
        return { 'element': element, 'left': left };
    }
    /**
     * Return inline index
     *
     * @private
     */
    //ElementBox
    getIndexInInline(elementBox) {
        let indexInInline = 0;
        if (elementBox instanceof TextElementBox) {
            const count = elementBox.line.children.indexOf(elementBox);
            for (let i = 0; i < count; i++) {
                const element = elementBox.line.children[i];
                if (element instanceof FieldElementBox || element instanceof ListTextElementBox) {
                    continue;
                }
                indexInInline += element.length;
            }
        }
        return indexInInline;
    }
    /**
     * Return true if widget is first inline of paragraph
     *
     * @private
     */
    isParagraphFirstLine(widget) {
        if (isNullOrUndefined(widget.paragraph.previousSplitWidget) &&
            widget === widget.paragraph.firstChild) {
            return true;
        }
        return false;
    }
    /**
     * @param widget
     * @private
     */
    isParagraphLastLine(widget) {
        if (isNullOrUndefined(widget.paragraph.nextSplitWidget)
            && widget === widget.paragraph.lastChild) {
            return true;
        }
        return false;
    }
    /**
     * Return line widget width
     *
     * @private
     */
    getWidth(widget, includeParagraphMark) {
        let width = 0;
        const paraFormat = widget.paragraph.paragraphFormat;
        if (this.isParagraphFirstLine(widget) && !paraFormat.bidi) {
            width += HelperMethods.convertPointToPixel(paraFormat.firstLineIndent);
        }
        for (let i = 0; i < widget.children.length; i++) {
            const elementBox = widget.children[i];
            if (elementBox instanceof ShapeBase && elementBox.textWrappingStyle !== 'Inline') {
                continue;
            }
            width += (elementBox.margin.left + elementBox.width + elementBox.padding.left);
        }
        if (includeParagraphMark && widget.paragraph.childWidgets.indexOf(widget) === widget.paragraph.childWidgets.length - 1
            && isNullOrUndefined(widget.paragraph.nextSplitWidget)) {
            width += this.documentHelper.textHelper.getParagraphMarkWidth(widget.paragraph.characterFormat);
        }
        return width;
    }
    /**
     * Return line widget left
     *
     * @private
     */
    getLeftInternal(widget, elementBox, index, skipPadding) {
        let left = widget.paragraph.x;
        let paraFormat = widget.paragraph.paragraphFormat;
        if (this.isParagraphFirstLine(widget) && !paraFormat.bidi) {
            left += HelperMethods.convertPointToPixel(widget.paragraph.paragraphFormat.firstLineIndent);
        }
        let renderedWidget = widget.renderedElements;
        let count = renderedWidget.indexOf(elementBox);
        if ((renderedWidget.length === 1 && renderedWidget[0] instanceof ListTextElementBox) || (renderedWidget.length === 2
            && renderedWidget[0] instanceof ListTextElementBox && renderedWidget[1] instanceof ListTextElementBox)) {
            count = renderedWidget.length;
        }
        let isFieldCode = false;
        for (let i = 0; i < count; i++) {
            let widgetInternal = renderedWidget[i];
            if (widgetInternal instanceof FieldElementBox && widgetInternal.fieldType === 2) {
                isFieldCode = false;
            }
            if (isFieldCode) {
                continue;
            }
            if (widgetInternal instanceof ShapeBase && widgetInternal.textWrappingStyle !== 'Inline') {
                continue;
            }
            if (i === 1 && widgetInternal instanceof ListTextElementBox) {
                left += widgetInternal.width;
                if (widgetInternal.padding && widgetInternal.padding.left) {
                    left += widgetInternal.padding.left;
                }
            }
            else if (widgetInternal instanceof TabElementBox && elementBox === widgetInternal) {
                left += widgetInternal.margin.left;
            }
            else {
                left += widgetInternal.margin.left + widgetInternal.width + widgetInternal.padding.left;
            }
            if (widgetInternal instanceof FieldElementBox && widgetInternal.fieldType === 0) {
                isFieldCode = true;
            }
        }
        let isRtlText = false;
        let isParaBidi = widget.paragraph.bidi;
        if (!isNullOrUndefined(elementBox)) {
            isRtlText = elementBox.characterRange === CharacterRangeType.RightToLeft;
            isParaBidi = elementBox.line.paragraph.paragraphFormat.bidi;
            left = (index === 0 && skipPadding) ? left + elementBox.margin.left : left + elementBox.margin.left + elementBox.padding.left;
            if (elementBox instanceof ShapeBase && !isParaBidi && !isNullOrUndefined(elementBox.nextElement)) {
                left += (elementBox.nextElement.margin.left + elementBox.nextElement.padding.left);
            }
            if (isRtlText || (this.documentHelper.moveCaretPosition === 1 && !isRtlText && isParaBidi)) {
                left += elementBox.width;
            }
        }
        let width = 0;
        if (elementBox instanceof TextElementBox) {
            if ((this.documentHelper.moveCaretPosition !== 0) && (isParaBidi || isRtlText)) {
                if ((isRtlText && isParaBidi && this.documentHelper.moveCaretPosition === 2)
                    || (isRtlText && !isParaBidi && this.documentHelper.moveCaretPosition === 1)) {
                    left -= elementBox.width;
                }
                this.documentHelper.moveCaretPosition = 0;
                return left;
            }
            if (index === elementBox.length && !isRtlText) {
                if (this.documentHelper.isTextInput ? !isParaBidi : true) {
                    left += elementBox.width;
                }
            }
            else if (index > elementBox.length) {
                width = this.documentHelper.textHelper.getParagraphMarkWidth(elementBox.line.paragraph.characterFormat);
                if (isRtlText) {
                    left -= elementBox.width + width;
                }
                else {
                    left += elementBox.width + width;
                }
            }
            else {
                if (index === elementBox.length && isRtlText && paraFormat.textAlignment === 'Justify') {
                    width = elementBox.width;
                }
                else {
                    width = this.documentHelper.textHelper.getWidth(elementBox.text.substr(0, index), elementBox.characterFormat, elementBox.scriptType);
                }
                if (isRtlText) {
                    if (this.documentHelper.isTextInput ? isParaBidi : true) {
                        left -= width;
                    }
                }
                else {
                    left += width;
                }
            }
            this.documentHelper.moveCaretPosition = 0;
        }
        else if (index > 0) {
            if (!isNullOrUndefined(elementBox) && !(elementBox instanceof ListTextElementBox)) {
                if (!(elementBox instanceof ShapeBase && elementBox.textWrappingStyle !== 'Inline')) {
                    left += elementBox.width;
                }
                if (index === 2) {
                    let paragraph = elementBox.line.paragraph;
                    left += this.documentHelper.textHelper.getParagraphMarkWidth(paragraph.characterFormat);
                }
            }
            else {
                left += this.documentHelper.textHelper.getParagraphMarkWidth(widget.paragraph.characterFormat);
            }
        }
        return left;
    }
    /**
     * Return line widget start offset
     * @private
     */
    getLineStartLeft(widget) {
        let left = widget.paragraph.x;
        let paragraphFormat = widget.paragraph.paragraphFormat;
        if (this.isParagraphFirstLine(widget) && !paragraphFormat.bidi) {
            left += HelperMethods.convertPointToPixel(paragraphFormat.firstLineIndent);
        }
        if (widget.children.length > 0) {
            left += widget.children[0].margin.left;
        }
        return left;
    }
    /**
     * Update text position
     * @private
     */
    updateTextPositionWidget(widget, point, textPosition, includeParagraphMark) {
        let caretPosition = point;
        let inline = undefined;
        let index = 0;
        let updatePositionObj;
        updatePositionObj = this.updateTextPositionIn(widget, inline, index, caretPosition, includeParagraphMark);
        inline = updatePositionObj.element;
        index = updatePositionObj.index;
        caretPosition = updatePositionObj.caretPosition;
        textPosition.setPositionForSelection(widget, inline, index, caretPosition);
    }
    /**
     * Clear selection highlight
     * @private
     */
    clearSelectionHighlightLineWidget(widget) {
        if (!isNullOrUndefined(this.owner) && this.selectedWidgets.length > 0) {
            this.clearSelectionHighlight(this);
        }
    }
    /**
     * Return first element from line widget
     * @private
     */
    getFirstElementInternal(widget) {
        let element = undefined;
        let childLen = widget.children.length;
        for (let i = 0; i < childLen; i++) {
            element = widget.children[i];
            if (element instanceof ListTextElementBox) {
                element = undefined;
            }
            else {
                break;
            }
        }
        return element;
    }
    //Selection API.   
    /**
     * Select content between given range
     * @private
     */
    selectRange(startPosition, endPosition, isBookmark) {
        this.start.setPositionInternal(startPosition);
        this.end.setPositionInternal(endPosition);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true, true, isBookmark);
    }
    /**
     * Selects current paragraph
     * @private
     */
    selectParagraphInternal(paragraph, positionAtStart) {
        let line;
        if (!isNullOrUndefined(paragraph) && !isNullOrUndefined(paragraph.firstChild)) {
            line = paragraph.firstChild;
            if (positionAtStart) {
                this.start.setPosition(line, positionAtStart);
            }
            else {
                let endOffset = line.getEndOffset();
                this.start.setPositionParagraph(line, endOffset);
            }
        }
        this.end.setPositionInternal(this.start);
        this.upDownSelectionLength = this.start.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * @private
     */
    setPositionForBlock(block, selectFirstBlock) {
        let position;
        if (block instanceof TableWidget) {
            if (selectFirstBlock) {
                block = this.documentHelper.getFirstParagraphInFirstCell(block);
            }
            else {
                block = this.documentHelper.getLastParagraphInLastCell(block);
            }
        }
        if (block instanceof ParagraphWidget) {
            position = new TextPosition(this.owner);
            if (selectFirstBlock) {
                position.setPosition(block.firstChild, true);
            }
            else {
                let line = block.lastChild;
                position.setPositionParagraph(line, line.getEndOffset());
            }
        }
        return position;
    }
    /**
     * Select content in given text position
     * @private
     */
    selectContent(textPosition, clearMultiSelection) {
        if (isNullOrUndefined(textPosition)) {
            throw new Error('textPosition is undefined.');
        }
        this.start.setPositionInternal(textPosition);
        this.end.setPositionInternal(textPosition);
        this.upDownSelectionLength = this.end.location.x;
        this.fireSelectionChanged(true);
    }
    /**
     * Select paragraph
     * @private
     */
    selectInternal(lineWidget, element, index, physicalLocation) {
        this.start.setPositionForSelection(lineWidget, element, index, physicalLocation);
        this.end.setPositionInternal(this.start);
        this.upDownSelectionLength = physicalLocation.x;
        this.fireSelectionChanged(true);
    }
    /**
     * @private
     */
    selects(lineWidget, offset, skipSelectionChange) {
        this.documentHelper.clearSelectionHighlight();
        this.start.setPositionForLineWidget(lineWidget, offset);
        this.end.setPositionInternal(this.start);
        if (!skipSelectionChange) {
            this.fireSelectionChanged(true);
        }
    }
    /**
     * Select content between start and end position
     * @private
     */
    selectPosition(startPosition, endPosition, skipFieldSelection) {
        if (isNullOrUndefined(startPosition) || isNullOrUndefined(endPosition)) {
            throw new Error('TextPosition cannot be undefined');
        }
        if (isNullOrUndefined(startPosition.paragraph)
            || startPosition.offset > this.getParagraphLength(startPosition.paragraph) + 1) {
            throw new Error('Start TextPosition is not valid.');
        }
        if (isNullOrUndefined(endPosition.paragraph)
            || endPosition.offset > this.getParagraphLength(endPosition.paragraph) + 1) {
            throw new Error('End TextPosition is not valid.');
        }
        if (startPosition.isAtSamePosition(endPosition)) {
            // Select start position.
            this.selectRange(startPosition, startPosition);
        }
        else {
            // If both text position exists within same comment or outside comment, and not at same position.
            if (!skipFieldSelection) {
                if (startPosition.isExistBefore(endPosition)) {
                    endPosition.validateForwardFieldSelection(startPosition.getHierarchicalIndexInternal(), endPosition.getHierarchicalIndexInternal());
                }
                else {
                    startPosition.validateForwardFieldSelection(endPosition.getHierarchicalIndexInternal(), startPosition.getHierarchicalIndexInternal());
                }
            }
            this.selectRange(startPosition, endPosition);
        }
    }
    /**
     * Notify selection change event
     * @private
     */
    fireSelectionChanged(isSelectionChanged, isKeyBoardNavigation, isBookmark) {
        if (!this.isMoveDownOrMoveUp) {
            this.upDownSelLength = 0;
        }
        if (!this.isSelectBookmark) {
            this.isExcludeBookmarkStartEnd = false;
        }
        if (!this.isSelectCurrentWord && this.documentHelper.isDoubleTap) {
            this.documentHelper.isDoubleTap = false;
        }
        if (!this.isEmpty) {
            if (this.isForward) {
                this.start.updatePhysicalPosition(true);
                this.end.updatePhysicalPosition(false);
            }
            else {
                this.start.updatePhysicalPosition(false);
                this.end.updatePhysicalPosition(true);
            }
        }
        if (this.isModifyingSelectionInternally) {
            return;
        }
        if (this.documentHelper.formFields.length > 0 && !this.owner.editor.isRemoteAction) {
            this.currentFormField = this.getCurrentFormField();
        }
        else {
            this.currentFormField = undefined;
        }
        if (!isNullOrUndefined(this.previousSelectedFormField) && isNullOrUndefined(this.previousSelectedFormField.fieldSeparator)) {
            this.previousSelectedFormField = this.currentFormField;
        }
        if (isSelectionChanged) {
            this.previousSelectedContentControl = this.currentContentControl;
        }
        if (this.documentHelper.contentControlCollection.length > 0) {
            this.currentContentControl = this.owner.editor.getContentControl();
        }
        else {
            this.currentContentControl = undefined;
        }
        if (!this.skipFormatRetrieval && !(!isNullOrUndefined(this.owner.optionsPaneModule) && this.owner.optionsPaneModule.isBuildHeading)) {
            this.retrieveCurrentFormatProperties();
        }
        this.updateContentControlHighlightSelection();
        this.documentHelper.clearSelectionHighlight();
        this.hideToolTip();
        if (this.owner.isLayoutEnabled && !this.owner.isShiftingEnabled) {
            this.highlightSelection(true, isBookmark);
        }
        if (this.documentHelper.restrictEditingPane.isShowRestrictPane && !this.skipEditRangeRetrieval) {
            this.documentHelper.restrictEditingPane.updateUserInformation();
        }
        if (isSelectionChanged) {
            if (this.start.paragraph.isInHeaderFooter && !this.owner.enableHeaderAndFooter) {
                this.owner.enableHeaderAndFooter = true;
            }
            else if (!this.start.paragraph.isInHeaderFooter && this.owner.enableHeaderAndFooter) {
                this.owner.enableHeaderAndFooter = false;
            }
            this.owner.fireSelectionChange();
        }
        this.triggerSpellCheckWhenSelectionChanges();
        if (this.owner.enableAutoFocus) {
            this.documentHelper.updateFocus();
        }
        if (this.documentHelper.isFormFillProtectedMode && isSelectionChanged) {
            this.triggerFormFillEvent(isKeyBoardNavigation);
            this.previousSelectedFormField = this.currentFormField;
        }
        if (this.owner.rulerHelper && this.owner.documentEditorSettings && this.owner.documentEditorSettings.showRuler &&
            !this.owner.isReadOnlyMode && this.owner.enableLayout) {
            this.owner.rulerHelper.updateRuler(this.owner, false);
        }
        // if selection is changed to another page, we need to update the selection end's page number if it is present in viewport.
        if (!isNullOrUndefined(this.viewer) && this.documentHelper.pages.length > 0) {
            if (this.viewer.visiblePages.length > 0) {
                const pages = this.viewer.visiblePages;
                const startPageNumber = pages[0].index + 1;
                const endPageNumber = pages[pages.length - 1].index + 1;
                if (this.endPage >= startPageNumber && this.endPage <= endPageNumber) {
                    const eventArgs = {
                        startPage: startPageNumber,
                        endPage: endPageNumber,
                        source: this.owner
                    };
                    this.owner.notify(internalviewChangeEvent, eventArgs);
                }
            }
        }
    }
    /**
     * Notify selection change event
     * @private
     */
    updateContentControlHighlightSelection() {
        this.contentControleditRegionHighlighters.clear();
        if (!this.isHighlightContentControlEditRegion) {
            return;
        }
        if (this.documentHelper.contentControlCollection.length > 0 && !(!isNullOrUndefined(this.owner.optionsPaneModule) && this.owner.optionsPaneModule.isBuildHeading)) {
            this.contentControls = this.owner.editor.getContentControls();
        }
        else {
            this.contentControls = [];
        }
        if (this.contentControls && this.contentControls.length > 0) {
            for (let i = 0; i < this.contentControls.length; i++) {
                this.highlightContentControlEditRegionInternal(this.contentControls[parseInt(i.toString(), 10)]);
            }
        }
        this.isHighlightNext = false;
    }
    //Formats Retrieval
    /**
     * Retrieve all current selection format
     * @private
     */
    retrieveCurrentFormatProperties() {
        this.isRetrieveFormatting = true;
        let startPosition = this.start;
        let endPosition = this.end;
        if (!this.isForward) {
            startPosition = this.end;
            endPosition = this.start;
        }
        this.retrieveImageFormat(startPosition, endPosition);
        this.retrieveCharacterFormat(startPosition, endPosition);
        this.retrieveParagraphFormat(startPosition, endPosition);
        this.retrieveSectionFormat(startPosition, endPosition);
        this.retrieveTableFormat(startPosition, endPosition);
        this.isRetrieveFormatting = false;
        this.setCurrentContextType();
    }
    triggerSpellCheckWhenSelectionChanges() {
        if (this.documentHelper.isSpellCheckPending && this.documentHelper.owner.isSpellCheck && !this.documentHelper.isTextInput && !this.owner.editorModule.isDeleteOrBackSpace && !this.owner.editorModule.handledEnter) {
            this.documentHelper.triggerElementsOnLoading = true;
            this.documentHelper.triggerSpellCheck = true;
            this.viewer.updateScrollBars();
            this.documentHelper.isSpellCheckPending = false;
            this.documentHelper.triggerElementsOnLoading = false;
            this.documentHelper.triggerSpellCheck = false;
        }
    }
    /**
     * @private
     */
    retrieveImageFormat(start, end) {
        let image;
        if (start.currentWidget === end.currentWidget && start.offset + 1 === end.offset) {
            let elementInfo = end.currentWidget.getInline(end.offset, 0);
            image = elementInfo.element;
            let index = elementInfo.index;
            if (image instanceof ImageElementBox || image instanceof GroupShapeElementBox) {
                let startOffset = start.currentWidget.getOffset(image, 0);
                if (startOffset !== start.offset) {
                    image = undefined;
                }
            }
        }
        if (image instanceof ImageElementBox) {
            this.imageFormat.copyImageFormat(image);
        }
        else {
            this.imageFormat.clearImageFormat();
        }
    }
    /**
     * Gets the context type of previous character or element.
     * @param isElement - Decides whether to get previous context type from element or character. By default, character.
     * @returns Returns the context type of previous character or element.
     */
    getPreviousContextType(isElement) {
        let contextType;
        let start = this.start;
        if (start.offset > 0) {
            let element = start.currentWidget.getInline(start.offset, 0).element;
            if (isElement) {
                element = element.previousElement;
            }
            else {
                element = start.currentWidget.getInline(start.offset - 1, 0).element;
            }
            contextType = this.getContextElement(element);
            return contextType;
        }
        return undefined;
    }
    /**
     * Gets the context type of next character or element.
     * @param isElement - Decides whether to get next context type from element or character. By default, character.
     * @return Returns the context type of next character or element.
     */
    getNextContextType(isElement) {
        let contextType;
        let start = this.start;
        let element = start.currentWidget.getInline(start.offset, 0).element;
        if (isElement && element.nextElement) {
            element = element.nextElement;
        }
        else {
            element = start.currentWidget.getInline(start.offset + 1, 0).element;
        }
        contextType = this.getContextElement(element);
        return contextType;
    }
    getContextElement(element) {
        if (element instanceof TextElementBox) {
            return 'Text';
        }
        else if (element instanceof FieldElementBox || element instanceof FieldTextElementBox) {
            return 'Field';
        }
        else if (element instanceof BookmarkElementBox) {
            return 'Bookmark';
        }
        else if (element instanceof ImageElementBox) {
            return 'Image';
        }
        else if (element instanceof ShapeElementBox) {
            return 'Shape';
        }
        else if (element instanceof CommentElementBox || element instanceof CommentCharacterElementBox) {
            return 'Comment';
        }
        else if (element instanceof ListTextElementBox) {
            return 'List';
        }
        else if (element instanceof EditRangeStartElementBox || element instanceof EditRangeEndElementBox) {
            return 'EditRange';
        }
        else {
            return undefined;
        }
    }
    getContentControlPositions(contenControl) {
        const offset = contenControl.line.getOffset(contenControl, 1);
        const startPosition = new TextPosition(this.owner);
        startPosition.setPositionParagraph(contenControl.line, offset);
        let contentControlEnd = contenControl.reference;
        const endoffset = contentControlEnd.line.getOffset(contentControlEnd, 0);
        const endPosition = new TextPosition(this.owner);
        endPosition.setPositionParagraph(contentControlEnd.line, endoffset);
        return { startPosition: startPosition, endPosition: endPosition };
    }
    /**
    * Retrieves the information about the content control associated with the current selection.
    *
    * @returns {ContentControlInfo} An object containing details about the content control, including
    * its title, tag, value, editability, deletability, type, and any XML mapping if applicable.
    */
    getContentControlInfo() {
        let contentControl = this.currentContentControl;
        if (!isNullOrUndefined(contentControl)) {
            let ccValue = '';
            if (contentControl.contentControlProperties.type === 'Text') {
                const position = this.getContentControlPositions(contentControl);
                ccValue = this.documentHelper.selection.getTextInternal(position.startPosition, position.endPosition, false);
            }
            else if (contentControl.contentControlProperties.type === 'RichText') {
                // When writing SFDT if the block is Richtext this will write has rich block not as paragraph block. To skip this changing the type as BuldingBlockGallery 
                contentControl.contentControlProperties.type = 'BuildingBlockGallery';
                const position = this.getContentControlPositions(contentControl);
                let documentContent = !isNullOrUndefined(this.owner.sfdtExportModule) ?
                    this.owner.sfdtExportModule.write((this.owner.documentEditorSettings.optimizeSfdt ? 1 : 0), position.startPosition.currentWidget, position.startPosition.offset, position.endPosition.currentWidget, position.endPosition.offset, false, true) : {};
                ccValue = JSON.stringify(documentContent);
                contentControl.contentControlProperties.type = 'RichText';
            }
            else if (contentControl.contentControlProperties.type === 'CheckBox') {
                ccValue = contentControl.contentControlProperties.isChecked ? 'true' : 'false';
            }
            else if (contentControl.contentControlProperties.type === 'ComboBox' || contentControl.contentControlProperties.type === 'DropDownList' || contentControl.contentControlProperties.type === 'Date') {
                let element = contentControl;
                while (element !== contentControl.reference) {
                    if (element instanceof TextElementBox) {
                        ccValue += element.text;
                    }
                    element = element.nextNode;
                }
            }
            else if (contentControl.contentControlProperties.type === 'Picture') {
                if (contentControl.nextNode instanceof ImageElementBox) {
                    ccValue = this.documentHelper.getImageString(contentControl.nextNode);
                }
            }
            let contentControlInfo = {
                title: contentControl.contentControlProperties.title,
                tag: contentControl.contentControlProperties.tag,
                value: ccValue,
                canDelete: contentControl.contentControlProperties.lockContentControl,
                canEdit: contentControl.contentControlProperties.lockContents,
                type: contentControl.contentControlProperties.type
            };
            return contentControlInfo;
        }
        return undefined;
    }
    setCurrentContextType() {
        let contextIsinImage = this.imageFormat.image ? true : false;
        let contextIsinTable = (isNullOrUndefined(this.tableFormat) || isNullOrUndefined(this.tableFormat.table)) ? false : true;
        let style = this.start.paragraph.paragraphFormat.baseStyle;
        if (style instanceof WParagraphStyle && style.name.toLowerCase().indexOf('toc') === 0) {
            let tocField = this.getTocFieldInternal();
            if (!isNullOrUndefined(tocField)) {
                this.contextTypeInternal = 'TableOfContents';
                return;
            }
        }
        let currentRevision = this.getCurrentRevision();
        if (!isNullOrUndefined(currentRevision) && this.owner.showRevisions && this.owner.isUpdateTrackChanges) {
            this.owner.trackChangesPane.currentSelectedRevision = currentRevision[0];
            if (isNullOrUndefined(this.owner.documentHelper.currentSelectedComment)) {
                this.owner.commentReviewPane.selectReviewTab('Changes');
            }
            this.owner.notify('reviewPane', { comment: this.owner.showComments, changes: true, isUserClosed: false });
        }
        else if (!isNullOrUndefined(this.owner.trackChangesPane.currentSelectedRevision)) {
            this.owner.trackChangesPane.currentSelectedRevision = undefined;
        }
        if (this.start.paragraph.isInHeaderFooter) {
            let isInHeader = this.start.paragraph.bodyWidget.headerFooterType.indexOf('Header') !== -1;
            if (contextIsinTable) {
                if (contextIsinImage) {
                    this.contextTypeInternal = isInHeader ? 'HeaderTableImage' : 'FooterTableImage';
                }
                else {
                    this.contextTypeInternal = isInHeader ? 'HeaderTableText' : 'FooterTableText';
                }
            }
            else {
                if (contextIsinImage) {
                    this.contextTypeInternal = isInHeader ? 'HeaderImage' : 'FooterImage';
                }
                else {
                    this.contextTypeInternal = isInHeader ? 'HeaderText' : 'FooterText';
                }
            }
        }
        else {
            if (contextIsinTable) {
                this.contextTypeInternal = contextIsinImage ? 'TableImage' : 'TableText';
            }
            else {
                this.contextTypeInternal = contextIsinImage ? 'Image' : 'Text';
            }
        }
        if (!contextIsinTable && !isNullOrUndefined(this.owner.editor) && !isNullOrUndefined(this.owner.editor.documentHelper) &&
            this.owner.editor.documentHelper.contentControlCollection &&
            this.owner.editor.documentHelper.contentControlCollection.length > 0) {
            let contentControl = this.currentContentControl;
            let contentControlImage = this.owner.getImageContentControl();
            if (!isNullOrUndefined(contentControl) || !isNullOrUndefined(contentControlImage)) {
                let type = contentControl ? contentControl.contentControlProperties.type :
                    contentControlImage.contentControlProperties.type;
                switch (type) {
                    case 'RichText':
                        this.contextTypeInternal = "RichTextContentControl";
                        break;
                    case 'Text':
                        this.contextTypeInternal = "PlainTextContentControl";
                        break;
                    case 'Picture':
                        this.contextTypeInternal = "PictureContentControl";
                        break;
                    case 'ComboBox':
                        this.contextTypeInternal = "ComboBoxContentControl";
                        break;
                    case 'DropDownList':
                        this.contextTypeInternal = "DropDownListContentControl";
                        break;
                    case 'CheckBox':
                        this.contextTypeInternal = "CheckBoxContentControl";
                        break;
                    case 'Date':
                        this.contextTypeInternal = "DatePickerContentControl";
                        break;
                }
            }
        }
    }
    addItemRevisions(currentItem, isFromAccept) {
        for (let i = 0; i < currentItem.revisions.length; i++) {
            let currentRevision = currentItem.revisions[i];
            this.selectRevision(currentRevision);
            if (isFromAccept) {
                currentRevision.accept();
            }
            else {
                currentRevision.reject();
            }
        }
    }
    /**
     * @private
     */
    hasRevisions() {
        if (this.getCurrentRevision()) {
            return true;
        }
        return false;
    }
    /**
     * @private
     */
    getCurrentRevision() {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        let isUpdateSelection = false;
        if (this.owner.enableTrackChanges && this.owner.editorHistoryModule && this.owner.editorHistoryModule.currentBaseHistoryInfo && this.owner.editorHistoryModule.currentBaseHistoryInfo.action === 'BackSpace') {
            isUpdateSelection = true;
        }
        let elementInfo;
        if (isUpdateSelection && this.getLineLength(start.currentWidget) >= start.offset + 1) {
            elementInfo = start.currentWidget.getInline(start.offset + 1, 0);
        }
        else {
            elementInfo = start.currentWidget.getInline(start.offset, 0);
        }
        let currentElement = elementInfo.element;
        let startPara = start.paragraph;
        let nextOffsetElement;
        if (isUpdateSelection && this.getLineLength(start.currentWidget) >= start.offset + 2) {
            nextOffsetElement = start.currentWidget.getInline(start.offset + 2, 0).element;
        }
        else {
            nextOffsetElement = start.currentWidget.getInline(start.offset + 1, 0).element;
        }
        let eleEndPosition;
        if (currentElement && currentElement === nextOffsetElement) {
            let offset = currentElement.line.getOffset(currentElement, (currentElement.length));
            eleEndPosition = new TextPosition(this.owner);
            eleEndPosition.setPositionParagraph(currentElement.line, offset);
            if (end.offset === eleEndPosition.offset && !isNullOrUndefined(currentElement.nextElement)) {
                return undefined;
            }
        }
        if (!isNullOrUndefined(currentElement) && currentElement.revisionLength > 0) {
            return currentElement.getAllRevision();
        }
        if (startPara.isInsideTable) {
            let cellWidget = startPara.associatedCell;
            if (!isNullOrUndefined(cellWidget.ownerRow) && cellWidget.ownerRow.rowFormat.revisionLength > 0) {
                return cellWidget.ownerRow.rowFormat.getAllRevision();
            }
        }
        if (end.offset > end.paragraph.getLength()) {
            if (end.paragraph.characterFormat.revisionLength > 0) {
                return end.paragraph.characterFormat.getAllRevision();
            }
        }
        return undefined;
    }
    processLineRevisions(linewidget, isFromAccept) {
        for (let i = 0; i < linewidget.children.length; i++) {
            let element = linewidget.children[i];
            if (element.revisionLength > 0) {
                this.addItemRevisions(element, isFromAccept);
            }
        }
    }
    /**
     * @private
     * @param isFromAccept
     */
    handleAcceptReject(isFromAccept) {
        if (this.isEmpty) {
            let elementInfo = this.start.currentWidget.getInline((this.start.offset + 1), 0);
            let currentElement = elementInfo.element;
            let startPara = this.start.paragraph;
            if (!isNullOrUndefined(currentElement) && currentElement.revisionLength > 0) {
                this.addItemRevisions(currentElement, isFromAccept);
            }
            if (startPara.isInsideTable) {
                let cellWidget = startPara.associatedCell;
                if (!isNullOrUndefined(cellWidget)) {
                    if (cellWidget.ownerRow.rowFormat.revisionLength > 0) {
                        this.addItemRevisions(cellWidget.ownerRow.rowFormat, isFromAccept);
                    }
                }
                else if (!startPara.isEmpty()) {
                    for (let i = 0; i < cellWidget.childWidgets.length; i++) {
                        let paraWidget = cellWidget.childWidgets[i];
                        for (let lineIndex; lineIndex < paraWidget.childWidgets.length; lineIndex++) {
                            let linewidget = paraWidget.childWidgets[lineIndex];
                            this.processLineRevisions(linewidget, isFromAccept);
                        }
                    }
                }
            }
        }
        else {
            let revisions = this.getselectedRevisionElements();
            while (revisions.length > 0) {
                // if it is grouped revision in that case the many revision deleted while accepting or rejecting. That's why we are check if it has range lenth greater then 0. if it is 0, It means the revision already removed.
                if (revisions[0].getRange(true).length !== 0) {
                    this.acceptReject(revisions[0], isFromAccept);
                }
                revisions.splice(0, 1);
            }
        }
    }
    acceptReject(currentRevision, toAccept) {
        if (toAccept) {
            currentRevision.accept();
        }
        else {
            currentRevision.reject();
        }
    }
    /**
     * @private
     */
    getselectedRevisionElements() {
        let revisionCollec = [];
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        for (let i = 0; i < this.selectedWidgets.length; i++) {
            let currentWidget = this.selectedWidgets.keys[i];
            if (currentWidget instanceof LineWidget) {
                revisionCollec = this.getSelectedLineRevisions(currentWidget, start, end, revisionCollec);
            }
            else if (currentWidget instanceof TableCellWidget) {
                if (currentWidget.ownerRow.rowFormat.revisionLength > 0) {
                    revisionCollec = this.addRevisionsCollec(currentWidget.ownerRow.rowFormat.getAllRevision(), revisionCollec);
                }
                for (let i = 0; i < currentWidget.childWidgets.length; i++) {
                    let paraWidget = currentWidget.childWidgets[i];
                    for (let lineIndex = 0; lineIndex < paraWidget.childWidgets.length; lineIndex++) {
                        let linewidget = paraWidget.childWidgets[lineIndex];
                        revisionCollec = this.getSelectedLineRevisions(linewidget, start, end, revisionCollec);
                    }
                }
            }
        }
        return revisionCollec;
    }
    getSelectedLineRevisions(currentWidget, start, end, elements) {
        if (currentWidget.paragraph.characterFormat.revisionLength > 0) {
            const eleStartPosition = this.getParagraphEndPosition(currentWidget.paragraph);
            const eleEndPosition = eleStartPosition.clone();
            eleEndPosition.offset += 1;
            if (((eleEndPosition.isExistAfter(start) && eleEndPosition.isExistBefore(end))
                || (eleStartPosition.isExistAfter(start) && eleStartPosition.isExistBefore(end))
                || eleStartPosition.isAtSamePosition(start)
                || (start.isExistAfter(eleStartPosition) && end.isExistBefore(eleEndPosition)))) {
                elements = this.addRevisionsCollec(currentWidget.paragraph.characterFormat.getAllRevision(), elements);
            }
        }
        for (let j = 0; j < currentWidget.children.length; j++) {
            let currentElement = currentWidget.children[j];
            let offset = currentElement.line.getOffset(currentElement, 0);
            let eleStartPosition = new TextPosition(this.owner);
            eleStartPosition.setPositionParagraph(currentElement.line, offset);
            offset = currentElement.line.getOffset(currentElement, (currentElement.length));
            let eleEndPosition = new TextPosition(this.owner);
            eleEndPosition.setPositionParagraph(currentElement.line, offset);
            if (((eleEndPosition.isExistAfter(start) && eleEndPosition.isExistBefore(end))
                || (eleStartPosition.isExistAfter(start) && eleStartPosition.isExistBefore(end))
                || eleStartPosition.isAtSamePosition(start)
                || (start.isExistAfter(eleStartPosition) && end.isExistBefore(eleEndPosition))) && currentElement.revisionLength > 0) {
                elements = this.addRevisionsCollec(currentElement.getAllRevision(), elements);
            }
        }
        return elements;
    }
    addRevisionsCollec(element, revisCollec) {
        for (let i = 0; i < element.length; i++) {
            if (revisCollec.indexOf(element[i]) === -1) {
                revisCollec.push(element[i]);
            }
        }
        return revisCollec;
    }
    //Table Format retrieval starts
    /**
     * Retrieve selection table format
     * @private
     */
    retrieveTableFormat(start, end) {
        let tableAdv = this.getTable(start, end);
        if (!isNullOrUndefined(tableAdv)) {
            this.tableFormat.table = tableAdv;
            this.tableFormat.copyFormat(tableAdv.tableFormat);
            this.retrieveCellFormat(start, end);
            this.retrieveRowFormat(start, end);
        }
        else {
            //When the selection is out of table
            this.tableFormat.clearFormat();
        }
    }
    /**
     * Retrieve selection cell format
     * @private
     */
    retrieveCellFormat(start, end) {
        if (start.paragraph.isInsideTable && end.paragraph.isInsideTable) {
            this.cellFormat.copyFormat(start.paragraph.associatedCell.cellFormat);
            this.getCellFormat(start.paragraph.associatedCell.ownerTable, start, end);
        }
        else {
            //When the selection is out of table
            this.cellFormat.clearCellFormat();
        }
    }
    /**
     * Retrieve selection row format
     * @private
     */
    retrieveRowFormat(start, end) {
        if (start.paragraph.isInsideTable && end.paragraph.isInsideTable) {
            this.rowFormat.copyFormat(start.paragraph.associatedCell.ownerRow.rowFormat);
            this.getRowFormat(start.paragraph.associatedCell.ownerTable, start, end);
        }
        else {
            //When the selection is out of table
            this.rowFormat.clearRowFormat();
        }
    }
    /**
     * Get selected cell format
     * @private
     */
    getCellFormat(table, start, end) {
        if (start.paragraph.associatedCell.equals(end.paragraph.associatedCell)) {
            return;
        }
        let isStarted = false;
        for (let i = 0; i < table.childWidgets.length; i++) {
            let row = table.childWidgets[i];
            if (row === start.paragraph.associatedCell.ownerRow) {
                isStarted = true;
            }
            if (isStarted) {
                for (let j = 0; j < row.childWidgets.length; j++) {
                    let cell = row.childWidgets[j];
                    if (this.isCellSelected(cell, start, end)) {
                        this.cellFormat.combineFormat(cell.cellFormat);
                    }
                    if (cell === end.paragraph.associatedCell) {
                        this.cellFormat.combineFormat(cell.cellFormat);
                        return;
                    }
                }
            }
        }
    }
    /**
     * Get selected row format
     * @private
     */
    getRowFormat(table, start, end) {
        let tableRow = start.paragraph.associatedCell.ownerRow;
        if (tableRow === end.paragraph.associatedCell.ownerRow) {
            return;
        }
        for (let i = table.childWidgets.indexOf(tableRow) + 1; i < table.childWidgets.length; i++) {
            let tempTableRow = table.childWidgets[i];
            this.rowFormat.combineFormat(tempTableRow.rowFormat);
            if (tempTableRow === end.paragraph.associatedCell.ownerRow) {
                return;
            }
        }
    }
    /**
     * Return table with given text position
     * @private
     */
    getTable(startPosition, endPosition) {
        if (!isNullOrUndefined(startPosition.paragraph.associatedCell) && !isNullOrUndefined(endPosition.paragraph.associatedCell)) {
            let startTable = startPosition.paragraph.associatedCell.ownerTable;
            let endTable = startPosition.paragraph.associatedCell.ownerTable;
            if (startTable === endTable) {
                return startTable;
            }
            else {
                if (startTable.contains(startPosition.paragraph.associatedCell)) {
                    return startTable;
                }
                else if (endTable.contains(startPosition.paragraph.associatedCell)) {
                    return endTable;
                }
                else if (!startTable.isInsideTable || !endTable.isInsideTable) {
                    return undefined;
                }
                else {
                    do {
                        startTable = startTable.associatedCell.ownerTable;
                        if (startTable === endTable || startTable.contains(endTable.associatedCell)) {
                            return startTable;
                        }
                        else if (endTable.contains(startTable.associatedCell)) {
                            return endTable;
                        }
                    } while (!isNullOrUndefined(startTable.associatedCell));
                }
            }
        }
        return undefined;
    }
    /**
     * @private
     */
    getContainerWidget(block) {
        let bodyWidget;
        if (block.containerWidget instanceof TextFrame) {
            bodyWidget = block.containerWidget.containerShape.line.paragraph.bodyWidget;
        }
        else if (block.containerWidget instanceof BlockContainer) {
            if (!isNullOrUndefined(block.containerWidget.containerWidget) && block.containerWidget.containerWidget instanceof FootNoteWidget) {
                bodyWidget = block.containerWidget.containerWidget;
            }
            else {
                bodyWidget = block.containerWidget;
            }
        }
        else {
            bodyWidget = block.containerWidget;
            while (!(bodyWidget instanceof BlockContainer)) {
                if (bodyWidget instanceof TextFrame) {
                    bodyWidget = bodyWidget.containerShape.line.paragraph;
                }
                bodyWidget = bodyWidget.containerWidget;
            }
        }
        return bodyWidget;
    }
    //Table format retrieval ends
    //Section format retrieval starts
    /**
     * Retrieve selection section format
     * @private
     */
    retrieveSectionFormat(start, end) {
        let startParaSection = this.getContainerWidget(start.paragraph);
        let endParaSection = this.getContainerWidget(end.paragraph);
        if (!isNullOrUndefined(startParaSection)) {
            this.sectionFormat.copyFormat(startParaSection.sectionFormat);
            let startPageIndex = this.documentHelper.pages.indexOf(startParaSection.page);
            let endPageIndex = this.documentHelper.pages.indexOf(endParaSection.page);
            for (let i = startPageIndex + 1; i <= endPageIndex; i++) {
                this.sectionFormat.combineFormat(this.documentHelper.pages[i].bodyWidgets[0].sectionFormat);
            }
        }
    }
    //section format retrieval ends.
    //Paragraph format retrieval implementation starts.
    /**
     * Retrieve selection paragraph format
     * @private
     */
    retrieveParagraphFormat(start, end) {
        this.getParagraphFormatForSelection(start.paragraph, this, start, end);
    }
    /**
     * @private
     */
    getParagraphFormatForSelection(paragraph, selection, start, end) {
        //Selection start in cell.
        if (start.paragraph.isInsideTable && (!end.paragraph.isInsideTable
            || start.paragraph.associatedCell !== end.paragraph.associatedCell
            || this.isCellSelected(start.paragraph.associatedCell, start, end))) {
            this.getParagraphFormatInternalInCell(start.paragraph.associatedCell, start, end);
        }
        else {
            this.getParagraphFormatInternalInParagraph(paragraph, start, end);
            if (end.paragraph === paragraph) {
                return;
            }
            let block = this.getNextRenderedBlock(paragraph);
            if (!isNullOrUndefined(block)) {
                this.getParagraphFormatInternalInBlock(block, start, end);
            }
        }
    }
    /**
     * @private
     */
    getParagraphsInSelection() {
        let selection = this.owner.selectionModule;
        let selectedWidgets = selection.selectedWidgets.keys;
        let paragraphsInSelection = [];
        if (selection.isEmpty || selection.start.paragraph === selection.end.paragraph) {
            return [selection.start.paragraph];
        }
        for (let i = 0; i < selectedWidgets.length; i++) {
            let widget = selectedWidgets[i];
            if (paragraphsInSelection.indexOf(widget.paragraph) === -1) {
                paragraphsInSelection.push(widget.paragraph);
            }
        }
        return paragraphsInSelection;
    }
    /**
     * @private
     */
    getParagraphFormatInternalInParagraph(paragraph, start, end) {
        if (start.paragraph === paragraph) {
            this.paragraphFormat.copyFormat(paragraph.paragraphFormat);
        }
        else {
            this.paragraphFormat.combineFormat(paragraph.paragraphFormat);
        }
    }
    /**
     * @private
     */
    getParagraphFormatInternalInBlock(block, start, end) {
        let current = block;
        while (current) {
            if (current instanceof ParagraphWidget) {
                this.getParagraphFormatInternalInParagraph(current, start, end);
                if (end && end.paragraph === current) {
                    return;
                }
                current = this.getNextRenderedBlock(current);
            }
            else {
                this.getParagraphFormatInternalInTable(current, start, end);
                break;
            }
        }
    }
    /**
     * @private
     */
    getParagraphFormatInternalInTable(table, start, end) {
        for (let i = 0; i < table.childWidgets.length; i++) {
            let tableRow = table.childWidgets[i];
            for (let j = 0; j < tableRow.childWidgets.length; j++) {
                this.getParagraphFormatInCell(tableRow.childWidgets[j]);
            }
            if (end.paragraph.isInsideTable && this.containsRow(tableRow, end.paragraph.associatedCell)) {
                return;
            }
        }
        let block = this.getNextRenderedBlock(table);
        //Goto the next block.
        this.getParagraphFormatInternalInBlock(block, start, end);
    }
    /**
     * Get paragraph format in cell
     * @private
     */
    getParagraphFormatInCell(cell) {
        for (let i = 0; i < cell.childWidgets.length; i++) {
            this.getParagraphFormatInBlock(cell.childWidgets[i]);
        }
    }
    /**
     * @private
     */
    getParagraphFormatInBlock(block) {
        if (block instanceof ParagraphWidget) {
            this.getParagraphFormatInParagraph(block);
        }
        else {
            this.getParagraphFormatInTable(block);
        }
    }
    /**
     * @private
     */
    getParagraphFormatInTable(tableAdv) {
        for (let i = 0; i < tableAdv.childWidgets.length; i++) {
            let tableRow = tableAdv.childWidgets[i];
            for (let j = 0; j < tableRow.childWidgets.length; j++) {
                this.getParagraphFormatInCell(tableRow.childWidgets[j]);
            }
        }
    }
    /**
     * @private
     */
    getParagraphFormatInParagraph(paragraph) {
        let start = this.start;
        if (!this.isForward) {
            start = this.end;
        }
        if (start.paragraph === paragraph) {
            this.paragraphFormat.copyFormat(paragraph.paragraphFormat);
        }
        else {
            this.paragraphFormat.combineFormat(paragraph.paragraphFormat);
        }
    }
    /**
     * Get paragraph format in cell
     * @private
     */
    getParagraphFormatInternalInCell(cellAdv, start, end) {
        if (end.paragraph.isInsideTable) {
            let containerCell = this.getContainerCellOf(cellAdv, end.paragraph.associatedCell);
            if (containerCell.ownerTable.contains(end.paragraph.associatedCell)) {
                let startCell = this.getSelectedCell(cellAdv, containerCell);
                let endCell = this.getSelectedCell(end.paragraph.associatedCell, containerCell);
                if (this.containsCell(containerCell, end.paragraph.associatedCell)) {
                    //Selection end is in container cell.
                    if (this.isCellSelected(containerCell, start, end)) {
                        this.getParagraphFormatInCell(containerCell);
                    }
                    else {
                        if (startCell === containerCell) {
                            this.getParagraphFormatInternalInParagraph(start.paragraph, start, end);
                            if (end.paragraph === start.paragraph) {
                                return;
                            }
                            let block = this.getNextRenderedBlock(start.paragraph);
                            if (!isNullOrUndefined(block)) {
                                this.getParagraphFormatInternalInBlock(block, start, end);
                            }
                        }
                        else {
                            this.getParagraphFormatInRow(startCell.ownerRow, start, end);
                        }
                    }
                }
                else {
                    //Format other selected cells in current table.
                    this.getParaFormatForCell(containerCell.ownerTable, containerCell, endCell);
                }
            }
            else {
                this.getParagraphFormatInRow(containerCell.ownerRow, start, end);
            }
        }
        else {
            let cell = this.getContainerCell(cellAdv);
            this.getParagraphFormatInRow(cell.ownerRow, start, end);
        }
    }
    /**
     * @private
     */
    getParaFormatForCell(table, startCell, endCell) {
        let startCellIn = this.getCellLeft(startCell.ownerRow, startCell);
        let endCellIn = startCellIn + startCell.cellFormat.cellWidth;
        let endCellLeft = this.getCellLeft(endCell.ownerRow, endCell);
        let endCellRight = endCellLeft + endCell.cellFormat.cellWidth;
        if (startCellIn > endCellLeft) {
            startCellIn = endCellLeft;
        }
        if (endCellIn < endCellRight) {
            endCellIn = endCellRight;
        }
        if (startCellIn > this.upDownSelectionLength) {
            startCellIn = this.upDownSelectionLength;
        }
        if (endCellIn < this.upDownSelectionLength) {
            endCellIn = this.upDownSelectionLength;
        }
        let count = table.childWidgets.indexOf(endCell.ownerRow);
        for (let i = table.childWidgets.indexOf(startCell.ownerRow); i <= count; i++) {
            let tableRow = table.childWidgets[i];
            for (let j = 0; j < tableRow.childWidgets.length; j++) {
                let cell = tableRow.childWidgets[j];
                let left = this.getCellLeft(tableRow, cell);
                if (HelperMethods.round(startCellIn, 2) <= HelperMethods.round(left, 2)
                    && HelperMethods.round(left, 2) < HelperMethods.round(endCellIn, 2)) {
                    this.getParagraphFormatInCell(cell);
                }
            }
        }
    }
    /**
     * Get paragraph format ins row
     * @private
     */
    getParagraphFormatInRow(tableRow, start, end) {
        for (let i = tableRow.rowIndex; i < tableRow.ownerTable.childWidgets.length; i++) {
            let row = tableRow.ownerTable.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                this.getParagraphFormatInCell(row.childWidgets[j]);
            }
            if (end.paragraph.isInsideTable && this.containsRow(row, end.paragraph.associatedCell)) {
                return;
            }
        }
        let block = this.getNextRenderedBlock(tableRow.ownerTable);
        //Goto the next block.
        this.getParagraphFormatInternalInBlock(block, start, end);
    }
    // paragraph format retrieval implementation ends
    // Character format retrieval implementation starts.
    /**
     * Retrieve Selection character format
     * @private
     */
    retrieveCharacterFormat(start, end) {
        this.characterFormat.copyFormat(start.paragraph.characterFormat);
        if (start.paragraph.isEmpty()) {
            this.characterFormat.copyFormat(start.paragraph.characterFormat, this.documentHelper.textHelper.getFontNameToRender(0, start.paragraph.characterFormat));
        }
        if (start.paragraph === end.paragraph && start.currentWidget.isLastLine()
            && start.offset === this.getLineLength(start.currentWidget) && start.offset + 1 === end.offset) {
            return;
        }
        let para = start.paragraph;
        if (start.paragraph === end.paragraph && this.isSelectList) {
            let listLevel = this.getListLevel(start.paragraph);
            // let breakCharacterFormat: WCharacterFormat = start.paragraph.characterFormat;
            if (listLevel && listLevel.characterFormat.uniqueCharacterFormat) {
                this.characterFormat.copyFormat(listLevel.characterFormat);
            }
            return;
        }
        if (start.offset === this.getParagraphLength(para) && !this.isEmpty) {
            para = this.getNextParagraphBlock(para);
        }
        while (!isNullOrUndefined(para) && para !== end.paragraph && para.isEmpty()) {
            para = this.getNextParagraphBlock(para);
        }
        let offset = para === start.paragraph ? start.offset : 0;
        let indexInInline = 0;
        if (!isNullOrUndefined(para) && !para.isEmpty()) {
            let position = new TextPosition(this.owner);
            let elemInfo = start.currentWidget.getInline(offset, indexInInline);
            let physicalLocation = this.getPhysicalPositionInternal(start.currentWidget, offset, true);
            position.setPositionForSelection(start.currentWidget, elemInfo.element, elemInfo.index, physicalLocation);
            this.getCharacterFormatForSelection(para, this, position, end);
        }
    }
    /**
     * @private
     */
    getCharacterFormatForSelection(paragraph, selection, startPosition, endPosition) {
        //Selection start in cell.
        if (startPosition.paragraph instanceof ParagraphWidget && startPosition.paragraph.isInsideTable
            && (!endPosition.paragraph.isInsideTable
                || startPosition.paragraph.associatedCell !== endPosition.paragraph.associatedCell
                || this.isCellSelected(startPosition.paragraph.associatedCell, startPosition, endPosition))) {
            this.getCharacterFormatInTableCell(startPosition.paragraph.associatedCell, selection, startPosition, endPosition);
        }
        else {
            let block = this.getCharacterFormat(paragraph, startPosition, endPosition);
            if (!isNullOrUndefined(block) && block != paragraph) {
                this.getCharacterFormatForBlock(block, startPosition, endPosition);
            }
        }
    }
    /**
     * Get Character format
     * @private
     */
    //Format Retrieval
    getCharacterFormatForTableRow(tableRowAdv, start, end) {
        for (let i = tableRowAdv.rowIndex; i < tableRowAdv.ownerTable.childWidgets.length; i++) {
            let tableRow = tableRowAdv.ownerTable.childWidgets[i];
            for (let j = 0; j < tableRow.childWidgets.length; j++) {
                this.getCharacterFormatForSelectionCell(tableRow.childWidgets[j], start, end);
            }
            if (end.paragraph.isInsideTable && this.containsRow(tableRow, end.paragraph.associatedCell)) {
                return;
            }
        }
        let block = this.getNextRenderedBlock(tableRowAdv.ownerTable);
        // //Goto the next block.
        this.getCharacterFormatForBlock(block, start, end);
    }
    /**
     * Get Character format in table
     * @private
     */
    getCharacterFormatInTableCell(tableCell, selection, start, end) {
        if (end.paragraph.isInsideTable) {
            let containerCell = this.getContainerCellOf(tableCell, end.paragraph.associatedCell);
            if (containerCell.ownerTable.contains(end.paragraph.associatedCell)) {
                let startCell = this.getSelectedCell(tableCell, containerCell);
                let endCell = this.getSelectedCell(end.paragraph.associatedCell, containerCell);
                if (this.containsCell(containerCell, end.paragraph.associatedCell)) {
                    //Selection end is in container cell.
                    if (this.isCellSelected(containerCell, start, end)) {
                        this.getCharacterFormatForSelectionCell(containerCell, start, end);
                    }
                    else {
                        if (startCell === containerCell) {
                            this.getCharacterFormat(start.paragraph, start, end);
                            let block = this.getCharacterFormat(start.paragraph, start, end);
                            if (!isNullOrUndefined(block) && block != start.paragraph) {
                                this.getCharacterFormatForBlock(block, start, end);
                            }
                        }
                        else {
                            this.getCharacterFormatForTableRow(startCell.ownerRow, start, end);
                        }
                    }
                }
                else {
                    //Format other selected cells in current table.
                    this.getCharacterFormatInternalInTable(containerCell.ownerTable, containerCell, endCell, start, end);
                }
            }
            else {
                this.getCharacterFormatForTableRow(containerCell.ownerRow, start, end);
            }
        }
        else {
            let cell = this.getContainerCell(tableCell);
            this.getCharacterFormatForTableRow(cell.ownerRow, start, end);
        }
    }
    /**
     * @private
     */
    getCharacterFormatInternalInTable(table, startCell, endCell, startPosition, endPosition) {
        let startIn = this.getCellLeft(startCell.ownerRow, startCell);
        let endIn = startIn + startCell.cellFormat.cellWidth;
        let endCellLeft = this.getCellLeft(endCell.ownerRow, endCell);
        let endCellRight = endCellLeft + endCell.cellFormat.cellWidth;
        if (startIn > endCellLeft) {
            startIn = endCellLeft;
        }
        if (endIn < endCellRight) {
            endIn = endCellRight;
        }
        if (startIn > this.upDownSelectionLength) {
            startIn = this.upDownSelectionLength;
        }
        if (endIn < this.upDownSelectionLength) {
            endIn = this.upDownSelectionLength;
        }
        let count = table.childWidgets.indexOf(endCell.ownerRow);
        for (let i = table.childWidgets.indexOf(startCell.ownerRow); i <= count; i++) {
            let row = table.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                let cell = row.childWidgets[j];
                let left = this.getCellLeft(row, cell);
                if (HelperMethods.round(startIn, 2) <= HelperMethods.round(left, 2) &&
                    HelperMethods.round(left, 2) < HelperMethods.round(endIn, 2)) {
                    this.getCharacterFormatForSelectionCell(cell, startPosition, endPosition);
                }
            }
        }
    }
    /**
     * Get character format with in selection
     * @private
     */
    getCharacterFormat(paragraph, start, end) {
        if (paragraph !== start.paragraph && paragraph !== end.paragraph && !paragraph.isEmpty()) {
            this.getCharacterFormatInternal(paragraph, this);
            if (!this.characterFormat.canRetrieveNextCharacterFormat())
                return paragraph;
        }
        if (end.paragraph === paragraph && start.paragraph !== paragraph && end.offset === 0) {
            return paragraph;
        }
        let startOffset = 0;
        let length = this.getParagraphLength(paragraph);
        if (paragraph === start.paragraph) {
            startOffset = start.offset;
            //Sets selection character format.            
            let isUpdated = this.setCharacterFormat(paragraph, start, end, length);
            if (isUpdated) {
                return paragraph;
            }
        }
        let startLineWidget = paragraph.childWidgets.indexOf(start.currentWidget) !== -1 ?
            paragraph.childWidgets.indexOf(start.currentWidget) : 0;
        let endLineWidget = paragraph.childWidgets.indexOf(end.currentWidget) !== -1 ?
            paragraph.childWidgets.indexOf(end.currentWidget) : paragraph.childWidgets.length - 1;
        let endOffset = end.offset;
        if (paragraph !== end.paragraph) {
            endOffset = length;
        }
        let isFieldStartSelected = false;
        for (let i = startLineWidget; i <= endLineWidget; i++) {
            let lineWidget = paragraph.childWidgets[i];
            if (i !== startLineWidget) {
                startOffset = this.getStartLineOffset(lineWidget);
            }
            if (lineWidget === end.currentWidget) {
                endOffset = end.offset;
            }
            else {
                endOffset = this.getLineLength(lineWidget);
            }
            let count = 0;
            for (let j = 0; j < lineWidget.children.length; j++) {
                let inline = lineWidget.children[j];
                if (inline instanceof ListTextElementBox) {
                    continue;
                }
                if (startOffset >= count + inline.length) {
                    count += inline.length;
                    continue;
                }
                if (inline instanceof FieldElementBox && inline.fieldType === 0
                    && HelperMethods.isLinkedFieldCharacter(inline)) {
                    let nextInline = isNullOrUndefined(inline.fieldEnd) ?
                        inline.fieldBegin : inline.fieldEnd;
                    j--;
                    do {
                        this.characterFormat.combineFormat(inline.characterFormat);
                        count += inline.length;
                        inline = inline.nextNode;
                        i++;
                        j++;
                    } while (!isNullOrUndefined(inline) && inline !== nextInline);
                    continue;
                    //isFieldStartSelected = true;
                }
                // if (inline instanceof FieldElementBox && (inline as FieldElementBox).fieldType === 1
                //     && HelperMethods.isLinkedFieldCharacter((inline as FieldElementBox)) && isFieldStartSelected) {
                //     let fieldInline: ElementBox = (inline as FieldElementBox).fieldBegin;
                //     do {
                //         this.characterFormat.combineFormat(fieldInline.characterFormat);
                //         fieldInline = fieldInline.nextNode as ElementBox;
                //     } while (!(fieldInline instanceof FieldElementBox));
                // }
                if (inline instanceof TextElementBox && inline.text !== '' || inline instanceof FieldElementBox) {
                    this.characterFormat.combineFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                }
                if (isNullOrUndefined(inline) || endOffset <= count + inline.length) {
                    break;
                }
                count += inline.length;
            }
        }
        if (end.paragraph === paragraph) {
            return paragraph;
        }
        return this.getNextRenderedBlock(paragraph);
    }
    setCharacterFormat(para, startPos, endPos, length) {
        let index = 0;
        let startOffset = startPos.offset;
        let inlineAndIndex = startPos.currentWidget.getInline(startOffset, index);
        index = inlineAndIndex.index;
        let inline = inlineAndIndex.element;
        if (isNullOrUndefined(inline)) {
            let currentLineIndex = startPos.paragraph.childWidgets.indexOf(startPos.currentWidget);
            if (startPos.currentWidget.previousLine) {
                inline = startPos.currentWidget.previousLine.children[startPos.currentWidget.previousLine.children.length - 1];
                this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                return true;
            }
        }
        if (startOffset < length) {
            if (this.isEmpty) {
                if ((inline instanceof TextElementBox && !(inline instanceof FootnoteElementBox)) || (inline instanceof FieldElementBox
                    && (inline.fieldType === 0 || inline.fieldType === 1))) {
                    let previousNode = this.getPreviousTextElement(inline);
                    if (startOffset === 0 && previousNode) {
                        inline = previousNode;
                    }
                    this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                    this.normalizeCheckboxFontSize(inline);
                    let nextNodeInfo = startPos.currentWidget.getInline(startOffset + 1, index);
                    let paraInfo = this.getParagraphInfo(this.start);
                    let lineInfo = this.getLineInfoBasedOnParagraph(paraInfo.paragraph, paraInfo.offset);
                    let lineLength = this.getLineLength(lineInfo.line);
                    if (lineInfo.offset >= lineLength && !(paraInfo.offset >= length)) {
                        if (!(lineInfo.line.nextLine && lineInfo.line.nextLine.children[0] && lineInfo.line.nextLine.children[0].characterFormat.highlightColor !== 'NoColor')) {
                            this.characterFormat.highlightColor = 'NoColor';
                        }
                    }
                    if ((inline !== nextNodeInfo.element && inline.characterFormat.highlightColor !== 'NoColor' && nextNodeInfo.element.characterFormat.highlightColor === 'NoColor') || paraInfo.offset >= length) {
                        this.characterFormat.highlightColor = 'NoColor';
                    }
                }
                else {
                    if (!isNullOrUndefined(this.getPreviousTextElement(inline))) {
                        let element = this.getPreviousTextElement(inline);
                        while (element instanceof FootnoteElementBox) {
                            element = this.getPreviousTextElement(element);
                        }
                        if (!isNullOrUndefined(element)) {
                            this.characterFormat.copyFormat(element.characterFormat, this.documentHelper.textHelper.getFontNameToRender(element.scriptType, inline.characterFormat));
                            this.normalizeCheckboxFontSize(element);
                        }
                        if (inline instanceof EditRangeStartElementBox) {
                            this.characterFormat.highlightColor = inline.characterFormat.highlightColor;
                        }
                        if (inline instanceof BookmarkElementBox && inline.bookmarkType === 1) {
                            this.characterFormat.highlightColor = 'NoColor';
                            let preNodeInfo = startPos.currentWidget.getInline(startOffset - 1, index);
                            let nextNodeInfo = startPos.currentWidget.getInline(startOffset + 1, index);
                            if (!isNullOrUndefined(preNodeInfo.element) && preNodeInfo.element.characterFormat.highlightColor !== 'NoColor' && !isNullOrUndefined(nextNodeInfo.element)
                                && nextNodeInfo.element.characterFormat.highlightColor !== 'NoColor') {
                                this.characterFormat.highlightColor = preNodeInfo.element.characterFormat.highlightColor;
                            }
                        }
                    }
                    else if (!isNullOrUndefined(this.getNextTextElement(inline))) {
                        let element = this.getNextTextElement(inline);
                        while (element instanceof FootnoteElementBox) {
                            element = this.getNextTextElement(element);
                        }
                        if (!isNullOrUndefined(element)) {
                            this.characterFormat.copyFormat(element.characterFormat, this.documentHelper.textHelper.getFontNameToRender(element.scriptType, inline.characterFormat));
                        }
                        if (inline instanceof EditRangeEndElementBox) {
                            this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                        }
                    }
                    else {
                        this.characterFormat.copyFormat(para.characterFormat);
                    }
                }
                return true;
            }
            else {
                if (index === inline.length && !isNullOrUndefined(inline.nextNode) || (inline instanceof ContentControl && inline.contentControlProperties.type == "RichText")) {
                    this.characterFormat.copyFormat(this.getNextValidCharacterFormat(inline), this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                    let element = this.getNextTextElement(inline);
                    this.normalizeCheckboxFontSize(element);
                }
                else if (inline instanceof TextElementBox) {
                    this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                }
                else if (inline instanceof FieldElementBox) {
                    this.characterFormat.copyFormat(this.getNextValidCharacterFormatOfField(inline));
                }
            }
        }
        else {
            if (length === endPos.offset) {
                if ((inline instanceof TextElementBox && !(inline instanceof FootnoteElementBox)) || inline instanceof FieldElementBox) {
                    this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                    this.characterFormat.highlightColor = para.characterFormat.highlightColor;
                }
                else if (!isNullOrUndefined(inline)) {
                    let isBookmark = false;
                    if (inline instanceof BookmarkElementBox && inline.bookmarkType === 1) {
                        isBookmark = true;
                    }
                    inline = this.getPreviousTextElement(inline);
                    while (inline instanceof FootnoteElementBox) {
                        inline = this.getPreviousTextElement(inline);
                    }
                    if (!isNullOrUndefined(inline)) {
                        this.characterFormat.copyFormat(inline.characterFormat, this.documentHelper.textHelper.getFontNameToRender(inline.scriptType, inline.characterFormat));
                        this.normalizeCheckboxFontSize(inline);
                    }
                    if (isBookmark) {
                        this.characterFormat.highlightColor = para.characterFormat.highlightColor;
                    }
                }
                else {
                    this.characterFormat.copyFormat(para.characterFormat);
                }
                return true;
            }
        }
        return false;
    }
    /**
     * Normalize checkbox font-size scaled for rendering when copying formats for UI.
     * This reverses the render-only scale (1.35) so the selection/toolbar show
     * the logical font size stored in the model.
     */
    normalizeCheckboxFontSize(element) {
        const RENDER_SCALE = 1.35;
        if (!isNullOrUndefined(element) && element instanceof TextElementBox && element.isCheckBoxElement) {
            this.characterFormat.fontSize = this.characterFormat.fontSize / RENDER_SCALE;
        }
    }
    /**
     * @private
     */
    getCharacterFormatForBlock(block, start, end) {
        let current = block;
        while (current) {
            if (current instanceof ParagraphWidget) {
                this.getCharacterFormat(current, start, end);
                if (end && end.paragraph === current) {
                    return;
                }
                current = this.getNextRenderedBlock(current);
            }
            else {
                this.getCharacterFormatInTable(current, start, end);
                break;
            }
        }
    }
    /**
     * @private
     */
    getCharacterFormatInTable(table, start, end) {
        for (let i = 0; i < table.childWidgets.length; i++) {
            let row = table.childWidgets[i];
            for (let j = 0; j < row.childWidgets.length; j++) {
                this.getCharacterFormatForSelectionCell(row.childWidgets[j], start, end);
            }
            if (end.paragraph.isInsideTable && this.containsRow(row, end.paragraph.associatedCell)) {
                return;
            }
        }
        let blockAdv = this.getNextRenderedBlock(table);
        // //Goto the next block.
        if (!isNullOrUndefined(blockAdv)) {
            this.getCharacterFormatForBlock(blockAdv, start, end);
        }
    }
    /**
     * Get character format in selection
     * @private
     */
    getCharacterFormatForSelectionCell(cell, start, end) {
        for (let i = 0; i < cell.childWidgets.length; i++) {
            this.getCharacterFormatForBlock(cell.childWidgets[i], start, end);
        }
    }
    /**
     * @private
     */
    getCharacterFormatInternal(paragraph, selection) {
        for (let i = 0; i < paragraph.childWidgets.length; i++) {
            let linewidget = paragraph.childWidgets[i];
            for (let j = 0; j < linewidget.children.length; j++) {
                let element = linewidget.children[j];
                if (!(element instanceof ImageElementBox || element instanceof GroupShapeElementBox || element instanceof FieldElementBox || element instanceof ListTextElementBox || element instanceof ContentControl || element instanceof TextElementBox && element.text === '')) {
                    selection.characterFormat.combineFormat(element.characterFormat);
                }
            }
        }
    }
    /**
     * Get next valid character format from inline
     * @private
     */
    getNextValidCharacterFormat(inline) {
        let startInline = this.getNextTextElement(inline);
        if (isNullOrUndefined(startInline)) {
            return inline.characterFormat;
        }
        let fieldBegin = undefined;
        if (startInline instanceof FieldElementBox) {
            if (fieldBegin.fieldType === 0) {
                fieldBegin = startInline;
            }
        }
        if (isNullOrUndefined(fieldBegin)) {
            return startInline.characterFormat;
        }
        else {
            return this.getNextValidCharacterFormatOfField(fieldBegin);
        }
    }
    /**
     * Get next valid paragraph format from field
     * @private
     */
    getNextValidCharacterFormatOfField(fieldBegin) {
        let startInline = fieldBegin;
        if (HelperMethods.isLinkedFieldCharacter(fieldBegin)) {
            if (isNullOrUndefined(fieldBegin.fieldSeparator)) {
                startInline = fieldBegin.fieldEnd;
            }
            else {
                startInline = fieldBegin.fieldSeparator;
            }
        }
        let nextValidInline = undefined;
        if (!isNullOrUndefined(startInline.nextNode)) {
            //Check the next node is a valid and returns inline.
            nextValidInline = this.documentHelper.getNextValidElement(startInline.nextNode);
        }
        //If field separator/end exists at end of paragraph, then move to next paragraph.
        if (isNullOrUndefined(nextValidInline)) {
            return startInline.characterFormat;
        }
        return nextValidInline.characterFormat;
    }
    /**
     * Return true if cursor point with in selection range
     * @private
     */
    checkCursorIsInSelection(widget, point) {
        if (isNullOrUndefined(this.start) || this.isEmpty || isNullOrUndefined(widget)) {
            return false;
        }
        let isSelected = false;
        do {
            if (this.selectedWidgets.containsKey(widget)) {
                let top;
                let left;
                if (widget instanceof LineWidget) {
                    top = this.owner.selectionModule.getTop(widget);
                    left = this.owner.selectionModule.getLeft(widget);
                }
                else {
                    top = widget.y;
                    left = widget.x;
                }
                let widgetInfo = this.selectedWidgets.get(widget);
                if (widgetInfo instanceof SelectionWidgetInfo) {
                    isSelected = widgetInfo.left <= point.x && top <= point.y &&
                        top + widget.height >= point.y && widgetInfo.left + widgetInfo.width >= point.x;
                }
                else {
                    let widgetIn = widgetInfo;
                    for (let j = 0; j < widgetIn.length; j++) {
                        if (widgetIn[j] instanceof SelectionWidgetInfo) {
                            isSelected = widgetIn[j].left <= point.x && top <= point.y &&
                                top + widget.height >= point.y && widgetIn[j].left + widgetIn[j].width >= point.x;
                            if (isSelected) {
                                break;
                            }
                        }
                    }
                }
            }
            widget = (widget instanceof LineWidget) ? widget.paragraph : widget.containerWidget;
        } while (!isNullOrUndefined(widget) && !isSelected);
        return isSelected;
    }
    /**
     * Copy paragraph for to selection paragraph format
     * @private
     */
    copySelectionParagraphFormat() {
        let format = new WParagraphFormat();
        this.paragraphFormat.copyToFormat(format);
        return format;
    }
    /**
     * Get hyperlink display text
     * @private
     */
    getHyperlinkDisplayText(paragraph, fieldSeparator, fieldEnd, isNestedField, format) {
        let para = paragraph;
        if (para !== fieldEnd.line.paragraph) {
            isNestedField = true;
            return { displayText: '<<Selection in Document>>', 'isNestedField': isNestedField, 'format': format };
        }
        let displayText = '';
        let lineIndex = para.childWidgets.indexOf(fieldSeparator.line);
        let index = para.childWidgets[lineIndex].children.indexOf(fieldSeparator);
        for (let j = lineIndex; j < para.childWidgets.length; j++) {
            let lineWidget = para.childWidgets[j];
            if (j !== lineIndex) {
                index = -1;
            }
            for (let i = index + 1; i < lineWidget.children.length; i++) {
                let inline = lineWidget.children[i];
                if (inline === fieldEnd) {
                    return { 'displayText': displayText, 'isNestedField': isNestedField, 'format': format };
                }
                if (inline instanceof TextElementBox) {
                    displayText += inline.text;
                    format = inline.characterFormat;
                }
                else if (inline instanceof FieldElementBox) {
                    if (inline instanceof FieldElementBox && inline.fieldType === 0
                        && !isNullOrUndefined(inline.fieldEnd)) {
                        if (isNullOrUndefined(inline.fieldSeparator)) {
                            index = lineWidget.children.indexOf(inline.fieldEnd);
                        }
                        else {
                            index = lineWidget.children.indexOf(inline.fieldSeparator);
                        }
                    }
                }
                else {
                    isNestedField = true;
                    return { 'displayText': '<<Selection in Document>>', 'isNestedField': isNestedField, 'format': format };
                }
            }
        }
        return { 'displayText': displayText, 'isNestedField': isNestedField, 'format': format };
    }
    /**
     * Navigates hyperlink on mouse Event.
     * @private
     */
    navigateHyperLinkOnEvent(cursorPoint, isTouchInput) {
        let widget = this.documentHelper.getLineWidget(cursorPoint);
        if (!isNullOrUndefined(widget)) {
            let hyperLinkField = this.getHyperLinkFieldInCurrentSelection(widget, cursorPoint);
            //Invokes Hyperlink navigation events.
            if (!isNullOrUndefined(hyperLinkField)) {
                this.documentHelper.updateTextPositionForSelection(cursorPoint, 1);
                this.fireRequestNavigate(hyperLinkField);
                setTimeout(() => {
                    if (this.viewer) {
                        this.documentHelper.isTouchInput = isTouchInput;
                        this.documentHelper.updateFocus();
                        this.documentHelper.isTouchInput = false;
                    }
                });
            }
        }
    }
    /**
     * @private
     */
    getLinkText(fieldBegin, copyAddress) {
        let hyperlink = new Hyperlink(fieldBegin, this);
        let link = hyperlink.navigationLink;
        let screenTip = hyperlink.screenTip;
        if (copyAddress) {
            if (hyperlink.localReference.length > 0) {
                if (hyperlink.localReference[0] === '_' && (isNullOrUndefined(link) || link.length === 0)) {
                    link = 'Current Document';
                }
                else {
                    if (hyperlink.isCrossRef) {
                        link += hyperlink.localReference;
                    }
                    else {
                        link += '#' + hyperlink.localReference;
                    }
                }
            }
            hyperlink.destroy();
            return link;
        }
        else {
            hyperlink.destroy();
            return screenTip;
        }
    }
    /**
     * Set Hyperlink content to tool tip element
     * @private
     */
    setHyperlinkContentToToolTip(fieldBegin, widget, xPos, isFormField) {
        if (fieldBegin) {
            if (this.owner.contextMenuModule &&
                this.owner.contextMenuModule.contextMenuInstance.element.style.display === 'block') {
                return;
            }
            if (!this.toolTipElement) {
                this.toolTipElement = createElement('div', { className: 'e-de-tooltip' });
                this.documentHelper.viewerContainer.appendChild(this.toolTipElement);
                this.screenTipElement = createElement('p');
                this.toolTipElement.appendChild(this.screenTipElement);
                this.toolTipTextElement = createElement('p', { styles: 'font-weight:bold' });
                this.toolTipElement.appendChild(this.toolTipTextElement);
            }
            this.toolTipElement.style.display = 'block';
            let l10n = new L10n('documenteditor', this.owner.defaultLocale);
            l10n.setLocale(this.owner.locale);
            let toolTipText = l10n.getConstant('Click to follow link');
            if (this.owner.useCtrlClickToFollowHyperlink) {
                if (this.documentHelper.isIosDevice) {
                    toolTipText = 'Command+' + toolTipText;
                }
                else {
                    toolTipText = 'Ctrl+' + toolTipText;
                }
            }
            let linkText = this.getScreenTipText(fieldBegin);
            if (isFormField) {
                let helpText = fieldBegin.formFieldData.helpText;
                if (isNullOrUndefined(helpText) || helpText === '') {
                    return;
                }
                this.screenTipElement.innerText = helpText;
                this.toolTipTextElement.innerText = '';
            }
            else {
                this.screenTipElement.innerText = linkText;
                this.toolTipTextElement.innerText = toolTipText;
            }
            let position = this.getTooltipPosition(fieldBegin.line, xPos, this.toolTipElement, false);
            this.showToolTip(position.x, position.y);
            if (!isNullOrUndefined(this.toolTipField) && fieldBegin !== this.toolTipField) {
                this.toolTipObject.position = { X: position.x, Y: position.y };
            }
            this.toolTipObject.show();
            this.toolTipField = fieldBegin;
        }
        else {
            this.hideToolTip();
        }
    }
    /**
    * Get screenTip text
    * @private
    */
    getScreenTipText(fieldBegin) {
        let hyperlink = new Hyperlink(fieldBegin, this);
        if (!hyperlink.screenTip && !hyperlink.localReference) {
            return hyperlink.navigationLink;
        }
        else if (hyperlink.screenTip) {
            return hyperlink.screenTip;
        }
        else {
            return hyperlink.localReference;
        }
    }
    /**
     * Set Hyperlink content to tool tip element
     * @private
     */
    setFootnoteContentToToolTip(footnote, widget, xPos) {
        if (footnote) {
            if (this.owner.contextMenuModule.contextMenuInstance.element.style.display === 'block' &&
                this.owner.contextMenuModule) {
                return;
            }
            if (!this.toolTipElement) {
                this.toolTipElement = createElement('div', { className: 'e-de-tooltip' });
                this.documentHelper.viewerContainer.appendChild(this.toolTipElement);
            }
            this.toolTipElement.style.display = 'block';
            let ln = new L10n('documenteditor', this.owner.defaultLocale);
            ln.setLocale(this.owner.locale);
            let toolTipText;
            if (footnote.footnoteType === 'Endnote') {
                toolTipText = ln.getConstant('Click to View/Edit Endnote');
            }
            else if (footnote.footnoteType === 'Footnote') {
                toolTipText = ln.getConstant('Click to View/Edit Footnote');
            }
            this.toolTipElement.innerHTML = '<b>' + toolTipText + '</b>';
            let positions = this.getTooltipPosition(footnote.line, xPos, this.toolTipElement, false);
            this.showToolTip(positions.x, positions.y);
            if (!isNullOrUndefined(this.toolTipField)) {
                this.toolTipObject.position = { X: positions.x, Y: positions.y };
            }
            this.toolTipObject.show();
            // this.toolTipField = fieldBegin;
        }
        else {
            this.hideToolTip();
        }
    }
    /**
     * Set locked content info to tool tip element
     * @private
     */
    setLockInfoTooptip(widget, xPos, user) {
        if (widget) {
            if (this.owner.contextMenuModule &&
                this.owner.contextMenuModule.contextMenuInstance.element.style.display === 'block') {
                return;
            }
            let toolTipElement = this.toolTipElement;
            if (!this.toolTipElement) {
                toolTipElement = createElement('div', { className: 'e-de-tooltip' });
                this.documentHelper.viewerContainer.appendChild(toolTipElement);
                this.toolTipElement = toolTipElement;
            }
            toolTipElement.style.display = 'block';
            let l10n = new L10n('documenteditor', this.owner.defaultLocale);
            l10n.setLocale(this.owner.locale);
            let toolTipInfo = l10n.getConstant('This region is locked by');
            toolTipElement.innerHTML = toolTipInfo + ' <b>' + user + '</b>';
            let position = this.getTooltipPosition(widget, xPos, toolTipElement, false);
            this.showToolTip(position.x, position.y);
            if (!isNullOrUndefined(this.toolTipField) && user !== this.toolTipField) {
                this.toolTipObject.position = { X: position.x, Y: position.y };
            }
            this.toolTipObject.show();
            this.toolTipField = user;
        }
        else {
            this.hideToolTip();
        }
    }
    /**
     * @private
     */
    getTooltipPosition(widget, xPos, toolTipElement, isFormField) {
        let widgetTop = this.getTop(widget) * this.documentHelper.zoomFactor;
        let page = this.getPage(widget.paragraph);
        let containerWidth = this.documentHelper.viewerContainer.getBoundingClientRect().width + this.documentHelper.viewerContainer.scrollLeft;
        let left = page.boundingRectangle.x + xPos * this.documentHelper.zoomFactor;
        if ((left + toolTipElement.clientWidth + 10) > containerWidth) {
            left = left - ((toolTipElement.clientWidth - (containerWidth - left)) + 15);
        }
        let offsetHeight = !isFormField ? toolTipElement.offsetHeight : 0;
        let top = this.getPageTop(page) + (widgetTop - offsetHeight);
        top = top > this.documentHelper.viewerContainer.scrollTop ? top : top + widget.height + offsetHeight;
        return new Point(left, top);
    }
    /**
     * @private
     */
    updateSelectionInfo(info) {
        let cells = this.selectedWidgets.keys;
        if (cells[0] instanceof TableCellWidget && cells[cells.length - 1] instanceof TableCellWidget) {
            if (cells.length > 0) {
                let firstcell = cells[0];
                let lastCell = cells[cells.length - 1];
                let firstrow = firstcell.ownerRow;
                let lastRow = lastCell.ownerRow;
                let startCell = firstrow.getCell(firstrow.rowIndex, undefined, 0);
                let firstPara = this.owner.documentHelper.getFirstParagraphInCell(startCell);
                info.start = this.owner.documentHelper.selection.getHierarchicalIndex(firstPara, "0");
                let lastCellInRow = lastRow.getCell(lastRow.rowIndex, undefined, lastRow.childWidgets.length - 1);
                let lastPara = this.getLastParagraph(lastCellInRow);
                var offset = this.getParagraphLength(lastPara);
                info.end = this.owner.documentHelper.selection.getHierarchicalIndex(lastPara, offset.toString());
            }
        }
        return info;
    }
    /**
     * @private
     */
    createPasteElement(top, left) {
        let items;
        let locale = new L10n('documenteditor', this.owner.defaultLocale);
        locale.setLocale(this.owner.locale);
        switch (this.currentPasteAction) {
            case 'DefaultPaste':
                items = [
                    {
                        text: locale.getConstant('Keep source formatting'),
                        iconCss: 'e-icons e-de-paste-source'
                    },
                    {
                        text: locale.getConstant('Match destination formatting'),
                        iconCss: 'e-icons e-de-paste-merge'
                    },
                    {
                        text: locale.getConstant('Text only'),
                        iconCss: 'e-icons e-de-paste-text'
                    }
                ];
                break;
            case 'TextOnly':
                items = [
                    {
                        text: locale.getConstant('Text only'),
                        iconCss: 'e-icons e-de-paste-text'
                    }
                ];
                break;
            case 'InsertAsColumns':
            case 'OverwriteCells':
            case 'InsertAsRows':
                items = [
                    {
                        text: locale.getConstant('NestTable'),
                        iconCss: 'e-icons e-de-paste-nested-table'
                    },
                    {
                        text: locale.getConstant('InsertAsRows'),
                        iconCss: 'e-icons e-de-paste-row'
                    }
                ];
                if (this.currentPasteAction === 'InsertAsColumns') {
                    let obj = {
                        text: locale.getConstant('InsertAsColumns'),
                        iconCss: 'e-icons e-de-paste-column'
                    };
                    items.unshift(obj);
                }
                else if (this.currentPasteAction === 'OverwriteCells') {
                    let obj = {
                        text: locale.getConstant('OverwriteCells'),
                        iconCss: 'e-icons e-de-paste-overwrite-cells'
                    };
                    items.splice(2, 0, obj);
                }
                break;
        }
        if (!this.pasteElement) {
            this.pasteElement = createElement('div', { className: 'e-de-tooltip' });
            this.documentHelper.viewerContainer.appendChild(this.pasteElement);
            let splitButtonEle = createElement('button', { id: this.owner.containerId + '_iconsplitbtn' });
            this.pasteElement.appendChild(splitButtonEle);
            this.pasteDropDwn = new DropDownButton({
                items: items, iconCss: 'e-icons e-de-paste', select: this.pasteOptions
            });
            this.pasteDropDwn.appendTo(splitButtonEle);
        }
        else {
            this.pasteDropDwn.items = items;
        }
        this.pasteElement.style.display = 'block';
        this.pasteElement.style.position = 'absolute';
        this.pasteElement.style.left = left;
        this.pasteElement.style.top = top;
        this.pasteDropDwn.dataBind();
    }
    /**
    * Returns an array of context-based paste options.
    *
    * @returns {(PasteOptions | TablePasteOptions)[]} An array containing the available paste options.
    */
    getContextBasedPasteOptions(sfdtContent) {
        // Parse the sfdt content
        let content = HelperMethods.getSfdtDocument(sfdtContent);
        if (!isNullOrUndefined(content.optimizeSfdt) && content.optimizeSfdt) {
            this.owner.editorModule.keywordIndex = 1;
        }
        else {
            this.owner.editorModule.keywordIndex = 0;
        }
        let widgets = [];
        this.owner.editorModule.getBlocks(content, true, widgets, [], [], true);
        let selection = this.documentHelper.selection;
        // Check the sfdt has table alone 
        if (selection.start.paragraph.isInsideTable && selection.end.paragraph.isInsideTable) {
            let isTablePaste = false;
            if (widgets.length === 1) {
                let childWidgets = widgets[0].childWidgets;
                if ((childWidgets.length < 3)) {
                    if (childWidgets.length === 1 && childWidgets[0] instanceof TableWidget || childWidgets.length === 2 && childWidgets[0] instanceof TableWidget && childWidgets[1].isEmpty()) {
                        isTablePaste = true;
                    }
                }
            }
            if (isTablePaste) {
                let startCell = selection.start.paragraph.associatedCell;
                let endCell = selection.end.paragraph.associatedCell;
                let newTable = widgets[0].childWidgets[0];
                // tslint:disable-next-line:max-line-length
                if (startCell.ownerTable.equals(endCell.ownerTable)) {
                    if (selection.start.paragraph.associatedCell.rowIndex === 0 && selection.end.paragraph.associatedCell.rowIndex === 0
                        && startCell.equals(endCell) && !this.isCellSelected(startCell, selection.start, selection.end)) {
                        return ['NewColumn', 'NestTable', 'NewRow'];
                    }
                    else {
                        return ['NestTable', 'NewRow', 'OverwriteCells'];
                    }
                }
            }
        }
        return ['KeepSourceFormatting', 'MergeWithExistingFormatting', 'KeepTextOnly'];
    }
    /**
     * Show hyperlink tooltip
     * @private
     */
    showToolTip(x, y) {
        if (!this.toolTipObject) {
            this.toolTipObject = new Popup(this.toolTipElement, {
                height: 'auto',
                width: 'auto',
                relateTo: this.documentHelper.viewerContainer.parentElement,
                position: { X: x, Y: y }
            });
        }
    }
    /**
     * Hide tooltip object
     * @private
     */
    hideToolTip() {
        this.toolTipField = undefined;
        if (this.toolTipObject) {
            this.toolTipElement.style.display = 'none';
            this.toolTipObject.hide();
            this.toolTipObject.destroy();
            this.toolTipObject = undefined;
        }
    }
    /**
     * Return hyperlink field
     * @private
     */
    getHyperLinkFieldInCurrentSelection(widget, cursorPosition, isFormField) {
        let inline = undefined;
        let top = this.getTop(widget);
        let lineStartLeft = this.getLineStartLeft(widget);
        let leftIndent = HelperMethods.convertPointToPixel(widget.paragraph.paragraphFormat.leftIndent);
        let rightIndent = HelperMethods.convertPointToPixel(widget.paragraph.paragraphFormat.rightIndent);
        if (cursorPosition.y < top || cursorPosition.y > top + widget.height
            || cursorPosition.x < lineStartLeft || cursorPosition.x > lineStartLeft + widget.paragraph.width + leftIndent + rightIndent) {
            return undefined;
        }
        let left = widget.paragraph.x;
        let elementValues = this.getFirstElement(widget, left);
        left = elementValues.left;
        let element = elementValues.element;
        if (isNullOrUndefined(element)) {
            let width = this.documentHelper.textHelper.getParagraphMarkWidth(widget.paragraph.characterFormat);
            if (cursorPosition.x <= lineStartLeft + width || cursorPosition.x >= lineStartLeft + width) {
                //Check if paragraph is within a field result.
                let checkedFields = [];
                let field = this.getHyperLinkFields(widget.paragraph, checkedFields, false, isFormField);
                checkedFields = [];
                checkedFields = undefined;
                return field;
            }
        }
        else {
            let renderedChild = widget.renderedElements;
            if (cursorPosition.x > left + element.margin.left) {
                for (let i = renderedChild.indexOf(element); i < renderedChild.length; i++) {
                    element = renderedChild[i];
                    if (cursorPosition.x < left + element.margin.left + element.width || i === renderedChild.length - 1) {
                        break;
                    }
                    left += element.margin.left + element.width;
                }
            }
            inline = element;
            let width = element.margin.left + element.width;
            if (isNullOrUndefined(inline.nextNode)) {
                //Include width of Paragraph mark.
                width += this.documentHelper.textHelper.getParagraphMarkWidth(inline.line.paragraph.characterFormat);
            }
            if (cursorPosition.x <= left + width) {
                //Check if inline is within a field result.
                let checkedFields = [];
                let field = this.getHyperLinkFieldInternal(inline.line.paragraph, inline, checkedFields, false, isFormField);
                checkedFields = [];
                checkedFields = undefined;
                return field;
            }
        }
        return undefined;
    }
    /**
     * Return FootnoteElementBox
     * @private
     */
    getFootNoteElementInCurrentSelection(lineWidget, position) {
        let inline = undefined;
        let top = this.getTop(lineWidget);
        let lineStartInLeft = this.getLineStartLeft(lineWidget);
        if (position.y < top || position.y > top + lineWidget.height
            || position.x < lineStartInLeft
            || position.x > lineStartInLeft + lineWidget.paragraph.width) {
            return undefined;
        }
        let leftLength = lineWidget.paragraph.x;
        let elementValues = this.getFirstElement(lineWidget, leftLength);
        leftLength = elementValues.left;
        let element = elementValues.element;
        if (isNullOrUndefined(element)) {
            let width = this.documentHelper.textHelper.getParagraphMarkWidth(lineWidget.paragraph.characterFormat);
            if (position.x <= lineStartInLeft + width || position.x >= lineStartInLeft + width) {
                //Check if paragraph is within a field result.
                let inlineObj = this.documentHelper.selection.start.currentWidget.getInline(this.documentHelper.selection.start.offset, 0);
                let footNote = inlineObj.element;
                if (footNote instanceof FootnoteElementBox) {
                    return footNote;
                }
                else {
                    return undefined;
                }
            }
        }
        else {
            if (position.x > leftLength + element.margin.left) {
                for (let i = lineWidget.children.indexOf(element); i < lineWidget.children.length; i++) {
                    element = lineWidget.children[i];
                    if (position.x < leftLength + element.margin.left + element.width || i === lineWidget.children.length - 1) {
                        break;
                    }
                    leftLength += element.margin.left + element.width;
                }
            }
            if (element instanceof FootnoteElementBox) {
                inline = element;
            }
            let width = element.margin.left + element.width;
            if (isNullOrUndefined(element.nextNode)) {
                //Include width of Paragraph mark.
                width += this.documentHelper.textHelper.getParagraphMarkWidth(element.line.paragraph.characterFormat);
            }
            if (position.x <= leftLength + width) {
                return inline;
            }
        }
        return undefined;
    }
    /**
     * Return field if paragraph contain hyperlink field
     * @private
     */
    getHyperlinkField(isRetrieve, isIncludeFieldStart, isIncludeFieldEnd, isIncludeField) {
        if (isNullOrUndefined(this.end)) {
            return undefined;
        }
        let index = 0;
        let selection = this.documentHelper.selection;
        let start = selection.start;
        let end = selection.end;
        if (!selection.isForward) {
            start = selection.end;
            end = selection.start;
            ;
        }
        let currentInline = this.end.currentWidget.getInline(end.offset, index);
        index = currentInline.index;
        let inline = currentInline.element;
        let checkedFields = [];
        let field = undefined;
        if (isNullOrUndefined(inline)) {
            field = this.getHyperLinkFields(this.end.paragraph, checkedFields, isRetrieve);
        }
        else if (this.documentHelper.isFormFillProtectedMode && inline instanceof BookmarkElementBox
            && inline.previousNode instanceof FieldElementBox && inline.previousNode.fieldType === 1) {
            field = undefined;
        }
        else {
            let paragraph = inline.line.paragraph;
            field = this.getHyperLinkFieldInternal(paragraph, inline, checkedFields, isRetrieve, false, isIncludeFieldStart, isIncludeFieldEnd, isIncludeField);
        }
        checkedFields = [];
        return field;
    }
    /**
     * @private
     */
    getHyperLinkFields(paragraph, checkedFields, isRetrieve, checkFormField) {
        for (let i = 0; i < this.documentHelper.fields.length; i++) {
            if (checkedFields.indexOf(this.documentHelper.fields[i]) !== -1 || isNullOrUndefined(this.documentHelper.fields[i].fieldSeparator)) {
                continue;
            }
            else {
                checkedFields.push(this.documentHelper.fields[i]);
            }
            let field = this.getFieldCode(this.documentHelper.fields[i]);
            field = field.trim().toLowerCase();
            let isParagraph = this.paragraphIsInFieldResult(this.documentHelper.fields[i], paragraph);
            if ((isRetrieve || (!isRetrieve && field.match('hyperlink '))) && isParagraph) {
                return this.documentHelper.fields[i];
            }
            if (isParagraph && checkFormField && this.documentHelper.fields[i].formFieldData) {
                return this.documentHelper.fields[i];
            }
            if ((isRetrieve || (!isRetrieve && field.match('ref '))) && isParagraph) {
                return this.documentHelper.fields[i];
            }
        }
        // if (paragraph.containerWidget instanceof BodyWidget && !(paragraph instanceof WHeaderFooter)) {
        //     return this.getHyperLinkFields((paragraph.con as WCompositeNode), checkedFields);
        // }
        return undefined;
    }
    /**
     * @private
     */
    getHyperLinkFieldInternal(paragraph, inline, fields, isRetrieve, checkFormField, isIncludeFieldStart, isIncludeFieldEnd, isIncludeField) {
        for (let i = 0; i < this.documentHelper.fields.length; i++) {
            if (fields.indexOf(this.documentHelper.fields[i]) !== -1 || isNullOrUndefined(this.documentHelper.fields[i].fieldSeparator)) {
                continue;
            }
            else {
                fields.push(this.documentHelper.fields[i]);
            }
            let fieldCode = this.getFieldCode(this.documentHelper.fields[i]);
            fieldCode = fieldCode.trim().toLowerCase();
            let fieldBegin = this.documentHelper.fields[i];
            let fieldEnd = fieldBegin.fieldEnd;
            if (isRetrieve && fieldBegin.nextNode instanceof BookmarkElementBox && fieldBegin.nextNode.reference) {
                fieldEnd = fieldBegin.nextNode.reference;
            }
            let isInline = (this.inlineIsInFieldResult(fieldBegin, fieldEnd, fieldBegin.fieldSeparator, inline, isRetrieve, isIncludeFieldStart, isIncludeFieldEnd, isIncludeField) || this.isImageField());
            if ((isRetrieve || (!isRetrieve && fieldCode.match('hyperlink '))) && isInline) {
                return this.documentHelper.fields[i];
            }
            if (isInline && checkFormField && this.documentHelper.fields[i].formFieldData) {
                return this.documentHelper.fields[i];
            }
            if ((isRetrieve || (!isRetrieve && fieldCode.match('ref '))) && isInline) {
                return this.documentHelper.fields[i];
            }
        }
        if (paragraph.containerWidget instanceof BodyWidget && !(paragraph instanceof HeaderFooterWidget)) {
            return this.getHyperLinkFieldInternal(paragraph.containerWidget, inline, fields, isRetrieve, checkFormField);
        }
        return undefined;
    }
    /**
     * @private
     */
    getBlock(currentIndex) {
        if (currentIndex === '' || isNullOrUndefined(currentIndex)) {
            return undefined;
        }
        let index = { index: currentIndex };
        let page = this.start.getPage(index);
        let bodyIndex = index.index.indexOf(';');
        let value = index.index.substring(0, bodyIndex);
        index.index = index.index.substring(bodyIndex).replace(';', '');
        let bodyWidget = page.bodyWidgets[parseInt(value, 10)];
        return this.getBlockInternal(bodyWidget, index.index);
    }
    /**
     * Return Block relative to position
     * @private
     */
    getBlockInternal(widget, position) {
        if (position === '' || isNullOrUndefined(position)) {
            return undefined;
        }
        let index = position.indexOf(';');
        let value = position.substring(0, index);
        position = position.substring(index).replace(';', '');
        let node = widget;
        // if (node instanceof Widget && value === 'HF') {
        //     //Gets the block in Header footers.
        //     let blockObj: BlockInfo = this.getBlock((node as WSection).headersFooters, position);
        //     return { 'node': (!isNullOrUndefined(blockObj)) ? blockObj.node : undefined, 'position': (!isNullOrUndefined(blockObj)) ? blockObj.position : undefined };
        // }
        index = parseInt(value, 10);
        if (index >= 0 && index < widget.childWidgets.length) {
            let child = widget.childWidgets[(index)];
            if (position.indexOf(';') >= 0) {
                if (child instanceof ParagraphWidget) {
                    if (position.indexOf(';') >= 0) {
                        position = '0';
                    }
                    return child;
                }
                if (child instanceof BlockWidget) {
                    let blockObj = this.getBlockInternal(child, position);
                    return blockObj;
                }
            }
            else {
                return child;
            }
        }
        else {
            return node;
        }
        return node;
    }
    /**
     * Return true if inline is in field result
     * @private
     */
    inlineIsInFieldResult(fieldBegin, fieldEnd, fieldSeparator, inline, isRetrieve, isIncludeFieldStart, isIncludeFieldEnd, isIncludeField) {
        if (!isNullOrUndefined(fieldEnd) && !isNullOrUndefined(fieldSeparator)) {
            if (this.isExistBeforeInline(fieldSeparator, inline, isIncludeFieldStart, isIncludeField)) {
                return this.isExistAfterInline(fieldEnd, inline, isRetrieve, isIncludeFieldEnd, isIncludeField);
            }
        }
        return false;
    }
    /**
     * Retrieve true if paragraph is in field result
     * @private
     */
    paragraphIsInFieldResult(fieldBegin, paragraph) {
        if (!isNullOrUndefined(fieldBegin.fieldEnd) && !isNullOrUndefined(fieldBegin.fieldSeparator)) {
            let fieldParagraph = fieldBegin.fieldSeparator.line.paragraph;
            if (fieldBegin.fieldSeparator.line.paragraph === paragraph
                || this.isExistBefore(fieldParagraph, paragraph)) {
                let currentParagraph = fieldBegin.fieldEnd.line.paragraph;
                return (currentParagraph !== paragraph && this.isExistAfter(fieldParagraph, paragraph));
            }
        }
        return false;
    }
    /**
     * Return true if image is In field
     * @private
     */
    isImageField() {
        if (this.start.paragraph.isEmpty() || this.end.paragraph.isEmpty()) {
            return false;
        }
        let startPosition = this.start;
        let endPosition = this.end;
        if (!this.isForward) {
            startPosition = this.end;
            endPosition = this.start;
        }
        let indexInInline = 0;
        let inlineInfo = startPosition.paragraph.getInline(startPosition.offset, indexInInline);
        let inline = inlineInfo.element;
        indexInInline = inlineInfo.index;
        if (indexInInline === inline.length) {
            inline = this.getNextRenderedElementBox(inline, indexInInline);
        }
        inlineInfo = endPosition.paragraph.getInline(endPosition.offset, indexInInline);
        let endInline = inlineInfo.element;
        indexInInline = inlineInfo.index;
        if (inline instanceof FieldElementBox && inline.fieldType === 0
            && endInline instanceof FieldElementBox && endInline.fieldType === 1 && inline.fieldSeparator) {
            let fieldValue = inline.fieldSeparator.nextNode;
            if (fieldValue instanceof ImageElementBox && fieldValue.nextNode === endInline) {
                return true;
            }
        }
        return false;
    }
    /**
     * Return true if selection is in Form field
     * @private
     */
    isFormField() {
        let inline = this.currentFormField;
        if (inline instanceof FieldElementBox && inline.formFieldData) {
            return true;
        }
        return false;
    }
    /**
     * Return true if selection is in reference field
     * @private
     */
    isReferenceField(field) {
        if (isNullOrUndefined(field)) {
            field = this.getHyperlinkField(true);
        }
        if (field) {
            let fieldCode = this.getFieldCode(field);
            fieldCode = fieldCode.toLowerCase();
            if (field instanceof FieldElementBox && fieldCode.match('ref ')) {
                return true;
            }
        }
        return false;
    }
    /**
     * Return true if selection is in text form field
     * @private
     */
    isInlineFormFillMode(field) {
        if (this.documentHelper.isInlineFormFillProtectedMode) {
            field = isNullOrUndefined(field) ? this.currentFormField : field;
            if (isNullOrUndefined(field)) {
                field = this.getCurrentFormField();
            }
            if (field) {
                if (field.formFieldData instanceof TextFormField) {
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * @private
     */
    getFormFieldType(formField) {
        if (isNullOrUndefined(formField)) {
            formField = this.currentFormField;
        }
        if (formField instanceof FieldElementBox) {
            if (formField.formFieldData instanceof TextFormField) {
                return 'Text';
            }
            else if (formField.formFieldData instanceof CheckBoxFormField) {
                return 'CheckBox';
            }
            else if (formField.formFieldData instanceof DropDownFormField) {
                return 'DropDown';
            }
        }
        return undefined;
    }
    /**
     * Get selected form field type
     * @private
     */
    getCurrentFormField(checkFieldResult) {
        let field;
        if (checkFieldResult || this.documentHelper.isFormFillProtectedMode && this.owner.documentEditorSettings.formFieldSettings &&
            this.owner.documentEditorSettings.formFieldSettings.formFillingMode === 'Inline') {
            for (let i = 0; i < this.documentHelper.formFields.length; i++) {
                let formField = this.documentHelper.formFields[i];
                let start = this.start;
                let end = this.end;
                if (!this.isForward) {
                    start = this.end;
                    end = this.start;
                }
                if (HelperMethods.isLinkedFieldCharacter(formField)) {
                    let offset = formField.fieldSeparator.line.getOffset(formField.fieldSeparator, 1);
                    let fieldStart = new TextPosition(this.owner);
                    fieldStart.setPositionParagraph(formField.fieldSeparator.line, offset);
                    let fieldEndElement = formField.fieldEnd;
                    offset = fieldEndElement.line.getOffset(fieldEndElement, 0);
                    let fieldEnd = new TextPosition(this.owner);
                    fieldEnd.setPositionParagraph(fieldEndElement.line, offset);
                    if ((start.isExistAfter(fieldStart) || start.isAtSamePosition(fieldStart))
                        && (end.isExistBefore(fieldEnd) || end.isAtSamePosition(fieldEnd))) {
                        field = formField;
                        break;
                    }
                }
            }
        }
        else {
            field = this.getHyperlinkField(true);
        }
        if (field instanceof FieldElementBox && field.fieldType === 0 && !isNullOrUndefined(field.formFieldData)) {
            return field;
        }
        return undefined;
    }
    /**
     * @private
     */
    getCurrentTextFrame() {
        let container = this.start.paragraph.containerWidget;
        do {
            if (container instanceof TextFrame) {
                return container;
            }
            if (container) {
                container = container.containerWidget;
            }
        } while (container);
        return null;
    }
    /**
     * @private
     */
    isTableSelected(isNested) {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (isNullOrUndefined(start.paragraph.associatedCell) ||
            isNullOrUndefined(end.paragraph.associatedCell)) {
            return false;
        }
        let table = start.paragraph.associatedCell.ownerTable.getSplitWidgets();
        let firstParagraph = this.getFirstBlockInFirstCell(table[0]);
        let lastParagraph = this.getLastBlockInLastCell(table[table.length - 1]);
        if (isNested) {
            let nestedTable = lastParagraph.associatedCell.ownerTable;
            while (nestedTable.containerWidget instanceof TableCellWidget) {
                nestedTable = nestedTable.containerWidget.ownerTable;
            }
            lastParagraph = this.getLastBlockInLastCell(nestedTable);
        }
        return start.paragraph.associatedCell.equals(firstParagraph.associatedCell) &&
            end.paragraph.associatedCell.equals(lastParagraph.associatedCell)
            && (!firstParagraph.associatedCell.equals(lastParagraph.associatedCell) || (start.offset === 0
                && end.offset === this.getLineLength(lastParagraph.lastChild) + 1));
    }
    /**
     * Returns true if the complete columns in the table is selected
     * @private
     */
    isWholeColumnSelected() {
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (isNullOrUndefined(start.paragraph.associatedCell) ||
            isNullOrUndefined(end.paragraph.associatedCell)) {
            return false;
        }
        let startCell = start.paragraph.associatedCell;
        let endCell = end.paragraph.associatedCell;
        let table = start.paragraph.associatedCell.ownerTable.getSplitWidgets();
        let firstParagraph = this.getFirstBlockInFirstCell(table[0]);
        let lastParagraph = this.getLastBlockInLastCell(table[table.length - 1]);
        return startCell.ownerRow.equals(firstParagraph.associatedCell.ownerRow) && endCell.ownerRow.equals(lastParagraph.associatedCell.ownerRow);
    }
    /**
     * Select List Text
     * @private
     */
    selectListText() {
        let lineWidget = this.documentHelper.selectionLineWidget;
        let endOffset = '0';
        let selectionIndex = lineWidget.getHierarchicalIndex(endOffset);
        let startPosition = this.getTextPosition(selectionIndex);
        let endPosition = this.getTextPosition(selectionIndex);
        this.isSelectList = true;
        this.selectRange(startPosition, endPosition);
        this.isSelectList = false;
        this.highlightListText(this.documentHelper.selectionLineWidget);
        this.contextTypeInternal = 'List';
    }
    /**
     * Manually select the list text
     * @private
     */
    highlightListText(linewidget) {
        let width = linewidget.children[0].width;
        let left = this.documentHelper.getLeftValue(linewidget);
        let top = linewidget.paragraph.y;
        this.createHighlightBorder(linewidget, width, left, top, false);
        this.documentHelper.isListTextSelected = true;
    }
    /**
     * @private
     */
    updateImageSize(imageFormat) {
        this.owner.isShiftingEnabled = true;
        let startPosition = this.start;
        let endPosition = this.end;
        if (!this.isForward) {
            startPosition = this.end;
            endPosition = this.start;
        }
        let inline = null;
        let index = 0;
        let paragraph = startPosition.paragraph;
        if (paragraph === endPosition.paragraph
            && startPosition.offset + 1 === endPosition.offset) {
            let inlineObj = paragraph.getInline(endPosition.offset, index);
            inline = inlineObj.element;
            index = inlineObj.index;
        }
        if (inline instanceof ImageElementBox || inline instanceof ShapeElementBox || inline instanceof GroupShapeElementBox) {
            let width = inline.width;
            let height = inline.height;
            let alternateText = inline.alternateText;
            inline.width = imageFormat.width;
            inline.height = imageFormat.height;
            inline.alternateText = imageFormat.alternatetext;
            imageFormat.width = width;
            imageFormat.height = height;
            imageFormat.alternatetext = alternateText;
            if (inline instanceof GroupShapeElementBox) {
                this.owner.documentHelper.layout.layoutGroupShape(inline);
            }
            if (paragraph !== null && paragraph.containerWidget !== null && this.owner.editorModule) {
                let lineIndex = paragraph.childWidgets.indexOf(inline.line);
                let elementIndex = inline.line.children.indexOf(inline);
                this.documentHelper.layout.reLayoutParagraph(paragraph, lineIndex, elementIndex);
                this.highlightSelection(false);
            }
        }
    }
    /**
     * Gets selected table content
     * @private
     */
    getSelectedCellsInTable(table, startCell, endCell) {
        let startColumnIndex = startCell.columnIndex;
        let endColumnIndex = endCell.columnIndex + endCell.cellFormat.columnSpan - 1;
        let startRowindex = startCell.ownerRow.index;
        let endRowIndex = endCell.ownerRow.index;
        let cells = [];
        for (let i = 0; i < table.childWidgets.length; i++) {
            let row = table.childWidgets[i];
            if (row.index >= startRowindex && row.index <= endRowIndex) {
                for (let j = 0; j < row.childWidgets.length; j++) {
                    let cell = row.childWidgets[j];
                    if (cell.columnIndex >= startColumnIndex && cell.columnIndex <= endColumnIndex) {
                        cells.push(cell);
                    }
                }
            }
            if (row.index > endRowIndex) {
                break;
            }
        }
        return cells;
        // return html;
    }
    /**
     * Copies the selected content to clipboard.
     *
     * @returns {void}
     */
    copy() {
        if (this.isEmpty) {
            return;
        }
        this.copySelectedContent(false);
    }
    /**
     * @private
     *
     * @returns {void}
     */
    copySelectedContent(isCut) {
        if (isNullOrUndefined(this.owner.sfdtExportModule)) {
            return;
        }
        this.documentHelper.isCopying = true;
        this.htmlContent = this.getHtmlContent();
        this.copyToClipboard();
        this.documentHelper.isCopying = false;
        if (isCut && this.owner.editorModule) {
            this.owner.editorModule.handleCut(this);
        }
        if (this.owner.enableAutoFocus) {
            this.documentHelper.updateFocus();
        }
    }
    /**
     * Write the selected content as SFDT.
     * @returns SFDT Object.
     */
    writeSfdt() {
        let startPosition = this.start;
        let endPosition = this.end;
        if (!this.isForward) {
            startPosition = this.end;
            endPosition = this.start;
        }
        let bookmarks = this.documentHelper.bookmarks;
        for (let index = 0; index < bookmarks.length; index++) {
            let bookmrkStart = bookmarks.get(bookmarks.keys[index]);
            if (!isNullOrUndefined(bookmrkStart.reference) && this.isElementInSelection(bookmrkStart, false) && this.isElementInSelection(bookmrkStart.reference, true)) {
                this.owner.sfdtExportModule.bookmarkCollection.push(bookmrkStart);
            }
        }
        let editRanges = this.documentHelper.editRanges;
        for (let i = 0; i < editRanges.keys.length; i++) {
            const editRangeStarts = editRanges.get(editRanges.keys[i]);
            for (let j = 0; j < editRangeStarts.length; j++) {
                const editRangeStart = editRangeStarts[j];
                if (!isNullOrUndefined(editRangeStart.editRangeEnd) &&
                    this.isElementInSelection(editRangeStart, false) &&
                    this.isElementInSelection(editRangeStart.editRangeEnd, true)) {
                    this.owner.sfdtExportModule.editRangeCollection.push(editRangeStart);
                }
            }
        }
        let returnSfdt = this.owner.sfdtExportModule.write((this.owner.documentEditorSettings.optimizeSfdt ? 1 : 0), startPosition.currentWidget, startPosition.offset, endPosition.currentWidget, endPosition.offset, true, false);
        this.owner.sfdtExportModule.bookmarkCollection = [];
        this.owner.sfdtExportModule.editRangeCollection = [];
        return returnSfdt;
    }
    /**
     * @private
     */
    getHtmlContent(skipStyle) {
        let isInlineOnlySelected = false;
        let endPosition = this.end;
        if (!this.isForward) {
            endPosition = this.start;
        }
        if (this.start.paragraph.equals(this.end.paragraph) && endPosition.offset <= this.getLineLength(endPosition.currentWidget)) {
            isInlineOnlySelected = true;
        }
        let documentContent = this.writeSfdt();
        this.sfdtContent = JSON.stringify(documentContent);
        if (this.owner.editorModule) {
            this.owner.editorModule.copiedData = JSON.stringify(documentContent);
        }
        let isOptimizedSfdt = this.owner.documentEditorSettings.optimizeSfdt;
        return this.htmlWriter.writeHtml(documentContent, isOptimizedSfdt, skipStyle, isInlineOnlySelected);
    }
    copyToClipboard(htmlContent) {
        window.getSelection().removeAllRanges();
        //Skip the copy operation Using shadow DOM if it is mobile device or IE browser.
        let isSafariOnMac = (navigator.vendor && navigator.vendor.indexOf('Apple') > -1 &&
            navigator.userAgent &&
            navigator.userAgent.indexOf('Macintosh') > -1 &&
            navigator.userAgent.indexOf('Safari') > -1 &&
            navigator.userAgent.indexOf('Chrome') === -1);
        let isMobileDeviceOrInternetExplorer = /Android|Windows Phone|iPhone|Trident|webOS/i.test(navigator.userAgent) || isSafariOnMac;
        let shadowRoot;
        let div = document.createElement('div');
        div.style.left = '-10000px';
        div.style.top = '-10000px';
        div.style.position = 'relative';
        if (!isNullOrUndefined(htmlContent)) {
            div.innerHTML = htmlContent;
        }
        else if (isSafariOnMac) {
            div.innerText = 'copy';
        }
        if (!isMobileDeviceOrInternetExplorer) {
            shadowRoot = document.createElement('div');
            let shadowDOM = shadowRoot.attachShadow({ mode: 'open' });
            shadowDOM.appendChild(div);
            document.body.appendChild(shadowRoot);
        }
        else {
            document.body.appendChild(div);
        }
        if (navigator !== undefined && navigator.userAgent.indexOf('Firefox') !== -1) {
            div.contentEditable = 'true';
        }
        let range = document.createRange();
        range.selectNodeContents(div);
        window.getSelection().addRange(range);
        let copySuccess = false;
        try {
            copySuccess = document.execCommand('copy');
        }
        catch (e) {
            // Copying data to Clipboard can potentially fail - for example, if another application is holding Clipboard open.       
        }
        finally {
            window.getSelection().removeAllRanges();
            div.parentNode.removeChild(div);
            if (!isMobileDeviceOrInternetExplorer) {
                shadowRoot.parentNode.removeChild(shadowRoot);
            }
        }
        return copySuccess;
    }
    /**
     * @private
     */
    onCopy(event) {
        if (event.clipboardData && !isNullOrUndefined(this.htmlContent)) {
            event.clipboardData.clearData();
            event.clipboardData.setData('text/html', this.htmlContent);
            event.clipboardData.setData('text/plain', this.text);
            event.clipboardData.setData('application/json', JSON.stringify(this.sfdtContent));
            this.htmlContent = undefined;
            this.sfdtContent = undefined;
        }
    }
    // Caret implementation starts
    /**
     * Shows caret in current selection position.
     *
     * @private
     * @returns {void}
     */
    showCaret() {
        let page = !isNullOrUndefined(this.documentHelper.currentPage) ? this.documentHelper.currentPage : this.documentHelper.currentRenderingPage;
        if (isNullOrUndefined(page) || this.documentHelper.isRowOrCellResizing || (this.owner.enableImageResizerMode && this.owner.imageResizerModule.isImageResizerVisible && !this.owner.imageResizerModule.isShapeResize)) {
            return;
        }
        let left = page.boundingRectangle.x;
        let right;
        if (this.viewer instanceof PageLayoutViewer) {
            right = page.boundingRectangle.width * this.documentHelper.zoomFactor + left;
        }
        else {
            right = page.boundingRectangle.width - this.owner.viewer.padding.right - this.documentHelper.scrollbarWidth;
        }
        if (!this.owner.enableImageResizerMode || (!this.owner.imageResizerModule.isImageResizerVisible || this.owner.imageResizerModule.isShapeResize)) {
            if (this.isHideSelection(this.start.paragraph)) {
                this.caret.style.display = 'none';
            }
            else if (this.isEmpty && ((!this.owner.isReadOnly && !this.documentHelper.isFormFillProtectedMode) || this.owner.enableCursorOnReadOnly || this.isInlineFormFillMode())) {
                let caretLeft = parseInt(this.caret.style.left.replace('px', ''), 10);
                if (caretLeft < left || caretLeft > right) {
                    this.caret.style.display = 'none';
                }
                else {
                    this.caret.style.display = 'block';
                }
            }
            else if (this.isImageSelected && !this.owner.enableImageResizerMode) {
                this.caret.style.display = 'block';
            }
            else {
                if (this.caret.style.display === 'block' || isNullOrUndefined(this)) {
                    if (!this.documentHelper.isComposingIME) {
                        this.caret.style.display = 'none';
                    }
                }
            }
        }
        if (!isNullOrUndefined(this) && this.documentHelper.isTouchInput && !this.owner.isReadOnlyMode) {
            let caretStartLeft = parseInt(this.documentHelper.touchStart.style.left.replace('px', ''), 10) + 14;
            let caretEndLeft = parseInt(this.documentHelper.touchEnd.style.left.replace('px', ''), 10) + 14;
            let page = this.getSelectionPage(this.start);
            if (page) {
                if (caretEndLeft < left || caretEndLeft > right) {
                    this.documentHelper.touchEnd.style.display = 'none';
                }
                else {
                    this.documentHelper.touchEnd.style.display = 'block';
                }
                if (!this.isEmpty) {
                    left = page.boundingRectangle.x;
                    right = page.boundingRectangle.width * this.documentHelper.zoomFactor + left;
                }
                if (caretStartLeft < left || caretStartLeft > right) {
                    this.documentHelper.touchStart.style.display = 'none';
                }
                else {
                    this.documentHelper.touchStart.style.display = 'block';
                }
            }
        }
        else {
            this.documentHelper.touchStart.style.display = 'none';
            this.documentHelper.touchEnd.style.display = 'none';
        }
    }
    /**
     * To set the editable div caret position
     *
     * @private
     * @returns {void}
     */
    setEditableDivCaretPosition(index) {
        this.documentHelper.editableDiv.focus();
        let child = this.documentHelper.editableDiv.childNodes[this.documentHelper.editableDiv.childNodes.length - 1];
        if (child) {
            let range = document.createRange();
            range.setStart(child, index);
            range.collapse(true);
            window.getSelection().removeAllRanges();
            window.getSelection().addRange(range);
        }
    }
    /**
     * Initializes caret.
     *
     * @private
     * @returns {void}
     */
    initCaret() {
        this.caret = createElement('div', {
            styles: 'position:absolute',
            className: 'e-de-blink-cursor e-de-cursor-animation'
        });
        this.caret.style.display = 'none';
        this.owner.documentHelper.viewerContainer.appendChild(this.caret);
    }
    /**
     * Updates caret position.
     *
     * @private
     * @returns {void}
     */
    updateCaretPosition() {
        let caretPosition = this.end.location;
        let page = this.getSelectionPage(this.end);
        if (page && !isNullOrUndefined(this.caret)) {
            let left = page.boundingRectangle.x + (Math.round(caretPosition.x) * this.documentHelper.zoomFactor) + 'px';
            this.caret.style.left = left;
            let caretInfo = this.updateCaretSize(this.owner.selectionModule.end);
            let topMargin = caretInfo.topMargin;
            //let caretHeight: number = caretInfo.height;
            let viewer = this.viewer;
            let top = (page.boundingRectangle.y - viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1)) * this.documentHelper.zoomFactor + viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1);
            let pageTop = top;
            this.caret.style.top = pageTop + (Math.round(caretPosition.y + topMargin) * this.documentHelper.zoomFactor) + 'px';
            if (this.owner.selectionModule.characterFormat.baselineAlignment === 'Subscript') {
                this.caret.style.top = parseFloat(this.caret.style.top) + (parseFloat(this.caret.style.height) / 2) + 'px';
            }
            if (this.documentHelper.isTouchInput || this.documentHelper.touchStart.style.display !== 'none') {
                this.documentHelper.touchStart.style.left = page.boundingRectangle.x + (Math.round(caretPosition.x) * this.documentHelper.zoomFactor - 14) + 'px';
                this.documentHelper.touchStart.style.top = pageTop + ((caretPosition.y + caretInfo.height) * this.documentHelper.zoomFactor) + 'px';
                this.documentHelper.touchEnd.style.left = page.boundingRectangle.x + (Math.round(caretPosition.x) * this.documentHelper.zoomFactor - 14) + 'px';
                this.documentHelper.touchEnd.style.top = pageTop + ((caretPosition.y + caretInfo.height) * this.documentHelper.zoomFactor) + 'px';
            }
            if (Browser.isDevice) {
                this.documentHelper.editableDiv.style.left = left + "px";
                this.documentHelper.editableDiv.style.top = top + "px";
            }
        }
        if (!isNullOrUndefined(this.owner.editorModule) && !isNullOrUndefined(this.owner.editorModule.positionForPasteIcon)) {
            let page = this.owner.editorModule.positionForPasteIcon.paragraph.containerWidget.page;
            let caretInfo = this.updateCaretSize(this.owner.editorModule.positionForPasteIcon);
            let top = (page.boundingRectangle.y - this.viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1)) * this.documentHelper.zoomFactor + this.viewer.pageGap * (this.documentHelper.pages.indexOf(page) + 1);
            let topValue = top + (Math.round(this.owner.editorModule.positionForPasteIcon.location.y + caretInfo.topMargin) * this.documentHelper.zoomFactor);
            let leftValue = page.boundingRectangle.x + (Math.round(this.owner.editorModule.positionForPasteIcon.location.x) * this.documentHelper.zoomFactor);
            this.showHidePasteOptions(topValue + "px", leftValue + "px");
        }
        else {
            this.showHidePasteOptions(this.caret.style.top, this.caret.style.left);
        }
    }
    /**
     * @private
     * @returns {void}
     */
    showHidePasteOptions(top, left) {
        if (Browser.isIE) {
            return;
        }
        if (this.isViewPasteOptions) {
            if (this.pasteElement && this.pasteElement.style.display === 'block') {
                return;
            }
            this.createPasteElement(top, left);
        }
        else if (this.pasteElement) {
            this.pasteElement.style.display = 'none';
            if (!isNullOrUndefined(this.owner.editorModule)) {
                this.owner.editorModule.isHtmlPaste = false;
            }
        }
    }
    /**
     * @private
     */
    getRect(position) {
        let caretPosition = position.location;
        let page = this.getSelectionPage(position);
        if (page) {
            let documentHelper = this.owner.documentHelper;
            let left = page.boundingRectangle.x + (Math.round(caretPosition.x) * documentHelper.zoomFactor);
            let pageGap = this.viewer.pageGap;
            let pageTop = (page.boundingRectangle.y - pageGap * (page.index + 1)) * documentHelper.zoomFactor + pageGap * (page.index + 1);
            let top = pageTop + (Math.round(caretPosition.y) * documentHelper.zoomFactor);
            return new Point(left, top);
        }
        return new Point(0, 0);
    }
    /**
     * Gets current selected page
     * @private
     */
    getSelectionPage(position) {
        let lineWidget = this.getLineWidgetInternal(position.currentWidget, position.offset, true);
        if (lineWidget) {
            return this.getPage(lineWidget.paragraph);
        }
        return undefined;
    }
    /**
     * Updates caret size.
     * @private
     */
    updateCaretSize(textPosition, skipUpdate) {
        let topMargin = 0;
        let isItalic = false;
        let caret;
        let index = 0;
        let caretHeight = 0;
        if (this.characterFormat.italic) {
            isItalic = this.characterFormat.italic;
        }
        if (textPosition.paragraph.isEmpty()) {
            let paragraph = textPosition.paragraph;
            let bottomMargin = 0;
            let paragraphInfo = this.getParagraphMarkSize(paragraph, topMargin, bottomMargin);
            topMargin = paragraphInfo.topMargin;
            bottomMargin = paragraphInfo.bottomMargin;
            let height = paragraphInfo.height;
            const baselineAlignment = this.characterFormat.baselineAlignment;
            let elementHeight = height;
            if (baselineAlignment !== 'Normal') {
                //Set the caret height as sub/super script text height and updates the top margin for sub script text.
                elementHeight = elementHeight / 1.5;
                if (baselineAlignment === 'Subscript') {
                    topMargin = height - elementHeight;
                }
            }
            caretHeight = topMargin < 0 ? topMargin + elementHeight : elementHeight;
            if (!skipUpdate) {
                this.caret.style.height = caretHeight * this.documentHelper.zoomFactor + 'px';
            }
            topMargin = 0;
        }
        else {
            let inlineInfo = textPosition.currentWidget.getInline(textPosition.offset, index);
            index = inlineInfo.index;
            let inline = inlineInfo.element;
            if (!isNullOrUndefined(inline)) {
                caret = this.getCaretHeight(inline, index, inline.characterFormat, true, topMargin, isItalic);
                caretHeight = caret.height;
                if (inline.characterFormat.hidden && caret.height === 0) {
                    let visibleElement = inline;
                    while (visibleElement && visibleElement.characterFormat.hidden) {
                        visibleElement = visibleElement.previousElement;
                    }
                    if (isNullOrUndefined(visibleElement)) {
                        visibleElement = inline;
                        while (visibleElement && visibleElement.characterFormat.hidden) {
                            visibleElement = visibleElement.nextElement;
                        }
                    }
                    if (!isNullOrUndefined(visibleElement)) {
                        let height = this.documentHelper.textHelper.getHeight(visibleElement.characterFormat).Height;
                        caretHeight = caret.height = height;
                    }
                }
                if (!skipUpdate) {
                    this.caret.style.height = caret.height * this.documentHelper.zoomFactor + 'px';
                }
            }
        }
        if (!skipUpdate) {
            if (isItalic) {
                this.caret.style.transform = 'rotate(13deg)';
            }
            else {
                this.caret.style.transform = '';
            }
        }
        return {
            'topMargin': topMargin,
            'height': caretHeight
        };
    }
    /**
     * Updates caret to page.
     * @private
     * @returns {void}
     */
    updateCaretToPage(startPosition, endPage) {
        if (!isNullOrUndefined(endPage)) {
            this.documentHelper.selectionEndPage = endPage;
            if (this.owner.selectionModule.isEmpty) {
                this.documentHelper.selectionStartPage = endPage;
            }
            else {
                let startLineWidget = this.getLineWidgetParagraph(startPosition.offset, startPosition.paragraph.childWidgets[0]);
                //Gets start page.
                let startPage = this.getPage(startLineWidget.paragraph);
                if (!isNullOrUndefined(startPage)) {
                    this.documentHelper.selectionStartPage = startPage;
                }
            }
        }
        if (this.owner.enableAutoFocus) {
            this.checkForCursorVisibility();
        }
    }
    /**
     * Gets caret bottom position.
     * @private
     */
    getCaretBottom(textPosition, isEmptySelection) {
        let bottom = textPosition.location.y;
        if (textPosition.paragraph.isEmpty()) {
            let paragraph = textPosition.paragraph;
            let topMargin = 0;
            let bottomMargin = 0;
            let sizeInfo = this.getParagraphMarkSize(paragraph, topMargin, bottomMargin);
            topMargin = sizeInfo.topMargin;
            bottomMargin = sizeInfo.bottomMargin;
            bottom += sizeInfo.height;
            bottom += topMargin;
            if (!isEmptySelection) {
                bottom += bottomMargin;
            }
        }
        else {
            let index = 0;
            let inlineInfo = textPosition.paragraph.getInline(textPosition.offset, index);
            let inline = inlineInfo.element;
            index = inlineInfo.index;
            let topMargin = 0;
            let isItalic = false;
            let caretHeightInfo = this.getCaretHeight(inline, index, inline.characterFormat, false, topMargin, isItalic);
            topMargin = caretHeightInfo.topMargin;
            isItalic = caretHeightInfo.isItalic;
            bottom += caretHeightInfo.height;
            if (isEmptySelection) {
                bottom -= HelperMethods.convertPointToPixel(this.documentHelper.layout.getAfterSpacing(textPosition.paragraph));
            }
        }
        return bottom;
    }
    /**
     * Checks for cursor visibility.
     *
     * @private
     * @returns {void}
     */
    checkForCursorVisibility() {
        this.showCaret();
    }
    // caret implementation ends
    /**
     * Keyboard shortcuts
     *
     * @private
     * @returns {void}
     */
    onKeyDownInternal(event, ctrl, shift, alt) {
        let key = HelperMethods.getLegacyKeyCode(event);
        this.owner.focusIn();
        if (ctrl && !shift && !alt) {
            this.documentHelper.isControlPressed = true;
            switch (key) {
                // case 9:
                //     event.preventDefault();
                //     if (this.owner.acceptTab) {
                //         this.selection.handleTabKey(false, false);
                //     }
                //     break;
                case 35:
                    this.handleControlEndKey();
                    break;
                case 36:
                    this.handleControlHomeKey();
                    break;
                case 37:
                    this.handleControlLeftKey();
                    break;
                case 38:
                    this.handleControlUpKey();
                    break;
                case 39:
                    this.handleControlRightKey();
                    break;
                case 40:
                    this.handleControlDownKey();
                    break;
                case 65:
                    this.owner.selectionModule.selectAll();
                    break;
                case 67:
                    event.preventDefault();
                    this.copy();
                    break;
                case 70:
                    event.preventDefault();
                    if (!isNullOrUndefined(this.owner.optionsPaneModule)) {
                        this.owner.optionsPaneModule.isReplace = false;
                        this.owner.optionsPaneModule.isFind = true;
                        this.owner.documentEditorSettings.showNavigationPane = true;
                        this.owner.optionsPaneModule.showHideOptionsPane(true);
                        setTimeout(() => {
                            if (this.owner.optionsPaneModule.isFind) {
                                this.owner.optionsPaneModule.isFind = false;
                            }
                        }, 10);
                    }
                    break;
            }
        }
        else if (shift && !ctrl && !alt) {
            this.documentHelper.isCompleted = false;
            switch (key) {
                case 33:
                    event.preventDefault();
                    this.handlePageUpPageDownKey(false, shift);
                    break;
                case 34:
                    event.preventDefault();
                    this.handlePageUpPageDownKey(true, shift);
                    break;
                case 35:
                    this.handleShiftEndKey();
                    event.preventDefault();
                    break;
                case 36:
                    this.handleShiftHomeKey();
                    event.preventDefault();
                    break;
                case 37:
                    this.handleShiftLeftKey();
                    event.preventDefault();
                    break;
                case 38:
                    this.handleShiftUpKey();
                    event.preventDefault();
                    break;
                case 39:
                    this.handleShiftRightKey();
                    event.preventDefault();
                    break;
                case 40:
                    this.handleShiftDownKey();
                    event.preventDefault();
                    break;
            }
        }
        else if (shift && ctrl && !alt) {
            switch (key) {
                case 32:
                    this.owner.editorModule.insertText(String.fromCharCode(160));
                    break;
                case 35:
                    this.handleControlShiftEndKey();
                    break;
                case 36:
                    this.handleControlShiftHomeKey();
                    break;
                case 37:
                    this.handleControlShiftLeftKey();
                    break;
                case 38:
                    this.handleControlShiftUpKey();
                    break;
                case 39:
                    this.handleControlShiftRightKey();
                    break;
                case 40:
                    this.handleControlShiftDownKey();
                    break;
                case 56:
                    this.owner.toggleShowHiddenMarksInternal();
                    break;
            }
        }
        else {
            switch (key) {
                // case 9:
                //     event.preventDefault();
                //     if (this.owner.acceptTab) {
                //         this.handleTabKey(true, false);
                //     }
                //     break;  
                case 33:
                    event.preventDefault();
                    this.handlePageUpPageDownKey(false, shift);
                    break;
                case 34:
                    event.preventDefault();
                    this.handlePageUpPageDownKey(true, shift);
                    break;
                case 35:
                    this.handleEndKey();
                    event.preventDefault();
                    break;
                case 36:
                    this.handleHomeKey();
                    event.preventDefault();
                    break;
                case 37:
                    this.handleLeftKey();
                    event.preventDefault();
                    break;
                case 38:
                    this.handleUpKey();
                    event.preventDefault();
                    break;
                case 39:
                    this.handleRightKey();
                    event.preventDefault();
                    break;
                case 40:
                    this.handleDownKey();
                    event.preventDefault();
                    break;
            }
        }
        if (this.isFormField() && !(this.documentHelper.isDocumentProtected)) {
            let formField = this.getCurrentFormField(true);
            if (formField && formField.formFieldData instanceof DropDownFormField) {
                formField = (key === 37 || key === 38 || key === 40) ? formField : formField.nextElement instanceof BookmarkElementBox ? formField.nextElement.reference : formField.fieldEnd;
                let index = key === 39 ? 1 : 0;
                let offset = formField.line.getOffset(formField, index);
                let point = this.getPhysicalPositionInternal(formField.line, offset, false);
                this.selectInternal(formField.line, formField, index, point);
            }
        }
        if (!this.owner.isReadOnlyMode || this.documentHelper.isCommentOnlyMode || this.isInlineFormFillMode() || (this.documentHelper.isDocumentProtected && this.documentHelper.protectionType === 'FormFieldsOnly' && this.documentHelper.owner.editor.canEditContentControl && !isNullOrUndefined(this.documentHelper.selection) && this.documentHelper.selection.checkContentControlLocked())) {
            this.owner.editorModule.onKeyDownInternal(event, ctrl, shift, alt);
        }
        else if (this.documentHelper.isDocumentProtected && this.documentHelper.protectionType === 'FormFieldsOnly') {
            if (key === 9 || key === 32) {
                this.owner.editorModule.onKeyDownInternal(event, ctrl, shift, alt);
            }
        }
        if (this.owner.searchModule) {
            if (!isNullOrUndefined(this.owner.searchModule.searchHighlighters) && this.owner.searchModule.searchHighlighters.length > 0) {
                this.owner.searchModule.searchResults.clear();
            }
        }
        if (key === 27) {
            if (!isNullOrUndefined(this.owner.optionsPaneModule)) {
                this.owner.optionsPaneModule.showHideOptionsPane(false);
                this.documentHelper.updateFocus();
            }
            if (this.owner.enableHeaderAndFooter) {
                this.disableHeaderFooter();
            }
        }
    }
    //#region Enable or disable Header Footer
    /**
     * @private
     */
    checkAndEnableHeaderFooter(point, pagePoint) {
        let page = this.documentHelper.currentPage;
        if (this.isCursorInsidePageRect(point, page)) {
            if (this.isCursorInHeaderRegion(point, page)) {
                if (this.owner.enableHeaderAndFooter) {
                    return false;
                }
                return this.enableHeadersFootersRegion(page.headerWidget, page);
            }
            if (this.isCursorInFooterRegion(point, page)) {
                if (this.owner.enableHeaderAndFooter) {
                    return false;
                }
                return this.enableHeadersFootersRegion(page.footerWidget, page);
            }
        }
        if (this.owner.enableHeaderAndFooter) {
            this.owner.enableHeaderAndFooter = false;
            this.documentHelper.updateTextPositionForSelection(pagePoint, 1);
            return true;
        }
        return false;
    }
    /**
     * @private
     */
    isCursorInsidePageRect(point, page) {
        if ((this.viewer.containerLeft + point.x) >= page.boundingRectangle.x &&
            (this.viewer.containerLeft + point.x) <= (page.boundingRectangle.x + (page.boundingRectangle.width * this.documentHelper.zoomFactor)) && this.viewer instanceof PageLayoutViewer) {
            return true;
        }
        else if ((this.viewer.containerLeft + point.x) >= page.boundingRectangle.x &&
            (this.viewer.containerLeft + point.x) <= (page.boundingRectangle.x + page.boundingRectangle.width)) {
            return true;
        }
        return false;
    }
    /**
     * @private
     */
    isCursorInHeaderRegion(point, page) {
        if (this.viewer instanceof PageLayoutViewer) {
            let pageTop = this.getPageTop(page);
            let headerHeight = 0;
            let header = page.headerWidget;
            if (header) {
                headerHeight = (header.y + header.height);
            }
            let isEmpty = header.isEmpty && !this.owner.enableHeaderAndFooter;
            let topMargin = HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.topMargin);
            let pageHeight = HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.pageHeight);
            let height = isEmpty ? topMargin : Math.min(Math.max(headerHeight, topMargin), (this.documentHelper.compatibilityMode === 'Word2013'
                && header.height + page.footerWidget.height < page.boundingRectangle.height / 100 * 80 ?
                page.boundingRectangle.height / 100 * 80 : pageHeight / 100 * 40));
            height = height * this.documentHelper.zoomFactor;
            if ((this.viewer.containerTop + point.y) >= pageTop && (this.viewer.containerTop + point.y) <= pageTop + height) {
                return true;
            }
        }
        return false;
    }
    /**
     * @private
     */
    isCursorInFooterRegion(point, page) {
        if (this.viewer instanceof PageLayoutViewer) {
            let pageRect = page.boundingRectangle;
            let pageTop = this.getPageTop(page);
            let pageBottom = pageTop + (pageRect.height * this.documentHelper.zoomFactor);
            let footerDistance = HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.footerDistance);
            let footerHeight = 0;
            if (page.footerWidget) {
                footerHeight = page.footerWidget.height;
            }
            let bottomMargin = HelperMethods.convertPointToPixel(page.bodyWidgets[0].sectionFormat.bottomMargin);
            let isEmpty = page.footerWidget.isEmpty && !this.owner.enableHeaderAndFooter;
            let height = pageRect.height;
            if (isEmpty) {
                height = (height - bottomMargin) * this.documentHelper.zoomFactor;
            }
            else {
                height = (height - Math.min(pageRect.height / 100 * 40, Math.max(footerHeight + footerDistance, bottomMargin))) * this.documentHelper.zoomFactor;
            }
            if ((this.viewer.containerTop + point.y) <= pageBottom && (this.viewer.containerTop + point.y) >= pageTop + height) {
                return true;
            }
        }
        return false;
    }
    /**
     * @private
     */
    enableHeadersFootersRegion(widget, page) {
        if (this.viewer instanceof PageLayoutViewer) {
            this.owner.enableHeaderAndFooter = true;
            widget.page = page;
            this.comparePageWidthAndMargins(widget, page);
            this.updateTextPositionForBlockContainer(widget);
            this.shiftBlockOnHeaderFooterEnableDisable();
            return true;
        }
        return false;
    }
    /**
    * Disable xml
    * @private
    */
    disableXml() {
        let page = this.getPage(this.start.paragraph);
        this.updateTextPositionForBlockContainer(page.bodyWidgets[0]);
        this.owner.enableHeaderAndFooter = false;
        this.shiftBlockOnHeaderFooterEnableDisable();
    }
    /**
     * /* Here is the explanation for the code below:
        1. When there are multiple sections in a document, the first section is the parent section of the other sections.
        2. If you change the page width or header distance of the parent section, the child section will inherit the page width or header distance of the parent section.
        3. So when you change the page width or header distance of the parent section, the child section should be relayouted.
     * @private
     */
    comparePageWidthAndMargins(parentHFWidget, page) {
        let headerFooterType = parentHFWidget.headerFooterType;
        let currentHFWidget;
        let isHeader = headerFooterType.indexOf('Header') != -1;
        let isRelayout = false;
        if (isHeader) {
            currentHFWidget = page.headerWidgetIn;
        }
        else {
            currentHFWidget = page.footerWidgetIn;
        }
        if (!isNullOrUndefined(currentHFWidget)) {
            const parentSectionFormat = parentHFWidget.sectionFormat;
            const currentSectionFormat = currentHFWidget.sectionFormat;
            if (!isNullOrUndefined(parentSectionFormat) && !isNullOrUndefined(currentSectionFormat)) {
                if (isHeader) {
                    if (parentHFWidget.width != currentHFWidget.width || parentSectionFormat.headerDistance != currentSectionFormat.headerDistance) {
                        isRelayout = true;
                    }
                }
                else {
                    if (parentHFWidget.width != currentHFWidget.width || parentSectionFormat.footerDistance != currentSectionFormat.footerDistance) {
                        isRelayout = true;
                    }
                }
            }
            if (isRelayout) {
                parentHFWidget.height = 0;
                this.documentHelper.layout.clearBlockWidget(parentHFWidget.childWidgets, false, true, true);
                this.owner.viewer.updateHFClientArea(parentHFWidget.sectionFormat, isHeader);
                parentHFWidget = this.documentHelper.layout.layoutHeaderFooterItems(this.owner.viewer, parentHFWidget);
            }
        }
    }
    /**
     * @private
     */
    shiftBlockOnHeaderFooterEnableDisable() {
        for (let i = 0; i < this.documentHelper.headersFooters.length; i++) {
            let headerFooter = this.documentHelper.headersFooters[i];
            let bodywidget = this.getBodyWidgetInternal(i, 0);
            if (isNullOrUndefined(bodywidget)) {
                continue;
            }
            let sectionFormat = bodywidget.sectionFormat;
            for (let key of Object.keys(headerFooter)) {
                let widget = headerFooter[key];
                if (widget.isEmpty) {
                    this.owner.editorModule.shiftPageContent(widget.headerFooterType, sectionFormat);
                }
            }
        }
    }
    /**
     * @private
     */
    updateTextPositionForBlockContainer(widget) {
        let block = widget.firstChild;
        if (block instanceof TableWidget) {
            block = this.getFirstBlockInFirstCell(block);
            if (block instanceof TableWidget) {
                block = this.getFirstBlockInFirstCell(block);
            }
        }
        this.selectParagraphInternal(block, true);
    }
    getPageStartEndPosition(page) {
        const firstBodyWidget = page.bodyWidgets[0];
        const lastBodyWidget = page.bodyWidgets[page.bodyWidgets.length - 1];
        // Updating the start and end based on the page.
        if (firstBodyWidget && lastBodyWidget) {
            let startPosition = new TextPosition(this.owner);
            let endPosition = new TextPosition(this.owner);
            let firstBlock = firstBodyWidget.firstChild;
            let lastBlock = lastBodyWidget.lastChild;
            if (firstBlock && lastBlock) {
                if (firstBlock instanceof TableWidget) {
                    firstBlock = this.getFirstBlockInFirstCell(firstBlock);
                    while (firstBlock instanceof TableWidget) {
                        firstBlock = this.getFirstBlockInFirstCell(firstBlock);
                    }
                }
                let line = firstBlock.firstChild;
                startPosition.setPosition(line, true);
                if (lastBlock instanceof TableWidget) {
                    lastBlock = this.getLastBlockInLastCell(lastBlock, true);
                    while (lastBlock instanceof TableWidget) {
                        lastBlock = this.getLastBlockInLastCell(lastBlock, true);
                    }
                }
                line = lastBlock.lastChild;
                let endOffset = line.getEndOffset();
                endPosition.setPositionParagraph(line, endOffset);
                return { startPosition, endPosition };
            }
        }
        return undefined;
    }
    /**
     * Disable Header footer
     * @private
     */
    disableHeaderFooter() {
        let page = this.getPage(this.start.paragraph);
        this.updateTextPositionForBlockContainer(page.bodyWidgets[0]);
        this.owner.enableHeaderAndFooter = false;
        this.shiftBlockOnHeaderFooterEnableDisable();
    }
    //#endregion
    /**
     * @private
     * @returns {void}
     */
    clear() {
        if (this.editRegionHighlighters) {
            this.editRegionHighlighters.clear();
        }
        this.editRangeCollection = [];
        if (this.selectedWidgets) {
            this.selectedWidgets.clear();
        }
        if (this.contentControleditRegionHighlighters) {
            this.contentControleditRegionHighlighters.clear();
        }
        this.contentControls = [];
        this.currentContentControl = undefined;
    }
    /**
     * @private
     * @returns {void}
     */
    destroy() {
        if (!isNullOrUndefined(this.contextTypeInternal)) {
            this.contextTypeInternal = undefined;
        }
        if (this.pasteDropDwn) {
            this.pasteDropDwn.destroy();
            this.pasteDropDwn = undefined;
        }
        this.caret = undefined;
        this.contextTypeInternal = undefined;
        this.upDownSelectionLength = undefined;
        this.owner = undefined;
        this.upDownSelectionLength = undefined;
        this.isSkipLayouting = undefined;
        this.isImageSelected = undefined;
        if (!isNullOrUndefined(this.documentHelper)) {
            this.documentHelper = undefined;
        }
        this.contextTypeInternal = undefined;
        this.isRetrieveFormatting = undefined;
        if (this.characterFormatIn) {
            this.characterFormatIn.destroy();
        }
        this.characterFormatIn = undefined;
        if (this.paragraphFormatIn) {
            this.paragraphFormatIn.destroy();
        }
        this.paragraphFormatIn = undefined;
        if (this.sectionFormatIn) {
            this.sectionFormatIn.destroy();
        }
        this.sectionFormatIn = undefined;
        if (this.tableFormatIn) {
            this.tableFormatIn.destroy();
        }
        this.tableFormatIn = undefined;
        if (this.cellFormatIn) {
            this.cellFormatIn.destroy();
        }
        this.cellFormatIn = undefined;
        if (this.rowFormatIn) {
            this.rowFormatIn.destroy();
        }
        this.rowFormatIn = undefined;
        this.imageFormatInternal = undefined;
        this.skipFormatRetrieval = undefined;
        this.startInternal = undefined;
        this.endInternal = undefined;
        this.htmlWriterIn = undefined;
        this.toolTipElement = undefined;
        if (!isNullOrUndefined(this.toolTipObject)) {
            this.toolTipObject.destroy();
        }
        this.toolTipField = undefined;
        this.isMoveDownOrMoveUp = undefined;
        this.pasteElement = undefined;
        this.currentPasteAction = undefined;
        this.isViewPasteOptions = undefined;
        this.skipEditRangeRetrieval = undefined;
        this.editPosition = undefined;
        if (!isNullOrUndefined(this.selectedWidgets)) {
            this.selectedWidgets.destroy();
        }
        this.isHighlightEditRegionIn = undefined;
        this.isHighlightFormFields = undefined;
        this.editRangeCollection = [];
        this.editRangeCollection = undefined;
        this.isHightlightEditRegionInternal = undefined;
        this.isCurrentUser = undefined;
        this.isHighlightNext = undefined;
        this.hightLightNextParagraph = undefined;
        this.isWebLayout = undefined;
        if (!isNullOrUndefined(this.editRegionHighlighters)) {
            this.editRegionHighlighters.destroy();
        }
        if (!isNullOrUndefined(this.formFieldHighlighters)) {
            this.formFieldHighlighters.destroy();
        }
        if (!isNullOrUndefined(this.contentControleditRegionHighlighters)) {
            this.contentControleditRegionHighlighters.destroy();
        }
        this.isCellPrevSelected = undefined;
        this.currentFormField = undefined;
        this.contentControls = [];
        this.editRangeCachePage = [];
    }
    /**
     * Returns the cells in between the bounds.
     * @param table Specify the table to find cells.
     * @param columnFirst Specify start index of column to find cells.
     * @param columnLast Specify end index of column to find cells.
     * @param bookmark Specify the bookmark element.
     */
    getCellsToSelect(table, columnFirst, columnLast, bookmark) {
        let rows = table.childWidgets;
        if (isNullOrUndefined(bookmark.paragraph.associatedCell) || !isNullOrUndefined(bookmark.reference) && isNullOrUndefined(bookmark.reference.paragraph.associatedCell)) {
            return undefined;
        }
        let startRowIndex = bookmark.paragraph.associatedCell.ownerRow.rowIndex;
        let endRowIndex = bookmark.reference.paragraph.associatedCell.ownerRow.rowIndex;
        let cellArray = [];
        for (let i = startRowIndex; i <= endRowIndex; i++) {
            let row = rows[i];
            for (let j = columnFirst; j <= columnLast; j++) {
                let cell = row.childWidgets[j];
                if (!isNullOrUndefined(cell)) {
                    cellArray.push(cell);
                }
            }
        }
        return cellArray;
    }
    /**
     * Selects the cells between bookmark start and end.
     * @param bookmark Specify the bookmark.
     */
    selectBookmarkInTable(bookmark) {
        this.documentHelper.clearSelectionHighlight();
        let columnFirst = parseInt(bookmark.properties['columnFirst']);
        let columnLast = parseInt(bookmark.properties['columnLast']);
        let table = bookmark.paragraph.associatedCell.ownerTable;
        let cellArray = this.getCellsToSelect(table, columnFirst, columnLast, bookmark);
        if (!isNullOrUndefined(cellArray)) {
            for (let i = 0; i < cellArray.length; i++) {
                this.highlightCellWidget(cellArray[i]);
            }
        }
    }
    /**
     * Navigates to the specified bookmark.
     * @param name
     * @param moveToStart
     * @param excludeBookmarkStartEnd
     * @private
     */
    navigateBookmark(name, moveToStart, excludeBookmarkStartEnd) {
        if (this.documentHelper.isDocumentLoadAsynchronously) {
            return;
        }
        let bookmarks = this.documentHelper.bookmarks;
        if (bookmarks.containsKey(name)) {
            //bookmark start element
            let bookmrkElmnt = bookmarks.get(name);
            if (!isNullOrUndefined(bookmrkElmnt.properties)) {
                this.selectBookmarkInTable(bookmrkElmnt);
            }
            else {
                let offset = bookmrkElmnt.line.getOffset(bookmrkElmnt, 0);
                if (excludeBookmarkStartEnd) {
                    offset++;
                }
                let startPosition = new TextPosition(this.owner);
                startPosition.setPositionParagraph(bookmrkElmnt.line, offset);
                if (moveToStart) {
                    this.documentHelper.selection.selectRange(startPosition, startPosition, true);
                }
                else {
                    //bookmark end element
                    let bookmrkEnd = bookmrkElmnt.reference;
                    if (bookmrkElmnt.reference && bookmrkElmnt.reference.line.paragraph.bodyWidget == null) {
                        bookmrkEnd = bookmrkElmnt;
                    }
                    let endoffset = bookmrkEnd.line.getOffset(bookmrkEnd, 1);
                    if (bookmrkEnd instanceof BookmarkElementBox && !excludeBookmarkStartEnd) {
                        if (!isNullOrUndefined(bookmrkEnd.properties)) {
                            if (bookmrkEnd.properties['isAfterParagraphMark']) {
                                endoffset = bookmrkEnd.line.getOffset(bookmrkEnd, 2);
                            }
                        }
                    }
                    if (excludeBookmarkStartEnd) {
                        endoffset--;
                    }
                    let endPosition = new TextPosition(this.owner);
                    endPosition.setPositionParagraph(bookmrkEnd.line, endoffset);
                    //selects the bookmark range
                    this.documentHelper.selection.selectRange(startPosition, endPosition, true);
                }
            }
        }
        else {
            this.moveToDocumentStart();
        }
    }
    /**
     * Selects the specified bookmark.
     * @param name Specify the bookmark name to select.
     * @param excludeBookmarkStartEnd Specify true to exclude bookmark start and end from selection, otherwise false.
     */
    selectBookmark(name, excludeBookmarkStartEnd) {
        this.isSelectBookmark = true;
        this.isExcludeBookmarkStartEnd = excludeBookmarkStartEnd;
        this.navigateBookmark(name, undefined, excludeBookmarkStartEnd);
        this.isSelectBookmark = false;
    }
    /**
     * Returns the toc field from the selection.
     * @private
     */
    getTocField() {
        let paragraph = this.start.paragraph;
        let tocPara = undefined;
        while ((paragraph !== undefined && this.isTocStyle(paragraph))) {
            tocPara = paragraph;
            paragraph = paragraph.previousRenderedWidget;
        }
        if (tocPara !== undefined) {
            let lineWidget = tocPara.childWidgets[0];
            if (lineWidget !== undefined) {
                return lineWidget.children[0];
            }
        }
        return undefined;
    }
    /**
     * Returns true if the paragraph has toc style.
     */
    isTocStyle(paragraph) {
        let style = paragraph.paragraphFormat.baseStyle;
        return (style !== undefined && (style.name.toLowerCase().indexOf('toc') !== -1));
    }
    /**
     * Return true if selection is in TOC
     * @private
     */
    isTOC() {
        let info = this.getParagraphInfo(this.start);
        let para = info.paragraph;
        for (let i = 0; i < para.childWidgets[0].children.length; i++) {
            let element = para.childWidgets[0].children[i];
            if (element instanceof FieldElementBox) {
                let fieldCode = this.owner.selectionModule.getFieldCode(element);
                if (fieldCode.match('TOC ') || fieldCode.match('Toc')) {
                    return true;
                }
            }
            else {
                continue;
            }
        }
        return false;
    }
    /**
     * @private
     */
    getElementsForward(lineWidget, startElement, endElement, bidi) {
        if (isNullOrUndefined(startElement)) {
            return undefined;
        }
        let elements = [];
        // while (bidi && startElement && startElement !== endElement && startElement.nextElement && !startElement.isRightToLeft) {
        //     startElement = startElement.nextElement;
        // }
        // while (bidi && endElement && startElement !== endElement && endElement.previousElement && !endElement.isRightToLeft) {
        //     endElement = endElement.previousElement;
        // }
        let elementIndex = lineWidget.children.indexOf(startElement);
        while (elementIndex >= 0) {
            for (let i = elementIndex; i < lineWidget.children.length; i++) {
                let inlineElement = lineWidget.children[i];
                if (inlineElement.line === lineWidget) {
                    if (inlineElement === endElement) {
                        elements.push(inlineElement);
                        elementIndex = -1;
                        break;
                    }
                    else {
                        elements.push(inlineElement);
                    }
                }
                else {
                    elementIndex = -1;
                    break;
                }
            }
            // inline = inline !== null && inline.NextNode !== null ? (inline.NextNode as Inline).GetNextRenderedInline() : null;
            elementIndex = -1;
        }
        return elements.length === 0 ? undefined : elements;
    }
    // Gets the current line elements in inline reverse order from the end element.
    /**
     * @private
     */
    getElementsBackward(lineWidget, startElement, endElement, bidi) {
        let elements = [];
        while (bidi && startElement && startElement.previousElement && (!startElement.isRightToLeft
            || startElement instanceof TextElementBox && this.documentHelper.textHelper.isRTLText(startElement.text))) {
            startElement = startElement.previousElement;
        }
        let elementIndex = lineWidget.children.indexOf(startElement);
        while (elementIndex >= 0) {
            for (let i = elementIndex; i > -1 && i < lineWidget.children.length; bidi ? i++ : i--) {
                let inlineElement = lineWidget.children[i];
                if (inlineElement.line === lineWidget) {
                    elements.push(inlineElement);
                    if (inlineElement === endElement) {
                        elementIndex = -1;
                        break;
                    }
                }
                else {
                    elementIndex = -1;
                    break;
                }
            }
            // inline = inline !== null && inline.NextNode !== null ? (inline.NextNode as Inline).GetNextRenderedInline() : null;
            elementIndex = -1;
        }
        return elements;
    }
    /**
     * Navigates to the previous comment in the document.
     *
     * @returns {void}
     */
    navigatePreviousComment() {
        this.commentNavigateInternal(false);
    }
    /**
     * Navigates to the next comment in the document.
     *
     * @returns {void}
     */
    navigateNextComment() {
        this.commentNavigateInternal(true);
    }
    commentNavigateInternal(next) {
        if (!this.documentHelper.currentSelectedComment) {
            if (this.documentHelper.comments.length === 0) {
                return;
            }
            this.documentHelper.currentSelectedComment = this.documentHelper.comments[0];
        }
        if (this.documentHelper.currentSelectedComment) {
            let comments = this.documentHelper.comments;
            let comment = this.documentHelper.currentSelectedComment;
            let index = comments.indexOf(comment);
            if (next) {
                comment = (index === (comments.length - 1)) ? comments[0] : comments[index + 1];
            }
            else {
                comment = index === 0 ? comments[comments.length - 1] : comments[index - 1];
            }
            this.documentHelper.currentSelectedComment = comment;
            this.selectComment(comment);
        }
    }
    /**
     * Navigates to the previous revision in the document.
     *
     * @returns {void}
     */
    navigatePreviousRevision() {
        this.revisionNavigateInternal(false);
    }
    /**
     * Navigates to the next revision in the document.
     *
     * @returns {void}
     */
    navigateNextRevision() {
        this.revisionNavigateInternal(true);
    }
    /**
     * Method to navigate revisions
     *
     * @private
     * @returns {void}
     */
    revisionNavigateInternal(next) {
        if (!this.documentHelper.currentSelectedRevisionInternal) {
            if (this.documentHelper.owner.revisions.length === 0) {
                return;
            }
            this.documentHelper.currentSelectedRevision = this.documentHelper.owner.revisions.get(0);
        }
        if (this.documentHelper.currentSelectedRevision) {
            let revisions = this.documentHelper.owner.revisions.changes;
            let revision = this.documentHelper.currentSelectedRevision;
            let index = revisions.indexOf(revision);
            if (next) {
                revision = (index === (revisions.length - 1)) ? revisions[0] : revisions[index + 1];
            }
            else {
                revision = index === 0 ? revisions[revisions.length - 1] : revisions[index - 1];
            }
            this.documentHelper.currentSelectedRevision = revision;
            this.selectRevision(revision);
        }
        this.owner.trackChangesPane.currentSelectedRevision = this.documentHelper.currentSelectedRevision;
    }
    /**
     * @private
     * @returns {void}
     */
    selectComment(comment) {
        if (!isNullOrUndefined(comment)) {
            let startPosition = this.getElementPosition(comment.commentStart, true).startPosition;
            let endPosition = this.getElementPosition(comment.commentEnd, false).startPosition;
            if (this.owner.commentReviewPane) {
                this.owner.commentReviewPane.selectComment(comment);
            }
            this.selectPosition(startPosition, endPosition);
        }
    }
    getGroupedRevision(revision) {
        if (this.owner.trackChangesPane) {
            if (this.owner.trackChangesPane.changes.containsKey(revision)) {
                return this.owner.revisions.groupedView.get(this.owner.trackChangesPane.changes.get(revision));
            }
        }
        return [revision];
    }
    /**
     * @private
     * @param revision
     * @returns {void}
     */
    selectRevision(revision, startPosition, endPosition, skipGroupSelect, isAcceptOrReject, isAccept) {
        let isSelect = false;
        if (isNullOrUndefined(startPosition) && isNullOrUndefined(endPosition)) {
            isSelect = true;
        }
        if (!isNullOrUndefined(revision) && revision.getRange(true).length > 0) {
            let firstElement = revision.getRange(false)[0];
            let lastElement = revision.getRange(false)[revision.getRange(false).length - 1];
            let groupedRevision = this.getGroupedRevision(revision);
            if (!skipGroupSelect) {
                let firstRevision = groupedRevision[0];
                let lastRevision = groupedRevision[groupedRevision.length - 1];
                firstElement = firstRevision.getRange(false)[0];
                lastElement = lastRevision.getRange(false)[lastRevision.getRange(false).length - 1];
                if (firstElement instanceof WRowFormat) {
                    this.selectTableRevision(groupedRevision);
                    return false;
                }
            }
            let paragraph;
            if (firstElement instanceof WCharacterFormat) {
                paragraph = firstElement.ownerBase;
            }
            else if (!(firstElement instanceof WRowFormat)) {
                paragraph = firstElement.line.paragraph;
            }
            if (!isNullOrUndefined(paragraph)) {
                let bodyWidget = paragraph.bodyWidget;
                let rangeIndex = 0;
                //Added code to remove the revision from the item because in this case (BUG_891413_1) the revision is not removed from the item even though contents are removed in the DOM.
                // The reason for revision not removed from the item is, in header footer widget the LinkToPrevious was enabled so the continuous pages contents are linked with eachother.
                //(For Example) When the first page footer revision(Delete revision) was accepted it was also reflected in the second page. Due to this the content in the both pages are removed but revision is not removed in the second page. 
                if (!isNullOrUndefined(bodyWidget) && bodyWidget instanceof HeaderFooterWidget && (isNullOrUndefined(bodyWidget.page) || (!isNullOrUndefined(bodyWidget.page) && bodyWidget.page.index === -1))) {
                    if (isAcceptOrReject) {
                        this.owner.editorModule.initHistory(isAccept ? 'Accept Change' : 'Reject Change');
                        for (let i = 0; i < groupedRevision.length; i++) {
                            let revision = groupedRevision[i];
                            while (revision.getRange().length > 0) {
                                if (revision.getRange()[rangeIndex] instanceof ElementBox || revision.getRange()[rangeIndex] instanceof WCharacterFormat || revision.getRange()[rangeIndex] instanceof WRowFormat) {
                                    if (revision.getRange()[rangeIndex] instanceof BookmarkElementBox && revision.revisionType === 'Deletion') {
                                        let inline = revision.getRange()[rangeIndex];
                                        if (this.owner.documentHelper.bookmarks.containsKey(inline.name)) {
                                            this.owner.documentHelper.bookmarks.remove(inline.name);
                                        }
                                    }
                                    const moveToNextItem = revision.unlinkRangeItem(revision.getRange()[rangeIndex], revision, true, this.start, this.end);
                                    if (moveToNextItem) {
                                        rangeIndex++;
                                    }
                                    else {
                                        rangeIndex = 0;
                                    }
                                }
                                else {
                                    break;
                                }
                            }
                            i--;
                        }
                        if (!isNullOrUndefined(this.owner.editorHistory) && !isNullOrUndefined(this.owner.editorHistory.currentHistoryInfo) && (this.owner.editorHistory.currentHistoryInfo.action === 'Accept All' || this.owner.editorHistory.currentHistoryInfo.action === 'Reject All')) {
                            this.owner.editorHistory.currentHistoryInfo.insertPosition = this.owner.selection.startOffset;
                            this.owner.editorHistory.currentHistoryInfo.endPosition = this.owner.selection.endOffset;
                        }
                    }
                    return true;
                }
            }
            if (firstElement instanceof WRowFormat) {
                let rowWidget = firstElement.ownerBase;
                let firstCell = rowWidget.childWidgets[0];
                let lastCell = rowWidget.childWidgets[rowWidget.childWidgets.length - 1];
                let firstPara = this.getFirstParagraph(firstCell);
                let lastPara = this.getLastParagraph(lastCell);
                this.start.setPosition(firstPara.firstChild, true);
                this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                this.selectPosition(this.start, this.end, true);
            }
            else if (firstElement && lastElement) {
                if (isNullOrUndefined(startPosition)) {
                    startPosition = new TextPosition(this.owner);
                }
                let offset = 0;
                if (firstElement instanceof WCharacterFormat) {
                    let currentPara = firstElement.ownerBase;
                    // Set the offset based on length of para - length of remaning lines except last line because we have added the remaning line length in getParagraphInfoInternal method.
                    //when we have add para length to the offset, again added the length of remaning lines except last line in getParagraphInfoInternal method. so when perform undo, the offset is greater than para length + 1. in this case, we set the para length to start and end offset, so paramark doesn't comes to selection region (undo case for splitted para but paramark only tracked).
                    if (currentPara.childWidgets.length > 1) {
                        offset = this.getParagraphLength(currentPara) - this.getParagraphLength(currentPara, currentPara.lastChild);
                    }
                    else {
                        // added the condition to set offset to paragraph start when para without contain text elements.
                        if (this.isEmptyWidget(currentPara)) {
                            offset = 0;
                        }
                        else {
                            offset = currentPara.getLength();
                        }
                    }
                    startPosition.setPositionParagraph(currentPara.lastChild, offset);
                }
                else {
                    offset = firstElement.line.getOffset(firstElement, 0);
                    startPosition.setPositionForLineWidget(firstElement.line, offset);
                }
                if (isNullOrUndefined(endPosition)) {
                    endPosition = new TextPosition(this.owner);
                }
                if (lastElement instanceof WCharacterFormat) {
                    let currentPara = lastElement.ownerBase;
                    const splittedWidgets = currentPara.getSplitWidgets();
                    currentPara = splittedWidgets[splittedWidgets.length - 1];
                    // Changed the condition to get last child of current paragraph instead of next para of current para if current para contain page break
                    if (currentPara.childWidgets.length > 1) {
                        offset = this.getParagraphLength(currentPara) - this.getParagraphLength(currentPara, currentPara.lastChild);
                    }
                    else {
                        offset = currentPara.getLength();
                    }
                    endPosition.setPositionParagraph(currentPara.lastChild, offset + 1);
                }
                else if (lastElement instanceof ElementBox) {
                    offset = lastElement.line.getOffset(lastElement, 0) + lastElement.length;
                    endPosition.setPositionForLineWidget(lastElement.line, offset);
                }
                let curentPosition = startPosition.clone();
                if (!startPosition.isExistBefore(endPosition)) {
                    startPosition = endPosition;
                    endPosition = curentPosition;
                }
                if (isSelect) {
                    this.selectPosition(startPosition, endPosition, true);
                }
            }
        }
        return false;
    }
    isEmptyWidget(block) {
        if (block instanceof TableWidget) {
            return false;
        }
        else if (block.isEmpty()) {
            return true;
        }
        else {
            for (let i = 0; i < block.childWidgets.length; i++) {
                let line = block.childWidgets[i];
                for (let j = 0; j < line.children.length; j++) {
                    if (line.children[j] instanceof TextElementBox) {
                        return false;
                    }
                }
            }
            return true;
        }
    }
    /**
     * @private
     */
    selectTableRevision(revision) {
        if (!isNullOrUndefined(revision) && revision[0].getRange(false).length > 0) {
            let firstElementTable = revision[0].getRange(false)[0];
            let table = firstElementTable.ownerBase.ownerTable.getSplitWidgets()[0];
            if (firstElementTable instanceof WRowFormat) {
                let rowFormats = this.getConsecutiveRevisionsFromSameTable(revision, table);
                let firstRowWidget = rowFormats[0].ownerBase;
                let lastRowWidget = rowFormats[rowFormats.length - 1].ownerBase;
                let firstCell = firstRowWidget.childWidgets[0];
                let lastCell = lastRowWidget.childWidgets[lastRowWidget.childWidgets.length - 1];
                let firstPara = this.getFirstParagraph(firstCell);
                let lastPara = this.getLastParagraph(lastCell);
                this.start.setPosition(firstPara.firstChild, true);
                this.end.setPositionParagraph(lastPara.lastChild, lastPara.lastChild.getEndOffset() + 1);
                this.selectPosition(this.start, this.end, true);
            }
        }
    }
    getConsecutiveRevisionsFromSameTable(revisions, table) {
        return revisions.reduce((result, revision) => {
            const range = revision.getRange(false);
            if (range.length > 0) {
                const firstElement = range[0];
                if (firstElement instanceof WRowFormat) {
                    if (firstElement.ownerBase.ownerTable.getSplitWidgets()[0] === table) {
                        result.push(firstElement);
                    }
                }
            }
            return result;
        }, []);
    }
    /**
     * @private
     * @returns {void}
     */
    updateEditRangeCollection() {
        if (this.editRangeCollection.length > 0) {
            this.editRangeCollection = [];
        }
        let editRangeStart;
        let everyOneArea;
        if (!this.documentHelper.isDocumentProtected) {
            for (let i = 0; i < this.documentHelper.editRanges.length; i++) {
                let user = this.documentHelper.editRanges.keys[i];
                editRangeStart = this.documentHelper.editRanges.get(user);
                for (let j = 0; j < editRangeStart.length; j++) {
                    if (!isNullOrUndefined(editRangeStart[j].editRangeEnd)) {
                        this.editRangeCollection.push(editRangeStart[j]);
                    }
                }
            }
        }
        else {
            if (this.documentHelper.editRanges.containsKey(this.owner.currentUser)) {
                editRangeStart = this.documentHelper.editRanges.get(this.owner.currentUser);
                for (let j = 0; j < editRangeStart.length; j++) {
                    if (!isNullOrUndefined(editRangeStart[j].editRangeEnd)) {
                        this.editRangeCollection.push(editRangeStart[j]);
                    }
                }
            }
            if (this.documentHelper.editRanges.containsKey('Everyone')) {
                let user = 'Everyone';
                everyOneArea = this.documentHelper.editRanges.get(user);
                for (let j = 0; j < everyOneArea.length; j++) {
                    if (!isNullOrUndefined(everyOneArea[j].editRangeEnd)) {
                        this.editRangeCollection.push(everyOneArea[j]);
                    }
                }
            }
        }
    }
    //Restrict editing implementation starts
    /**
     * @private
     * @returns {void}
     */
    onHighlight() {
        if (this.isHighlightEditRegion) {
            this.highlightEditRegion();
        }
        else {
            this.unHighlightEditRegion();
            this.viewer.renderVisiblePages();
        }
    }
    //Restrict editing implementation starts
    /**
     * @private
     * @returns {void}
     */
    onHighlightContentControl() {
        if (this.isHighlightContentControlEditRegion) {
            if (this.documentHelper.contentControlCollection.length > 0) {
                for (let i = 0; i < this.documentHelper.contentControlCollection.length; i++) {
                    if (this.documentHelper.contentControlCollection[i].paragraph.isInHeaderFooter && this.documentHelper.owner.layoutType === "Continuous") {
                        continue;
                    }
                    if (this.documentHelper.contentControlCollection[i].line.paragraph.bodyWidget.page
                        && this.documentHelper.contentControlCollection[i].line.paragraph.bodyWidget.page.documentHelper) {
                        this.highlightContentControlEditRegionInternal(this.documentHelper.contentControlCollection[i]);
                    }
                }
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    highlightContentControlEditRegionInternal(editRangeStart) {
        let positionInfo = this.getPosition(editRangeStart, true);
        if (!isNullOrUndefined(positionInfo.startPosition) && !isNullOrUndefined(positionInfo.endPosition)) {
            let startPosition = positionInfo.startPosition;
            let endPosition = positionInfo.endPosition;
            this.highlight(editRangeStart.line.paragraph, startPosition, endPosition, editRangeStart);
            let currentParagraph = editRangeStart.line.paragraph;
            while (currentParagraph !== endPosition.paragraph) {
                if (currentParagraph.nextRenderedWidget instanceof ParagraphWidget) {
                    currentParagraph = currentParagraph.nextRenderedWidget;
                    this.highlight(currentParagraph, startPosition, endPosition, editRangeStart);
                }
                else {
                    return;
                }
            }
        }
    }
    /**
     * @private
     * @returns {void}
     */
    selectPlaceHolderText(contentControl) {
        if (contentControl.contentControlProperties && contentControl.contentControlProperties.hasPlaceHolderText && (contentControl.contentControlProperties.type === 'RichText' || contentControl.contentControlProperties.type === 'Text')) {
            this.selectContentControlInternal(contentControl);
        }
    }
    /**
     * @private
     * @returns {void}
     */
    isPlainContentControl() {
        let contentControl = this.owner.editorModule.getContentControl();
        if (contentControl && contentControl.contentControlProperties && (contentControl.contentControlProperties.type === 'Text' || contentControl.contentControlProperties.lockContents)) {
            return true;
        }
        return false;
    }
    /**
     * @private
     * @returns {void}
     */
    updateEditRegionByPage(page) {
        // The logic used here is when the page comes to render for the the first time we will push it on the collection.
        // Then we we will check is the editregionstart and editregionend is present in the page then we will update the selection.
        // Also if a edit region has multiple page then we will iterate the blocks and update selection. So that it won't affect the performance. 
        // If any content inserted then will clear the cache pages. So that it will update only for that page. So that performance won't be affected.
        // Finally if a page comes for multiple time to update edit region then we will check the page in the collection if yes then we will return it. 
        if (!this.isHighlightEditRegion || this.documentHelper.editRanges.length === 0) {
            return;
        }
        if (this.editRangeCachePage.indexOf(page) >= 0) {
            return;
        }
        else {
            this.editRangeCachePage.push(page);
        }
        this.updateEditRangeCollection();
        let editRangeCollection = [];
        let headerEditRangeCollection = [];
        let editRangePage = undefined;
        if (this.editRangeCollection.length > 0) {
            // Converting the page into start and end position.
            let pagePostionInfo = this.getPageStartEndPosition(page);
            if (pagePostionInfo) {
                for (let i = 0; i < this.editRangeCollection.length; i++) {
                    const startElement = this.editRangeCollection[i];
                    if (startElement && startElement.line && startElement.line.paragraph && startElement.line.paragraph.bodyWidget instanceof HeaderFooterWidget) {
                        headerEditRangeCollection.push(startElement);
                    }
                    else if (startElement && startElement.editRangeEnd && isNullOrUndefined(editRangePage)) {
                        // Gets the edit range start and end position.
                        let positionInfo = this.getPosition(startElement, true);
                        if (positionInfo.startPosition && positionInfo.endPosition) {
                            let editRangeStart = positionInfo.startPosition;
                            let editRangeEnd = positionInfo.endPosition;
                            let pageStart = pagePostionInfo.startPosition;
                            let pageEnd = pagePostionInfo.endPosition;
                            // Check is the page needs to update completely.
                            const isPageStartAfter = pageStart.isExistAfter(editRangeStart);
                            const isPageEndBefore = pageEnd.isExistBefore(editRangeEnd);
                            if (isPageStartAfter && isPageEndBefore) {
                                editRangePage = startElement;
                                editRangeCollection = [];
                            }
                            else if (!((isPageStartAfter && pageStart.isExistAfter(editRangeEnd)) ||
                                (pageEnd.isExistBefore(editRangeStart) && isPageEndBefore))) {
                                // Only edit range start or end is present inside the page then need to update it.
                                editRangeCollection.push(startElement);
                            }
                        }
                    }
                }
            }
            else {
                editRangeCollection = this.editRangeCollection;
            }
        }
        this.isHightlightEditRegionInternal = true;
        if (isNullOrUndefined(this.editRegionHighlighters)) {
            this.editRegionHighlighters = new Dictionary();
        }
        if (!isNullOrUndefined(editRangePage)) {
            // Updating the whole page.
            let positionInfo = this.getPosition(editRangePage);
            let startPosition = positionInfo.startPosition;
            let endPosition = positionInfo.endPosition;
            this.isCurrentUser = true;
            for (let i = 0; i < page.bodyWidgets.length; i++) {
                const bodyWidget = page.bodyWidgets[i];
                for (let j = 0; j < bodyWidget.childWidgets.length; j++) {
                    const block = bodyWidget.childWidgets[j];
                    if (block instanceof ParagraphWidget) {
                        this.highlight(block, startPosition, endPosition);
                    }
                    else if (block instanceof TableWidget) {
                        this.highlightTable(block, startPosition, endPosition);
                    }
                }
            }
            this.isHighlightNext = false;
            this.hightLightNextParagraph = undefined;
            this.isCurrentUser = false;
        }
        else {
            for (let j = 0; j < editRangeCollection.length; j++) {
                this.highlightEditRegionInternal(editRangeCollection[j]);
            }
        }
        // By default whole header footer editrange will be updated because we can't check based on the selection.
        for (let j = 0; j < headerEditRangeCollection.length; j++) {
            this.highlightEditRegionInternal(headerEditRangeCollection[j]);
        }
        this.isHightlightEditRegionInternal = false;
    }
    /**
     * @private
     * @returns {void}
     */
    highlightEditRegion() {
        if (this.owner.enableLockAndEdit) {
            this.viewer.updateScrollBars();
            return;
        }
        if (!this.isHighlightEditRegion) {
            this.unHighlightEditRegion();
            this.viewer.updateScrollBars();
            return;
        }
        if (isNullOrUndefined(this.editRegionHighlighters)) {
            this.editRegionHighlighters = new Dictionary();
        }
        this.editRegionHighlighters.clear();
        // When editing the page need to clear the page. so that it will be update again currently visible page. 
        this.editRangeCachePage = [];
        this.viewer.updateScrollBars();
    }
    /**
     * @private
     * @returns {void}
     */
    highlightFormFields() {
        if (isNullOrUndefined(this.formFieldHighlighters)) {
            this.formFieldHighlighters = new Dictionary();
        }
        this.formFieldHighlighters.clear();
        let formFields = this.documentHelper.formFields;
        if (!isNullOrUndefined(formFields) && formFields.length > 0) {
            for (let i = 0; i < formFields.length; i++) {
                let formField = formFields[i];
                if (HelperMethods.isLinkedFieldCharacter(formField)) {
                    let offset = formField.line.getOffset(formField, 0);
                    let startPosition = new TextPosition(this.owner);
                    startPosition.setPositionParagraph(formField.line, offset);
                    let endElement = formField.fieldEnd;
                    offset = endElement.line.getOffset(endElement, 1);
                    let endPosition = new TextPosition(this.owner);
                    endPosition.setPositionParagraph(endElement.line, offset);
                    this.isHighlightFormFields = true;
                    this.highlight(startPosition.paragraph, startPosition, endPosition);
                    if (this.isHighlightNext) {
                        this.highlightNextBlock(this.hightLightNextParagraph, startPosition, endPosition);
                        this.isHighlightNext = false;
                        this.hightLightNextParagraph = undefined;
                    }
                }
            }
            this.isHighlightFormFields = false;
            this.viewer.updateScrollBars();
        }
    }
    /**
     * @private
     * @returns {void}
     */
    unHighlightEditRegion() {
        if (!isNullOrUndefined(this.editRegionHighlighters)) {
            this.editRegionHighlighters.clear();
            this.editRegionHighlighters = undefined;
        }
        this.isHightlightEditRegionInternal = false;
    }
    /**
     * @private
     * @returns {void}
     */
    highlightEditRegionInternal(editRangeStart) {
        let positionInfo = this.getPosition(editRangeStart);
        let startPosition = positionInfo.startPosition;
        let endPosition = positionInfo.endPosition;
        // if (editRangeStart.user === this.owner.currentUser && editRangeStart.group === '') {
        this.isCurrentUser = true;
        // }
        this.highlightEditRegions(editRangeStart, startPosition, endPosition);
        this.isCurrentUser = false;
    }
    /**
     * Shows all the editing region, where current user can edit.
     *
     * @returns {void}
     */
    showAllEditingRegion() {
        if (this.editRangeCollection.length === 0) {
            this.updateEditRangeCollection();
        }
        this.documentHelper.clearSelectionHighlight();
        for (let j = 0; j < this.editRangeCollection.length; j++) {
            let editRangeStart = this.editRangeCollection[j];
            let positionInfo = this.getPosition(editRangeStart);
            let startPosition = positionInfo.startPosition;
            let endPosition = positionInfo.endPosition;
            this.highlightEditRegions(editRangeStart, startPosition, endPosition);
        }
    }
    highlightEditRegions(editRangeStart, startPosition, endPosition) {
        if (!editRangeStart.line.paragraph.isInsideTable
            || (editRangeStart.line.paragraph.isInsideTable && !editRangeStart.editRangeEnd.line.paragraph.isInsideTable) || editRangeStart.columnFirst === -1) {
            this.highlight(editRangeStart.line.paragraph, startPosition, endPosition);
            if (this.isHighlightNext) {
                this.highlightNextBlock(this.hightLightNextParagraph, startPosition, endPosition);
                this.isHighlightNext = false;
                this.hightLightNextParagraph = undefined;
            }
        }
        else {
            let row = editRangeStart.line.paragraph.associatedCell.ownerRow;
            let cell = row.childWidgets[editRangeStart.columnFirst];
            if (cell) {
                for (let i = 0; i < cell.childWidgets.length; i++) {
                    if (cell.childWidgets[i] instanceof ParagraphWidget) {
                        this.highlight(cell.childWidgets[i], startPosition, endPosition);
                        if (this.isHighlightNext) {
                            this.highlightNextBlock(this.hightLightNextParagraph, startPosition, endPosition);
                            this.isHighlightNext = false;
                            this.hightLightNextParagraph = undefined;
                        }
                    }
                }
            }
        }
    }
    /**
     * Navigates to the next editing region, where current user can edit.
     *
     * @returns {void}
     */
    navigateToNextEditingRegion() {
        let editRange = this.getEditRangeStartElement(true);
        if (this.editRangeCollection.length > 0) {
            this.sortEditRangeCollection();
            let editRangeStart;
            let length = this.editRangeCollection.length;
            let index = length;
            if (!isNullOrUndefined(editRange)) {
                index = this.editRangeCollection.indexOf(editRange);
                editRangeStart = index < length - 1 ?
                    this.editRangeCollection[index + 1] : this.editRangeCollection[0];
            }
            else {
                for (var i = 0; i < this.editRangeCollection.length; i++) {
                    let editStart = this.editRangeCollection[i];
                    let position = this.getPosition(editStart, true);
                    let start = position.startPosition;
                    if ((start.isExistAfter(this.start))) {
                        editRangeStart = this.editRangeCollection[i];
                        break;
                    }
                }
                if (isNullOrUndefined(editRangeStart)) {
                    editRangeStart = this.editRangeCollection[0];
                }
            }
            let positionInfo = this.getPosition(editRangeStart, true);
            let startPosition = positionInfo.startPosition;
            let endPosition = positionInfo.endPosition;
            this.selectRange(startPosition, endPosition);
        }
    }
    sortEditRangeCollection() {
        //Sort based on position
        for (let i = this.editRangeCollection.length - 1; i >= 0; i--) {
            for (let j = 1; j <= i; j++) {
                let nextPosition = this.getPosition(this.editRangeCollection[j - 1]).startPosition;
                let firstPosition = this.getPosition(this.editRangeCollection[j]).startPosition;
                if (nextPosition.isExistAfter(firstPosition)) {
                    let temp = this.editRangeCollection[j - 1];
                    this.editRangeCollection[j - 1] = this.editRangeCollection[j];
                    this.editRangeCollection[j] = temp;
                }
            }
        }
    }
    /**
     * Highlights all the editing region, where current user can edit.
     *
     * @returns {void}
     */
    toggleEditingRegionHighlight() {
        this.isHighlightEditRegion = !this.isHighlightEditRegion;
    }
    /**
     * @private
     */
    getEditRangeStartElement(isNavigateToNextEditRegion, returnAllMatches) {
        let editRangeStartElementBox = [];
        for (let i = 0; i < this.editRangeCollection.length; i++) {
            let editStart = this.editRangeCollection[i];
            let position = this.getPosition(editStart, isNavigateToNextEditRegion, returnAllMatches);
            let start = position.startPosition;
            let end = position.endPosition;
            if ((this.start.isExistAfter(start) || this.start.isAtSamePosition(start))
                && (this.end.isExistBefore(end) || this.end.isAtSamePosition(end))) {
                if (returnAllMatches) {
                    editRangeStartElementBox.push(editStart);
                }
                else {
                    return editStart;
                }
            }
        }
        if (returnAllMatches) {
            return editRangeStartElementBox;
        }
        return undefined;
    }
    /**
     * Determines whether the selection is inside the edit region.
     *
     * @returns {boolean} Returns true if the selection is inside the edit region; Otherwise, false.
     */
    isSelectionInEditRegion() {
        if (!this.documentHelper.isDocumentProtected) {
            return false;
        }
        return this.checkSelectionIsAtEditRegion();
    }
    /**
     * Determines whether the specified start and end position of the selection is inside the edit region.
     * @param {TextPosition} start Specify the start position of the selection.
     * @param {TextPosition} end Specify the end position of the selection.
     * @returns {boolean} Returns true if the specified start and end position of the selection is inside the edit region; Otherwise, false.
     */
    checkSelectionIsAtEditRegion(start, end) {
        if (isNullOrUndefined(start) && isNullOrUndefined(end)) {
            start = this.start;
            end = this.end;
            if (!this.isForward) {
                start = this.end;
                end = this.start;
            }
        }
        if (this.editRangeCollection.length > 0 && this.isFootEndNoteParagraph(start.paragraph) && this.isFootEndNoteParagraph(end.paragraph) && start.paragraph.containerWidget == end.paragraph.containerWidget) {
            let position = this.getElementPosition(start.paragraph.containerWidget.footNoteReference, true).startPosition;
            start = position;
            end = position;
        }
        for (let i = 0; i < this.editRangeCollection.length; i++) {
            let editRangeStart = this.editRangeCollection[i];
            if (!editRangeStart.line.paragraph.isInsideTable
                || (editRangeStart.line.paragraph.isInsideTable && !editRangeStart.editRangeEnd.line.paragraph.isInsideTable)
                || editRangeStart.columnFirst === -1) {
                if (this.isSelectionInsideEditRange(editRangeStart, start, end)) {
                    return true;
                }
            }
            else {
                if (editRangeStart.paragraph.isInsideTable && editRangeStart.editRangeEnd &&
                    editRangeStart.editRangeEnd.line.paragraph.isInsideTable) {
                    let editRangeRow = editRangeStart.paragraph.associatedCell.ownerRow;
                    let startCell = start.paragraph.associatedCell;
                    let endCell = end.paragraph.associatedCell;
                    if (!isNullOrUndefined(startCell) && !isNullOrUndefined(endCell)) {
                        if (editRangeRow.equals(startCell.ownerRow) && editRangeRow.equals(endCell.ownerRow)
                            && startCell.index >= editRangeStart.columnFirst && startCell.index <= editRangeStart.columnLast) {
                            if (this.isEmpty && startCell.index === editRangeStart.line.paragraph.associatedCell.index) {
                                if (this.isSelectionInsideEditRange(editRangeStart, start, end)) {
                                    return true;
                                }
                            }
                            else if (!this.isCellSelected(startCell, start, end)) {
                                return true;
                            }
                        }
                    }
                }
            }
        }
        return false;
    }
    /**
     * @private
     */
    isEditRangeCellSelected(start, end) {
        if (isNullOrUndefined(start) && isNullOrUndefined(end)) {
            start = this.start;
            end = this.end;
            if (!this.isForward) {
                start = this.end;
                end = this.start;
            }
        }
        for (var i = 0; i < this.editRangeCollection.length; i++) {
            var editRangeStart = this.editRangeCollection[i];
            if (editRangeStart.paragraph.isInsideTable && editRangeStart.editRangeEnd &&
                editRangeStart.editRangeEnd.line.paragraph.isInsideTable) {
                let startCell = start.paragraph.associatedCell;
                let endCell = end.paragraph.associatedCell;
                let editRangeCell = editRangeStart.paragraph.associatedCell;
                if (!isNullOrUndefined(startCell) && !isNullOrUndefined(endCell)) {
                    if (startCell.index >= editRangeStart.columnFirst && startCell.index <= editRangeStart.columnLast) {
                        if (this.isCellSelected(editRangeCell, start, end)) {
                            return true;
                        }
                    }
                }
            }
        }
        return false;
    }
    isSelectionInsideEditRange(editRangeStart, start, end) {
        let positionInfo = this.getPosition(editRangeStart);
        let startPosition = positionInfo.startPosition;
        let endPosition = positionInfo.endPosition;
        if ((start.isExistAfter(startPosition) || start.isAtSamePosition(startPosition))
            && (end.isExistBefore(endPosition) || end.isAtSamePosition(endPosition))) {
            return true;
        }
        return false;
    }
    /**
     * @private
     */
    getPosition(element, isNavigateToNextEditRegion, returnAllMatches) {
        let offset = 0;
        if ((isNavigateToNextEditRegion || returnAllMatches) && !isNullOrUndefined(element.previousElement) && element.previousElement instanceof BookmarkElementBox) {
            offset = element.line.getOffset(element, 0);
        }
        else {
            offset = element.line.getOffset(element, 1);
        }
        let startPosition = new TextPosition(this.owner);
        startPosition.setPositionParagraph(element.line, offset);
        let endElement;
        if (element instanceof EditRangeStartElementBox) {
            endElement = element.editRangeEnd;
        }
        else if (element instanceof ContentControl) {
            endElement = element.reference;
        }
        else if (element instanceof BookmarkElementBox) {
            endElement = element.reference;
        }
        else if (element instanceof CommentCharacterElementBox) {
            endElement = element.comment.commentEnd;
        }
        let endPosition;
        if (endElement) {
            let line = endElement.line;
            if (!isNullOrUndefined(endElement.line) && !isNullOrUndefined(line.children)) {
                offset = endElement.line.getOffset(endElement, isNavigateToNextEditRegion ? 0 : 1);
                endPosition = new TextPosition(this.owner);
                endPosition.setPositionParagraph(endElement.line, offset);
            }
            else {
                endPosition = startPosition.clone();
            }
        }
        return { 'startPosition': startPosition, 'endPosition': endPosition };
    }
    /**
     * @private
     */
    getParagraphEndPosition(paragraph) {
        let startPosition = new TextPosition(this.owner);
        if (paragraph.isEmptyInternal(true)) {
            startPosition.setPositionParagraph(paragraph.lastChild, 0);
        }
        else {
            startPosition.setPositionParagraph(paragraph.lastChild, paragraph.lastChild.getEndOffset());
        }
        return startPosition;
    }
    /**
     * @private
     */
    checkContentControlLocked(checkFormat) {
        if (this.owner.editorModule) {
            this.owner.editorModule.isXmlMapped = false;
        }
        for (let i = 0; i < this.documentHelper.contentControlCollection.length; i++) {
            let contentControlStart = this.documentHelper.contentControlCollection[i];
            if (isNullOrUndefined(contentControlStart.reference) || contentControlStart.reference.indexInOwner === -1) {
                continue;
            }
            let position = this.getPosition(contentControlStart, true);
            let cCstart = position.startPosition;
            let cCend = position.endPosition;
            let start = this.start;
            let end = this.end;
            if (!this.isForward) {
                start = this.end;
                end = this.start;
            }
            if (isNullOrUndefined(checkFormat)) {
                let cCStartInsideSelction = ((cCstart.isExistAfter(start) || cCstart.isAtSamePosition(start)) && (cCstart.isExistBefore(end) || cCstart.isAtSamePosition(end)));
                let cCEndInsideSelction = ((cCend.isExistAfter(start) || cCend.isAtSamePosition(start)) && (cCend.isExistBefore(end) || cCend.isAtSamePosition(end)));
                if (cCStartInsideSelction && cCEndInsideSelction) {
                    if (contentControlStart.contentControlProperties.lockContentControl || this.documentHelper.isFormFillProtectedMode) {
                        this.owner.trigger(contentControlEvent);
                        return true;
                    }
                    if (cCend.isExistBefore(end) && cCend.currentWidget != end.currentWidget) {
                        continue;
                    }
                    return false;
                }
                if ((cCStartInsideSelction) || (cCEndInsideSelction)) {
                    if (!(cCstart.isAtSamePosition(start) || cCend.isAtSamePosition(start)) && (contentControlStart.contentControlProperties.lockContentControl || contentControlStart.contentControlProperties.lockContents)) {
                        return true;
                    }
                }
            }
            if (checkFormat) {
                let cCStartInsideSelction = ((cCstart.isExistAfter(start) || cCstart.isAtSamePosition(start)) && (cCstart.isExistBefore(end) || cCstart.isAtSamePosition(end)));
                let cCEndInsideSelction = ((cCend.isExistAfter(start) || cCend.isAtSamePosition(start)) && (cCend.isExistBefore(end) || cCend.isAtSamePosition(end)));
                if (cCStartInsideSelction && cCEndInsideSelction) {
                    if (contentControlStart.contentControlProperties.lockContents) {
                        this.owner.trigger(contentControlEvent);
                        return true;
                    }
                    return false;
                }
                if ((cCStartInsideSelction) || (cCEndInsideSelction)) {
                    if (!(cCstart.isAtSamePosition(start) || cCend.isAtSamePosition(start)) && contentControlStart.contentControlProperties.lockContents) {
                        return true;
                    }
                }
            }
            if ((start.isExistAfter(cCstart) || start.isAtSamePosition(cCstart))
                && (end.isExistBefore(cCend) || end.isAtSamePosition(cCend))) {
                if (this.owner.editorModule && contentControlStart.contentControlProperties.xmlMapping
                    && contentControlStart.contentControlProperties.xmlMapping.isMapped) {
                    this.owner.editorModule.isXmlMapped = true;
                }
                if (contentControlStart.contentControlProperties.lockContents) {
                    this.owner.trigger(contentControlEvent);
                    return true;
                }
                else if (isNullOrUndefined(checkFormat)
                    && (contentControlStart.contentControlProperties.type === 'CheckBox'
                        || contentControlStart.contentControlProperties.type === 'ComboBox'
                        || contentControlStart.contentControlProperties.type === 'DropDownList'
                        || contentControlStart.contentControlProperties.type === 'Date'
                        || contentControlStart.contentControlProperties.type === 'Picture'
                        || contentControlStart.contentControlProperties.type === 'Text'
                        || contentControlStart.contentControlProperties.type === 'RichText')) {
                    this.owner.trigger(contentControlEvent);
                    return true;
                }
            }
        }
        return false;
    }
    /**
     * @private
     */
    getElementPosition(element, isEnd, updatePhysicalPosition) {
        let offset = element.line.getOffset(element, isEnd ? 0 : 1);
        let startPosition = new TextPosition(this.owner);
        startPosition.setPositionParagraph(element.line, offset, updatePhysicalPosition);
        return { 'startPosition': startPosition, 'endPosition': undefined };
    }
    //Restrict editing implementation ends
    /**
     * Update ref field.
     * @private
     */
    updateRefField(field) {
        if (isNullOrUndefined(field)) {
            field = this.getHyperlinkField(true);
        }
        if (!isNullOrUndefined(field)) {
            if (!this.isReferenceField(field)) {
                return;
            }
            let fieldCode = this.getFieldCode(field).replace(/\s+/g, ' ');
            fieldCode = fieldCode.trim();
            if (fieldCode.toLowerCase().indexOf('ref') === 0) {
                let code = fieldCode.split(' ');
                if (code.length > 1) {
                    let bookmarkId = code[1];
                    if (this.documentHelper.bookmarks.containsKey(bookmarkId)) {
                        let start = this.start;
                        let end = this.end;
                        if (!this.isForward) {
                            start = this.end;
                            end = this.start;
                        }
                        let bookmarkStart = this.documentHelper.bookmarks.get(bookmarkId);
                        let bookmarkEnd = bookmarkStart.reference;
                        let previousNode = bookmarkStart.previousNode;
                        if ((isNullOrUndefined(previousNode) || !(previousNode instanceof FieldElementBox))
                            && bookmarkEnd && bookmarkEnd.previousNode instanceof FieldElementBox
                            && bookmarkEnd.previousNode.fieldType === 1
                            && !isNullOrUndefined(bookmarkEnd.previousNode.fieldBegin)
                            && !isNullOrUndefined(bookmarkEnd.previousNode.fieldBegin.formFieldData)) {
                            bookmarkStart = bookmarkEnd.previousNode.fieldBegin.fieldSeparator;
                            bookmarkEnd = bookmarkEnd.previousNode.fieldBegin.fieldEnd;
                        }
                        else if (previousNode instanceof FieldElementBox && previousNode.fieldType === 0
                            && !isNullOrUndefined(previousNode.formFieldData)) {
                            bookmarkStart = previousNode.fieldSeparator;
                            bookmarkEnd = previousNode.fieldEnd;
                        }
                        let offset = bookmarkStart.line.getOffset(bookmarkStart, 1);
                        start.setPositionParagraph(bookmarkStart.line, offset);
                        end.setPositionParagraph(bookmarkEnd.line, bookmarkEnd.line.getOffset(bookmarkEnd, 0));
                        let documentContent = this.owner.sfdtExportModule.write((this.owner.documentEditorSettings.optimizeSfdt ? 1 : 0), start.currentWidget, start.offset, end.currentWidget, end.offset, false, true);
                        let startElement = field.fieldSeparator;
                        let endElement = field.fieldEnd;
                        start.setPositionParagraph(startElement.line, startElement.line.getOffset(startElement, 1));
                        end.setPositionParagraph(endElement.line, endElement.line.getOffset(endElement, 0));
                        this.owner.editorModule.pasteContents(documentContent);
                    }
                }
            }
        }
    }
    /**
     *
     * @private
     * @returns {void}
     */
    footnoteReferenceElement(start, end, inline) {
        let container = this.getContainerWidget(start.paragraph);
        let count = 0;
        if (container instanceof FootNoteWidget) {
            let footNoteElement = this.start.paragraph.bodyWidget.footNoteReference;
            for (let i = 0; i < this.documentHelper.pages.length; i++) {
                count = 0;
                let page = this.documentHelper.pages[i];
                for (let j = 0; j < page.bodyWidgets.length; j++) {
                    let bodyWidget = page.bodyWidgets[j];
                    for (let k = 0; k < bodyWidget.childWidgets.length; k++) {
                        let paragraph = bodyWidget.childWidgets[k];
                        if (paragraph instanceof TableWidget) {
                            for (let tr = 0; tr < paragraph.childWidgets.length; tr++) {
                                let tablerow = paragraph.childWidgets[tr];
                                for (let tc = 0; tc < tablerow.childWidgets.length; tc++) {
                                    let tablecell = tablerow.childWidgets[tc];
                                    for (let para = 0; para < tablecell.childWidgets.length; para++) {
                                        let paragr = tablecell.childWidgets[para];
                                        for (let line = 0; line < paragr.childWidgets.length; line++) {
                                            let lines = paragr.childWidgets[line];
                                            count = 0;
                                            if (!isNullOrUndefined(lines.children)) {
                                                for (let m = 0; m < lines.children.length; m++) {
                                                    let child = lines.children[m];
                                                    count += child.length;
                                                    if (child instanceof FootnoteElementBox && child === footNoteElement) {
                                                        start.setPositionParagraph(lines, count - 1);
                                                        end.setPositionParagraph(lines, count);
                                                        this.selectRange(start, end);
                                                    }
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                        else {
                            for (let l = 0; l < paragraph.childWidgets.length; l++) {
                                let lines = paragraph.childWidgets[l];
                                count = 0;
                                if (!isNullOrUndefined(lines.children)) {
                                    for (let m = 0; m < lines.children.length; m++) {
                                        let child = lines.children[m];
                                        count += child.length;
                                        if (child instanceof FootnoteElementBox && child === footNoteElement) {
                                            start.setPositionParagraph(lines, count - 1);
                                            end.setPositionParagraph(lines, count);
                                            this.selectRange(start, end);
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
    /**
     * Convert hierachical index to linear index;
     * @private
     */
    getAbsolutePositionFromRelativePosition(textPosition) {
        let startPosition;
        if (typeof textPosition == 'string') {
            startPosition = this.getTextPosBasedOnLogicalIndex(textPosition);
        }
        else {
            startPosition = textPosition;
        }
        let paragraphInfo = this.getParagraphInfo(startPosition);
        let positionInfo = { position: 0, done: false };
        this.getPositionInfoForHeaderFooter(paragraphInfo, positionInfo);
        if (!positionInfo.done) {
            //Iterate Footnotes content;
        }
        return positionInfo.position;
    }
    /**
     * @private
     */
    getPositionInfoForBodyContent(paragraphInfo, positionInfo, blockWidget, tableBlock) {
        let block = !isNullOrUndefined(blockWidget) ? blockWidget : this.documentHelper.pages[0].bodyWidgets[0].childWidgets[0];
        //Iterate body content;
        positionInfo.position += this.getBlockIndex(block, paragraphInfo, positionInfo, tableBlock);
        return positionInfo;
    }
    /**
     * @private
     */
    getPositionInfoForHeaderFooter(paragraphInfo, positionInfo, tableBlock) {
        positionInfo = this.getPositionInfoForBodyContent(paragraphInfo, positionInfo, undefined, tableBlock);
        if (!positionInfo.done) {
            //Iterate header/footer content;
            this.getBlockIndexFromHeaderFooter(paragraphInfo, positionInfo, tableBlock);
        }
        return positionInfo;
    }
    getBlockIndexFromHeaderFooter(paragraphInfo, positionInfo, tableBlock) {
        //Iterate header/footer content;
        const headersFooters = this.documentHelper.headersFooters;
        for (const headerFooter of headersFooters) {
            for (let i = 0; i < 6; i++) {
                const currentHeaderFooter = headerFooter[i];
                if (currentHeaderFooter) {
                    positionInfo.position += this.getBlockIndex(currentHeaderFooter.childWidgets[0], paragraphInfo, positionInfo, tableBlock);
                    if (positionInfo.done) {
                        return positionInfo;
                    }
                }
                else {
                    positionInfo.position += 1;
                }
            }
        }
        return positionInfo;
    }
    getBlockIndex(block, paragraphInfo, positionInfo, tableBlock) {
        let position = 0;
        let fieldResult = { length: 0 };
        do {
            if (block instanceof ParagraphWidget && !isNullOrUndefined(paragraphInfo) && !isNullOrUndefined(paragraphInfo.paragraph) && paragraphInfo.paragraph.equals(block)) {
                //Paragraph start
                position += 1;
                let elementInfo = block.getInline(paragraphInfo.offset, 0);
                position += this.getBlockOffsetByElement(paragraphInfo, block, elementInfo.element, elementInfo.index, fieldResult);
                // if (this.isEndOffset && this.end.offset === this.getLineLength(this.end.currentWidget) + 1) {
                //     position += 1;
                // }
                // if (this.owner.documentHelper.isDocumentProtected && this.owner.documentHelper.protectionType === 'FormFieldsOnly') {
                //     position -= fieldResult.length;
                // }
                positionInfo.done = true;
                break;
            }
            position = this.getBlockLength(paragraphInfo, block, position, positionInfo, true, tableBlock, fieldResult);
            if (positionInfo.done) {
                // if (this.owner.documentHelper.isDocumentProtected && this.owner.documentHelper.protectionType === 'FormFieldsOnly') {
                //     position -= fieldResult.length;
                // }
                break;
            }
            if (!isNullOrUndefined(block)) {
                if (block.containerWidget instanceof BodyWidget && block.containerWidget.containerWidget instanceof FootNoteWidget) {
                    let nextBlock = block.getSplitWidgets().pop().nextRenderedWidget;
                    if (!isNullOrUndefined(nextBlock) && block.containerWidget !== nextBlock.containerWidget) {
                        break;
                    }
                    else {
                        block = nextBlock;
                    }
                }
                else {
                    block = block.getSplitWidgets().pop().nextRenderedWidget;
                }
            }
        } while (block);
        //positionInfo.position = position;
        return position;
    }
    getBlockTotalLength(block, targetBlock, positionInfo, tableBlock, fieldResult) {
        let offset = 0;
        let isDropdown = false;
        let splittedWidget = block.getSplitWidgets();
        for (let i = 0; i < splittedWidget.length; i++) {
            for (let j = 0; j < splittedWidget[i].childWidgets.length; j++) {
                let line = splittedWidget[i].childWidgets[j];
                for (let k = 0; k < line.children.length; k++) {
                    let element = line.children[k];
                    if (element instanceof ListTextElementBox) {
                        continue;
                    }
                    if (element instanceof ShapeElementBox || element instanceof FootnoteElementBox) {
                        if (element instanceof ShapeElementBox) {
                            if (element.textFrame.childWidgets.length > 0) {
                                offset += this.getBlockIndex(element.textFrame.childWidgets[0], targetBlock, positionInfo, undefined);
                            }
                        }
                        else {
                            offset += this.getBlockIndex(element.bodyWidget.childWidgets[0], targetBlock, positionInfo, undefined);
                        }
                        if (positionInfo.done) {
                            return offset;
                        }
                    }
                    if (element instanceof GroupShapeElementBox) {
                        for (let k = 0; k < element.childWidgets.length; k++) {
                            if (element.childWidgets[k] instanceof ShapeElementBox && element.childWidgets[k].textFrame.childWidgets.length > 0) {
                                offset += this.getBlockIndex(element.childWidgets[k].textFrame.childWidgets[0], targetBlock, positionInfo, undefined);
                            }
                            if (positionInfo.done) {
                                return offset;
                            }
                        }
                    }
                    if (element instanceof FieldElementBox && element.fieldType == 0 && element.formFieldData instanceof DropDownFormField) {
                        isDropdown = true;
                    }
                    if (isDropdown && element instanceof FieldElementBox && element.fieldType == 1) {
                        if (element.previousNode instanceof TextElementBox) {
                            fieldResult.length += element.previousNode.length;
                            isDropdown = false;
                        }
                    }
                    if (!element.skipformFieldLength) {
                        offset += element.length;
                    }
                }
            }
        }
        return offset;
    }
    /**
     * @private
     */
    getBlockLength(paragraphInfo, block, position, completed, skipShapeElement, tableBlock, fieldResult) {
        if (paragraphInfo && block instanceof ParagraphWidget && !isNullOrUndefined(paragraphInfo.paragraph) && paragraphInfo.paragraph.equals(block)) {
            //Paragraph start
            position += 1;
            let elementInfo = block.getInline(paragraphInfo.offset, 0);
            position += this.getBlockOffsetByElement(paragraphInfo, block, elementInfo.element, elementInfo.index, fieldResult);
            if (this.isEndOffset && block.isInsideTable && block.associatedCell.lastChild.equals(block) && paragraphInfo.offset === this.getParagraphLength(block) + 1) {
                position += 1;
            }
            completed.done = true;
            return position;
        }
        if (block instanceof ParagraphWidget) {
            // Code for Comparing the offset calculated using old approach and optimized approach
            // if (this.isNewApproach) {
            // position += 1;
            // if (!skipShapeElement) {
            //     position += block.length;
            // } else {
            //     position += this.getBlockTotalLength(block, paragraphInfo, completed, tableBlock, fieldResult);
            // }
            // } else {
            //Add Paragraph start length;
            position += 1;
            if (!skipShapeElement) {
                position += (block.getTotalLength());
            }
            else {
                position += this.getBlockTotalLength(block, paragraphInfo, completed, tableBlock, fieldResult);
            }
            // }
        }
        else if (block instanceof TableWidget) {
            // Table start mark length
            position += 1;
            if (!isNullOrUndefined(tableBlock)) {
                if (tableBlock instanceof TableWidget) {
                    if (tableBlock.equals(block)) {
                        completed.done = true;
                        return position;
                    }
                }
            }
            let row = block.firstChild;
            while (row) {
                // Row mark length
                position += 1;
                if (!isNullOrUndefined(tableBlock)) {
                    if (tableBlock instanceof TableRowWidget) {
                        if (tableBlock.equals(row)) {
                            completed.done = true;
                            return position;
                        }
                    }
                }
                let cell = row.firstChild;
                while (cell) {
                    // Cell mark length
                    position += 1;
                    if (!isNullOrUndefined(tableBlock)) {
                        if (tableBlock instanceof TableCellWidget) {
                            if (tableBlock.equals(cell)) {
                                completed.done = true;
                                return position;
                            }
                        }
                    }
                    let childBlock = cell.firstChild;
                    while (childBlock) {
                        position = this.getBlockLength(paragraphInfo, childBlock, position, completed, skipShapeElement, tableBlock, fieldResult);
                        if (completed.done) {
                            return position;
                        }
                        childBlock = childBlock.getSplitWidgets().pop().nextRenderedWidget;
                    }
                    cell = cell.nextWidget;
                }
                let tableIndex = row.ownerTable.index;
                row = row.getSplitWidgets().pop().nextRenderedWidget;
                if (row && row.ownerTable.index !== tableIndex) {
                    row = undefined;
                }
            }
            // Table end mark length
            // position += 1;
        }
        return position;
    }
    /**
     * Calculate the cell length.
     * @private
     */
    calculateCellLength(cell) {
        let block = cell.firstChild;
        let position = 0;
        let completed = { "done": false };
        let paragraphInfo = { 'paragraph': null, 'offset': 0 };
        while (block) {
            position = this.getBlockLength(paragraphInfo, block, position, completed, true, undefined, undefined);
            block = block.getSplitWidgets().pop().nextRenderedWidget;
        }
        return position;
    }
    getBlockOffsetByElement(paragraphInfo, block, targetElement, elementIndex, fieldResult) {
        let offset = 0;
        let isDropdown = false;
        let splittedWidget = block.getSplitWidgets();
        for (let i = 0; i < splittedWidget.length; i++) {
            for (let j = 0; j < splittedWidget[i].childWidgets.length; j++) {
                let line = splittedWidget[i].childWidgets[j];
                for (let k = 0; k < line.children.length; k++) {
                    let element = line.children[k];
                    if (element instanceof ListTextElementBox) {
                        continue;
                    }
                    if (element instanceof FieldElementBox && element.fieldType == 0 && element.formFieldData instanceof DropDownFormField) {
                        isDropdown = true;
                    }
                    if (isDropdown && element instanceof FieldElementBox && element.fieldType == 1) {
                        if (element.previousNode instanceof TextElementBox) {
                            fieldResult.length += element.previousNode.length;
                            isDropdown = false;
                        }
                    }
                    if (element === targetElement) {
                        return offset + elementIndex;
                    }
                    if (element instanceof ShapeElementBox || element instanceof FootnoteElementBox) {
                        if (element instanceof ShapeElementBox) {
                            if (element.textFrame.childWidgets.length > 0) {
                                for (let m = 0; m < element.textFrame.childWidgets.length; m++) {
                                    offset = this.getBlockLength(paragraphInfo, element.textFrame.childWidgets[m], offset, { done: false }, false, undefined, undefined);
                                }
                            }
                        }
                        else {
                            if (element.bodyWidget.childWidgets.length > 0) {
                                for (let m = 0; m < element.bodyWidget.childWidgets.length; m++) {
                                    offset = this.getBlockLength(paragraphInfo, element.bodyWidget.childWidgets[m], offset, { done: false }, false, undefined, undefined);
                                }
                            }
                        }
                    }
                    if (!element.skipformFieldLength) {
                        offset += element.length;
                    }
                }
            }
        }
        return offset;
    }
    /**
     * This method is for collaborative editing.
     * @private
     */
    getTableRelativeValue(startPosition, endPosition) {
        // If start is in firset row first cell and end is in last row last cell or next table or next para. we need to minus the offset to 3. Else checking row.
        // If start is first cell and end is in row last cell or other row last cell or other widgets. we need to minus the offset to 2. else return 0.
        if (startPosition.currentWidget.paragraph.isInsideTable) {
            if (this.isTableSelected()) {
                return 3;
            }
            else if (this.isRowSelect() && endPosition.paragraph.isInsideTable && startPosition.paragraph.associatedCell.ownerTable.equals(endPosition.paragraph.associatedCell.ownerTable)) {
                return 2;
            }
            else {
                let table = startPosition.paragraph.associatedCell.ownerTable.getSplitWidgets();
                let firstParagraph = this.getFirstBlockInFirstCell(table[0]);
                if (startPosition.paragraph.associatedCell.equals(firstParagraph.associatedCell)) {
                    if (endPosition.paragraph.isInsideTable) {
                        if (!startPosition.paragraph.associatedCell.ownerTable.equals(endPosition.paragraph.associatedCell.ownerTable)) {
                            let length = this.isRowSelect() ? 2 : 3;
                            let table = startPosition.paragraph.associatedCell.ownerTable;
                            while (table.containerWidget instanceof TableCellWidget) {
                                length += 3;
                                table = table.containerWidget.ownerTable;
                                if (table.equals(endPosition.paragraph.associatedCell.ownerTable)) {
                                    break;
                                }
                            }
                            return length;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 3;
                    }
                }
                else {
                    if (endPosition.currentWidget.paragraph.isInsideTable) {
                        if (!startPosition.paragraph.associatedCell.ownerTable.equals(endPosition.paragraph.associatedCell.ownerTable)) {
                            return 2;
                        }
                        else {
                            return 0;
                        }
                    }
                    else {
                        return 2;
                    }
                }
            }
        }
        return 0;
    }
    /**
     *
     * @private
     */
    isRowSelect() {
        // This method wil return if start row child widgets equals to end row child widgets. 
        let start = this.start;
        let end = this.end;
        if (!this.isForward) {
            start = this.end;
            end = this.start;
        }
        if (isNullOrUndefined(start.paragraph.associatedCell) ||
            isNullOrUndefined(end.paragraph.associatedCell) || start.paragraph.associatedCell.equals(end.paragraph.associatedCell) || this.isTableSelected(true)) {
            return false;
        }
        let endTable = end.paragraph.associatedCell.ownerTable;
        let isRowSelect = false;
        if (endTable.containerWidget instanceof TableCellWidget) {
            while (endTable.containerWidget instanceof TableCellWidget) {
                endTable = endTable.containerWidget.ownerTable;
                for (let i = 0; i < endTable.childWidgets.length; i++) {
                    let row = endTable.childWidgets[i];
                    if (row.childWidgets[row.childWidgets.length - 1].equals(endTable.containerWidget)) {
                        isRowSelect = true;
                    }
                }
            }
        }
        else {
            for (let i = 0; i < endTable.childWidgets.length; i++) {
                let row = endTable.childWidgets[i];
                if (row.childWidgets[row.childWidgets.length - 1].equals(end.paragraph.associatedCell)) {
                    isRowSelect = true;
                }
            }
        }
        let row = start.paragraph.associatedCell.ownerRow.getSplitWidgets();
        let firstcell;
        if (row[0].childWidgets.length > 0) {
            firstcell = row[0].childWidgets[0];
        }
        return start.paragraph.associatedCell.equals(firstcell) && isRowSelect;
    }
}
